/* eslint-disable import/first */
import { isAdminUser } from '../../utils/adminUserTypes';
import { getBaseUnixForLeadTime, getInstallEndPatchFromLead, isInstallBeforeRequiredLead, resolveProductsLeadTime } from 'src/utils/installationLeadTime';
import { isRushFeeOn, calcRushFeeAmount, calcTotalWithRushFee, createRushFeeSyncRefs, runRushFeeLeadSync, markRushFeeUserToggled } from 'src/utils/rushFee';
import {
  Autocomplete,
  Avatar,
  Backdrop,
  Badge,
  Box,
  Button,
  Card,
  CardHeader,
  Checkbox,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Skeleton,
  Stack,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  Collapse,
} from '@material-ui/core'
import Page from '../../components/Page'
import { capitalCase, sentenceCase } from 'change-case'
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill'
import trash2Outline from '@iconify/icons-eva/trash-2-outline'
import lockOpenFill from '@iconify/icons-ph/lock-open-fill'
import editFill from '@iconify/icons-eva/edit-fill'
import plusFill from '@iconify/icons-eva/plus-fill'
//materail
import * as Yup from 'yup'
import { Form, FormikProvider, useFormik } from 'formik'
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs'
import Label from 'src/components/Label'
import { useLocation, useNavigate, useParams } from 'react-router'

import ViewRequest from 'src/components/_dashboard/official-request/ViewRequest'
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import PublicMsgBoard from 'src/components/_dashboard/official-request/PublicMsgBoard'
import RequestTabUpdates from 'src/components/_dashboard/user/account/RequestTabUpdates'
import PublicMessageBoard from 'src/components/_dashboard/user/profile/PublicMessageBoard.js'
import RequestUpdates from 'src/components/_dashboard/official-request/RequestUpdates'
import PaymentRequest from 'src/components/_dashboard/official-request/PaymentRequest'
import {
  AddCircle,
  BlockOutlined,
  Delete,
  KeyboardBackspaceOutlined,
  Print,
  LocationOn,
  Add,
  Remove,
  CenterFocusStrong,
  NoteAdd,
  Edit,
  UploadFile,

  DragIndicator,
  MergeType,
} from '@material-ui/icons'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import Modal from 'src/components/_dashboard/blog/ProjectModel'
import Icon from '@iconify/react'
import filePdfIcon from '@iconify/icons-mdi/file-pdf'
import Scrollbar from 'src/components/Scrollbar'
import axios from 'axios'
import {
  currentFacilityId,
  FacilityTypes,
  REST_API,
  REST_API_END_POINT,
  SEND_EMAIL,
  UNITS,
} from 'src/constants/Defaultvalues'
import {
  sortServicesByProductIndex,
  buildServiceIndexMapping,
  serviceLineMatches,
} from 'src/utils/sortServicesByIndex'
import moment from 'moment'
import AddProducts from 'src/components/_dashboard/blog/AddProducts'

const isApiProductWriteRow = (row) =>
  row?.is_product_row == 1 ||
  row?.is_product_row === '1' ||
  row?.is_product_row === true

/** Catalog choose rows for the main Products Autocomplete (includes grouped members). */
const isProductAutocompleteCatalogRow = (row) =>
  row?.fromMapServices != true &&
  !row?.isAdditionalProduct &&
  !row?.is_product_row &&
  (Boolean(row?.id || row?.product_id) ||
    (row?.group_id != null && row?.group_id !== ''))

/** Ungrouped catalog rows that participate in Autocomplete multiselect add/replace merges. */
const isProductAutocompleteMultiselectRow = (row) =>
  isProductAutocompleteCatalogRow(row) && !row?.group_id

const splitOrderCatalogTypes = [
  { id: 'all', label: 'All', inhouse: null, isTrafficCatalog: null },
  { id: 'in_stock', label: 'In Stock', inhouse: 4, isTrafficCatalog: false },
  {
    id: 'client_owned',
    label: 'Client Owned',
    inhouse: 5,
    isTrafficCatalog: false,
  },
  { id: 'traffic', label: 'Traffic', inhouse: 1, isTrafficCatalog: true },
  {
    id: 'production_catalog',
    label: 'Production Catalog',
    inhouse: 1,
    isTrafficCatalog: false,
  },
  {
    id: 'split_catalog',
    label: 'Split Catalog',
    inhouse: 6,
    isTrafficCatalog: false,
  },
  {
    id: 'estimate_catalog',
    label: 'Estimate Catalog',
    inhouse: 7,
    isTrafficCatalog: false,
  },
]

import { PATH_DASHBOARD } from 'src/routes/paths'
import { useSnackbar } from 'notistack'
import {
  LoadingButton,
  MobileDatePicker,
  MobileDateRangePicker,
} from '@material-ui/lab'
import { useCallback } from 'react'
import { UploadAvatar, UploadMultiFile } from 'src/components/upload'
import AttachmentDownloadAllButton from 'src/components/_dashboard/official-request/AttachmentDownloadAllButton'
import AddClients from 'src/components/_dashboard/official-request/AddClients'
import AddProposal from 'src/components/_dashboard/official-request/AddProposal'
import ConfirmationPopup from 'src/components/_dashboard/official-request/ConfirmationPopup'
import ViewProductFormulaModal from 'src/components/ViewProductFormulaModal'
import {
  ESTIMATE_PREVIEW_LOCK_SX,
  EstimatePreviewNoteActions,
  getEstimatePreviewFormulaModalProps,
  getEstimatePreviewNoteFieldProps,
  getEstimatePreviewUploadProps,
  renderPreviewAttachmentContent,
} from 'src/utils/estimateJobPreview'
import {
  applyInstallPriceEdit,
  applyRetailPriceEdit,
  clearCatalogInstallCost,
  ensureCatalogBaselines,
  formatPriceToTwoDecimals,
  formatRetailPriceDisplay,
  getCatalogPickerOriginalPrices,
  getCatalogProductWithAdjustment,
  getDisplayedActualRetail,
  getDisplayedInstallPrice,
  getSignedMarketingAdjustment,
  getSignedInstallMarketingAdjustment,
  hydrateEstimateLineMarketingPrices,
  canShowProductFormulaIcon,
  hydrateSavedOrderLinePrices,
  limitDecimalInput,
  normalizeProductForSave,
  normalizeRetailArrowChange,
  reconcileCatalogMarketingPrices,
  applyProductAdjValueTypeChange,
  applyInstallAdjValueTypeChange,
  stepRetailPriceByArrow,
} from 'src/utils/retailPriceEdit'
import {
  snapshotGroupMemberMarketing,
  ensureGroupMemberMarketingSnapshot,
  hydrateGroupedMemberMarketingFromRow,
  resolveGroupMemberMarketingForSave,
  restoreUngroupedProductMarketing,
  getNestedLineMarketingAdjustmentValue,
  formatNestedMarketingAdjustmentDisplay,
  getNestedLineMarketingAdjValueType,
  isIndexIdInList,
  isQuotationChooseCatalogRow,
  QUOTATION_ROW_DELETE_CELL_SX,
  QUOTATION_ROW_ACTIONS_BOX_SX,
  QUOTATION_ROW_ACTIONS_LEADING_SLOT_SX,
  enrichQuotationAttachmentForDisplay,
  mapQuotationProductAttachmentForDisplay,
  collapseProductsForAutocompleteChips,
  getCatalogAutocompleteDisplayName,
  getCatalogAutocompleteTooltip,
  getAutocompleteSelectionKey,
  getAddToGroupOptions,
  getValidUngroupedSelectionIds,
  withInheritedGroupNotes,
  getCatalogSourceDropdownOptions,
  getCatalogSourceOptionLabel,
  getCatalogSourceCreateOptionLabel,
  quotationGroupNameExists,
  getSingleProductFormulaCostEach,
  computeGroupedProducts,
  GROUP_QUANTITY_MODE_SET_MULTIPLIER,
  getGroupProductMarketingAdjustmentDisplay,
  resolveGroupProductMarketingAdjustment,
  resolveGroupInstallMarketingAdjustment,
  getGroupInstallMarketingAdjustmentDisplay,
  getNestedLineLosingMoneyFlags,
  getGroupMemberProductQty,
  getGroupMemberInstallQty,
} from './quotation/quotationGroupingHelpers'
import { GroupEditActionButtons } from './quotation/QuotationProductGroupingUI'
import {
  buildGroupedDesignOrderDisplayRows,
  serializeDesignOrderGroupedRowsForInvoice,
} from 'src/utils/designOrderInvoiceUtils'
import ReactToPrint from 'react-to-print'
import { storage } from '../../firebase/firebase'
import {
  getDownloadURL,
  ref as imageref,
  uploadBytesResumable,
} from 'firebase/storage'
import { Link } from 'react-router-dom'
import { empty } from 'src/Helpers/Common'
import { resolveAttachmentProxyPath } from 'src/Helpers/FileDownloadUtils'
import Locations from 'src/components/_dashboard/official-request/Locations'
import Workflow from 'src/components/_dashboard/general-analytics/RfqForm'
import { AccountNotifications } from '../../components/_dashboard/user/account'
import { set } from 'lodash'
import Proposals from 'src/components/_dashboard/official-request/Proposals'
import useCompanyProfile from 'src/hooks/useCompanyProfile'
import LoadingScreen from 'src/components/LoadingScreen'
import { ButtonAnimate, DialogAnimate } from 'src/components/animate'
import AnimatedButton from 'src/components/animate/AnimatedButton'
import RouteMap from 'src/components/_dashboard/official-request/RouteMap'
import React from 'react'
import { supabase } from '../../supabase/supabaseClient'
import AVALARALOGO from 'src/assets/Avalara_Logo.png'
import JobNoteWindow from 'src/components/_dashboard/chat/JobNoteWindow'
import RequestProgressModal from 'src/components/RequestProgressModal'
import emailFillIcon from '@iconify/icons-eva/email-fill'
import SendDesignsEmailModal from 'src/components/_dashboard/official-request/SendDesignsEmailModal'
import Editproduct from 'src/components/_dashboard/blog/EditProducts'
import LabourCostList from './LabourCostList'
import { fUSPrice, roundMoneyValue } from 'src/utils/formatNumber'
import { formatDateOnly, dateOnlyMoment, dateOnlyToUnix, estimateDatePickerMoment, localTodayDateOnlyUnix, toDateOnlyUnix } from 'src/utils/dateOnly';
import getLabourCostServiceTabLabel from 'src/utils/getLabourCostServiceTabLabel'
import {
  computeFilteredServicesForDropdown,
  fetchLabourCostServicesForDropdown,
} from 'src/utils/labourCostServiceDropdown'

const ATTACHMENTS_PUBLIC_MARKER = '/storage/v1/object/public/signwise-attachments/'

const normalizeUrlString = (value) => {
  if (!value || typeof value !== 'string') return ''
  const raw = value.trim()
  try {
    const u = new URL(raw)
    return `${u.origin}${u.pathname}`.replace(/\/+$/, '')
  } catch {
    return raw.split('?')[0].split('#')[0].trim()
  }
}

/** True for URLs / storage paths — false for bare filenames like "Screenshot.png". */
const looksLikeAttachmentRef = (raw) => {
  const s = String(raw || '')
  if (!s) return false
  if (
    s.includes('://') ||
    s.includes('/attachments/file') ||
    s.includes('/storage/v1/object/') ||
    s.includes(ATTACHMENTS_PUBLIC_MARKER)
  ) {
    return true
  }
  // storage-relative path e.g. sales-orders/123_file.png
  return s.includes('/') && /\.[a-z0-9]+$/i.test(s)
}

/** Collapse proxy URLs + direct Supabase URLs to the same storage path. */
const normalizeAttachmentIdentifier = (raw) => {
  if (!raw) return ''
  const str = String(raw).trim()
  if (!str) return ''

  if (str.includes('/attachments/file') && str.includes('path=')) {
    return normalizeUrlString(resolveAttachmentProxyPath(str))
  }

  const publicIdx = str.indexOf(ATTACHMENTS_PUBLIC_MARKER)
  if (publicIdx !== -1) {
    return normalizeUrlString(str.slice(publicIdx + ATTACHMENTS_PUBLIC_MARKER.length))
  }

  return normalizeUrlString(str)
}

const getAttachmentRecordId = (f) =>
  f?.id ?? f?.ID ?? f?.attachment_id ?? f?.request_attachment_id ?? null

/** Prefer url/file_url; only use name when it is a URL/path (not a bare filename). */
const getAttachmentPrimaryRef = (f) => {
  if (!f) return ''
  if (f.url) return f.url
  if (f.file_url) return f.file_url
  if (looksLikeAttachmentRef(f.name)) return f.name
  return ''
}

const attachmentFileKey = (f) => {
  const primary = getAttachmentPrimaryRef(f)
  if (primary) return normalizeAttachmentIdentifier(primary)
  // last resort: bare name (unique only when filenames differ)
  return normalizeAttachmentIdentifier(f?.name || '')
}

const attachmentMatches = (a, b) => {
  const idA = getAttachmentRecordId(a)
  const idB = getAttachmentRecordId(b)
  if (idA != null && idB != null && String(idA) !== '' && String(idB) !== '') {
    return String(idA) === String(idB)
  }

  const keyA = attachmentFileKey(a)
  const keyB = attachmentFileKey(b)
  return Boolean(keyA && keyB && keyA === keyB)
}

const pruneAttachmentMapsByFile = (map, fileToRemove) => {
  if (!fileToRemove || !map) return map || {}
  const next = { ...map }
  Object.keys(next).forEach((k) => {
    const arr = next[k]
    if (!Array.isArray(arr)) return
    const filtered = arr.filter((f) => !attachmentMatches(f, fileToRemove))
    if (filtered.length === 0) {
      delete next[k]
    } else {
      next[k] = filtered
    }
  })
  return next
}

const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}))
const MAX_CHARACTERS = 500
const formatProjectAddress = (project) => {
  if (!project) return 'No address available'
  const addressParts = [project.address, project.city, project.state, project.zip]
    .map((part) => (part || '').toString().trim())
    .filter(Boolean)
  return addressParts.length > 0 ? addressParts.join(', ') : 'No address available'
}

const selectInputValue = (event) => {
  const input = event.target
  setTimeout(() => {
    if (input?.select) {
      input.select()
    }
  }, 0)
}

const ENTRY_TOGGLE_PAD = 4

const ProductLineEntryToggle = ({ mode, onChange, disabled, lockDisplay }) => {
  const theme = useTheme()
  const isWrite = mode === 'write'
  const pad = ENTRY_TOGGLE_PAD

  const segmentButtonSx = (active) => ({
    flex: 1,
    minWidth: 0,
    px: 1,
    py: 0.5,
    borderRadius: '10px',
    fontSize: '0.72rem',
    fontWeight: active ? 700 : 600,
    lineHeight: 1.25,
    textTransform: 'none',
    color: active
      ? theme.palette.common.white
      : theme.palette.mode === 'dark'
      ? theme.palette.grey[300]
      : theme.palette.grey[800],
    zIndex: 1,
  })

  const shellSx = {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'stretch',
    width: '100%',
    maxWidth: 170,
    minWidth: 150,
    p: `${pad}px`,
    borderRadius: '13px',
    border: `1px solid ${theme.palette.divider}`,
    bgcolor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.04)'
        : 'rgba(145, 158, 171, 0.1)',
  
    // do not fade locked display, only fade real disabled state
    opacity: disabled && !lockDisplay ? 0.55 : 1,
  
    pointerEvents: disabled || lockDisplay ? 'none' : 'auto',
  }

  if (lockDisplay) {
    return (
      <Box role="group" sx={shellSx}>
        <Box
          aria-hidden
          sx={{
            position: 'absolute',
            top: pad,
            left: pad,
            right: pad,
            bottom: pad,
            borderRadius: '9px',
            zIndex: 0,
            background: isWrite
              ? `linear-gradient(145deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 55%, ${theme.palette.primary.dark} 100%)`
              : `linear-gradient(145deg, ${theme.palette.success.light} 0%, ${theme.palette.success.main} 55%, ${theme.palette.success.dark} 100%)`,
          }}
        />
        <Button
          variant="text"
          disableRipple
          size="small"
          sx={{
            ...segmentButtonSx(true),
            width: '100%',
            color: theme.palette.common.white,
          }}
        >
          {isWrite ? 'Write' : 'Choose'}
        </Button>
      </Box>
    )
  }

  return (
    <Box role="group" sx={shellSx}>
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          top: pad,
          left: pad,
          bottom: pad,
          width: `calc((100% - ${pad * 2}px) / 2)`,
          borderRadius: '9px',
          transform: isWrite ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 0.28s ease',
          zIndex: 0,
          background: isWrite
            ? `linear-gradient(145deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 55%, ${theme.palette.primary.dark} 100%)`
            : `linear-gradient(145deg, ${theme.palette.success.light} 0%, ${theme.palette.success.main} 55%, ${theme.palette.success.dark} 100%)`,
        }}
      />
      <Button variant="text" disableRipple size="small" onClick={() => onChange('write')} sx={segmentButtonSx(isWrite)}>
        Write
      </Button>
      <Button variant="text" disableRipple size="small" onClick={() => onChange('choose')} sx={segmentButtonSx(!isWrite)}>
        Choose
      </Button>
    </Box>
  )
}

const markupTypes = [
  { id: 1, name: 'Wholesale Markup' },
  { id: 2, name: 'Retail Markup' },
]

const marketingAdjustmentType = [
  { id: 1, name: '%' },
  { id: 2, name: '$' },
  { id: 3, name: '¢' },
]

const EditEstimateJob = forwardRef(function EditEstimateJob({
  setJustSubmittedEstimate,
  isPreview,
  setIsPreview,
  setIsOpenEdit,
  estimateId,
  isEditEstimateJob,
  setRefreshRFQData, refreshRFQData,
  popupOn,
  idOfProject,
  isEditEstimate,
  closeView,
  setRenderCards,
  renderCards,
  onDataChange,
}, ref) {
  const { COMPANY_LOGO, COMPANY_NAME } = useCompanyProfile()
  const theme = useTheme()
  const id = popupOn ? idOfProject : estimateId
  let edit = popupOn ? isEditEstimate : isEditEstimateJob
  const componentRef = useRef()
  const prevGroupFormulaTotalsRef = useRef({ product: {}, install: {} })
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const user = JSON.parse(localStorage.getItem('user'))
  const [currentRFQData, setCurrentRFQdata] = useState({})
  console.log('currentRFQDataaaa', currentRFQData)
  const [showProgressModal, setShowProgressModal] = useState(false)
  const [createJob, setCreateJob] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false)
  const [progressRequestData, setProgressRequestData] = useState(null)
  const [socketReady, setSocketReady] = useState(false)
  const [socket, setSocket] = useState(null)
  const [openEdit, setOpenEdit] = useState(false)
  const [showServices, setShowServices] = useState(true)
  const [selectedProducts, setSelectedProducts] = useState([])
  console.log('selectedProducts=======', selectedProducts)
  const [openGroupedRows, setOpenGroupedRows] = useState({})
  const [groupEditMode, setGroupEditMode] = useState({})
  const [groupLocationStates, setGroupLocationStates] = useState({})
  const [groupSelectedProductIds, setGroupSelectedProductIds] = useState([])
  const [groupProductQuantityDrafts, setGroupProductQuantityDrafts] = useState({})
  const [groupProductMarketingValues, setGroupProductMarketingValues] = useState({})
  const [groupInstallMarketingValues, setGroupInstallMarketingValues] = useState({})
  const [addToGroupId, setAddToGroupId] = useState(null)
  const [openAddToGroupModal, setOpenAddToGroupModal] = useState(false)
  const [openGroupCatalogSourceModal, setOpenGroupCatalogSourceModal] = useState(false)
  const [groupCatalogSourceIndexId, setGroupCatalogSourceIndexId] = useState(null)
  const [groupCatalogCustomSourceId, setGroupCatalogCustomSourceId] = useState(null)
  const [groupCatalogSourceInputValue, setGroupCatalogSourceInputValue] = useState('')
  const [customCatalogGroupSources, setCustomCatalogGroupSources] = useState([])
  const [showGroupCatalogCreateForm, setShowGroupCatalogCreateForm] = useState(false)
  const [groupCatalogCustomName, setGroupCatalogCustomName] = useState('')
  const [groupCatalogCustomDescription, setGroupCatalogCustomDescription] = useState('')
  const [groupCatalogCreateError, setGroupCatalogCreateError] = useState('')
  const [selectedGroupIdForCatalog, setSelectedGroupIdForCatalog] = useState(null)
  const [customerOrderProductGroups, setCustomerOrderProductGroups] = useState([])
  const [pendingJobLogActivities, setPendingJobLogActivities] = useState([])
  const [
    initialServiceCostInProductFormula,
    setInitialServiceCostInProductFormula,
  ] = useState(0)
  const [markupType, setMarkupType] = useState()
  const [clientApprove, setClientApprove] = useState()
  const [managerApprovalRequired, setManagerApprovalRequired] = useState(0)
  const [releaseApprovalDialog, setReleaseApprovalDialog] = useState({
    open: false,
    catalogs: [],
  })
  const [designs, setDesigns] = useState([])
  const [details, setDetails] = useState(null)
  const [skills, setSkill] = useState(null)
  const [workflow, setWorkFlow] = useState(null)
  const [allProducts, setAllproducts] = useState(null)
  console.log('allProductsssssssss', allProducts)
  console.log('allProductsssssssss', allProducts)
  const [invoice, setInvoice] = useState(null)
  const [open, setIsOpen] = useState(false)
  const [totalsum, setTotalSum] = useState(0)
  const [rfqSubTotal, setRFQSubTotal] = useState(0)
  const [DiscountTotal, setDiscountTotal] = useState(0)
  const [totalWholesalePrice, setTotalWholesalePrice] = useState(0)
  const [totalRetailPrice, setTotalRetailPrice] = useState(0)
  const [totalProductFormula, setTotalProductFormula] = useState(0)
  const [addClient, setAddClient] = useState(false)
  const [addVendor, setAddVendor] = useState(false)
  const [addProposal, setAddProposal] = useState(false)
  const [openInvoice, setOpenInvoice] = useState(false)
  const [requestAccept, setRequestAccept] = useState(false)
  const [requestReject, setRequestReject] = useState(false)
  const [allClients, setAllClients] = useState([])
  const [allClientsEdit, setAllClientsEdit] = useState(null)
  const [customerData, setCustomerData] = useState(null)
  const [currentDate, setCurrentDate] = useState(moment().format('YYYY-MM-DD'))
  const [openProductFormulaModal, setOpenProductFormulaModal] = useState(false)
  const [selectedProductFormulaId, setSelectedProductFormulaId] = useState(null)
  const [currentTab, setCurrentTab] = useState(
    user.isVendor ? 'Details' : 'Estimate Details',
  )
  const [openPreview, setOpenPreview] = useState(false)
  const [avatarUrl, setAvatarUrl] = useState([])
  const [isUploading, setIsUploading] = useState(false)
  const [productAttachments, setProductAttachments] = useState({})
  const [isUploadingProduct, setIsUploadingProduct] = useState({})
  const [productAttachmentDragOver, setProductAttachmentDragOver] = useState({})
  const [attachmentTabValue, setAttachmentTabValue] = useState({})
  const [selectedUploadedImages, setSelectedUploadedImages] = useState({})
  const [openProductAttachment, setOpenProductAttachment] = useState({})
  const [serviceAttachments, setServiceAttachments] = useState({})
  const [isUploadingService, setIsUploadingService] = useState({})
  const [attachmentTabValueService, setAttachmentTabValueService] = useState({})
  const [selectedUploadedImagesService, setSelectedUploadedImagesService] = useState({})
  const [openServiceAttachment, setOpenServiceAttachment] = useState({})
  const [selectedPDF, setSelectedPDF] = useState(null)
  const [openPDFModal, setOpenPDFModal] = useState(false)
  const [pdfLoading, setPdfLoading] = useState(true)
  const [useOfficeViewer, setUseOfficeViewer] = useState(true)
  const [openDelete, setOpenDelete] = useState(false)
  const [reOpen, setReopen] = useState(false)
  const [convertRfq, setConvertRfq] = useState(false)
  const [confirmInvoice, setConfirmInvoice] = useState(false)
  const [invoiceReject, setRejectInvoice] = useState(false)
  const [openInvoiceEmailModal, setOpenInvoiceEmailModal] = useState(false)
  const [invoicePdfData, setInvoicePdfData] = useState(null)
  // const [reqAcceptClient,setReqAcceptClient] = useState(false)
  const [reason, setReason] = useState('')
  const [acceptedClients, setAcceptedClients] = useState(null)
  const [updates, setUpdates] = useState(null)
  const [isSaving, setIsSaving] = useState(false)
  const [previewData, setPreviewData] = useState({})
  const [locationStates, setLocationStates] = useState({})
  const [payments, setPayments] = useState(null)
  const [projectTypes, setProjectTypes] = useState([])
  const [projectCategories, setProjectCategories] = useState([])
  const [communities, setCommunities] = useState([])
  const [jobNoteMembers, setJobNoteMembers] = useState(null)
  const [isMember, setIsMember] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [refreshData, setRefreshData] = useState(false)
  const pageRef = useRef()
  const [openWorkflow, setWorkflowOpen] = useState(false)
  const [manual, setManual] = useState(false)
  const [signAgreements, setSignAgreements] = useState(null)
  const [signAgreementsData, setSignAgreementsData] = useState(null)
  const [portfolio, setPortfolio] = useState(null)
  const [customTemplate, setCustomTemplate] = useState(null)
  const [questionnaireTemplate, setQuestionnaireTemplate] = useState(null)
  const [allDataEmpty, setDataEmpty] = useState(true)
  const [proposalData, setProposalData] = useState(null)
  const [teamMembers, setTeamMember] = useState([])
  const [labourCostServices, setLabourCostServices] = useState([])
  const [allEstimators, setAllEstimators] = useState([])
  const [selectedEstimators, setSelectedEstimators] = useState([])
  const [collaborators, setCollaborators] = useState([])
  const [teamMembersOptions, setTeamMembersOptions] = useState([])
  const [teamMembersLoading, setTeamMembersLoading] = useState(false)
  const [salesRepName, setSalesRepName] = useState('')
  const [salesRepId, setSalesRepId] = useState(null)
  const [salesRepOptions, setSalesRepOptions] = useState([])
  const [selectedServices, setSelectedServices] = useState([])
  const [invoiceSelectedServices, setInvoiceSelectedServices] = useState([])
  const [filteredServices, setFilteredServices] = useState([])
  const [requestServices, setRequestServices] = useState([])
  const [loading, setLoading] = useState(false)
  const [budget, setBudget] = useState(0)
  const [totalMarkupPercentage, setTotalMarkupPercentage] = useState(0)
  const [totalMarkupAmount, setTotalMarkupAmount] = useState(0)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [labourInstallService, setLabourInstallService] = useState([])
  const [designersList, setDesignersList] = useState([])
  const [produtFormulaMaterial, setProductFormulaMaterial] = useState([])

  const [additionalSelectedServices, setAdditionalSelectedServices] = useState(
    [],
  )
  console.log('additionalSelectedServices', additionalSelectedServices)
  const [serviceIndexCounter, setServiceIndexCounter] = useState(0)
  const [saveAsDraft, setSaveAsDraft] = useState(0)
  const saveAsDraftRef = useRef(0)
  const rushFeeSyncRefs = useRef(createRushFeeSyncRefs())
  const sessionNewEstimateCatalogIdsRef = useRef([])
  const releaseApprovalConfirmRef = useRef(null)
  localStorage.setItem('requestId', id ? id : null)
  let isClient = user?.isClient
  let userType = isClient ? 3 : user.user_type
  console.log('userTypeisClient', userType)
  let userId = user.user_id

  if (user.added_by_client && user.parent_user_type && user.parent_id) {
    userId = user.parent_id
    userType = 3 //user.parent_user_type
  }


  const getSalesRepOptionsFromCommunity = (community) => {
    // Use ?? so an empty eligible list does not fall back to raw stored IDs.
    const rawNames = community?.all_sales_rep_names ?? community?.sales_rep_names;
    const rawIds = community?.all_sales_rep_ids ?? community?.sales_rep_ids;

    const names = Array.isArray(rawNames)
      ? rawNames
      : typeof rawNames === 'string'
        ? rawNames
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean)
        : [];

    const ids = Array.isArray(rawIds)
      ? rawIds
      : typeof rawIds === 'string'
        ? rawIds
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean)
        : [];

    return names.map((name, idx) => ({
      id: ids[idx] ?? null,
      name,
    }));
  };

  const getCommunitySalesRepIds = (community) => {
    const rawIds = community?.all_sales_rep_ids ?? community?.sales_rep_ids;
    if (!rawIds) {
      return [];
    }

    const ids = Array.isArray(rawIds)
      ? rawIds
      : typeof rawIds === 'string'
        ? rawIds.split(',')
        : [];

    return ids
      .map((id) => String(id ?? '').trim())
      .filter(Boolean);
  };

  const getMaxNegativeAdjustment = (item, hasPermission) => {
    // Quantity and location quantities
    const qty = Number(item.quantity) || 1;
    const locQty = Number(item.locationQuantity) || 1;

    // Product Formula Cost per unit (material + service with markup)
    const formulaEach = getSingleProductFormulaCostEach(item);
    const formulaTotal = formulaEach * qty * locQty;

    // Base retail each BEFORE marketing adjustment
    const retailEachBase = Math.max(
      0,
      Number(
        item.original_actual_retail_price ??
          item.original_retail_price ??
          item.actual_retail_price ??
          item.retail_price ??
          item.product_retail_price ??
          0,
      ),
    );
    const retailTotal = retailEachBase * qty * locQty;

    // Max negative adjustment allowed so that retailTotal - adjustment >= formulaTotal
    // Authorized users can bypass formula cost check but retail value cannot be zero or less
    const maxNegative = hasPermission 
      ? retailEachBase 
      : Math.max(0, retailEachBase - formulaEach);

    console.log('getMaxNegativeAdjustment1-item--', item);
    console.log('getMaxNegativeAdjustment1-formulaEach--', formulaEach);
    console.log('getMaxNegativeAdjustment1-retailEachBase--', retailEachBase);
    console.log('getMaxNegativeAdjustment1-qty--', qty);
    console.log('getMaxNegativeAdjustment1-locQty--', locQty);
    console.log('getMaxNegativeAdjustment1-formulaTotal--', formulaTotal);
    console.log('getMaxNegativeAdjustment1-retailTotal--', retailTotal);
    console.log('getMaxNegativeAdjustment1-maxNegative--', maxNegative);

    return maxNegative;
  };
  const MIN_INSTALL_RETAIL_EACH = 0.01

  const getMaxNegativeInstallAdjustment = (data, hasPermission) => {
    const formula = Number(data?.expected_install_labor_cost_with_markup) || 0
    const retail = Math.max(
      0,
      Number(data?.original_install_cost) || Number(data?.install_cost) || 0,
    )
    if (hasPermission) {
      return Math.max(0, Number((retail - MIN_INSTALL_RETAIL_EACH).toFixed(2)))
    }
    return Math.max(0, Number((retail - formula).toFixed(2)))
  }

  const resolveInstallBaseline = (product) => {
    const baselined = ensureCatalogBaselines(product)
    return Number(baselined.original_install_cost) || Number(baselined.install_cost) || 0
  }

  const computeInstallCostFromAdjustment = (baseInstall, adjustment, isPositiveType) => {
    const adj = Number(adjustment) || 0
    const signed = isPositiveType ? adj : -adj
    return Number((baseInstall + signed).toFixed(2))
  }

  const isInstallRetailPriceAllowed = (installCost, formulaEach, hasPermission) => {
    const minAllowed = hasPermission ? MIN_INSTALL_RETAIL_EACH : formulaEach
    return Number(installCost) >= minAllowed - 0.001
  }

  const getLosingMoneyRowSx = (isLosingMoneyItem) =>
    isLosingMoneyItem
      ? {
          // Exclude product name (4) and note (5); column 11 is Markup (%) and must stay in warning color
          '& .MuiTableCell-root:not(:nth-of-type(4)):not(:nth-of-type(5)), & .MuiTableCell-root:not(:nth-of-type(4)):not(:nth-of-type(5)) .MuiInputBase-input, & .MuiTableCell-root:not(:nth-of-type(4)):not(:nth-of-type(5)) .MuiFormLabel-root':
            {
              color: `${theme.palette.error.main} !important`,
            },
        }
      : undefined

  const getGroupLosingMoneyFlags = (group) => {
    if (!group) {
      return { isGroupProductLosingMoney: false, isGroupInstallLosingMoney: false }
    }
    const groupKey = String(group.id)
    const productMarketing =
      groupProductMarketingValues?.[groupKey] ||
      groupProductMarketingValues?.[group.id] ||
      {}
    const installMarketing =
      groupInstallMarketingValues?.[groupKey] ||
      groupInstallMarketingValues?.[group.id] ||
      {}

    const groupAdjValueType =
      productMarketing.adjValueType ?? group.groupAdjValueType ?? 1
    const groupInstallAdjValueType =
      installMarketing.adjValueType ?? group.groupInstallAdjValueType ?? 1

    const isNegativeGroupProductAdjustmentMode =
      groupAdjValueType === false ||
      groupAdjValueType === 0 ||
      groupAdjValueType === '0' ||
      groupAdjValueType === 'false'
    const isNegativeGroupInstallAdjustmentMode =
      groupInstallAdjValueType === false ||
      groupInstallAdjValueType === 0 ||
      groupInstallAdjValueType === '0' ||
      groupInstallAdjValueType === 'false'

    const productFormulaEach = Number(
      group.baseProductFormulaEach ?? group.totalProductFormulaEach ?? 0,
    )
    const productRetailEach = Number(group.adjustedGroupRetailEach ?? 0)
    const installFormulaEach = Number(
      group.baseInstallFormulaEach ?? group.totalInstallFormulaEach ?? 0,
    )
    const installRetailEach = Number(group.adjustedGroupInstallRetailEach ?? 0)

    return {
      isGroupProductLosingMoney:
        isNegativeGroupProductAdjustmentMode &&
        productRetailEach < productFormulaEach,
      isGroupInstallLosingMoney:
        isNegativeGroupInstallAdjustmentMode &&
        installRetailEach < installFormulaEach,
    }
  }

  const explodedPermissions = user?.exploded_permissions
  const hasMarkupPermission = explodedPermissions?.some((permission) =>
    ['View Markup'].includes(permission),
  )
    ? true
    : false
  const hasDiscountPermission = explodedPermissions?.some((permission) =>
    ['Manage Discount'].includes(permission),
  )
    ? false
    : true
  const [showWarning, setShowWarning] = useState(
    selectedServices.map(() => false),
  )
  const [allLocationSame, setAllLocationSame] = useState(false)
  const [indexCounter, setIndexCounter] = useState(0)
  // const [productRows, setProductRows] = useState([{ indexId: 0, product_name: '', product_desc: '', is_product_row: 1, backendId: null }]);
  const [productRows, setProductRows] = useState([]);
  const [serviceRows, setServiceRows] = useState([{ indexId: 0, product_name: '', product_desc: '', is_product_row: 1, backendId: null }]);
  const [productRowsIndexCounter, setProductRowsIndexCounter] = useState(0);
  const [serviceRowsIndexCounter, setServiceRowsIndexCounter] = useState(0);
  const [autoSavingField, setAutoSavingField] = useState(null); // Track which field is being auto-saved: { indexId, field: 'name' | 'desc' }
  const originalValuesRef = useRef({}); // Track original values when field is focused
  const productInputValueRef = useRef('') // Track product autocomplete input value for production builds
  const catalogProductsRef = useRef([])
  const debounceTimerRef = useRef(null); // Debounce timer for auto-save after typing
  const autoSavingFieldRef = useRef(null); // Synchronous ref for checking if currently saving
  const editClientSyncedRef = useRef(null)
  let productFormulaCost = 0
  const [totalLabourCost, setTotalLabourCost] = useState(0)
  const [totalProductLabourCost, setTotalProductLabourCost] = useState(0)
  const [rfps, setRfps] = useState([]) // List of RFPs
  const [selectedRfp, setSelectedRfp] = useState(null) // Selected RFP
  const [openModal, setOpenModal] = useState(false)
  const [tabIndex, setTabIndex] = useState(0)
  const [rfpServices, setRfpServices] = useState([])
  const [rfpProducts, setRfpProducts] = useState([])
  const [cart, setCart] = useState([])
  console.log('cartcart', cart)
  const [cartService, setCartService] = useState([])
  const [rfpServicesEdit, setRfpServicesEdit] = useState([])
  const [rfpLocationStates, setRfpLocationStates] = useState({})
  const [selectedMaterials, setSelectedMaterials] = useState([])
  const [materials, setAllMaterials] = useState([])
  const [openProductNote, setOpenProductNote] = useState({})
  const [groupNoteTargets, setGroupNoteTargets] = useState({})
  const [openGroupProductNoteIndex, setOpenGroupProductNoteIndex] = useState(null)
  const [openServiceNote, setOpenServiceNote] = useState({})
  const [isSavingNote, setIsSavingNote] = useState(false)
  const [isClearingNote, setIsClearingNote] = useState(false)
  const [currentNote, setCurrentNote] = useState('')
  const [openMaterialNote, setOpenMaterialNote] = useState({});
  const [error, setError] = useState(false);
  const [taxAmount, setTaxAmount] = useState(0)
  const [taxRateData, setTaxRateData] = useState([])
  const [grandTotal, setGrandTotal] = useState(0)
  const [selectedTaxCategory, setSelectedTaxCategory] = useState(null)
  const [taxCategories, setTaxCategories] = useState([])
  const [data, setData] = useState({})
  const [isCommunityLoading, setIsCommunityLoading] = useState(false)
  const [mapServices, setMapServices] = useState([])
  const prevRushFeeAutoLockedRef = useRef(false)
  const [mapServicesLoading, setMapServicesLoading] = useState(false)
  const [selectedMapserviceProducts, setSelectedMapserviceProducts] = useState(
    [],
  )
  const [rfpServiceLocationStates, setRfpServiceLocationStates] = useState({})
  const [allRfpServiceLocationSame, setAllRfpServiceLocationSame] =
    useState(true)
  const [allRfpProductsLocationSame, setAllRfpProductsLocationSame] =
    useState(true)
  const [singleLocationCard, setSingleLocationCard] = useState(false)
  const [pendingAutocompleteMaterials, setPendingAutocompleteMaterials] =
    useState([])
  const [openDialog, setOpenDialog] = useState(false)
  const [pendingProject, setPendingProject] = useState(null)
  const [stockType, setStockType] = useState(1)
  const [pendingMaterial, setPendingMaterial] = useState(null)
  const [partialProducts, setPartialProducts] = useState([])
  const [convertionUnit, setConvertionUnit] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [totalProductInstallCost, setTotalProductInstallCost] = useState(0)
  const [installCosts, setInstallCost] = useState(0)
  const [incomingSplitMarkup, setIncomingSplitMarkup] = useState(0)
  const [splitPercentage, setSplitPerscentage] = useState(0)
  const [splitManagementSettings, setSplitManagementSettings] = useState([])
  const [isSplitOrder, setIsSplitOrder] = useState(false)
  const [openCatalogModal, setOpenCatalogModal] = useState(false)
  const [openChooseProductDialog, setOpenChooseProductDialog] = useState(false)
  const [chooseProductDialogRow, setChooseProductDialogRow] = useState(null)
  const [chooseProductDialogValue, setChooseProductDialogValue] = useState(null)
  const [openChooseServiceDialog, setOpenChooseServiceDialog] = useState(false)
  const [chooseServiceDialogRow, setChooseServiceDialogRow] = useState(null)
  const [chooseServiceDialogValue, setChooseServiceDialogValue] = useState(null)
  const [openServiceModal, setOpenServiceModal] = useState(false)
  const [serviceNameForAdd, setServiceNameForAdd] = useState(false)
  const [serviceDescForAdd, setServiceDescForAdd] = useState(false)
  const [selectedProductForCatalog, setSelectedProductForCatalog] = useState(null)
  const [selectedServiceForCatalog, setSelectedServiceForCatalog] = useState(null)
  const [changeCatalog, setChangeCatalog] = useState(false)
  const [openEditCatalogModal, setOpenEditCatalogModal] = useState(false)
  const [openProductCatalogChoiceModal, setOpenProductCatalogChoiceModal] =
    useState(false)
  const [productRowForCatalogChoice, setProductRowForCatalogChoice] =
    useState(null)
  const [openServiceCatalogChoiceModal, setOpenServiceCatalogChoiceModal] =
    useState(false)
  const [serviceRowForCatalogChoice, setServiceRowForCatalogChoice] =
    useState(null)
  const [openEditServiceModal, setOpenEditServiceModal] = useState(false)
  const [loadingProducts, setLoadingProducts] = useState(false)
  const [loadingServices, setLoadingServices] = useState(false)
  const [selectedSplitOrderSettings, setSelectedSplitOrderSettings] = useState([])
  const [refreshCalculation,setRefreshCalculation] = useState(false)
  const handleOpenProductFormula = async (id) => {
    setSelectedProductFormulaId(id)
    setOpenProductFormulaModal(true)
  }

  const handleMaterialStockCheck = async (material) => {
    setPendingMaterial(material)
    setStockType(1) // default to Finished
    setConvertionUnit(0)
    setPartialProducts([])

    // if (material.inhouse !== 1) {
    //   enqueueSnackbar('Only inhouse materials can be stocked', { variant: 'warning' });
    //   return;
    // }

    try {
      const res = await axios.post(
        `${REST_API_END_POINT}product/get-partial-finished-products-stock-by-unit`,
        { editId: material?.id },
      )
      const productListData = res.data.results

      // Check if partial already selected for this material
      const alreadyPartialSelected = selectedMaterials.some(
        (item) =>
          item.product_id === material.product_id && item.stock_type === 2,
      )

      if (alreadyPartialSelected) {
        // Only allow finished, as partial already exists
        setPartialProducts([])
        setStockType(1) // Force finished
        enqueueSnackbar(
          'Partial stock already selected. Only Finished stock available.',
          { variant: 'info' },
        )
      } else {
        setPartialProducts(productListData || [])
      }
    } catch (err) {
      console.error(err)
      setPartialProducts([])
    } finally {
      openDialogs() // open the stock type dialog
    }
  }

  const handleSubmitPopUp = () => {
    if (!pendingMaterial) return

    if (stockType === 2 && !convertionUnit) {
      enqueueSnackbar('Please choose a conversion unit', { variant: 'error' })
      return
    }

    const normalizedId = pendingMaterial.product_id || pendingMaterial.id

    // Check if the same partial stock for this material already exists
    const alreadyHasPartial = selectedMaterials.some(
      (item) => item.product_id === normalizedId && item.stock_type === 2,
    )

    if (stockType === 2 && alreadyHasPartial) {
      enqueueSnackbar('Partial stock type for this product already added', {
        variant: 'error',
      })
      return
    }

    // Prevent exact duplicates
    const alreadyAdded = selectedMaterials.some(
      (item) =>
        item.product_id === normalizedId &&
        item.stock_type === stockType &&
        (stockType === 1 || item.convertion_unit === convertionUnit),
    )

    if (alreadyAdded) {
      enqueueSnackbar('Material Already Added', { variant: 'error' })
      return
    }

    let initial_max_price = 0
    let unit = 4

    if (stockType === 1) {
      initial_max_price =
        pendingMaterial.max_price || pendingMaterial.special_price
      unit = pendingMaterial.unit || 4
    } else {
      const selectedUnitData = partialProducts.find(
        (p) => p.partial_unit === convertionUnit,
      )
      if (!selectedUnitData || selectedUnitData.total_qty <= 0) {
        enqueueSnackbar('No Partial Stock Available', { variant: 'error' })
        return
      }
      initial_max_price = selectedUnitData.max_unit_cost || 0
      unit = selectedUnitData.partial_unit || 4
    }

    const maxIndexId = Math.max(
      0,
      ...selectedMaterials.map((item) => item.newIndexId || 0),
    )

    const newMaterial = {
      ...pendingMaterial,
      product_id: normalizedId,
      quantity: 1,
      price: initial_max_price,
      unit,
      stock_type: stockType,
      convertion_unit: convertionUnit || 0,
      initial_max_price,
      newIndexId: maxIndexId + 1,
    }

    const updatedMaterials = [...selectedMaterials, newMaterial]

    setPendingAutocompleteMaterials(updatedMaterials)
    setFieldValue('additionalMaterials', updatedMaterials)
    handleMaterial(updatedMaterials)
    setSelectedMaterials(updatedMaterials)

    setPendingMaterial(null)
    setPartialProducts([])
    setStockType(1)
    setConvertionUnit(0)
    closeDialog()
  }
  const closeDialog = () => {
    setOpenDialog(false)
  }
  const openDialogs = () => {
    setOpenDialog(true)
  }

  const accessPublicMessageBoard = explodedPermissions?.some((permission) =>
    ['Access Estimate Client Message Board'].includes(permission),
  )

  const fetchDetails = async () => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}settings/get-companyProfile-details`,
      )
      if (res.data.status === 1) {
        setData(...res.data.data)
      }
    } catch (error) {
      console.log('get-companyProfile-details error : ', error)
    }
  }

  useEffect(() => {
    fetchDetails()
    // fetchProducts()
  }, [])

  // Clear popup-related localStorage when component mounts or URL changes
  useEffect(() => {
    // Clear popup state from localStorage to prevent popups from persisting
    localStorage.removeItem('estimateProjectId')
    localStorage.removeItem('estimateProjectName')
    localStorage.removeItem('isEditEstimate')
    localStorage.removeItem('estimateOpenProductionPopup')
    localStorage.removeItem('openProductionPopup')
  }, [id]) // Clear when ID changes (URL change)

  useEffect(() => {
    if (Array.isArray(jobNoteMembers) && user?.user_id) {
      const found = jobNoteMembers?.some(
        (member) => member.user_id === user.user_id,
      )
      console.log('jobNoteMembers:', jobNoteMembers)
      console.log('user.user_id:', user.user_id)
      console.log('isMember found:', found)
      setIsMember(found)
    }
  }, [jobNoteMembers, user?.user_id])

  const getGroupMemberIndexIdsByAnchor = (anchorIndexId) => {
    const anchor = (selectedProducts || []).find(
      (p) => Number(p?.indexId) === Number(anchorIndexId),
    )
    if (!anchor?.group_id) return [anchorIndexId]
    return (selectedProducts || [])
      .filter((p) => String(p?.group_id) === String(anchor.group_id))
      .map((p) => p?.indexId)
      .filter((id) => id != null)
  }

  const handleOpenNote = (indexId, note) => {
    setCurrentNote(note || '')
    setOpenProductNote((prev) => ({ ...prev, [indexId]: true }))
  }

  const getProductLineNote = (product) =>
    product?.product_notes ?? product?.note ?? ''

  const handleOpenGroupNote = (indexId, note) => {
    const key = String(indexId)
    setCurrentNote(note || '')
    setGroupNoteTargets((prev) => ({
      ...prev,
      [key]: getGroupMemberIndexIdsByAnchor(indexId),
    }))
    setOpenGroupProductNoteIndex(indexId)
  }

  const handleCloseNote = (indexId) => {
    setOpenProductNote((prev) => ({ ...prev, [indexId]: false }))
    setCurrentNote('')
  }

  const handleNoteChange = (event) => {
    if (isPreview) return
    const newNote = event.target.value
    if (newNote.length <= MAX_CHARACTERS) {
      setCurrentNote(newNote)
    }
  }

  const handleSaveNote = (indexId) => {
    setIsSavingNote(true)
    setTimeout(() => {
      const targetIds = groupNoteTargets[String(indexId)] || [indexId]
      setSelectedProducts((prev) =>
        prev.map((product) =>
          targetIds.some(
            (targetId) => String(targetId) === String(product.indexId),
          )
            ? { ...product, product_notes: currentNote }
            : product,
        ),
      )
      setIsSavingNote(false)
      handleCloseNote(indexId)
      setOpenGroupProductNoteIndex(null)
    }, 100)
  }

  // Clear product note and save empty value
  const handleClearNote = (indexId) => {
    setIsClearingNote(true)
    setTimeout(() => {
      const targetIds = groupNoteTargets[String(indexId)] || [indexId]
      setSelectedProducts((prev) =>
        prev.map((product) =>
          targetIds.some(
            (targetId) => String(targetId) === String(product.indexId),
          )
            ? { ...product, product_notes: '' }
            : product,
        ),
      )
      setCurrentNote('')
      setIsClearingNote(false)
      setOpenGroupProductNoteIndex(null)
    }, 100)
  }

  // Service notes handlers
  const handleOpenServiceNote = (indexId, note) => {
    setCurrentNote(note || '')
    setOpenServiceNote((prev) => ({ ...prev, [indexId]: true }))
  }

  const handleCloseServiceNote = (indexId) => {
    setOpenServiceNote((prev) => ({ ...prev, [indexId]: false }))
    setCurrentNote('')
  }

  const handleServiceNoteChange = (event) => {
    if (isPreview) return
    const newNote = event.target.value
    if (newNote.length <= MAX_CHARACTERS) {
      setCurrentNote(newNote)
    }
  }


  const handleSaveServiceNote = (indexId) => {
    setIsSavingNote(true)
    setTimeout(() => {
      // Update selectedServices
      setSelectedServices((prev) =>
        prev.map((service) =>
          serviceLineMatches(service, indexId)
            ? { ...service, service_notes: currentNote }
            : service,
        ),
      )
      // Update additionalSelectedServices
      setAdditionalSelectedServices((prev) =>
        prev.map((service) =>
          serviceLineMatches(service, indexId)
            ? { ...service, service_notes: currentNote }
            : service,
        ),
      )
      // Update cartService
      setCartService((prev) =>
        prev.map((service) =>
          serviceLineMatches(service, indexId)
            ? { ...service, service_notes: currentNote }
            : service,
        ),
      )
      setIsSavingNote(false)
      handleCloseServiceNote(indexId)
    }, 100)
  }
// Material notes handlers
const handleOpenMaterialNote = (indexId, note) => {
  setCurrentNote(note || '');
  setOpenMaterialNote((prev) => ({ ...prev, [indexId]: true }));
};
const handleCloseMaterialNote = (indexId) => {
  setOpenMaterialNote((prev) => ({ ...prev, [indexId]: false }));
  setCurrentNote('');
};
const handleSaveMaterialNote = (indexId) => {
  if (!currentNote.trim()) {
    setError('Note cannot be empty or just spaces');
    return; 
  }
  setIsSavingNote(true);
  setTimeout(() => {
    setSelectedMaterials((prev) =>
      prev.map((material) =>
        material.newIndexId === indexId ? { ...material, material_notes: currentNote } : material
      )
    );
    setIsSavingNote(false);
    handleCloseMaterialNote(indexId);
  }, 100);
};

  // Clear material note and save empty value
  const handleClearMaterialNote = (indexId) => {
    setError(false);
    setIsClearingNote(true);
    setTimeout(() => {
      setSelectedMaterials((prev) =>
        prev.map((material) =>
          material.newIndexId === indexId ? { ...material, material_notes: '' } : material
        )
      );
      setCurrentNote('');
      setIsClearingNote(false);
    }, 100);
  };
  const handleRfpSelect = (event, value) => {
    setSelectedRfp(value)
    setRfpServices(
      value?.services?.filter((service) => !isInCartService(service)) || [],
    )
    setRfpProducts(
      value?.products?.filter((product) => !isInCart(product)) || [],
    )
    if (!empty(value)) {
      setOpenModal(true)
    }
  }

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue)
  }
  const handleSendClientReq = async () => {
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}quotation/send-to-client`,
        { request_id: details.id, client: details?.customer_id },
      )
      if (response.data.status === 1) {
        enqueueSnackbar('Success', { variant: 'success' })
        setRefresh(true)
      } else {
        enqueueSnackbar('Failed', { variant: 'error' })
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  // const addToCart = (item) => {
  //   // Extract project location from Formik's values
  //   const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
  //   const communityAddress = {
  //     id: 0,
  //     address: projAddress,
  //     city: projCity,
  //     state: projState,
  //     zip: projZip,
  //   };

  //   if (tabIndex === 0) {
  //     // Handle RFP services
  //     const serviceWithLocation = {
  //       ...item,
  //       location: [communityAddress], // Assign project location to the service
  //     };

  //     setCartService((prevServices) => [...prevServices, serviceWithLocation]);
  //   } else {
  //     // Handle RFP products
  //     let location = [
  //       {
  //         id: 0,
  //         address: '',
  //         city: '',
  //         state: '',
  //         zip: '',
  //       },
  //     ];

  //     // Use project location if available
  //     if (projAddress && projCity && projState && projZip) {
  //       location = [communityAddress];
  //     }

  //     const productWithLocation = {
  //       ...item,
  //       location,
  //     };

  //     setCart((prevProducts) => [...prevProducts, productWithLocation]);
  //   }

  //   // Close modal and reset RFP selection
  //   setOpenModal(false);
  //   setSelectedRfp(null);
  //   setFieldValue('rfp', null);
  // };

  const addToCart = (item) => {
    // Extract project/community address
    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = '',
    } = values?.community || {}
    const communityAddress = {
      address: projAddress,
      city: projCity,
      state: projState,
      zip: projZip,
    }

    const locationQuantity = item.location_quantity || 1 // Ensure a default value of 1

    if (tabIndex === 1) {
      // ✅ Adding to RFP Services
      const newService = assignDefaultLocation(
        cartService,
        item,
        allRfpServiceLocationSame,
        communityAddress,
        locationQuantity,
      )
      setCartService([...cartService, newService])

      if (allRfpServiceLocationSame) {
        setCartService((prevServices) =>
          prevServices.map((service) => ({
            ...service,
            location: Array.from({ length: locationQuantity }, () => ({
              ...communityAddress,
            })),
          })),
        )
      }
    } else {
      // ✅ Adding to RFP Products
      const newProduct = assignDefaultLocation(
        cart,
        item,
        item.allRfpProductsLocationSame,
        communityAddress,
        locationQuantity,
      )
      setCart([...cart, newProduct])

      if (item.allRfpProductsLocationSame) {
        setCart((prevProducts) =>
          prevProducts.map((product) => ({
            ...product,
            location: Array.from({ length: locationQuantity }, () => ({
              ...communityAddress,
            })),
          })),
        )
      }
    }

    // ✅ Close modal and reset form fields
    setOpenModal(false)
    setSelectedRfp(null)
    setFieldValue('rfp', null)
  }

  const assignDefaultLocation = (
    existingItems,
    newItem,
    allLocationsSame,
    communityAddress,
  ) => {
    let assignedLocation = []

    if (allLocationsSame && existingItems.length > 0) {
      // Use the first item's location as the common location
      const commonLocation = existingItems[0]?.location?.[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
      }
      assignedLocation = [{ ...commonLocation }]
    } else if (
      communityAddress.address &&
      communityAddress.city &&
      communityAddress.state &&
      communityAddress.zip
    ) {
      // Use the community address as the default location
      assignedLocation = [
        {
          id: 0,
          address: communityAddress.address,
          city: communityAddress.city,
          state: communityAddress.state,
          zip: communityAddress.zip,
        },
      ]
    } else {
      // Default to an empty location
      assignedLocation = [
        {
          id: 0,
          address: '',
          city: '',
          state: '',
          zip: '',
        },
      ]
    }

    return {
      ...newItem,
      location: assignedLocation,
    }
  }

  console.log('######################Cart', cart)
  console.log('######################Cart Service', cartService)
  const isInCart = (item) => {
    return cart.some((cartItem) => cartItem.product_id === item.product_id)
  }
  const isInCartService = (item) => {
    return cartService.some(
      (cartItem) =>
        cartItem.labour_cost_service_id === item.labour_cost_service_id,
    )
  }
  const closeModal = () => {
    setOpenModal(false)
    setFieldValue('rfp', null)
  }
  const handleDeleteRFPProduct = (productId) => {
    setCart((prevCart) =>
      prevCart.filter((item) => item.product_id !== productId),
    )
  }
  const handleDeleteRFPService = (productId) => {
    console.log('######################Cartde', productId)
    setCartService((prevCart) =>
      prevCart.filter((item) => item.labour_cost_service_id !== productId),
    )
  }

  const handleMaterial = (newValue) => {
    setSelectedMaterials((prevMaterials) => {
      const additionals = prevMaterials?.filter(
        (item) => item.isAdditionalProduct == true,
      )
      const baseIndex = prevMaterials?.length || 0
      const updatedNewValue = newValue.map((item, idx) => ({
        ...item,
        newIndexId: baseIndex + 1,
        quantity: item.quantity ?? 1,
      }))
      return [...updatedNewValue, ...additionals]
    })
  }

  const getProductEntryMode = (row) => {
    if (row?.entryMode) return row.entryMode
    return row?.is_product_row == 1 || row?.isAdditionalProduct ? 'write' : 'choose'
  }

  const isRequestEstimateLockedProductToggle = (row) =>
    userType != 1 &&
    userType != 12 &&
    !(
      userType == 18 &&
      (row?.addedByUserType ?? row?.added_by_user_type) == 18
    )&&
    details?.is_request_estimate == 1 &&
    !row?.isNewlyAddedProductRow


  const getProductToggleDisplayMode = (row) => {
    if (Number(row?.product_write) === 1) return 'write'
    if (row?.entryMode === 'write' || row?.entryMode === 'choose') return row.entryMode
    if (row?.is_product_row == 1 || row?.isAdditionalProduct) return 'write'
    return 'choose'
  }

  const isRequestEstimateLockedServiceToggle = (row) =>
    userType != 1 &&
    userType != 12 &&
    !(
      userType == 18 &&
      (row?.addedByUserType ?? row?.added_by_user_type) == 18
    )&&
    details?.is_request_estimate == 1 &&
    !row?.isNewlyAddedServiceRow

  const getServiceToggleDisplayMode = (row) => {
    if (Number(row?.service_write) === 1) return 'write'
    if (row?.entryMode === 'write' || row?.entryMode === 'choose') return row.entryMode
    if (row?.is_service_row == 1 || row?.isAdditionalProduct) return 'write'
    return 'choose'
  }

  const isBlankEstimateWriteRow = (row) => {
    if (getProductEntryMode(row) !== 'write') return false
    const hasName = Boolean((row.name || row.product_name || '').trim())
    const hasDesc = Boolean((row.product_desc || '').trim())
    const hasBackend = Boolean(row.backendId || row.id)
    return !hasName && !hasDesc && !hasBackend
  }

  const hasEmptyRequiredWriteProductName = (products) =>
    (products || []).some((row) => {
      if (getProductEntryMode(row) !== 'write') return false
      if (isBlankEstimateWriteRow(row)) return false
      return !(row.name || row.product_name || '').trim()
    })

  const writeProductRowHasEstimateCatalog = (row, products) => {
    if (Number(row?.is_line_catalog) === 1) return true
    const gid = row?.group_id
    if (!gid) return false
    return (products || []).some(
      (p) =>
        p?.group_id &&
        String(p.group_id) === String(gid) &&
        p.indexId !== row.indexId &&
        (Number(p?.is_line_catalog) === 1 || Boolean(p?.id || p?.product_id)),
    )
  }

  const hasWriteProductRowMissingEstimateCatalog = (products) =>
    (products || []).some((row) => {
      if (getProductEntryMode(row) !== 'write') return false
      if (isBlankEstimateWriteRow(row)) return false
      if (!(row.name || row.product_name || '').trim()) return false
      return !writeProductRowHasEstimateCatalog(row, products)
    })

  const isEstimateJobWriteService = (row) =>
    row?.is_service_row == 1 ||
    row?.is_service_row === '1' ||
    row?.is_service_row === true ||
    row?.entryMode === 'write' ||
    (row?.isAdditionalProduct && row?.entryMode !== 'choose')

  /** Write row with a catalog service picked (Add Service / choose dialog). */
  const estimateJobServiceRowHasAddedCatalog = (row) => {
    if (Number(row?.is_line_catalog) === 1) return true
    const labourId = row?.labour_cost_service_id ?? row?.productId
    if (labourId == null || Number(labourId) <= 0) return false
    return (
      row?.entryMode === 'choose' ||
      row?.is_service_row == 1 ||
      row?.is_service_row === '1' ||
      row?.entryMode === 'write'
    )
  }

  const resolveSubmitIsServiceRow = (service, isReqEst) => {
    if (!isReqEst) return 0
    if (estimateJobServiceRowHasAddedCatalog(service)) return 0
    const isWrite =
      getServiceEntryMode(service) === 'write' || service?.is_service_row == 1
    return isWrite ? 1 : 0
  }

  const getServiceEntryMode = (row) => {
    // BACKUP: is_line_catalog first — Add Existing on a write row flipped mode to Choose.
    // if (Number(row?.is_line_catalog) === 1) return 'choose'
    if (row?.entryMode === 'write' || row?.entryMode === 'choose') return row.entryMode
    if (Number(row?.is_line_catalog) === 1) return 'choose'
    if (estimateJobServiceRowHasAddedCatalog(row)) return 'choose'
    if (isEstimateJobWriteService(row)) return 'write'
    if (row?.isAdditionalProduct) return 'write'
    if (row?.labour_cost_service_id || row?.id) return 'choose'
    // if (estimateJobServiceRowHasAddedCatalog(row)) return 'choose'
    // // Legacy write rows from backend — keep until migrated:
    // if (row?.entryMode === 'write' || isEstimateJobWriteService(row)) return 'write'
    return 'choose'
    // Previous Write/Choose resolution (may restore later):
    // if (row?.entryMode === 'write' || row?.entryMode === 'choose') return row.entryMode
    // if (estimateJobServiceRowHasAddedCatalog(row)) return 'choose'
    // if (isEstimateJobWriteService(row)) return 'write'
    // if (row?.isAdditionalProduct) return 'write'
    // if (row?.labour_cost_service_id || row?.id) return 'choose'
    // return 'choose'
  }

  const getNormalCatalogTypeOptions = () =>
    splitOrderCatalogTypes
      .filter((type) => type.id !== 'split_catalog')
      .concat([
        {
          id: 'sub_contract',
          label: 'Sub Contract',
          inhouse: 0,
          isTrafficCatalog: false,
        },
      ])
      .sort((a, b) => {
        if (a.id === 'all') return -1
        if (b.id === 'all') return 1
        return a.label.localeCompare(b.label)
      })

  const openChooseProductDialogForRow = (row) => {
    setChooseProductDialogRow(row)
    const rowProductId = row?.id ?? row?.product_id
    if (rowProductId != null) {
      const matched = (filteredProductOptions || []).find((opt) => {
        const optId = opt?.id ?? opt?.product_id
        return Number(optId) === Number(rowProductId)
      })
      setChooseProductDialogValue(matched || null)
    } else {
      setChooseProductDialogValue(null)
    }
    setOpenChooseProductDialog(true)
  }

  const handleConfirmChooseProductDialog = () => {
    if (!chooseProductDialogValue || !chooseProductDialogRow?.indexId) {
      enqueueSnackbar('Please select a product', { variant: 'warning' })
      return
    }
    const targetIndexId = chooseProductDialogRow.indexId
    const nextSelection = stripGroupFieldsFromCatalogOption({
      ...chooseProductDialogValue,
      isaddedFromJob: 1,
    })
    handleProduct([nextSelection], targetIndexId, true)
    setOpenChooseProductDialog(false)
    setChooseProductDialogRow(null)
    setChooseProductDialogValue(null)
  }

  const chooseServiceDialogOptions = useMemo(
    () =>
      (filteredServices || []).filter(
        (item) =>
          item.service_type != 44 &&
          item.is_service_row !== 1 &&
          item.status === 1 &&
          Number(item.inhouse) !== 1,
      ),
    [filteredServices],
  )

  const openChooseServiceDialogForRow = (row) => {
    setChooseServiceDialogRow(row)
    const serviceId = row?.id ?? row?.labour_cost_service_id
    if (serviceId != null) {
      const matched = chooseServiceDialogOptions.find(
        (opt) => Number(opt.id) === Number(serviceId),
      )
      setChooseServiceDialogValue(matched || null)
    } else {
      setChooseServiceDialogValue(null)
    }
    setOpenChooseServiceDialog(true)
  }

  const handleConfirmChooseServiceDialog = () => {
    if (!chooseServiceDialogValue || !chooseServiceDialogRow) {
      enqueueSnackbar('Please select a service', { variant: 'warning' })
      return
    }
    const row = chooseServiceDialogRow
    const catalog = chooseServiceDialogValue
    const rowAttachmentKey = String(row.newIndexId ?? row.indexId ?? '')

    setAdditionalSelectedServices((prev) => {
      const prevList = Array.isArray(prev) ? prev : []
      const existingIndex = prevList.findIndex((p) => {
        if (row.newIndexId != null && p?.newIndexId != null) {
          return Number(p.newIndexId) === Number(row.newIndexId)
        }
        const selIdx = row.product_index ?? row.indexId
        const rowIdx = p?.product_index ?? p?.indexId
        if (selIdx != null && rowIdx != null) {
          return Number(rowIdx) === Number(selIdx)
        }
        return false
      })
      if (existingIndex < 0) {
        return prevList
      }
      const prevRow = prevList[existingIndex]
      if (prevRow?.id && prevRow.id !== catalog.id) {
        setServiceAttachments((prevAttachments) => {
          const next = { ...prevAttachments }
          delete next[rowAttachmentKey]
          return next
        })
      }
      const next = [...prevList]
      next[existingIndex] = {
        ...prevRow,
        ...catalog,
        labour_cost_service_id: catalog.id,
        id: catalog.id,
        is_service_row: 0,
        is_line_catalog: 1,
        isAdditionalProduct: false,
        isaddedFromJob: prevRow.backendId
          ? Number(prevRow.isaddedFromJob) === 1
            ? 1
            : 0
          : 1,
        qty: prevRow.quantity ?? catalog.quantity ?? 1,
        quantity: prevRow.quantity ?? catalog.quantity ?? 1,
        service_name: catalog.name || catalog.service_name,
        name: catalog.name || catalog.service_name,
        service_desc: catalog.description || prevRow.service_desc || '',
        description: catalog.description || prevRow.description || '',
      }
      setFieldValue('services', next)
      return next
    })

    setOpenChooseServiceDialog(false)
    setChooseServiceDialogRow(null)
    setChooseServiceDialogValue(null)
  }

  const clearProductRowAttachments = (rowIndexId) => {
    const key = String(rowIndexId)
    setProductAttachments((prev) => {
      const next = { ...prev }
      delete next[rowIndexId]
      delete next[key]
      return next
    })
    setOpenProductAttachment((prev) => {
      const next = { ...prev }
      delete next[rowIndexId]
      delete next[key]
      return next
    })
  }

  const handleProductRowEntryModeChange = (indexId, mode) => {
    const targetRow = (selectedProducts || []).find(
      (row) => Number(row?.indexId) === Number(indexId),
    )
  
    if (targetRow && getProductToggleDisplayMode(targetRow) === mode) return
  
    if (mode !== 'write' && mode !== 'choose') return
  
    clearProductRowAttachments(indexId)
  
    const isReqEst = details?.is_request_estimate == 1
  
    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = '',
    } = values?.community || {}
  
    const defaultLocation = [
      {
        id: 0,
        address: projAddress,
        city: projCity,
        state: projState,
        zip: projZip,
      },
    ]
  
    setSelectedProducts((prev) =>
      (prev || []).map((row) => {
        if (Number(row?.indexId) !== Number(indexId)) return row
  
        const commonResetData = {
          indexId: row.indexId,
          backendId: row.backendId ?? null,
  
          product_name: '',
          product_desc: '',
          name: '',
          description: '',
          is_line_catalog: 0,
          is_existing_catalog: 0,
          id: null,
          product_id: null,
  
          productAttachments: [],
          quantity: 1,
          locationQuantity: 1,
          allLocationSame: true,
          is_single_card: values.project_category?.id !== 14,
          location: defaultLocation,
  
          isNewlyAddedProductRow: row?.isNewlyAddedProductRow,
          isaddedFromJob:
            row?.isaddedFromJob ?? (row?.isNewlyAddedProductRow ? 1 : 0),
          addedByUserType: row?.addedByUserType ?? userType,

          group_id: row.group_id ?? null,
          group_name: row.group_name ?? null,
          group_description: row.group_description ?? null,
          group_catalog_anchor_index_id:
            row.group_catalog_anchor_index_id ?? null,
        }
  
        if (mode === 'write') {
          return {
            ...commonResetData,
            entryMode: 'write',
            is_product_row: isReqEst ? 1 : 0,
            isAdditionalProduct: !isReqEst,
            product_write: isReqEst ? 1 : row?.product_write ?? 0,
          }
        }
  
        return {
          ...commonResetData,
          entryMode: 'choose',
          is_product_row: 0,
          isAdditionalProduct: false,
          product_write: 0,
          isaddedFromJob: row?.isNewlyAddedProductRow || !row?.backendId ? 1 : 0,
        }
      }),
    )
  }

  const handleServiceRowEntryModeChange = (indexId, mode) => {
    const targetRow = (additionalSelectedServices || []).find((row) => {
      const rowId = row?.newIndexId ?? row?.indexId ?? row?.product_index
      return Number(rowId) === Number(indexId)
    })
    if (targetRow && getServiceToggleDisplayMode(targetRow) === mode) return

    const rowAttachmentKey = String(indexId)
    setServiceAttachments((prev) => {
      const next = { ...prev }
      delete next[rowAttachmentKey]
      return next
    })

    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = '',
    } = values?.community || {}
    const isReqEst = details?.is_request_estimate == 1

    setAdditionalSelectedServices((prev) => {
      const next = (prev || []).map((row) => {
        const rowId = row?.newIndexId ?? row?.indexId ?? row?.product_index
        if (Number(rowId) !== Number(indexId)) return row

        const preservedIds = {
          newIndexId: row.newIndexId ?? indexId,
          indexId: row.indexId ?? indexId,
          product_index: row.product_index ?? indexId,
          backendId: row.backendId ?? null,
        }
        const defaultAddresses = row.addresses || [
          {
            id: 0,
            address: projAddress,
            city: projCity,
            state: projState,
            zip: projZip,
          },
        ]

        if (mode === 'write') {
          return {
            ...preservedIds,
            entryMode: 'write',
            service_name: '',
            service_desc: '',
            name: '',
            description: '',
            id: null,
            labour_cost_service_id: null,
            productId: null,
            is_service_row: isReqEst ? 1 : 0,
            is_line_catalog: 0,
            isAdditionalProduct: !isReqEst,
            service_write: isReqEst ? 1 : (row?.service_write ?? 0),
            isNewlyAddedServiceRow: row?.isNewlyAddedServiceRow,
            isaddedFromJob: row?.isaddedFromJob ?? (row?.isNewlyAddedServiceRow ? 1 : 0),
            addedByUserType: row?.addedByUserType ?? userType,
            quantity: 1,
            qty: 1,
            cost: 0,
            unit_cost: 0,
            total_cost: 0,
            product_total: 0,
            markup: 0,
            originalMarkup: 0,
            service_type: null,
            allLocationSame: true,
            service_notes: '',
            addresses: defaultAddresses,
            facility_id: currentFacilityId,
          }
        }
        return {
          ...preservedIds,
          entryMode: 'choose',
          service_name: '',
          service_desc: '',
          name: '',
          description: '',
          id: null,
          labour_cost_service_id: null,
          productId: null,
          is_service_row: 0,
          is_line_catalog: 0,
          isAdditionalProduct: false,
          service_write: 0,
          isNewlyAddedServiceRow: row?.isNewlyAddedServiceRow,
          isaddedFromJob: row?.isNewlyAddedServiceRow || !row?.backendId ? 1 : 0,
          addedByUserType: row?.addedByUserType ?? userType,
          quantity: 1,
          qty: 1,
          cost: 0,
          unit_cost: 0,
          total_cost: 0,
          product_total: 0,
          markup: 0,
          originalMarkup: 0,
          service_type: null,
          allLocationSame: true,
          service_notes: '',
          addresses: defaultAddresses,
          facility_id: currentFacilityId,
        }
      })
      setFieldValue('services', next)
      return next
    })
  }

  const handleDeleteMaterial = (id, indexId) => {
    const updatedMaterials = selectedMaterials?.filter((data) => {
      if (data?.isAdditionalProduct) {
        return data?.newIndexId !== indexId
      }
      return data?.id !== id
    })

    setSelectedMaterials(updatedMaterials)
  }

  // Product rows handlers for request_estimate
  const addNewRequestEstimateProductRow = () => {
    const nextIndex = Math.max(
      0,
      ...((selectedProducts || []).map((row) => Number(row?.indexId) || 0)),
      Number(indexCounter) || 0
    ) + 1
    setProductRowsIndexCounter(nextIndex)

    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = '',
    } = values?.community || {}

    const newProduct = {
      indexId: nextIndex,
      product_name: '',
      product_desc: '',
      entryMode: 'write',
      is_product_row: 1,
      isNewlyAddedProductRow: true,
      isaddedFromJob: 1,
      addedByUserType: userType,
      locationQuantity: 1,
      quantity: 1,
      allLocationSame: true,
      is_single_card: values.project_category?.id !== 14 ? true : false,
      location: [
        {
          id: 0,
          address: projAddress,
          city: projCity,
          state: projState,
          zip: projZip,
        },
      ],
    }
    setSelectedProducts((prevProducts) => [...prevProducts, newProduct])
  }

  const addNewRequestEstimateServiceRow = () => {
    const nextIndex = Math.max(
      0,
      ...((serviceRows || []).map((row) => Number(row?.indexId) || 0)),
      ...((additionalSelectedServices || []).map((row) => 
        Number(row?.indexId || row?.product_index || row?.newIndexId) || 0
      )),
      Number(serviceIndexCounter) || 0,
    ) + 1
    setServiceRowsIndexCounter(nextIndex)

    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = '',
    } = values?.community || {}

    const newService = {
      indexId: nextIndex,
      product_index: nextIndex,
      service_name: '',
      service_desc: '',
      name: '',
      // entryMode: 'choose',
      entryMode: 'write',
      quantity: 1,
      cost: 0,
      unit_cost: 0,
      total_cost: 0,
      product_total: 0,
      // is_service_row: 0,
      is_service_row: 1,
      isNewlyAddedServiceRow: true,
      isaddedFromJob: 1,
      addedByUserType: userType,
      allLocationSame: true,
      location: [
        {
          id: 0,
          address: projAddress,
          city: projCity,
          state: projState,
          zip: projZip,
        },
      ],
      facility_id: currentFacilityId,
    }

    setServiceRows((prevRows) => [...prevRows, newService])
    setAdditionalSelectedServices((prevServices) => [
      ...prevServices,
      { ...newService, newIndexId: nextIndex },
    ])
  }

  const handleDeleteRequestEstimateProduct = async (indexId, backendId = null) => {
    // If row has a backendId, delete from backend first
    if (backendId && id) {
      try {
        const response = await axios.post(`${REST_API_END_POINT}request/update-product-row-estimate`, {
          requestId: id,
          productRow: { backendId },
          action: 'delete',
          userId: user.user_id,
          userType:userType
        });
        
        if (response.data.status !== 1) {
          enqueueSnackbar('Failed to delete product row from server.', { variant: 'error' });
          console.error('Failed to delete product row:', response.data);
          return;
        }
        enqueueSnackbar('Product row deleted successfully!', { variant: 'success' });
      } catch (error) {
        console.error('Error deleting product row:', error);
        enqueueSnackbar('Error deleting product row.', { variant: 'error' });
        return;
      }
    }

    const remainingProducts = (selectedProducts || []).filter((product) => {
      if (product?.is_product_row == 1) {
        if (backendId && product.backendId) {
          return product.backendId !== backendId
        }
        if (backendId && product.id) {
          return product.id !== backendId
        }
        return product.indexId !== indexId
      }
      return true
    })
    const sorted = [...remainingProducts].sort(
      (a, b) => (a?.indexId || 0) - (b?.indexId || 0),
    )
    const indexIdMap = {}
    sorted.forEach((p, idx) => {
      indexIdMap[String(p.indexId)] = idx + 1
    })
    remapProductIndexIds(indexIdMap, remainingProducts, {
      removeProductRowBackendIds: backendId ? [String(backendId)] : [],
      removeIndexKeys: [String(indexId)],
    })
  };

  const handleRequestEstimateProductNameChange = (indexId, value) => {
    setProductRows((prevRows) => 
      prevRows.map(row => 
        row.indexId === indexId ? { ...row, product_name: value, name: value } : row
      )
    );
    // Also update selectedProducts since the table renders from selectedProducts
    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product?.is_product_row == 1 && product.indexId === indexId) {
          return { ...product, product_name: value, name: value };
        }
        return product;
      })
    );
  };

  const handleRequestEstimateServiceNameChange = (indexId, value) => {
    setServiceRows((prevRows) => 
      prevRows.map(row => 
        row.indexId === indexId ? { ...row, service_name: value, name: value } : row
      )
    );
    // Also update selectedProducts since the table renders from selectedProducts
    setAdditionalSelectedServices((prevProducts) =>
      prevProducts.map((product) => {
        if (product?.is_service_row == 1 && product.indexId === indexId) {
          return { ...product, service_name: value, name: value };
        }
        return product;
      })
    );
  };

  const handleRequestEstimateProductDescChange = (indexId, value) => {
    setProductRows((prevRows) => 
      prevRows.map(row => 
        row.indexId === indexId ? { ...row, product_desc: value } : row
      )
    );
    // Also update selectedProducts since the table renders from selectedProducts
    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product?.is_product_row == 1 && product.indexId === indexId) {
          return { ...product, product_desc: value };
        }
        return product;
      })
    );
  };

  const handleProductDescChange = (indexId, value) => {
    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product.indexId !== indexId) return product
        if (product.entryMode === 'choose' && (product.id || product.product_id)) {
          return {
            ...product,
            product_desc: value,
            description: value,
          }
        }
        return product
      }),
    )
  }

  const handleRequestEstimateServiceDesChange = (indexId, value) => {
    setServiceRows((prevRows) => 
      prevRows.map(row => 
        row.indexId === indexId ? { ...row, service_desc: value } : row
      )
    );
    // Also update selectedProducts since the table renders from selectedProducts
    setAdditionalSelectedServices((prevProducts) =>
      prevProducts.map((product) => {
        if (product?.is_service_row == 1 && product.indexId === indexId) {
          return { ...product, product_desc: value };
        }
        return product;
      })
    );
  };
  // Store original value when field is focused
  const handleFieldFocus = (indexId, fieldType, value) => {
    const key = `${indexId}-${fieldType}`;
    originalValuesRef.current[key] = value || '';
  };

  // Check if value has changed from original
  const hasFieldChanged = (indexId, fieldType, currentValue) => {
    const key = `${indexId}-${fieldType}`;
    const originalValue = originalValuesRef.current[key] || '';
    return (currentValue || '') !== originalValue;
  };

  // Debounced auto-save trigger
  const triggerDebouncedAutoSave = (row, fieldType) => {
    // Clear any existing timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    
    // Set new timer for 1.5 seconds after typing stops
    debounceTimerRef.current = setTimeout(() => {
      handleProductRowAutoSave(row, fieldType, true);
    }, 1500);
  };

  const triggerDebouncedAutoSaveService = (row, fieldType) => {
    // Clear any existing timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    
    // Set new timer for 1.5 seconds after typing stops
    debounceTimerRef.current = setTimeout(() => {
      handleServiceRowAutoSave(row, fieldType, true);
    }, 1500);
  };

  const syncEstimateJobAfterRowSave = async () => {
    if (Number(details?.is_request_estimate) !== 1 || !id) return;
    try {
      await axios.post(`${REST_API}webservice/request/create-or-update-estimate-job`, {
        requestId: id,
        userId: user.user_id,
        requestPartnerId: details?.rt_partner_id,
        fromAutosave: true
      });
    } catch (error) {
      console.error('Estimate job sync after row save failed:', error);
    }
  };

  // Auto-save product row to backend on blur or after typing stops
  // fieldType: 'name' or 'desc' to show specific message
  // fromDebounce: true if called from debounce timer
  const handleProductRowAutoSave = async (row, fieldType = 'name', fromDebounce = false) => {
    // Clear debounce timer if called from blur
    if (!fromDebounce && debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
      debounceTimerRef.current = null;
    }

    // Only auto-save if this is an existing estimate (has an id) and in edit mode
    if (!id || !openEdit || isPreview) return;
    
    // Don't auto-save if both name and description are empty
    if ((row.product_name || '').trim() === '' && (row.product_desc || '').trim() === '') {
      return;
    }

    // Check if there are actual changes
    const currentValue = fieldType === 'name' ? row.product_name : row.product_desc;
    if (!hasFieldChanged(row.indexId, fieldType, currentValue)) {
      return; // No changes, don't save
    }

    // Don't auto-save if already saving (use ref for synchronous check)
    if (autoSavingFieldRef.current) return;

    // Set ref first for synchronous checking, then state for UI update
    const savingField = { indexId: row.indexId, field: fieldType };
    autoSavingFieldRef.current = savingField;
    setAutoSavingField(savingField);

    try {
      const successMessage = fieldType === 'name' ? 'Product name auto saved' : 'Product description auto saved';

      if (!row.backendId) {
        // New row - create it in backend
        const response = await axios.post(`${REST_API_END_POINT}request/update-product-row-estimate`, {
          requestId: id,
          productRow: row,
          action: 'create',
          userId: user.user_id,
          userType:userType
        });
        
        if (response.data.status === 1 && response.data.data?.backendId) {
          // Update the row with the new backendId
          setProductRows(prevRows =>
            prevRows.map(r =>
              r.indexId === row.indexId ? { ...r, backendId: response.data.data.backendId } : r
            )
          );
          enqueueSnackbar(successMessage, { variant: 'success' });
          await syncEstimateJobAfterRowSave();
        } else {
          console.error('Failed to auto-save new product row:', response.data);
        }
      } else {
        // Existing row - update it in backend
        const response = await axios.post(`${REST_API_END_POINT}request/update-product-row-estimate`, {
          requestId: id,
          productRow: row,
          action: 'update',
          userId: user.user_id,
          userType:userType
        });
        
        if (response.data.status === 1) {
          enqueueSnackbar(successMessage, { variant: 'success' });
          await syncEstimateJobAfterRowSave();
        } else {
          console.error('Failed to auto-save product row:', response.data);
        }
      }
    } catch (error) {
      console.error('Error auto-saving product row:', error);
      enqueueSnackbar('Error auto-saving product row.', { variant: 'error' });
    } finally {
      // Update original value to current value after save (success or fail)
      const currentValue = fieldType === 'name' ? row.product_name : row.product_desc;
      originalValuesRef.current[`${row.indexId}-${fieldType}`] = currentValue || '';
      autoSavingFieldRef.current = null;
      setAutoSavingField(null);
    }
  };

  const handleServiceRowAutoSave = async (row, fieldType = 'name', fromDebounce = false) => {
    // Clear debounce timer if called from blur
    if (!fromDebounce && debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
      debounceTimerRef.current = null;
    }

    // Only auto-save if this is an existing estimate (has an id) and in edit mode
    if (!id || !openEdit || isPreview) return;
    
    // Don't auto-save if both name and description are empty
    if ((row.service_name || '').trim() === '' && (row.service_desc || '').trim() === '') {
      return;
    }

    // Check if there are actual changes
    const currentValue = fieldType === 'name' ? row.service_name : row.service_desc;
    if (!hasFieldChanged(row.indexId, fieldType, currentValue)) {
      return; // No changes, don't save
    }

    // Don't auto-save if already saving (use ref for synchronous check)
    if (autoSavingFieldRef.current) return;

    // Set ref first for synchronous checking, then state for UI update
    const savingField = { indexId: row.indexId, field: fieldType };
    autoSavingFieldRef.current = savingField;
    setAutoSavingField(savingField);

    try {
      const successMessage = fieldType === 'name' ? 'Service name auto saved' : 'Service description auto saved';

      if (!row.backendId) {
        // New row - create it in backend
        const response = await axios.post(`${REST_API_END_POINT}request/update-service-row-estimate`, {
          requestId: id,
          productRow: row,
          action: 'create',
          userId: user.user_id
        });
        
        if (response.data.status === 1 && response.data.data?.backendId) {
          // Update the row with the new backendId in both serviceRows and table state
          setServiceRows(prevRows =>
            prevRows.map(r =>
              r.indexId === row.indexId ? { ...r, backendId: response.data.data.backendId } : r
            )
          );
          setAdditionalSelectedServices((prevRows) =>
            prevRows.map((r) =>
              r.indexId === row.indexId && r?.is_service_row == 1
                ? { ...r, backendId: response.data.data.backendId }
                : r,
            ),
          )
          enqueueSnackbar(successMessage, { variant: 'success' });
          await syncEstimateJobAfterRowSave();
        } else {
          console.error('Failed to auto-save new service row:', response.data);
        }
      } else {
        // Existing row - update it in backend
        const response = await axios.post(`${REST_API_END_POINT}request/update-service-row-estimate`, {
          requestId: id,
          productRow: row,
          action: 'update',
          userId: user.user_id
        });
        
        if (response.data.status === 1) {
          enqueueSnackbar(successMessage, { variant: 'success' });
          await syncEstimateJobAfterRowSave();
        } else {
          console.error('Failed to auto-save service row:', response.data);
        }
      }
    } catch (error) {
      console.error('Error auto-saving service row:', error);
      enqueueSnackbar('Error auto-saving service row.', { variant: 'error' });
    } finally {
      // Update original value to current value after save (success or fail)
      const currentValue = fieldType === 'name' ? row.service_name : row.service_desc;
      originalValuesRef.current[`${row.indexId}-${fieldType}`] = currentValue || '';
      autoSavingFieldRef.current = null;
      setAutoSavingField(null);
    }
  };

  const addNewProductRow = () => {
    const newIndexCounter = indexCounter + 1
    setIndexCounter(newIndexCounter)
    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = '',
    } = values?.community || {}
    // Auto-populate addresses from the selected Project
    const newAddresses = [
      {
        id: 0,
        address: projAddress,
        city: projCity,
        state: projState,
        zip: projZip,
      },
    ]

    setSelectedProducts((prevProducts) => {
      // if (allLocationSame && prevProducts.length > 0) {
      //     const commonAddress = { ...prevProducts[0].addresses[0] } || {
      //     address: '',
      //     city: '',
      //     state: '',
      //     zip: '',
      //     };
      //     newAddresses[0] = commonAddress;
      // }
      return [
        ...prevProducts,
        {
          indexId: newIndexCounter,
          name: '',
          quantity: 1,
          price: 0,
          adjustment: 0,
          retail_price: 0,
          unit: 4,
          locationQuantity: 1,
          expected_total_service_cost: 0,
          expected_service_cost: 0,
          expected_material_cost: 0,
          discount: 0,
          allLocationSame: true,
          service: [],
          isAdditionalProduct: true,
          location: newAddresses,
          is_single_card: values.project_category?.id !== 14 ? true : false,
          addedByUserType: userType,
        },
      ]
    })
  }

  // const addNewServiceRow = () => {
  //   const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
  //   // Auto-populate addresses from the selected Project
  //   const newAddresses = [{
  //     id: 0,
  //     address: projAddress,
  //     city: projCity,
  //     state: projState,
  //     zip: projZip
  //   }];

  //   setAdditionalSelectedServices((prevServices) => {
  //     return [
  //       ...prevServices,
  //       {
  //         id:null,
  //         newIndexId: prevServices?.length + 1,
  //         name: '',
  //         avatarUrl: null,
  //         quantity: 1,
  //         cost: 0,
  //         markup: 0,
  //         workflow: null,
  //         originalMarkup: 0,
  //         service_type: null,
  //         total_cost:0,
  //         product_total:0,
  //         allLocationSame: true,
  //         isAdditionalProduct:true,
  //         addresses: newAddresses,
  //       }
  //     ]
  //   });
  // };

  const addNewServiceRow = () => {
    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = '',
    } = values?.community || {}

    const newAddresses = [
      {
        id: 0,
        address: projAddress,
        city: projCity,
        state: projState,
        zip: projZip,
      },
    ]

    setAdditionalSelectedServices((prevServices) => {
      const maxId = prevServices.reduce(
        (max, item) => Math.max(max, item.newIndexId || 0),
        0,
      )

      return [
        ...prevServices,
        {
          id: null,
          newIndexId: maxId + 1,
          // entryMode: 'choose',
          name: '',
          // service_name: '',
          avatarUrl: null,
          quantity: 1,
          cost: 0,
          markup: 0,
          workflow: null,
          originalMarkup: 0,
          service_type: null,
          total_cost: 0,
          product_total: 0,
          allLocationSame: true,
          // isAdditionalProduct: false,
          isAdditionalProduct: true,
          isaddedFromJob: 1,
          addresses: newAddresses,
        },
      ]
    })
  }

  // const addNewMaterialRow = () => {
  //   setSelectedMaterials((prevProducts) => {
  //   return [
  //   ...prevProducts,
  //   {
  //     newIndexId: prevProducts?.length + 1,
  //     quantity: 1,
  //     allLocationSame: true,
  //     isAdditionalProduct:true,
  //     description: '',
  //     finishedProductQty: 0,
  //     markUpCost: 0,
  //     markup: 0,
  //     material_types: 1,
  //     max_price: null,
  //     max_value: 10,
  //     meterial: 1,
  //     min_value: 1,
  //     name: '',
  //     partial: 0,
  //     partialProductQty: 0,
  //     pf_retail_markup: null,
  //     price: 0,
  //     recipe_id: null,
  //     retail_price: 0,
  //     special_price: 0,
  //     tags: '',
  //     tax: null,
  //     tax_category: 0,
  //     total_qty: 0,
  //     twilio_field_value_sid: null,
  //     unit: 4,
  //     unit_qty: 0,
  //     vendor_id: '',
  //     vpt_number: '',
  //     workflow: null,
  //   },
  //   ]});
  // };

  const addNewMaterialRow = () => {
    setSelectedMaterials((prevProducts) => {
      const maxId = prevProducts.reduce(
        (max, item) => Math.max(max, item.newIndexId || 0),
        0,
      )

      return [
        ...prevProducts,
        {
          newIndexId: maxId + 1,
          quantity: 1,
          allLocationSame: true,
          isAdditionalProduct: true,
          description: '',
          finishedProductQty: 0,
          markUpCost: 0,
          product_retail_price: 0,
          markup: 0,
          material_types: 1,
          max_price: null,
          max_value: 10,
          meterial: 1,
          min_value: 1,
          name: '',
          partial: 0,
          partialProductQty: 0,
          pf_retail_markup: null,
          price: 0,
          product_price: 0,
          recipe_id: null,
          retail_price: 0,
          special_price: 0,
          tags: '',
          tax: null,
          tax_category: 0,
          total_qty: 0,
          twilio_field_value_sid: null,
          unit: 4,
          unit_qty: 0,
          vendor_id: '',
          vpt_number: '',
          workflow: null,
        },
      ]
    })
  }

  const VALUE = [
    { id: 0, value: 'Sl No.' },
    { id: 24, value: 'Mode' },
    { id: 1, value: 'Products' },
    { id: 2, value: 'Note' },
    { id: 19, value: 'Attachments' },
    { id: 7, value: 'Product Formula' },
    { id: 3, value: '' },
    { id: 3, value: 'Product Description' },
    { id: 4, value: 'Product formula cost Each' },
    { id: 20, value: 'Markup (%)' },
    { id: 16, value: 'Split Markup' },
    {
      id: 5,
      value: markupType
        ? markupType == 2 && hasMarkupPermission
          ? 'Retail Price Each'
          : null
        : null,
    },
    {
      id: 6,
      value: markupType
        ? markupType == 1 && hasMarkupPermission
          ? 'Retail Price Each'
          : null
        : null,
    },
    // { id: 14, value: hasMarkupPermission ? 'SPMA' : null },
    // { id: 7, value: hasMarkupPermission ? 'Markup (%)' : null },
    // { id: 8, value: 'Unit' },
    { id: 9, value: 'Quantity' },
    { id: 10, value: 'Location' },
    { id: 11, value: 'Marketing Adjustment Type' },
    { id: 15, value: 'Marketing Adjustment' },
    { id: 12, value: 'Subtotal' },
    { id: 14, value: 'Product Total' },
    { id: 13, value: '' },
  ]

  const VALUEPreview = [
    { id: 0, value: 'Sl No.' },
    { id: 1, value: 'Products' },
    // { id: 2, value: 'Product formula cost (Material cost + Service cost with markup)' },
    {
      id: 3,
      value: markupType
        ? markupType == 2 && hasMarkupPermission
          ? 'Retail Price Each'
          : null
        : null,
    },
    {
      id: 4,
      value: markupType
        ? markupType == 1 && hasMarkupPermission
          ? 'Retail Price Each'
          : null
        : null,
    },
    { id: 14, value: hasMarkupPermission ? 'SPMA' : null },
    { id: 5, value: hasMarkupPermission ? 'Markup (%)' : null },
    { id: 6, value: 'Unit' },
    { id: 7, value: 'Quantity' },
    // { id: 8, value: 'Discount' },
    { id: 11, value: 'Marketing Adjustment Type' },
    { id: 8, value: 'Marketing Adjustment' },
    { id: 9, value: 'Subtotal' },
    { id: 14, value: 'Product Total' },
    { id: 10, value: '' },
  ]

  const VALUE_SERVICES = [
    { id: 0, value: 'Sl No.' },
    { id: 24, value: 'Mode' },
    { id: 1, value: 'Service Name' },
    { id: 2, value: 'Notes' },
    { id: 19, value: 'Attachments' },
    { id: 12, value: '' },
    { id: 11, value: 'Service Description' },
    { id: 3, value: 'Markup (%)' },
    { id: 4, value: 'Cost (Hourly)' },
    { id: 5, value: 'Markup Cost (Hourly)' },
    { id: 6, value: 'Hours' },
    // { id: 7, value: 'Make As Task' },
    // { id: 8, value: 'Make Install Card' },
    // { id: 7, value: 'Product Formula Cost' },
    { id: 8, value: 'Additional cost' },
    { id: 9, value: 'Total cost' },
    { id: 10, value: '' },
  ]
  const VALUE_MATERIAL = [
    { id: 0, value: 'Product' },
    { id: 10, value: 'Note' },
    { id: 9, value: 'Stock Type' },
    { id: 1, value: 'Unit Price' },
    { id: 2, value: 'Markup (%)' },
    { id: 3, value: 'Markup Cost (Unit)' },
    { id: 4, value: 'Quantity' },
    { id: 5, value: 'Product Formula Cost' },
    { id: 6, value: 'Total' },
    { id: 7, value: '' },
  ]
  const VALUE_RFP_Product = [
    { id: 0, value: 'Name' },
    { id: 12, value: 'Note' },
    { id: 1, value: 'Mark Up (%)' },
    { id: 2, value: 'Cost ' },
    { id: 3, value: 'Retail Price Each ' },
    { id: 4, value: 'Unit' },
    { id: 5, value: 'Quantity' },
    // { id: 6, value: 'Product Formula Cost'},
    { id: 7, value: 'Total' },
    // { id: 8, value: 'Make As Task' },
    // { id: 9, value: 'Make Install Card' },
    { id: 10, value: 'Location' },
    { id: 11, value: '' },
  ]
  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue)
    // Both Job Notes and Design Notes share jobNoteMembers as TO recipients
    if (newValue === 'Job Notes' || newValue === 'Design Notes') {
      fetchJobNoteMembers()
    }
    // setRefresh(true)
  }
  const HandleClickmenu = () => {
    setAddClient(true)
  }

  const fetchTaxCategory = async () => {
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}product/get-tax-category`,
      )
      if (response.data.status === 1) {
        setTaxCategories(response.data.taxResult)
      } else {
        setTaxCategories([])
      }
    } catch (error) {
      console.log('Error - ', error)
      setTaxCategories([])
    }
  }

  const fetchAllSignAgreements = async () => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}agreement/get-all-agreements`);
      if (response.data.status === 1 && Array.isArray(response.data.result)) {
        setSignAgreementsData(response.data.result); // Set only if it's an array
      } else {
        setSignAgreementsData([]); // Empty array if the result is not valid
      }
    } catch (error) {
      console.log(error, 'Error in fetching all agreements');
      setSignAgreementsData([]); // Ensure signAgreementsData is an empty array on error
    }
  };

  //add clients
  const fetchAllRequestClients = async () => {
    try {
      const res = await axios.post(
        `${REST_API}webservice/request/fetch-all-clients-request`,
        { requestId: id },
      )

      await setAllClients(res.data.data)
    } catch (error) {
      console.log(error, 'Error in fetching all clients')
    }
  }

  // useEffect(() => {
  //   fetchAllRequestClients()
  // }, [addClient])

  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string().required('Description is required'),
    //  avatarUrl: Yup.mixed().required('Image is required'),
    // skills:userType!=3 && Yup.array().min(1, 'Skill is required'),
    // workflow:userType!=3 && Yup.array().min(1, 'Workflow is required'),
    // start: Yup.mixed().required('Start Date is required'),
    // end: Yup.date()
    //   .nullable()
    //   .transform((value, originalValue) => {
    //     return originalValue ? new Date(originalValue * 1000) : null;
    //   })
    //   .when('start', (start, schema) => {
    //     return start
    //       ? schema.min(
    //         start,
    //         'Installation Date must be greater than the Start Date'
    //       )
    //       : schema;
    //   }),
    products: isAdminUser (userType) && Yup.array(), //.min(1, 'At least one product is required'),
    // services:userType!=3 && Yup.array().min(1, 'At least one service is required'),
    markup_type:
      userType != 3 &&
      Yup.object().nullable().required('Please select the markup type'),
    // map_service:userType!=3 && Yup.object().nullable().required('Please select the map service'),
    project_type:
      userType != 3 &&
      Yup.object().nullable().required('Job class is required'),
    map_service: Yup.mixed().when('project_category', {
      is: (project_category) =>
        userType !== 3 &&
        project_category?.id === 14 &&
        values.project_type?.name == 'TS',
      then: Yup.object().nullable().required('Please select the map service'),
      otherwise: Yup.mixed().nullable(),
    }),
    // project_type:Yup.object().nullable().required('Job Type is required'),
    // project_category:Yup.object().nullable().required('Job Category is required'),
    community:userType != 3 && Yup.object().nullable().required('Please select the Project'),
    clients:userType != 3 && Yup.object().nullable().required('Please select the Client'),
  })

  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    // color: theme.palette.text.secondary,
    //   marginBottom: theme.spacing(1)
  }))
  const LabelStyleHead = styled(Typography)(({ theme }) => ({
    ...theme.typography.h5,
    // color: theme.palette.text.secondary,
  }))
  //delete official request
  const handleDeleteRFQ = async () => {
    try {
      setIsLoading(true)
      const data = { request_id: id, request: false, userId: userId }
      const res = await axios.post(
        `${REST_API}webservice/delete-request-estimate/id`,
        data,
      )

      if (res.data.data == true) {
        enqueueSnackbar('Delete success', { variant: 'success' })
        // navigate(PATH_DASHBOARD.quotation.root)
        if (popupOn) {
          closeView()
          setRenderCards(!renderCards)
        } else {
          navigate(`/dashboard/quick-bid`)
        }
      }
    } catch (error) {
      console.log(error, 'Error in deleting the request')
    } finally {
      setIsLoading(false)
    }
  }
  // const getTransactionTaxDetails = async (estimateDocNumber) => {
  //   try {
  //     if (!estimateDocNumber) return;
  //     const response = await axios.post(`${REST_API}webservice/request/get-qb-transaction-tax-details`, {
  //       estimate_id: estimateDocNumber
  //     });
  //     const items = response?.data?.items || [];
  //     setTaxRateData(items);
  //     console.log('getTransactionTaxDetails response:', response);
  //   } catch (error) {
  //     console.log("error fetching transaction tax details:", error);
  //   }
  // };

  //fetch request details
  const fetchRequestDetails = async () => {
    try {
      setLoading(true)
      // BACKUP: Original API call - const res = await axios.post(`${REST_API}webservice/view-request`, { request_id: id,userId, userType });
      // NEW: Updated to use view-request-without-team-products API
      const res = await axios.post(
        `${REST_API}webservice/request/view-request-estimate-new`,
        { request_id: id, userId, userType ,isNotSplitOrder : true},
      )
      res.data
      setTeamMember(res.data.team)
      setAvatarUrl(res.data.attachments)
      setDetails(res.data?.data[0])
      const requestData = res.data?.data[0]
      // if (requestData) {
      //   getTransactionTaxDetails(requestData.doc_number || requestData.estimate_id || requestData.id)
      // }

      // Job note members are now fetched separately when Job Notes tab is active
      // BACKUP: Removed skill and allProposals from here - now fetched via products API
      // setRfps(res.data.allProposals)
      setDesignersList(res.data.projectMembers)
      setMarkupType(res.data?.data[0]?.markup_type)
      setDesigns(res.data?.attachments)
      setCustomerData(res.data.customerData)
      setTaxAmount(res.data.customerData?.tax_amount || 0)
      // setSkill(res.data.skill)
      setWorkFlow(res.data.workflows)
      // // BACKUP: Original products fetch - setAllproducts(res.data.products)
      // Products will now be fetched separately via get-products API when Edit button is clicked

      setClientApprove(res.data?.data[0]?.client_approve)
      setManagerApprovalRequired(res.data?.data[0]?.manager_approval_required ?? 0)
      // setSingleLocationCard(res.data?.data[0]?.is_single_card === 1);
      // BACKUP: Removed materials processing from here - now fetched via products API
      // setAllMaterials(res.data.materials)  15-01-25
      // const allMatData = Array.isArray(res.data.materials)
      // ? res.data.materials.map((material) => ({
      //     ...material,
      //     markup: Number(material.retail_price || 0),
      //   }))
      // : [];
      // setAllMaterials(allMatData?.filter(item=>item.isAdditionalProduct == 0))

      setAcceptedClients(res.data.requestAcceptedPartners)
      setUpdates(res.data.updates)
      setPayments(res.data.payments)
      setCustomTemplate(res.data.fieldTemplates)
      setQuestionnaireTemplate(res.data.QuestionTemplates)
      setSignAgreements(res.data.signAgrementData)
      setDataEmpty(res.data.allDataEmpty)
      setPortfolio(res.data.portfolio)
      setRefresh(false)
      setProposalData(res.data.requestProposals)
      // BACKUP: Removed labourCostServices and materials from here - now fetched via products API
      // setLabourCostServices(res.data.labourCostServices)
      // setFilteredServices(res.data.labourCostServices)
      setRequestServices(
        res.data.requestServices.filter((row) => row.rfp === 0),
      )
      setRfpServicesEdit(
        res.data.requestServices.filter((row) => row.rfp === 1),
      )
      // if(res.data?.data[0]?.is_location===1){
      //   setAllLocationSame(true)

      let currentInstallationProductData = res?.data?.products
      let otherInstallationProductData = res?.data?.otherInstallationProducts
      let combinedProducts = [
        ...(currentInstallationProductData || []),
        ...(otherInstallationProductData || []),
      ]
      // setAllproducts(combinedProducts)
      let incomingSplitMarkup =
        res?.data?.currentFacilitySplitManagementSettings?.find(
          (setting) => setting?.is_default,
        )?.incoming_percentage
      setIncomingSplitMarkup(incomingSplitMarkup)
      setSplitManagementSettings(
        res?.data?.otherInstallationSplitManagementSettings,
      )

      let filteredValue = res.data?.data[0].facility_type // e.g. "2,3,4"

      const selectedData = String(filteredValue)
        .split(',')
        .map((v) => v.trim())
        .map((id) =>
          res?.data?.otherInstallationSplitManagementSettings?.find(
            (s) => s?.id == id,
          ),
        )
        .filter(Boolean)

      setSelectedSplitOrderSettings(
        res?.data?.otherInstallationSplitManagementSettings,
      )
      console.log('selectedData11212121212 1', selectedData)
      // }
      if (edit) {
        await fetchProducts()
        setOpenEdit(true)
      }
      // setTimeout(()=>{
      //   setLoading(false)
      // },2000)
      setIsSplitOrder(res.data?.data[0]?.is_split_order)

            
      // Initialize productRows from request data if it exists
      if (res.data?.data[0]?.is_request_estimate == 1 && res.data?.data[0]?.productRows) {
        // Map backend data to include backendId from the database 'id' field
        const mappedRows = res.data.data[0].productRows.map(r => ({
          ...r,
          indexId: r.product_index || r.indexId,
          backendId: r.id || r.backendId || null,
          is_product_row: 1,
          product_desc: r.product_desc || r.description || '',
        }));
        setProductRows(mappedRows.length > 0 ? mappedRows : [{ indexId: 0, product_name: '', product_desc: '', is_product_row: 1, backendId: null }]);
        if (mappedRows && mappedRows.length > 0) {
          const maxIndex = Math.max(...mappedRows.map(r => r.indexId || 0));
          setProductRowsIndexCounter(maxIndex);
        }
      }
     
    } catch (error) {
      console.error('Error fetching request details:', error)
    } finally {
      setLoading(false)
    }
  }

  // Shared TO recipients for Job Notes and Design Notes tabs
  const fetchJobNoteMembers = async () => {
    try {
      const res = await axios.post(
        `${REST_API}webservice/request/get-job-note-members`,
        {
          request_id: id,
          userId: user.user_id,
          userType: user.user_type,
        },
      )
      if (res.data.status === 1) {
        setJobNoteMembers(res.data.jobNoteMembers || [])
      }
    } catch (error) {
      console.log('Error fetching job note members:', error)
    }
  }

  // NEW: Separate function to fetch products - only called when Edit button is clicked
  const fetchProducts = async () => {
    try {
      const [productOnly,productsRes,materialOnly,customerOrderProductGroups] = await Promise.all([
        axios.post(`${REST_API}webservice/request/get-products`, {isNotSplitOrder : true,ProductOnly:true}),
        axios.post(`${REST_API}webservice/request/get-products`, {isNotSplitOrder : true,noProduct:true,noMaterial:true}),
        axios.post(`${REST_API}webservice/view-request-materials`, {isNoAdditionalProduct:true,inHouse:true}),
        axios.post(`${REST_API}webservice/view-request-groups`, {request_id:id}),
      ])
      // const productsRes = await axios.post(
      //   `${REST_API}webservice/request/get-products`,
      //   {isNotSplitOrder : true,newProduct:true},
      // )
      const groupsFromResult = customerOrderProductGroups?.data.customerOrderProductGroups || []
      setCustomerOrderProductGroups(groupsFromResult)

      // Initialize group marketing values
      const initialProductMarketing = {}
      const initialInstallMarketing = {}
      groupsFromResult.forEach((group) => {
        initialProductMarketing[String(group.id)] = {
          adjustment: Number(group.product_marketing_adjustment ?? 0),
          // DB stores 0 = negative, 1 = positive — must use ?? not || (0 is valid)
          adjValueType:
            group.product_marketing_adj_value_type ??
            group.productMarketingAdjValueType ??
            1,
        }
        initialInstallMarketing[String(group.id)] = {
          adjustment: Number(group.install_marketing_adjustment ?? 0),
          adjValueType:
            group.install_marketing_adj_value_type ??
            group.installMarketingAdjValueType ??
            1,
        }
      })
      setGroupProductMarketingValues(initialProductMarketing)
      setGroupInstallMarketingValues(initialInstallMarketing)
      // let currentInstallationProductData = productsRes?.data?.products
      let currentInstallationProductData = productOnly?.data?.products
      console.log('currentInstallationProductData', currentInstallationProductData)
      let otherInstallationProductData =
        productsRes?.data?.otherInstallationProducts
      let combinedProducts = [
        ...(currentInstallationProductData || []),
        ...(otherInstallationProductData || []),
      ]
      setAllproducts(combinedProducts)
      catalogProductsRef.current = combinedProducts // sync ref before openEdit — state allProducts can still be [] when addingInitialdataRFQ runs
      let incomingSplitMarkup =
        productsRes?.data?.currentFacilitySplitManagementSettings?.find(
          (setting) => setting?.is_default,
        )?.incoming_percentage
      setIncomingSplitMarkup(incomingSplitMarkup)
      setSplitManagementSettings(
        productsRes?.data?.otherInstallationSplitManagementSettings,
      )

      setSelectedSplitOrderSettings(
        productsRes?.data?.otherInstallationSplitManagementSettings,
      )

      // setAllproducts(productsRes.data.products);
      // NEW: Set labourCostServices and materials from products API
      setLabourCostServices(productsRes.data.labourCostServices)
      setFilteredServices(productsRes.data.labourCostServices)

      // NEW: Process materials data (moved from main fetchRequestDetails function)
      // const allMatData = Array.isArray(productsRes.data.materials)
      const allMatData = Array.isArray(materialOnly.data.materials)
        ? materialOnly.data.materials.map((material) => ({
            ...material,
            markup: Number(material.retail_price || 0),
          }))
        : []
      setAllMaterials(
        allMatData?.filter((item) => item.isAdditionalProduct == 0),
      )

      // NEW: Set skill and allProposals from products API
      setSkill(productsRes.data.skill)
      setRfps(productsRes.data.allProposals)
      // return productsRes.data.labourCostServices || []
      return combinedProducts // was: return productsRes.data.labourCostServices || []
    } catch (productsError) {
      console.error('Error fetching products:', productsError)
      setAllproducts([]) // Set empty array as fallback
      catalogProductsRef.current = []
      setLabourCostServices([])
      setFilteredServices([])
      setAllMaterials([])
      setSkill([])
      setRfps([])
      return []
    }
  }

  const refreshProducts = async (
    addedProductId,
    editProduct = false,
    isExisting,
    productsToUse = null,
    insertCatalogAtIndex = null,
    catalogAnchorIndexId = null,
    addedProductData = null,
  ) => {
    setLoadingProducts(true)
    try {
      const [productOnly,productsRes] = await Promise.all([
        axios.post(`${REST_API}webservice/request/get-products`, {isNotSplitOrder : true,ProductOnly:true}),
        axios.post(`${REST_API}webservice/request/get-products`, {isNotSplitOrder : true,noProduct:true,noMaterial:true}),       
      ])
      // const productsRes = await axios.post(
      //   `${REST_API}webservice/request/get-products`,
      //   {},
      // )
      let currentInstallationProductData = productOnly?.data?.products
      let otherInstallationProductData = productsRes?.data?.otherInstallationProducts
      let combinedProducts = [
        ...(currentInstallationProductData || []),
        ...(otherInstallationProductData || []),
      ]
      setAllproducts(combinedProducts)
      if(addedProductId){
        // Group→catalog passes insert index + anchor; selectedProductForCatalog is still
        // the pre-close payload in this closure until the next render — do not use replace path.
        const useReplaceBySelectedCatalog =
          Boolean(selectedProductForCatalog) &&
          insertCatalogAtIndex == null &&
          catalogAnchorIndexId == null
        if (useReplaceBySelectedCatalog) {
          // Find the new product object from API results
          // Number() match: string/number id mismatch used to skip the API row and fall
          // back to add-product payload without expected_*_with_markup (formula cost = 0).
          let newProductFromApi = combinedProducts?.find(
            (product) =>
              Number(product.id) === Number(addedProductId) &&
              (product?.facility_id == null ||
                Number(product?.facility_id) === Number(currentFacilityId)),
          )

          if (!newProductFromApi && addedProductData) {
            newProductFromApi = addedProductData;
          } else if (newProductFromApi && addedProductData) {
            // On edit, prefer close-payload formula fields (API join can be stale right after update).
            // On add, prefer API row and fill gaps from close payload (same as before).
            newProductFromApi = {
              ...newProductFromApi,
              expected_material_cost_with_markup: editProduct
                ? (addedProductData.expected_material_cost_with_markup ??
                  newProductFromApi.expected_material_cost_with_markup)
                : (newProductFromApi.expected_material_cost_with_markup ??
                  addedProductData.expected_material_cost_with_markup),
              expected_service_cost_with_markup: editProduct
                ? (addedProductData.expected_service_cost_with_markup ??
                  newProductFromApi.expected_service_cost_with_markup)
                : (newProductFromApi.expected_service_cost_with_markup ??
                  addedProductData.expected_service_cost_with_markup),
              expected_install_labor_cost_with_markup: editProduct
                ? (addedProductData.expected_install_labor_cost_with_markup ??
                  newProductFromApi.expected_install_labor_cost_with_markup)
                : (newProductFromApi.expected_install_labor_cost_with_markup ??
                  addedProductData.expected_install_labor_cost_with_markup),
            }
          }
          if (newProductFromApi) {
            newProductFromApi.product_formula_cost_each = getSingleProductFormulaCostEach(newProductFromApi)
            newProductFromApi.install_formula_cost_each = Number(
              newProductFromApi.expected_install_labor_cost_with_markup || 0,
            )
          }
          console.log('refreshProducts: replacing catalog for', selectedProductForCatalog, 'with', newProductFromApi)

          if (newProductFromApi) {
            // Try to replace the existing product in-place to preserve order
            const existingIndex = selectedProducts?.findIndex(
              (p) => p.indexId === selectedProductForCatalog?.indexId,
            )

            if (existingIndex != null && existingIndex >= 0) {
              const newProductList = [...(productsToUse || selectedProducts || [])]
              const priorRow = newProductList[existingIndex] ?? selectedProductForCatalog
              // Preserve some flags; handleProduct will fill defaults
              let addValues = {}
              const catalogDescription =
                selectedProductForCatalog?.product_desc ||
                selectedProductForCatalog?.description ||
                newProductFromApi?.description ||
                newProductFromApi?.product_desc ||
                priorRow?.product_desc ||
                priorRow?.description ||
                ''
              if (isExisting) {
                addValues = {
                  is_existing_catalog: 1,
                  description: catalogDescription,
                  product_desc: catalogDescription,
                  product_name: selectedProductForCatalog?.product_name || selectedProductForCatalog?.name || '',
                  name: selectedProductForCatalog?.name || selectedProductForCatalog?.name || '',
                  product_write: priorRow?.product_write ?? selectedProductForCatalog?.product_write ?? 1,
                  isaddedFromJob: 1,
                }
              } else {
                addValues = {
                  is_existing_catalog: 0,
                  product_write: priorRow?.product_write ?? selectedProductForCatalog?.product_write ?? 1,
                  product_desc: catalogDescription,
                  description: catalogDescription,
                  isaddedFromJob: 1,
                }
              }
              newProductList[existingIndex] = {
                ...newProductFromApi,
                is_line_catalog: 1, // Ensure it becomes groupable after conversion
                is_single_card: values.project_category?.id !== 14 ? true : false,
                ...addValues,
                product_notes:
                  priorRow?.product_notes ??
                  selectedProductForCatalog?.product_notes ??
                  selectedProductForCatalog?.note ??
                  '',
                addedByUserType:
                  priorRow?.addedByUserType ??
                  priorRow?.added_by_user_type ??
                  selectedProductForCatalog?.addedByUserType ??
                  selectedProductForCatalog?.added_by_user_type ??
                  null,
              }

              const updated = newProductList.map((item) => ({
                ...item,
                is_single_card: values.project_category?.id !== 14 ? true : false,
                isaddedFromJob:
                  Number(item.isaddedFromJob) === 1
                    ? 1
                    : item.id === addedProductId
                      ? 1
                      : 0,
              }))

              handleProduct(updated, selectedProductForCatalog?.indexId, editProduct)
            } else {
              // Fallback: append if we couldn't find the original product
              const updatedAppend = [...(productsToUse || selectedProducts || []), newProductFromApi].map((item) => ({
                ...item,
                is_single_card: values.project_category?.id !== 14 ? true : false,
                isaddedFromJob: item.id === addedProductId ? 1 : item.isaddedFromJob ?? 0,
              }))
              handleProduct(updatedAppend)
            }
          } else {
            // If API didn't return the product, keep current selection
            handleProduct(selectedProducts)
          }
        }else{
          let newFromApi = combinedProducts?.find(
            (product) =>
              Number(product.id) === Number(addedProductId) &&
              (product?.facility_id == null ||
                Number(product?.facility_id) === Number(currentFacilityId)),
          )
          if (!newFromApi && addedProductData) {
            newFromApi = addedProductData;
          } else if (newFromApi && addedProductData) {
            newFromApi = {
              ...newFromApi,
              expected_material_cost_with_markup: editProduct
                ? (addedProductData.expected_material_cost_with_markup ??
                  newFromApi.expected_material_cost_with_markup)
                : (newFromApi.expected_material_cost_with_markup ??
                  addedProductData.expected_material_cost_with_markup),
              expected_service_cost_with_markup: editProduct
                ? (addedProductData.expected_service_cost_with_markup ??
                  newFromApi.expected_service_cost_with_markup)
                : (newFromApi.expected_service_cost_with_markup ??
                  addedProductData.expected_service_cost_with_markup),
              expected_install_labor_cost_with_markup: editProduct
                ? (addedProductData.expected_install_labor_cost_with_markup ??
                  newFromApi.expected_install_labor_cost_with_markup)
                : (newFromApi.expected_install_labor_cost_with_markup ??
                  addedProductData.expected_install_labor_cost_with_markup),
            }
          }
          if (newFromApi) {
            newFromApi.product_formula_cost_each = getSingleProductFormulaCostEach(newFromApi)
            newFromApi.install_formula_cost_each = Number(
              newFromApi.expected_install_labor_cost_with_markup || 0,
            )
          }
          const newValue = newFromApi ? [newFromApi] : []
          const base = [...(productsToUse || selectedProducts || [])]
          const newProductValue =
            insertCatalogAtIndex != null &&
            insertCatalogAtIndex >= 0 &&
            insertCatalogAtIndex <= base.length
              ? [...base.slice(0, insertCatalogAtIndex), ...newValue, ...base.slice(insertCatalogAtIndex)]
              : [...base, ...newValue]
          const updated = newProductValue.map((item) => ({
            ...item,
            is_line_catalog: (item.id === addedProductId || item.backendId === addedProductId) ? 1 : item.is_line_catalog,
            is_single_card: values.project_category?.id !== 14 ? true : false,
            isaddedFromJob:
              item.id === addedProductId || item.backendId === addedProductId
                ? 1
                : item.isaddedFromJob ?? 0,
          }))

          const anchorForNewRow =
            details?.is_request_estimate == 1 && catalogAnchorIndexId != null
              ? catalogAnchorIndexId
              : false
          handleProduct(updated, anchorForNewRow, editProduct)
        }
      }else{
        handleProduct(selectedProducts)
      }
    } catch (productsError) {
      console.error('Error fetching products:', productsError)
      setAllproducts([]) // Set empty array as fallback
    }finally {
      setLoadingProducts(false)
    }
  }

  const refreshServices = async (addedServiceId, catalogRowSnapshot = null) => {
    setLoadingServices(true);
    try {
      const productsRes = await axios.post(`${REST_API}webservice/request/get-products`, {
        isNotSplitOrder: true,
        noProduct: true,
        noMaterial: true
      });
  
      const allServices = productsRes?.data?.labourCostServices;
      setLabourCostServices(allServices);
      setFilteredServices(allServices);
  
      if (addedServiceId) {
        const idNum = Number(addedServiceId)
        const resolveNewServiceFromApi = (list) => {
          if (!list?.length) return null
          const byFacility = list.find(
            (service) =>
              Number(service.id) === idNum &&
              Number(service?.facility_id) === Number(currentFacilityId),
          )
          if (byFacility) return byFacility
          return list.find((service) => Number(service.id) === idNum) || null
        }

        const rowForReplace = catalogRowSnapshot ?? selectedServiceForCatalog

        const findRowIndex = (list, row) => {
          if (!row || !Array.isArray(list)) return -1
          return list.findIndex((p) => {
            if (row.backendId != null && p?.backendId != null) {
              return String(p.backendId) === String(row.backendId)
            }
            const selIdx = row.product_index ?? row.indexId
            const rowIdx = p?.product_index ?? p?.indexId
            if (selIdx != null && rowIdx != null) {
              return Number(rowIdx) === Number(selIdx)
            }
            if (row.newIndexId != null && p?.newIndexId != null) {
              return Number(p.newIndexId) === Number(row.newIndexId)
            }
            return false
          })
        }

        if (rowForReplace) {
          const newServiceFromApi = resolveNewServiceFromApi(allServices)
          console.log(
            'refreshServices: replacing catalog for',
            rowForReplace,
            'with',
            newServiceFromApi,
          )

          if (newServiceFromApi) {
            setAdditionalSelectedServices((prevServices) => {
              const prev = Array.isArray(prevServices) ? prevServices : []
              const existingIndex = findRowIndex(prev, rowForReplace)
              console.log('refreshServices existingIndex', existingIndex)

              if (existingIndex >= 0) {
                const newServiceList = [...prev]
                const prevRow = newServiceList[existingIndex]
                const isChooseService = (prevRow?.entryMode ?? rowForReplace?.entryMode) === 'choose'
                newServiceList[existingIndex] = {
                  ...prevRow,
                  ...newServiceFromApi,
                  labour_cost_service_id: newServiceFromApi.id,
                  is_service_row: 0,
                  service_write:
                    Number(prevRow?.service_write) === 1 || prevRow?.is_service_row == 1 ? 1 : 0,
                  is_line_catalog: 1,
                  entryMode: prevRow?.entryMode ?? rowForReplace?.entryMode ?? 'choose',
                  isAdditionalProduct: false,
                  qty: 1,
                  quantity: 1,
                  service_name:
                    (isChooseService ? newServiceFromApi?.name : prevRow.service_name) ||
                    newServiceFromApi?.name ||
                    '',
                  service_desc:
                  prevRow.service_desc ||
                    newServiceFromApi.description ||
                    '',
                  is_existing_service: Boolean(rowForReplace?.is_existing_service),
                  name:
                    (isChooseService ? newServiceFromApi?.name : prevRow.service_name) ||
                    newServiceFromApi?.name ||
                    '',
                  description:
                  prevRow.service_desc ||
                    newServiceFromApi.description ||
                    '',
                  addedByUserType: prevRow?.addedByUserType ?? rowForReplace?.addedByUserType ?? userType,
                }
                setFieldValue('services', newServiceList)
                return newServiceList
              }

              const updatedAppend = [
                ...prev,
                {
                  ...newServiceFromApi,
                  is_existing_service: Boolean(rowForReplace?.is_existing_service),
                  is_service_row: 0,
                  is_line_catalog: 1,
                  entryMode: rowForReplace?.entryMode ?? 'choose',
                  labour_cost_service_id: newServiceFromApi.id,
                  qty: 1,
                  quantity: 1,
                },
              ]
              setFieldValue('services', updatedAppend)
              return updatedAppend
            })
            setSelectedServiceForCatalog(null)
          } else {
            // Fallback: service list API may be eventually consistent.
            // Still convert the selected request-estimate row so it doesn't remain in "Add Service" state.
            setAdditionalSelectedServices((prevServices) => {
              const prev = Array.isArray(prevServices) ? prevServices : []
              const existingIndex = findRowIndex(prev, rowForReplace)

              if (existingIndex >= 0) {
                const updated = [...prev]
                const prevRow = updated[existingIndex]
                updated[existingIndex] = {
                  ...prevRow,
                  labour_cost_service_id: idNum,
                  id: prevRow?.id || idNum,
                  is_service_row: 0,
                  service_write:
                    Number(prevRow?.service_write) === 1 || prevRow?.is_service_row == 1 ? 1 : 0,
                  is_line_catalog: 1,
                  entryMode: prevRow?.entryMode ?? rowForReplace?.entryMode ?? 'choose',
                  isAdditionalProduct: false,
                  qty: 1,
                  quantity: 1,
                  is_existing_service: Boolean(rowForReplace?.is_existing_service),
                  name: prevRow?.service_name || prevRow?.name || '',
                  service_name: prevRow?.service_name || prevRow?.name || '',
                  description: prevRow?.product_desc || prevRow?.service_desc || prevRow?.description || '',
                  service_desc: prevRow?.service_desc || prevRow?.description || '',
                }
                setFieldValue('services', updated)
                setSelectedServiceForCatalog(null)
                return updated
              }

              setFieldValue('services', prev)
              return prev
            })
          }
        } else {
          const newServiceFromApi = resolveNewServiceFromApi(allServices)

          if (newServiceFromApi) {
            setAdditionalSelectedServices((prevServices) => {
              const prev = Array.isArray(prevServices) ? prevServices : [];

              const alreadyExists = prev.some(
                (s) =>
                  Number(s?.id) === Number(newServiceFromApi?.id) ||
                  Number(s?.labour_cost_service_id) === Number(newServiceFromApi?.id),
              );
              if (alreadyExists) {
                setFieldValue('services', prev);
                return prev;
              }

              const maxNewIndexId = Math.max(
                Number(serviceIndexCounter) || 0,
                ...prev.map((s) => Number(s?.newIndexId) || 0),
              );
              const maxProductIndex = Math.max(
                0,
                ...prev.map((s) => Number(s?.product_index ?? s?.indexId) || 0),
              );

              const nextItem = {
                ...newServiceFromApi,
                labour_cost_service_id: newServiceFromApi?.id,
                service_desc: newServiceFromApi.description || '',
                productId: newServiceFromApi?.id,
                backendId: null,
                is_service_row: 0,
                qty: 1,
                quantity: 1,
                product_index: maxProductIndex + 1,
                indexId: maxProductIndex + 1,
                newIndexId: maxNewIndexId + 1,
                addresses: [
                  {
                    address: '',
                    city: '',
                    state: '',
                    zip: '',
                  },
                ],
              };

              const updated = [...prev, nextItem];
              setServiceIndexCounter(maxNewIndexId + 1);
              setFieldValue('services', updated);
              return updated;
            });
          } else {
            setFieldValue('services', additionalSelectedServices);
          }
        }
      }
    } catch (productsError) {
      console.error('Error fetching services:', productsError);
      setLabourCostServices([]);
    } finally {
      setLoadingServices(false);
    }
  };
  

  console.log('materialssssssssss', materials)
  const fetchAllMapServices = async () => {
    setMapServicesLoading(true)
    try {
      const res = await axios.post(
        `${REST_API}webservice/route/fetch-routes-with-locations`,
        { requestId: id },
      )
      let data = res.data?.routeData
      if (data) {
        const newData = data?.filter((i) => i.locations != null)
        if (newData) {
          setMapServices(newData)
        } else {
          setMapServices([])
        }
      } else {
        setMapServices([])
      }
    } catch (error) {
      setMapServices([])
      console.log(error, 'Error in fetching map services')
    } finally {
      setMapServicesLoading(false)
    }
  }

  const fetchTeamMembersForCollaborators = async () => {
    setTeamMembersLoading(true)
    try {
      const res = await axios.post(`${REST_API}webservice/teams/get-all-teams-data-collaborators`, {
        usersId: userId,
        usersType: userType,
        isClient: isClient || false,
        page: 1,
        rowsPerPage: 5000,
        orderBy: 'name',
        order: 'asc',
      })
      const raw = res.data?.team_members?.data || res.data?.team_members || []
      const filteredList = Array.isArray(raw) ? raw.filter(member => member.userRole !== "Development" && member.user_type !== 51) : []
      setTeamMembersOptions(filteredList)
    } catch (error) {
      setTeamMembersOptions([])
    } finally {
      setTeamMembersLoading(false)
    }
  }

  const findEditClientByCustomerId = (clients, customerId) => {
    if (customerId == null || customerId === '' || !Array.isArray(clients)) {
      return null
    }
    return (
      clients.find((client) => String(client?.id) === String(customerId)) ||
      null
    )
  }

  const fetchAllClients = async () => {
    try {
      const res = await axios.post(
        `${REST_API}webservice/clients/getAllClients`,
        { userType, userId: userId, order: true },
      )
      let data = res.data?.customer
      await setAllClientsEdit(data)
    } catch (error) {
      console.log(error, 'Error in fetching all clients', error)
    }
  }

  const fetchAllCommunityByClient = async (clientId) => {
    setIsCommunityLoading(true)
    try {
      clientId = clientId?.id
      const res = await axios.post(
        `${REST_API}webservice/rfq/get-community-by-client`,
        { clientId ,noAllCommunity:true},
      )
      let data = res.data?.community
      await setCommunities(data)
    } catch (error) {
      console.log(error, 'Error in fetching all clients')
      setCommunities([])
    } finally {
      setIsCommunityLoading(false)
    }
  }
  console.log('fetchRequestDetails===id=',id)
  useEffect(() => {
    if (id) {
      fetchRequestDetails()
    }
    fetchTaxCategory()
    fetchAllSignAgreements()
    fetchAllMapServices()
    fetchAllClients()
    fetchAllCommunityByClient()
    fetchTeamMembersForCollaborators()
  }, [id, refresh])

  useEffect(() => {
    try {
      axios
        .post(`${REST_API_END_POINT}project/get-specific-data-for-add-project`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          if (response.data.status === 1) {
            setProjectTypes(response.data.projectTypes)
            const category = response.data.projectCategories
            const filteredCategory = category?.filter((item) => item.id == 14)
            setProjectCategories(filteredCategory)
            setAllEstimators(response.data.allEstimators)
          }
        })
        .catch((error) => {
          console.error(error)
        })
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }, [])
  //rfq product detais
  const fetchOrderProductDetails = async () => {
    try {
      let orderId = details?.id
      const res = await axios.post(
        `${REST_API}webservice/get-customer-order-product/${orderId}`,
      )
      setInvoice(res.data.data)
      setCommunities(res.data.community)

      // Prefill request_estimate product rows from already submitted products (if any)
      if (details?.is_request_estimate == 1) {
        const submittedProducts = res?.data?.data?.cust_product || [];
        const submittedServices = res?.data?.data?.jobcost_service || [];
        const productRowProducts = submittedProducts.filter(prod => prod?.is_product_row == 1); // was: submittedProducts (all products — catalog lines were wrongly treated as write rows)
        const serviceRowServices = submittedServices.filter(service => service?.is_service_row == 1);
        // if (submittedProducts.length > 0) {
        //   const mappedRows = submittedProducts.map((prod, idx) => ({
        //     indexId: prod?.product_index ?? idx,
        //     product_name: prod?.product_name || '',
            // product_desc: prod?.product_desc || prod?.description || ''
        if (productRowProducts.length > 0) {
          const mappedRows = productRowProducts.map((prod, idx) => ({
            indexId: prod?.product_index ?? (idx + 1),
            product_name: prod?.product_name || '',
            product_desc: prod?.product_desc || prod?.description || '',
            product_desc: prod?.product_desc || prod?.description || '',
            backendId: prod?.id || prod?.backendId || null,
            is_product_row: 1
          }));
          // Only override if we don't already have user edits
          const hasUserProductNames = productRows?.some(r => (r?.product_name || '').trim() !== '');
          if (!hasUserProductNames) {
            setProductRows(mappedRows);
            // const maxIdx = Math.max(...mappedRows.map(r => r.indexId || 0), mappedRows.length - 1);
            const maxIdx = Math.max(...mappedRows.map(r => r.indexId || 0), mappedRows.length);
            setProductRowsIndexCounter(maxIdx);
          }
        }
        if (serviceRowServices.length > 0) {
          const mappedRows = serviceRowServices.map((service, idx) => ({
            indexId: service?.product_index ?? idx,
            service_name: service?.service_name || '',
            service_desc: service?.service_desc || '',
            backendId: service?.id || service?.backendId || null,
            is_service_row: 1
          }));
          const hasExistingRows = serviceRows?.length > 0 && serviceRows.some(r => r.backendId || (r?.service_name || '').trim() !== '');
          if (!hasExistingRows) {
            setServiceRows(mappedRows);
            const maxIdx = Math.max(...mappedRows.map(r => r.indexId || 0), mappedRows.length);
            setServiceRowsIndexCounter(maxIdx);
          }
        }
      }

      const rfqServicesData = res?.data?.data?.cust_product?.flatMap(
        (product) => {
          console.log('product1234', product)
          return product.services.map((service) => ({
            ...service,
            productIndex: product.product_index,
            product_id: product.product_id,
            qtyData: product.quantity,
            locationQuantity: product.locationQuantity || 1,
            productName: product?.product_name,
          }))
        },
      )
      let labourInstallData = rfqServicesData?.filter(
        (item) => item.labour_cost_service_id == 10,
      )
      setLabourInstallService(labourInstallData)

      return res.data
    } catch (error) {
      console.error('Error fetching request details:', error)
      throw error
    }
  }
  const handleSendEmail = async () => {
    try {
      let orderId = details?.id
      const res = await axios.post(`${REST_API}webservice/settings/send-mail`, {
        id: orderId,
      })

      if (res.data.status === 1) {
        enqueueSnackbar('Email send successfully', { variant: 'success' })
        setOpenInvoice(false)
      }
      return res.data
    } catch (error) {
      console.error('Error fetching request details:', error)
      throw error
    }
  }

  const handleSendInvoiceEmail = () => {
    if (!invoice || !details) {
      enqueueSnackbar('Invoice data not available', { variant: 'warning' })
      return
    }

    const groupedDesignOrderDisplayRows = serializeDesignOrderGroupedRowsForInvoice(
      buildGroupedDesignOrderDisplayRows({
        designOrderProducts: selectedProducts,
        customerOrderProductGroups,
        markupType,
        groupProductMarketingValues,
        groupInstallMarketingValues,
      }),
    )

    // Create invoice PDF object formatted for SendDesignsEmailModal
    const invoicePdfObject = {
      id: `invoice_${details.id}`,
      name: `Invoice_${details.name || details.id}_${moment().format(
        'YYYY-MM-DD',
      )}.pdf`,
      file_type: 'application/pdf',
      extension: 'pdf',
      url: null, // Will be generated on backend
      invoiceData: {
        invoice: invoice,
        details: details,
        invoiceDate: invoiceDate,
        subTotal: subTotal,
        cartService: cartService,
        additionalSelectedServices: additionalSelectedServices,
        invoiceSelectedServices: invoiceSelectedServices,
        labourInstallService: labourInstallService,
        taxRateData: taxRateData,
        taxAmount: taxAmount,
        customerOrderProductGroups,
        groupedDesignOrderDisplayRows,
        markupType,
        groupProductMarketingValues,
        groupInstallMarketingValues,
      },
    }

    setInvoicePdfData([invoicePdfObject])
    setOpenInvoiceEmailModal(true)
  }

  const handleInvoiceEmailSent = () => {
    setInvoicePdfData(null)
  }
  const fetchRequestServicesDetails = async () => {
    try {
      let orderId = details?.id
      const res = await axios.post(
        `${REST_API}webservice/get-request-services/${orderId}`,
      )
      setInvoice(res.data.data)
      return res.data.data
    } catch (error) {
      console.error('Error fetching request details:', error)
      throw error
    }
  }

  const assignProjectAgain = (
    rfqCommunity,
    shouldCallAssignProject,
    shouldCallAssignProjectRFP,
  ) => {
    console.log('New Value:', rfqCommunity)
    const { address, city, state, zip } = rfqCommunity
    if (shouldCallAssignProject) {
      setAdditionalSelectedServices((prevServices) =>
        prevServices.map((service) => {
          const updatedAddresses =
            service.addresses?.map((loc) => ({
              ...loc,
              address: address ?? loc.address,
              city: city ?? loc.city,
              state: state ?? loc.state,
              zip: zip ?? loc.zip,
            })) ?? [] // Ensures addresses is never undefined

          return { ...service, addresses: updatedAddresses }
        }),
      )
    }
    if (shouldCallAssignProjectRFP) {
      setCartService((prevServices) =>
        prevServices.map((service) => {
          const updatedAddresses =
            service.addresses?.map((loc) => ({
              ...loc,
              address: address ?? loc.address,
              city: city ?? loc.city,
              state: state ?? loc.state,
              zip: zip ?? loc.zip,
            })) ?? []

          return { ...service, addresses: updatedAddresses }
        }),
      )
    }
  }

  const ensureLabourCostServicesLoaded = async () => {
    if (labourCostServices?.length) return labourCostServices
    try {
      const loaded = await fetchLabourCostServicesForDropdown(axios, REST_API, {
        isNotSplitOrder: true,
      })
      if (loaded.length) {
        setLabourCostServices(loaded)
        setFilteredServices(loaded)
      }
      return loaded
    } catch (error) {
      console.error('Error loading labour cost services:', error)
      return []
    }
  }

  const addingInitialdataRFQ = async () => {
    // setLoading(true)
    try {
      if (openEdit) {
        let servicesArray = details?.services?.split(',')?.map(Number)
        let workflowSet = details?.workflows?.split(',')?.map(Number)
        const newInvoiceData = await fetchOrderProductDetails()
        const invoiceData = newInvoiceData?.data
        const communityData = newInvoiceData?.community
        const rfqTaxCategory =
          taxCategories?.find((cat) => invoiceData.tax_category === cat.id) ||
          null
        setSelectedTaxCategory(rfqTaxCategory)
        // let rfqSkill = skills?.filter((row) => row.id == details?.services);
        // let rfqSkill = skills.filter(skill => servicesArray.includes(skill.id));
        // let rfqWorkFlow = workflow?.filter(skill => workflowSet?.includes(skill.id));
        let rfqProjectType = projectTypes?.find(
          (type) => details.project_type === type.id,
        )
        let rfqSignAgreements = details?.sign_agreement ? details.sign_agreement.split(',').map(Number) : [];
        let rfqSignAgreementsData = invoiceData?.sign_agreements?.filter(item => rfqSignAgreements.includes(item.id))
        console.log('rfqSignAgreementsData++++++++',rfqSignAgreementsData)
        const customerId =
          customerData?.customer_id ?? details?.customer_id
        let rfqCustomerData = findEditClientByCustomerId(
          allClientsEdit,
          customerId,
        )
        let rfqProjectcategory = projectCategories?.find(
          (cat) => details.project_category === cat.id,
        )
        let rfqMarkupType = markupTypes?.find(
          (cat) => details?.markup_type === cat.id,
        )
        let rfqMapServices = mapServices?.find(
          (cat) => details?.map_service === cat.id,
        )
        let rfqCommunity = communityData?.find(
          (com) => details.community === com.id,
        )

        // rfqProduct = invoiceData?.cust_product.filter((row) => {
        //   return allProducts.filter(data => data.id == row.product_id)
        // })
        let productsCatalog = catalogProductsRef.current?.length ? catalogProductsRef.current : allProducts
        if (!productsCatalog?.length) {
          productsCatalog = (await fetchProducts()) || []
        }
        let rfqProduct = invoiceData?.cust_product
          ?.filter((row) => row.rfp === 0 && row.material === 0)
          ?.map((row) => {
            const lineIndex =
              Number(row.product_index) > 0
                ? Number(row.product_index)
                : Number(row.indexId) > 0
                  ? Number(row.indexId)
                  : null

            if (isApiProductWriteRow(row) && Number(row?.is_line_catalog) !== 1) {
              // Draft does not store expected_*_with_markup; restore from order-product recipe join
              // (and catalog list as fallback) so Product formula cost Each matches pre-draft.
              const writeCatalogMatch =
                row.product_id != null && productsCatalog?.length
                  ? productsCatalog.find(
                      (data) => Number(data.id) === Number(row.product_id),
                    )
                  : null
              return {
                indexId: lineIndex ?? row.product_index,
                product_name: row.product_name || '',
                product_desc: row.product_desc || '',
                name: row.product_name || '',
                description: row.product_desc || row.description || '',
                productAttachments: row.attachments || row.productAttachments || [],
                retail_price: row.product_retail_price || row.retail_price || 0,
                is_catalog_line_item: row.is_catalog_line_item || 0,
                is_line_catalog: row.is_line_catalog ?? 0,
                is_product_row: 1,
                entryMode: 'write',
                backendId: row.id || null,
                product_total: row.product_total || 0,
                product_notes: row.product_notes,
                discount: row.discount,
                adjustment: row.adjustment,
                adj_value_type: row.adj_value_type,
                quantity: row.quantity || row.product_qty || 1,
                install_cost: row.install_cost,
                install_adjustment: row.install_adjustment,
                install_adj_value_type: row.install_adj_value_type,
                install_quantity: row.install_qty,
                location: row.location,
                allLocationSame: row.allLocationSame,
                locationQuantity: row.locationQuantity,
                group_product_quantity:
                  row.group_product_quantity ?? row.locationQuantity ?? row.location_quantity ?? 1,
                group_install_quantity:
                  row.group_install_quantity ?? row.install_qty ?? row.install_quantity ?? 1,
                markAdjType: row.markAdjType,
                fromMapServices: row.map_service == 1 ? true : false,
                is_single_card: row.is_single_card == 1 ? true : false,
                max_price_mi_id: row.materialInvId || null,
                group_id: row.group_id || null,
                group_name: row.group_name || null,
                group_description: row.group_description || null,
                product_write:row.product_write,
                isaddedFromJob: row.isaddedFromJob ?? 0,
                addedByUserType: row.addedByUserType ?? row.added_by_user_type ?? null,
                ...hydrateSavedOrderLinePrices(row),
                ...(row.group_id ? hydrateGroupedMemberMarketingFromRow(row) : {}),
                id: row.product_id || writeCatalogMatch?.id || undefined,
                recipe_id: row.recipe_id ?? writeCatalogMatch?.recipe_id,
                recipe_status: row.recipe_status ?? writeCatalogMatch?.recipe_status,
                inhouse: row.inhouse ?? writeCatalogMatch?.inhouse,
                expected_material_cost_with_markup:
                  row.expected_material_cost_with_markup ??
                  writeCatalogMatch?.expected_material_cost_with_markup,
                expected_service_cost_with_markup:
                  row.expected_service_cost_with_markup ??
                  writeCatalogMatch?.expected_service_cost_with_markup,
                expected_install_labor_cost_with_markup:
                  row.expected_install_labor_cost_with_markup ??
                  writeCatalogMatch?.expected_install_labor_cost_with_markup ??
                  writeCatalogMatch?.install_labour_cost_with_markup,
                expected_cost: row.expected_cost ?? writeCatalogMatch?.expected_cost,
                product_formula_cost_each: row.product_formula_cost_each ?? null,
                install_formula_cost_each: row.install_formula_cost_each ?? null,
              }
            }
            // let match = allProducts?.find((data) => data.id == row.product_id)
            // if (match || row.product_id == null) {
            let match = productsCatalog?.length > 0
              ? productsCatalog.find(
                  (data) => Number(data.id) === Number(row.product_id),
                )
              : null // was: allProducts?.find(...) / data.id == row.product_id
            if (match) {
              console.log('row++++++++row++++++++row++++++++',match)
              console.log('row++++++++row++++++++row++++++++',row)
              return {
                // ...(match || { indexId: row.product_index, product_name: row.product_name || '', product_desc: row.product_desc || '' }),
                // product_desc:  row.product_desc || '',
                ...match,
                product_desc: match ? match.description : (row.product_desc ||row.description || ''),
                product_name: row.product_name || '',
                name: row.product_name || match?.name || '',
                description: row.description || match?.description || '',
                is_existing_catalog: row?.is_existing_catalog || 0,
                inhouse: row?.inhouse ?? (row?.is_existing_catalog==1 ? 7 : match?.inhouse),
                status: match?.status ?? row?.product_status,
                created_with_approval: match?.created_with_approval ?? row?.created_with_approval,
                product_desc: row.product_desc || row.description || match?.product_desc || match?.description || '',
                productAttachments: row.attachments || row.productAttachments || [],
                // ALL-815 backup - previous manual saved price hydration:
                // retail_price: row.product_retail_price || row.retail_price || 0,
                // original_actual_retail_price: row.original_actual_retail_price,
                // original_retail_price: row.original_retail_price,
                // original_price: row.original_price,
                // original_product_retail_price: row.original_product_retail_price,
                // original_product_price: row.original_product_price,
                // original_install_cost: row.original_install_cost,
               ...(() => {
                    const savedPriceHydration = hydrateSavedOrderLinePrices(row, match)

                    // Saved order lines already contain adjusted prices.
                    // Do not run them through getCatalogPickerOriginalPrices again,
                    // otherwise the adjustment can be applied twice.
                    if (Object.keys(savedPriceHydration).length) {
                      return savedPriceHydration
                    }

                    // Fallback for rows that do not have saved-order price hydration.
                    return getCatalogPickerOriginalPrices({
                  ...(match || {}),
                  ...row,
                  actual_retail_price:
                    row.product_retail_price ??
                  row.retail_price ??
                  match?.actual_retail_price,
                  retail_price: row.retail_price ?? match?.retail_price,
                  install_cost: row.install_cost ?? match?.install_cost,
                    })
                  })(),

                expected_material_cost_with_markup:
                  row.expected_material_cost_with_markup ??
                  match?.expected_material_cost_with_markup,

                expected_service_cost_with_markup:
                  row.expected_service_cost_with_markup ??
                  match?.expected_service_cost_with_markup,

                expected_install_labor_cost_with_markup:
                  row.expected_install_labor_cost_with_markup ??
                  match?.expected_install_labor_cost_with_markup,

                product_formula_cost_each:
                  row.product_formula_cost_each ?? null,

                install_formula_cost_each:
                  row.install_formula_cost_each ?? null,

                recipe_id:
                  match?.recipe_id ??
                  row.recipe_id,

                recipe_status:
                  match?.recipe_status ??
                  row.recipe_status,
                indexId: lineIndex ?? row.product_index,
                is_catalog_line_item: row.is_catalog_line_item || 0,
                is_line_catalog: row.is_line_catalog ?? 0,
                // entryMode: row.is_product_row ? 'write' :'choose',
                is_product_row: row.is_product_row || 0,
                backendId: row.id || null, // Backend ID for delete/update operations
                product_total: row.product_total || 0,
                product_notes: row.product_notes,
                discount: row.discount,
                adjustment: row.adjustment,
                adj_value_type: row.adj_value_type,
                quantity: row.quantity,
                install_cost: row.install_cost,
                install_adjustment: row.install_adjustment,
                install_adj_value_type: row.install_adj_value_type,
                // install_quantity: row.install_quantity,
                install_quantity: row.install_qty,
                location: row.location,
                allLocationSame: row.allLocationSame,
                locationQuantity: row.locationQuantity,
                group_product_quantity:
                  row.group_product_quantity ?? row.locationQuantity ?? row.location_quantity ?? 1,
                group_install_quantity:
                  row.group_install_quantity ?? row.install_qty ?? row.install_quantity ?? 1,
                markAdjType: row.markAdjType,
                fromMapServices: row.map_service == 1 ? true : false,
                is_single_card: row.is_single_card == 1 ? true : false,
                max_price_mi_id: row.materialInvId || null,
                sub_contract_markup : match?.markup,
                group_id: row.group_id || null,
                group_name: row.group_name || null,
                group_description: row.group_description || null,
                ...(row.group_id ? hydrateGroupedMemberMarketingFromRow(row) : {}),
                product_write:row.product_write,
                isaddedFromJob: row.isaddedFromJob ?? 0,
                entryMode: row.is_product_row == 1 ? 'write' : 'choose',
                addedByUserType: row.addedByUserType ?? row.added_by_user_type ?? null,
              }
            }
            if (row.product_id == null || row?.product_name) { // was: if (match || row.product_id == null) — catalog rows with product_id but no catalog match were dropped after design→estimate
              const rowRetail = row.product_retail_price ?? row.retail_price ?? 0
              const rowWholesale = row.product_price ?? row.price ?? 0
              return {
                id: row.product_id || row.id,
                indexId: lineIndex ?? row.product_index,
                product_name: row.product_name || '',
                product_desc: row.product_desc || '',
                name: row.product_name || '',
                description: row.product_desc || row.description || '',
                productAttachments: row.attachments || row.productAttachments || [],
                retail_price: row.install_cost
                  ? rowRetail + (row?.adj_value_type ? -(Number(row.adjustment) || 0) : +(Number(row.adjustment) || 0))
                  : rowRetail,
                product_retail_price: rowRetail,
                price: rowWholesale,
                product_price: rowWholesale,
                is_catalog_line_item: row.is_catalog_line_item || 0,
                is_line_catalog: row.is_line_catalog ?? 0,
                is_product_row: row.is_product_row || 0,
                inhouse: row?.inhouse ?? (row?.is_existing_catalog==1 ? 7 : undefined),
                status: row?.product_status,
                created_with_approval: row?.created_with_approval,
                backendId: row.id || null,
                product_total: row.product_total || 0,
                product_notes: row.product_notes,
                discount: row.discount,
                adjustment: row.adjustment,
                adj_value_type: row.adj_value_type,
                quantity: row.quantity || row.product_qty || 1,
                install_cost: row.install_cost,
                install_adjustment: row.install_adjustment,
                install_adj_value_type: row.install_adj_value_type,
                install_quantity: row.install_qty || row.install_quantity,
                location: row.location,
                allLocationSame: row.allLocationSame,
                locationQuantity: row.locationQuantity || row.location_quantity || 1,
                group_product_quantity:
                  row.group_product_quantity ??
                  row.locationQuantity ??
                  row.location_quantity ??
                  1,
                group_install_quantity:
                  row.group_install_quantity ?? row.install_qty ?? row.install_quantity ?? 1,
                markAdjType: row.markAdjType,
                fromMapServices: row.map_service == 1 ? true : false,
                is_single_card: row.is_single_card == 1 ? true : false,
                max_price_mi_id: row.materialInvId || null,
                group_id: row.group_id || null,
                group_name: row.group_name || null,
                group_description: row.group_description || null,
                product_write: row.product_write,
                isaddedFromJob: row.isaddedFromJob ?? 0,
                entryMode: row.is_product_row == 1 ? 'write' : 'choose',
                isAdditionalProduct: !match && row.product_id == null,
                addedByUserType: row.addedByUserType ?? row.added_by_user_type ?? null,
                ...hydrateSavedOrderLinePrices(row),
                ...(row.group_id ? hydrateGroupedMemberMarketingFromRow(row) : {}),
                recipe_id: row.recipe_id,
                recipe_status: row.recipe_status,
                inhouse: row.inhouse,
                expected_material_cost_with_markup: row.expected_material_cost_with_markup,
                expected_service_cost_with_markup: row.expected_service_cost_with_markup,
                expected_install_labor_cost_with_markup: row.expected_install_labor_cost_with_markup,
                expected_cost: row.expected_cost,
                product_formula_cost_each: row.product_formula_cost_each ?? null,
                install_formula_cost_each: row.install_formula_cost_each ?? null,
              }
            }
            return undefined
          })
          .filter((item) => item !== undefined)
        rfqProduct = (rfqProduct || []).map((p, idx) => {
          const indexId = Number(p.indexId) > 0 ? Number(p.indexId) : idx + 1
          return { ...p, indexId, product_index: indexId }
        })
        console.log('####################RFQ', rfqProduct)
        console.log('invoiceData----', invoiceData)
        const highestIndexId = rfqProduct?.reduce((max, product) => {
          return typeof product.indexId === 'number' && product.indexId > max
            ? product.indexId
            : max
        }, 0)

        setIndexCounter(highestIndexId)
        const rfqProductWithLocations = (rfqProduct || []).map((product) =>
          withCommunityLocationIfMissing(product, rfqCommunity),
        )
        const filteredData = rfqProductWithLocations?.filter(
          (item) => item?.fromMapServices == true,
        )
        setSelectedMapserviceProducts(filteredData || [])
        // Deduplicate products by indexId to prevent duplicates on refresh
        const deduplicatedProducts = rfqProductWithLocations?.reduce((unique, product) => {
          if (!unique.find(p => String(p.indexId) === String(product.indexId))) {
            unique.push(product)
          }
          return unique
        }, []) || []
        setSelectedProducts(deduplicatedProducts)
        // setSelectedProducts(rfqProductWithLocations)
        const productAttachmentsMap = {}
        ;(rfqProductWithLocations || []).forEach((p) => {
          const idx = p.indexId
          const raw = p.productAttachments || p.attachments
          if (idx != null && idx !== '' && Array.isArray(raw) && raw.length) {
            const key = String(idx)
            productAttachmentsMap[key] = raw.map((att) => ({
              url: att.url || att.file_url || att.name,
              name: att.name || att.file_url || att.url,
              file_type: att.file_type,
              extension: att.extension,
              size: att.size,
              product_index_id: key,
            }))
          }
        })
        setProductAttachments(productAttachmentsMap)
        // const serviceIdArray = details?.labour_cost_services?.split(',')?.map(Number);
        // const rfqServices = invoiceData?.cust_product?.map((row)=>
        //   labourCostServices?.find(data => data.id == row.id)
        // )
        //   const rfqServices = invoiceData?.cust_product?.map(product => {
        //     const productServices = product.services?.map(service => {
        //         const serviceData = labourCostServices.find(data => data.id === service.id);
        //         return serviceData;
        //     });

        //     // Return an object containing product details along with its services
        //     return productServices;
        // });
        let rfpProduct = invoiceData?.cust_product?.filter(
          (row) => row.rfp === 1,
        )
        // let materials = invoiceData?.cust_product.filter((row) => row.material === 1 &&  row.rfp === 0 )

        let materials = invoiceData?.cust_product
          ?.filter((row) => row.material === 1 && row.rfp === 0)
          ?.map((row, index) => ({
            ...row,
            newIndexId: index + 1,
            product_description: row.product_description || '',
          }))

        console.log('rfpProduct---', rfpProduct)

        let rfpProductUpdated = rfpProduct?.map((item) => ({
          ...item,
          allRfpProductsLocationSame: item.allLocationSame == 1 ? true : false,
        }))
        console.log('rfpProduct---rfpProductUpdated', rfpProductUpdated)

        setSelectedMaterials(materials)
        setCart(
          (rfpProductUpdated || []).map((product) =>
            withCommunityLocationIfMissing(product, rfqCommunity),
          ),
        )
        const rfpServices = rfpServicesEdit
          ?.filter((item) => item?.recipe_id === null && item?.rfp === 1)
          ?.map((serviceItem) => ({
            ...serviceItem,
            location: [
              {
                address: serviceItem.address,
                city: serviceItem.city,
                state: serviceItem.state,
                zip: serviceItem.zip,
              },
            ],
          }))
        setCartService(rfpServices)
        const rfqServicesData =
          invoiceData?.cust_product?.flatMap((product) => {
            console.log('product--', product)
            return (product.services || []).map((service) => ({
              ...service,
              productIndex: product.product_index,
              product_id: product.product_id,
              qtyData: product.quantity,
              fromMapServices: product.map_service == 1 ? true : false,
              locationQuantity: product.locationQuantity || 1,
            }))
          }) ?? []
        console.log('##################rfqServiceData', rfqServicesData)
        await setSelectedServices(rfqServicesData)

        const servicesSource = await ensureLabourCostServicesLoaded()
        setFilteredServices(
          computeFilteredServicesForDropdown(servicesSource, rfqServicesData),
        )

        const additionalServices = requestServices?.filter(
          (item) => item?.recipe_id === null,
        )
        const additionalServicesData = sortServicesByProductIndex(
          additionalServices?.filter(dataa => dataa?.service_type != 44) || [],
        )
        console.log('additionalServicesData1234',additionalServicesData)
        const usedLineIndices = new Set()
        const updatedServicesData = additionalServicesData?.map(
          (serviceItem, index) => {
            let lineIndex = Number(serviceItem?.product_index)
            if (!lineIndex || lineIndex <= 0 || usedLineIndices.has(lineIndex)) {
              lineIndex = index + 1
              while (usedLineIndices.has(lineIndex)) {
                lineIndex += 1
              }
            }
            usedLineIndices.add(lineIndex)
            const flaggedWriteRow =
              Number(serviceItem.is_service_row) === 1 ||
              serviceItem.is_service_row === '1' ||
              serviceItem.is_service_row === true
            const hasCatalogOnLoad =
              Number(serviceItem?.is_line_catalog) === 1 ||
              (serviceItem.labour_cost_service_id != null &&
                Number(serviceItem.labour_cost_service_id) > 0)
            const isWriteRow = flaggedWriteRow && !hasCatalogOnLoad
            return {
              ...serviceItem,
              newIndexId: lineIndex,
              indexId: lineIndex,
              product_index: lineIndex,
              is_service_row: isWriteRow ? 1 : 0,
              service_write: serviceItem.service_write,
              is_line_catalog: hasCatalogOnLoad
                ? 1
                : serviceItem.is_line_catalog ?? 0,
              entryMode: isWriteRow ? 'write' : serviceItem.labour_cost_service_id ? 'choose' : undefined,
              backendId: serviceItem.id || null, // Backend ID for delete/update operations
              isaddedFromJob: serviceItem.isaddedFromJob ?? 0,
              addedByUserType: serviceItem.addedByUserType ?? serviceItem.added_by_user_type ?? null,
              productId: isWriteRow ? null : serviceItem.labour_cost_service_id,
              labour_cost_service_id: isWriteRow
                ? null
                : serviceItem.labour_cost_service_id,
              name: serviceItem.service_name || serviceItem.name,
              description: serviceItem.service_desc || serviceItem.description,
              serviceAttachments: serviceItem.attachments || serviceItem.serviceAttachments || [],
              addresses: [
                {
                  address: serviceItem.address,
                  city: serviceItem.city,
                  state: serviceItem.state,
                  zip: serviceItem.zip,
                },
              ],
            }
          },
        )
        console.log('updatedServicesData1234',updatedServicesData)
        setAdditionalSelectedServices(updatedServicesData)
        const serviceAttachmentsMap = {}
        ;(updatedServicesData || []).forEach((svc) => {
          const idx = svc?.newIndexId ?? svc?.indexId
          const raw = svc.serviceAttachments || svc.attachments
          if (idx != null && idx !== '' && Array.isArray(raw) && raw.length) {
            const key = String(idx)
            serviceAttachmentsMap[key] = raw.map((att) => ({
              url: att.url || att.file_url || att.name,
              name: att.name || att.file_url || att.url,
              file_type: att.file_type,
              extension: att.extension,
              size: att.size,
              service_index_id: key,
            }))
          }
        })
        setServiceAttachments(serviceAttachmentsMap)

        const shouldCallAssignProject = (updatedServicesData ?? []).some(
          (service) =>
            (service.addresses ?? []).some(
              (loc) =>
                loc.address == null ||
                loc.city == null ||
                loc.state == null ||
                loc.zip == null,
            ),
        )

        const shouldCallAssignProjectRFP = (rfpServices ?? []).some((service) =>
          (service.addresses ?? []).some(
            (loc) =>
              loc.address == null ||
              loc.city == null ||
              loc.state == null ||
              loc.zip == null,
          ),
        )

        if (
          rfqCommunity &&
          (shouldCallAssignProject || shouldCallAssignProjectRFP)
        ) {
          assignProjectAgain(
            rfqCommunity,
            shouldCallAssignProject,
            shouldCallAssignProjectRFP,
          )
        }
        console.log('string rfqCommunity++++', rfqCommunity)
        console.log('string details?.sales_rep_ids++++', details?.sales_rep_ids)
        if (rfqCommunity) {
          const repOptions = getSalesRepOptionsFromCommunity(rfqCommunity);
          setSalesRepOptions(repOptions);
          console.log('string repOptions++++', repOptions)
          if (repOptions.length > 0) {
            const selectedSalesRepId = details?.sales_rep_ids;
            setSalesRepName(repOptions?.find((rep) => String(rep.id) === String(selectedSalesRepId))?.name || '');
            setSalesRepId(repOptions?.find((rep) => String(rep.id) === String(selectedSalesRepId))?.id || null);
          } else {
            setSalesRepName('');
            setSalesRepId(null);
          }
        }

        console.log('details++++', details)

        setCurrentRFQdata({
          name: details?.name,
          created_at: details?.created_at,
          po_number: details?.po_number,
          description: details?.description,
          notes: details?.notes,

          // skills: rfqSkill,
          // workflow: rfqWorkFlow,
          project_category: rfqProjectcategory,
          markup_type: rfqMarkupType || markupTypes[1] || null,
          client: rfqCustomerData,
          community: rfqCommunity,
          project_type: rfqProjectType,
          sign_agreement: rfqSignAgreementsData,
          map_service: rfqMapServices,
          start:
            toDateOnlyUnix(details?.start) ??
            toDateOnlyUnix(details?.submission_deadline) ??
            localTodayDateOnlyUnix(),
          end:
            toDateOnlyUnix(details?.end) ??
            toDateOnlyUnix(details?.installation_end_date) ??
            toDateOnlyUnix(details?.participation_ends) ??
            localTodayDateOnlyUnix(),
          installation_start_date: details?.installation_start_date,
          installation_end_date: details?.installation_end_date,
          labour_cost: details?.labour_cost,
          budget: invoiceData?.budget || 0,
          products: rfqProductWithLocations || null,
          services: additionalServicesData || null,
          invoice_discount: invoiceData?.extra_discount,
          welcome_message: details?.welcome_message == 1 ? true : false || null,
         
          show_install_price: details?.show_install_price ?? 1,
          rush_fee: details?.rush_fee,
          rush_fee_amount: details?.rush_fee_amount,
          total: invoiceData?.total,
          taxAmount: invoiceData?.taxAmount || 0,
          tax: invoiceData?.tax,
          draft: details?.status == 1 ? true : false || null,
          sub_total: invoiceData?.sub_total,
          order_id: invoiceData?.id,
          subject: details?.subject || null,
          email_content: details?.email_content || null,
          estimate_id: details?.estimate_id,
          customer_name: details?.customer_name,
          // Manager approval toggle defaults OFF; keep ON only if previously saved
          manager_approval_required: details?.manager_approval_required == 1,
          facility_type: details?.facility_type,
          bill_to: details?.bill_to || '',
          ship_to: details?.ship_to || '',
          // avatarUrl:details?.thumbnail||null
        })

        // Parse and set estimators from comma-separated string
        if (details?.estimator_ids) {
          const estimatorIdArray = details.estimator_ids
            .split(',')
            .map((id) => id.trim())
            .map(Number)
            .filter((id) => !isNaN(id))

          const selectedEstimatorData =
            allEstimators?.filter((estimator) =>
              estimatorIdArray.includes(estimator.id),
            ) || []

          setSelectedEstimators(selectedEstimatorData)
        } else {
          setSelectedEstimators([])
        }
      }
    } catch (error) {
      console.error('Error adding initial data for Sales Order:', error)
    } finally {
      // setTimeout(() => {
      //   setLoading(false)
      // }, 3000);
    }
  }

  const handleAllRfpServiceLocationSameChange = () => {
    if (!allRfpServiceLocationSame) {
      // Ensure there's at least one service and its location array is valid
      const commonAddress = cartService[0]?.location?.[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
      }

      console.log('Common Address being applied:', commonAddress)

      // Update all locations to use the commonAddress
      setCartService((prevProducts) =>
        prevProducts.map((product) => ({
          ...product,
          location: product.location
            ? product.location.map(() => ({ ...commonAddress }))
            : [{ ...commonAddress }],
        })),
      )
    }

    setAllRfpServiceLocationSame(!allRfpServiceLocationSame)
  }

  const handleAllRfpProductsLocationSameChange = (productIndex) => {
    setCart((prevProducts) =>
      prevProducts.map((product, index) => {
        if (index === productIndex) {
          const isAllSame = !product.allRfpProductsLocationSame

          // Ensure there's at least one valid address and it matches `location_quantity`
          const locationQuantity = product.location_quantity || 1
          const commonAddress = product?.location?.[0] || {
            address: '',
            city: '',
            state: '',
            zip: '',
          }

          console.log('Common Address being applied:', commonAddress)

          return {
            ...product,
            allRfpProductsLocationSame: isAllSame,
            location: isAllSame
              ? Array.from({ length: locationQuantity }, () => ({
                  ...commonAddress,
                }))
              : Array.from({ length: locationQuantity }, () => ({
                  ...commonAddress,
                })),
            // : Array.from({ length: locationQuantity }, () => ({ address: '', city: '', state: '', zip: '' })),
          }
        }
        return product
      }),
    )
  }

  useEffect(() => {
    if (details) {
      fetchOrderProductDetails()
      if (details?.is_rfp_service_location == 1) {
        setAllRfpServiceLocationSame(true)
      } else {
        setAllRfpServiceLocationSame(false)
      }
      if (details?.is_rfp_product_location == 1) {
        setAllRfpProductsLocationSame(true)
      } else {
        setAllRfpProductsLocationSame(false)
      }
    }
  }, [details])

  useEffect(() => {
    if (!openEdit) return
    let cancelled = false
    const initEditForm = async () => {
      setLoading(true)
      await ensureLabourCostServicesLoaded()
      if (!cancelled) {
        await addingInitialdataRFQ()
      }
      if (!cancelled) {
        setLoading(false)
      }
    }
    initEditForm()
    return () => {
      cancelled = true
    }
  }, [openEdit])

  useEffect(() => {
    if (!openEdit || !labourCostServices?.length) return
    setFilteredServices(
      computeFilteredServicesForDropdown(labourCostServices, selectedServices),
    )
  }, [openEdit, labourCostServices, selectedServices])

  useEffect(() => {
    const raw = details?.collaborators || null
    if (!raw || !teamMembersOptions?.length) return
    const collaboratorIds = Array.isArray(raw) ? raw.map((c) => String(c?.id ?? c)) : String(raw || '').split(',').map((s) => s.trim()).filter(Boolean)
    const matched = teamMembersOptions.filter((opt) => collaboratorIds.includes(String(opt.id)) || collaboratorIds.includes(String(opt.user_id)))
    setCollaborators(matched)
  }, [teamMembersOptions, details?.collaborators])

  // The below useEffect is used for fetching the invoice details only
  useEffect(() => {
    if (details) {
      fetchOrderProductDetails()
    }
    console.log('requestServices--', requestServices)
    const rfqServicesData = invoice?.cust_product?.flatMap((product) => {
      console.log('product--', product)
      return product.services.map((service) => ({
        ...service,
        productIndex: product.product_index,
        product_id: product.product_id,
        qtyData: product.quantity,
        locationQuantity: product.locationQuantity || 1,
      }))
    })
    console.log('##################rfqInvoiceServiceData', rfqServicesData)
    const newrfqServicesData = rfqServicesData
      ?.filter((item) => {
        const newQty = parseFloat(
          (item.prQty * item.qtyData * item.locationQuantity)?.toFixed(2),
        )
        console.log('rfqInvoiceServiceDatanewQty-----------', newQty)
        console.log('rfqInvoiceServiceDataitem.qty-----------', item.qty)
        return newQty !== item.qty
      })
      .map((item) => {
        const newQty = item.prQty * item.qtyData * item.locationQuantity
        const quantityDifference = item.qty - newQty
        return {
          ...item,
          quantity: quantityDifference,
          quantityDifference: quantityDifference,
          total_cost: item.unit_cost * quantityDifference,
        }
      })

    console.log('newrfqServicesData-------', newrfqServicesData)

    setInvoiceSelectedServices(newrfqServicesData || [])
    const additionalServices = requestServices?.filter(
      (item) => item?.recipe_id === null,
    )
    const additionalServicesData = additionalServices || []
    setAdditionalSelectedServices(additionalServicesData)
    const rfpServices = rfpServicesEdit?.filter(
      (item) => item?.recipe_id === null && item?.rfp === 1,
    )
    setCartService(rfpServices)
  }, [openInvoice])

  const invoiceDate = formatDateOnly(details?.timestamp)

  /** Catalog options / merged rows must not inherit group membership from slot rows. */
  const stripGroupFieldsFromCatalogOption = (item) => {
    if (!item || typeof item !== 'object') return item
    const { group_id, group_name, group_description, group_catalog_anchor_index_id, ...rest } = item
    return rest
  }

  const productAutocompleteDisplayValue = useMemo(
    () =>
      collapseProductsForAutocompleteChips(
        (selectedProducts || []).filter((item) => isProductAutocompleteCatalogRow(item)),
        customerOrderProductGroups,
      ),
    [selectedProducts, customerOrderProductGroups],
  )

  const expandAutocompleteValueToMainProducts = useCallback((newCollapsed, prevSelected) => {
    const prev = prevSelected || []
    const mainPrev = prev.filter((p) => isProductAutocompleteCatalogRow(p))
    const expanded = []
    for (const chip of newCollapsed || []) {
      if (chip?.isGroupAutocompleteChip || (chip?.group_id != null && chip?.group_id !== '')) {
        const gid = String(chip.group_id)
        mainPrev
          .filter((p) => String(p.group_id) === gid)
          .sort((a, b) => Number(a.indexId || 0) - Number(b.indexId || 0))
          .forEach((p) => expanded.push(p))
        continue
      }
      const existing =
        chip?.indexId != null
          ? mainPrev.find((p) => Number(p.indexId) === Number(chip.indexId))
          : undefined
      if (existing) expanded.push(existing)
      else expanded.push(chip)
    }
    return expanded
  }, [])

  const handleAutocompleteCatalogProductsChange = (event, newCollapsed) => {
    const currentChips = productAutocompleteDisplayValue
    const currentKeys = new Set(currentChips.map((p) => getAutocompleteSelectionKey(p)))
    const withSingleCard = (rows) =>
      (rows || []).map((item) => ({
        ...item,
        is_single_card: values.project_category?.id !== 14,
      }))

    // Add newly selected catalog options (allow same product id multiple times)
    if ((newCollapsed || []).length > currentChips.length) {
      const added = (newCollapsed || []).filter(
        (p) => !currentKeys.has(getAutocompleteSelectionKey(p)),
      )
      if (added.length === 0) return

      let nextIndex = Math.max(...(selectedProducts || []).map((r) => r.indexId || 0), 0)
      const newCatalogRows = added.map((product) => {
        nextIndex += 1
        return {
          ...stripGroupFieldsFromCatalogOption(product),
          indexId: nextIndex,
          group_id: null,
          group_name: null,
          group_description: null,
          group_catalog_anchor_index_id: null,
        }
      })
      handleProduct(withSingleCard([...(selectedProducts || []), ...newCatalogRows]))
      return
    }

    // Remove: drop chips (and all members of a removed group chip)
    const expanded = expandAutocompleteValueToMainProducts(newCollapsed, selectedProducts)
    const keptIndexIds = new Set(
      expanded
        .map((p) => (p?.indexId != null ? Number(p.indexId) : null))
        .filter((id) => id != null),
    )

    const catalogKept = (selectedProducts || []).filter((p) => {
      if (!isProductAutocompleteCatalogRow(p)) return false
      return keptIndexIds.has(Number(p.indexId))
    })
    const nonCatalogRows = (selectedProducts || []).filter(
      (p) => !isProductAutocompleteCatalogRow(p),
    )
    const updated = [...nonCatalogRows, ...catalogKept].sort(
      (a, b) => Number(a.indexId || 0) - Number(b.indexId || 0),
    )
    handleProduct(withSingleCard(updated))
  }

  const handleProduct = (value, productRowIndexId=false, editProduct=false) => {
    console.log('handleProduct---value', value)
    // Extract community address from Formik's values
    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = '',
    } = values?.community || {}
    const communityAddress = {
      address: projAddress,
      city: projCity,
      state: projState,
      zip: projZip,
    }

    setSelectedProducts((prevProducts) => {
      const commonAddress = null

      let runningMaxIndexId = Math.max(
        0,
        Number(indexCounter) || 0,
        ...(prevProducts || []).map((p) => Number(p.indexId) || 0),
      )

      const updatedProducts = value.map((product) => {
        const dataRetailPrice =
          product.product_retail_price || product.retail_price
        const dataWholesalePrice = product.product_price || product.price || 0

        // Check if the product already exists in the selected products
        const existingProduct =
          details?.is_request_estimate == 1
            ? prevProducts.find(
                (p) =>
                  p.indexId != null &&
                  product.indexId != null &&
                  String(p.indexId) === String(product.indexId),
              )
            : prevProducts.find(
                (p) =>
                  (p.id === product.id || p.id === product.product_id) &&
                  p.indexId !== undefined &&
                  p.indexId === product.indexId,
              )

        console.log('###############ExistingProduct', existingProduct)

        if (existingProduct) {
          const quantity = existingProduct.quantity
          const locationQuantity = existingProduct.locationQuantity
          const marketingAdjustment = Number(existingProduct?.adjustment)
          let location = [...(existingProduct.location || [])]
          if (!hasProductLocationPresent(existingProduct)) {
            location = getDefaultProductLocationEntries(
              existingProduct.locationQuantity || 1,
            )
          } else if (allLocationSame && commonAddress) {
            location = [...commonAddress]
          } else {
            for (let i = location.length; i < 1; i++) {
              location.push(
                getDefaultProductLocationEntries(1)[0] || {
                  id: i,
                  address: '',
                  city: '',
                  state: '',
                  zip: '',
                },
              )
            }
          }

          const rowTotal = calculateTotal(
            markupType === 1
              ? dataWholesalePrice
              : markupType === 2
              ? dataRetailPrice
              : 0,
            product.dataQuantity,
            product.dataDiscount,
            quantity,
            locationQuantity,
            marketingAdjustment,
          )

          if (details?.is_request_estimate == 1) {
            return {
              ...existingProduct,
              ...product,
              indexId: existingProduct.indexId,
              group_id: existingProduct.group_id ?? null,
              group_name: existingProduct.group_name ?? null,
              group_description: existingProduct.group_description ?? null,
              isaddedFromJob: existingProduct?.backendId
                ? Number(existingProduct?.isaddedFromJob) === 1
                  ? 1
                  : 0
                : Number(product?.isaddedFromJob) === 1 ||
                    Number(existingProduct?.isaddedFromJob) === 1 ||
                    existingProduct?.isNewlyAddedProductRow
                  ? 1
                  : 1,
              addedByUserType:
                existingProduct.addedByUserType ??
                existingProduct.added_by_user_type ??
                product.addedByUserType ??
                product.added_by_user_type ??
                null,
              quantity,
              locationQuantity,
              rowTotal,
              location,
            }
          }

          // Catalog edit/refresh (editProduct): keep updated formula/cost fields.
          // Same id+indexId would otherwise drop them and leave Product formula cost Each stale.
          if (editProduct) {
            return {
              ...existingProduct,
              ...product,
              indexId: existingProduct.indexId,
              quantity,
              locationQuantity,
              rowTotal,
              location,
            }
          }

          return {
            ...existingProduct,
            quantity,
            rowTotal,
            location,
          }
        } else {
          // Add new product with default quantity and location
          const location = commonAddress || {
            id: 0,
            address: communityAddress.address || '',
            city: communityAddress.city || '',
            state: communityAddress.state || '',
            zip: communityAddress.zip || '',
          }
          let newIndexCounter
          if (productRowIndexId !== false && productRowIndexId != null) {
            newIndexCounter = Number(productRowIndexId)
          } else if (details?.is_request_estimate == 1) {
            runningMaxIndexId += 1
            newIndexCounter = runningMaxIndexId
          } else {
            newIndexCounter = indexCounter + 1
            setIndexCounter(newIndexCounter)
          }
          runningMaxIndexId = Math.max(runningMaxIndexId, Number(newIndexCounter) || 0)

          const priorRowAtIndex =
            productRowIndexId !== false && productRowIndexId != null
              ? (prevProducts || []).find(
                  (p) =>
                    p?.indexId != null &&
                    String(p.indexId) === String(productRowIndexId),
                )
              : null

          return {
            ...product,
            ...getCatalogPickerOriginalPrices(product),
            group_id: null,
            group_name: null,
            group_description: null,
            group_catalog_anchor_index_id: null,
            isaddedFromJob: 1,
            addedByUserType:
              priorRowAtIndex?.addedByUserType ??
              priorRowAtIndex?.added_by_user_type ??
              product?.addedByUserType ??
              product?.added_by_user_type ??
              userType,
            product_desc: product?.product_desc || product?.description || '',
            indexId: newIndexCounter,
            quantity: 1,
            locationQuantity: editProduct ? selectedProductForCatalog?.locationQuantity || 1 : 1,
            discount: 0,
            allLocationSame: editProduct ? selectedProductForCatalog?.allLocationSame : true,
            adjustment: 0,
            markAdjType: 1,
            product_formula_cost_each: getSingleProductFormulaCostEach(product),
            install_formula_cost_each:
              product?.install_formula_cost_each != null && product?.install_formula_cost_each !== ''
                ? Number(product.install_formula_cost_each)
                : Number(product?.expected_install_labor_cost_with_markup || 0),
            rowTotal: calculateTotal(
              markupType === 1
                ? dataWholesalePrice
                : markupType === 2
                ? dataRetailPrice
                : 0,
              product.dataQuantity,
              product.dataDiscount,
              1,
              editProduct ? selectedProductForCatalog?.locationQuantity || 1 : 1,
              0,
            ),
            location: [location],
            sub_contract_markup : product?.markup,
          }
        }
      })

      if (details?.is_request_estimate == 1) {
        const maxFromResult = Math.max(
          0,
          ...updatedProducts.map((p) => Number(p.indexId) || 0),
        )
        setIndexCounter(Math.max(runningMaxIndexId, maxFromResult))
      }

      // Request estimate: keep stable indexId per row (line + catalog). Otherwise legacy sequential Sl No.
      const updatedProductsWithIndex =
        details?.is_request_estimate == 1
          ? updatedProducts
          : updatedProducts.map((product, index) => ({
              ...product,
              indexId: index + 1,
            }))

      // Choose-dialog picks pass a single catalog item; merge into the target row only.
      let primaryProducts = updatedProductsWithIndex
      if (
        productRowIndexId !== false &&
        productRowIndexId != null &&
        value.length === 1 &&
        (prevProducts || []).length > 1
      ) {
        const targetKey = String(productRowIndexId)
        const updatedRow =
          updatedProductsWithIndex.find(
            (p) => p?.indexId != null && String(p.indexId) === targetKey,
          ) || updatedProductsWithIndex[0]
        if (updatedRow) {
          const prev = prevProducts || []
          const rowIndex = prev.findIndex(
            (p) => p?.indexId != null && String(p.indexId) === targetKey,
          )
          const mergedRow =
            rowIndex >= 0
              ? {
                  ...prev[rowIndex],
                  ...updatedRow,
                  indexId: prev[rowIndex].indexId,
                  entryMode: prev[rowIndex].entryMode ?? updatedRow.entryMode ?? 'choose',
                  is_product_row: prev[rowIndex].is_product_row ?? updatedRow.is_product_row ?? 0,
               product_write: prev[rowIndex].product_write ?? updatedRow.product_write ?? 0,
                  isaddedFromJob: prev[rowIndex].backendId
                    ? Number(prev[rowIndex].isaddedFromJob) === 1
                      ? 1
                      : 0
                    : 1,
                  isAdditionalProduct:
                    prev[rowIndex].isAdditionalProduct ?? updatedRow.isAdditionalProduct ?? false,
                  product_notes:
                    updatedRow?.product_notes ??
                    prev[rowIndex]?.product_notes ??
                    prev[rowIndex]?.note ??
                    '',
                  addedByUserType:
                    prev[rowIndex].addedByUserType ??
                    prev[rowIndex].added_by_user_type ??
                    updatedRow.addedByUserType ??
                    updatedRow.added_by_user_type ??
                    null,
                }
              : {
                  ...updatedRow,
                  indexId: Number(productRowIndexId),
                  entryMode: 'choose',
                  isaddedFromJob: 1,
                  addedByUserType: userType,
                }
          primaryProducts =
            rowIndex >= 0
              ? prev.map((row, idx) => (idx === rowIndex ? mergedRow : row))
              : [...prev, mergedRow]
        } else {
          primaryProducts = prevProducts || []
        }
      }

      // Merge additional / map rows from prev snapshot (not render closure) and avoid
      // duplicate indexId lines after group delete + catalog refresh.
      const primaryIndexIds = new Set(
        primaryProducts.map((p) =>
          p?.indexId != null ? String(p.indexId) : '',
        ),
      )
      const extraAdditional = (prevProducts || []).filter(
        (item) =>
          item?.isAdditionalProduct == true &&
          item?.indexId != null &&
          !primaryIndexIds.has(String(item.indexId)),
      )
      const extraMap = (selectedMapserviceProducts || []).filter((product) => {
        if (product?.fromMapServices != true) return false
        if (product?.indexId == null) return true
        return !primaryIndexIds.has(String(product.indexId))
      })

      const allSelectedProducts = [
        ...primaryProducts,
        ...extraAdditional,
        ...extraMap,
      ].map((product) => withCommunityLocationIfMissing(product))

      setFieldValue('products', allSelectedProducts)
      const productServices = allSelectedProducts?.reduce(
        (services, product) => {
          if (product.services && product.services.length > 0) {
            return services.concat(
              product.services.map((service) => ({
                ...service,
                fromMapServices: product?.fromMapServices,
                productIndex: product.indexId,
                locationQuantity: 1,
              })),
            )
          }
          return services
        },
        [],
      )

      setSelectedServices((prevServices) => {
        const filteredProductServices = productServices.filter((service) => {
          return !prevServices.some(
            (existingService) =>
              existingService?.labour_cost_service_id === service?.id &&
              existingService?.recipe_id === service?.recipe_id &&
              existingService?.product_id === service?.product_id &&
              existingService?.productIndex === service?.productIndex,
          )
        })

        let updatedServices = prevServices.map((service) => ({
          ...service,
          quantity: service.quantity || 1,
          locationQuantity: service.locationQuantity || 1,
        }))

        updatedServices = updatedServices.filter((existingService) =>
          productServices.some(
            (service) =>
              (existingService?.labour_cost_service_id === service?.id ||
                existingService?.id === service?.id) &&
              existingService?.recipe_id === service?.recipe_id &&
              existingService?.product_id === service?.product_id &&
              existingService?.productIndex === service?.productIndex,
          ),
        )

        const filteredProductServicesUnique = filteredProductServices.filter(
          (service) => {
            return !updatedServices.some(
              (existingService) =>
                (existingService?.labour_cost_service_id === service?.id ||
                  existingService?.id === service?.id) &&
                existingService?.recipe_id === service?.recipe_id &&
                existingService?.product_id === service?.product_id &&
                existingService?.productIndex === service?.productIndex,
            )
          },
        )

        return updatedServices.concat(filteredProductServicesUnique)
      })

      const filteredServicesForProducts =
        productServices.length === 0
          ? labourCostServices
          : labourCostServices.filter(
              (service) =>
                !productServices.find(
                  (selectedService) => selectedService.id === service.id,
                ),
            )
      setFilteredServices(filteredServicesForProducts)

      ///////////////////////for additional service filter
      const updatedAdditionalSelectedServices =
        additionalSelectedServices?.filter(
          (service) =>
            !productServices.some(
              (selectedService) => selectedService.id === service.id,
            ),
        )

      setAdditionalSelectedServices(updatedAdditionalSelectedServices)
      setFieldValue('services', updatedAdditionalSelectedServices)

      let initialServicesCost = 0
      if (primaryProducts.length > 0) {
        initialServicesCost = primaryProducts.reduce((total, data) => {
          return (
            total +
            data.quantity *
              parseFloat(data.expected_total_service_cost?.toFixed(2))
          )
        }, 0)
      }

      setInitialServiceCostInProductFormula(initialServicesCost)

      const patch = getInstallEndPatchFromLead(
        values,
        getBaseUnixForLeadTime(values),
        allSelectedProducts,
      )
      if (patch) setFieldValue(patch.field, patch.finalUnix)

      return allSelectedProducts
    })
    setSelectedProductForCatalog(null)
  }
  console.log('###############ExistingProduct111', selectedProducts)
  console.log('selectedServices-------', selectedServices)

  // const handleAllLocationSameChange = () => {

  //   console.log("##################Alllll",allLocationSame);
  //   if (!allLocationSame) {
  //     const commonAddress = selectedProducts[0]?.location[0] || {
  //       address: '',
  //       city: '',
  //       state: '',
  //       zip: '',
  //     };
  //     console.log("##################Alllll",commonAddress);
  //     setSelectedProducts(prevProducts =>
  //       prevProducts.map(product => ({
  //         ...product,
  //         location: product.location.map(() => commonAddress),
  //       }))
  //     );
  //   }
  //   setAllLocationSame(!allLocationSame);
  // };

  const handleAllLocationSameChange = (productIndex) => {
    setSelectedProducts((prevProducts) =>
      prevProducts.map((product, index) => {
        if (index === productIndex) {
          console.log('productIndex--1---', index)
          console.log('productIndex--2---', productIndex)

          // Toggle allLocationSame flag
          const isAllSame = !product?.allLocationSame
          // Get the first address of the selected product
          const commonAddress = product.location[0] || {
            address: '',
            city: '',
            state: '',
            zip: '',
          }

          return {
            ...product,
            allLocationSame: isAllSame,
            location: product.location.map(() => commonAddress),
          }
        }
        return product
      }),
    )
  }
  const handleDeleteProduct = (productId, indexId) => {
    const matchesDeletedRow = (data) =>
      String(data?.id ?? data?.product_id) === String(productId) &&
      String(data?.indexId) === String(indexId)

    const deletedProducts = selectedProducts.filter(matchesDeletedRow);
    deletedProducts.forEach(async (deletedProduct) => {
      // If it's an estimate catalog that requires manager approval (pending or rejected), 
      // permanently delete it from inventory catalogs when removed from the estimate.
      if (deletedProduct?.inhouse == 7 && (deletedProduct?.status == 0 || deletedProduct?.status == 3)) {
        try {
          const productIdToDelete = deletedProduct?.product_id || deletedProduct?.id;
          if (productIdToDelete) {
            await axios.post(`${REST_API_END_POINT}product/delete-product?id=${productIdToDelete}&status=2`);
          }
        } catch (error) {
          console.error("Failed to permanently delete estimate catalog product:", error);
        }
      }
    });

    const remainingProductsBeforeIndexReset = selectedProducts.filter((data) => !matchesDeletedRow(data))
    let fileredProduct = remainingProductsBeforeIndexReset
    const deletedRowKeys = selectedProducts
      .filter(matchesDeletedRow)
      .flatMap((p) => [p.id, p.backendId, p.product_id])
      .filter((v) => v != null && v !== '')
      .map(String)

    if (details?.is_request_estimate == 1) {
      const sorted = [...fileredProduct].sort(
        (a, b) => (a?.indexId || 0) - (b?.indexId || 0),
      )
      const indexIdMap = {}
      sorted.forEach((p, idx) => {
        indexIdMap[String(p.indexId)] = idx + 1
      })
      fileredProduct = remapProductIndexIds(indexIdMap, fileredProduct, {
        removeProductRowBackendIds: deletedRowKeys,
        removeIndexKeys: [String(indexId)],
      })
    } else {
      fileredProduct = fileredProduct.map((product, index) => ({
        ...product,
        indexId: index + 1,
      }))

      setProductAttachments((prev) => {
        const next = {}
        remainingProductsBeforeIndexReset.forEach((product, idx) => {
          const oldKey = String(product.indexId ?? '')
          const newKey = String(idx + 1)
          if (prev[oldKey]?.length) {
            next[newKey] = prev[oldKey].map((f) => ({
              ...f,
              product_index_id: newKey,
            }))
          }
        })
        return next
      })
      const remapProductKeys = (prev) => {
        const next = {}
        remainingProductsBeforeIndexReset.forEach((product, idx) => {
          const oldKey = String(product.indexId ?? '')
          const newKey = String(idx + 1)
          if (prev[oldKey] !== undefined) next[newKey] = prev[oldKey]
        })
        return next
      }
      setAttachmentTabValue(remapProductKeys)
      setSelectedUploadedImages(remapProductKeys)
      setOpenProductAttachment(remapProductKeys)

      setFieldValue('products', fileredProduct)
      setSelectedProducts(fileredProduct)
      const newIndexCounter =
        fileredProduct.length > 0
          ? Math.max(...fileredProduct.map((item) => Number(item.indexId) || 0))
          : 0
      setIndexCounter(newIndexCounter)
    }
    const quantityFieldName = `quantity_${productId}`
    const discountFieldName = `discount_${productId}`
    setFieldValue(quantityFieldName, 1)
    setFieldValue(discountFieldName, 1)
    console.log('fileredProduct-------', fileredProduct)
    console.log('selectedServices-------', selectedServices)
    console.log(
      '###############InitialserviceCost',
      initialServiceCostInProductFormula,
    )
    const filteredServices = selectedServices?.filter((service) => {
      // Check if there is any product in fileredProduct array which contains the service
      return fileredProduct?.some(
        (product) =>
          product?.recipe_id === service?.recipe_id &&
          product?.id === service?.product_id &&
          product?.indexId === service?.productIndex,
      )
    })

    setSelectedServices(filteredServices)
    let initialServicesCost = 0
    if (fileredProduct.length > 0) {
      initialServicesCost = fileredProduct?.reduce((total, data, index) => {
        return (
          total +
          data?.quantity *
            parseFloat(data?.expected_total_service_cost?.toFixed(2))
        )
      }, 0)
    }
    console.log(
      'initialServiceCost In ProductFormula-----',
      initialServicesCost,
    )
    setInitialServiceCostInProductFormula(initialServicesCost)

    const patch = getInstallEndPatchFromLead(
      values,
      getBaseUnixForLeadTime(values),
      fileredProduct,
    )
    if (patch) setFieldValue(patch.field, patch.finalUnix)
  }

  const handleDeleteInstallCost = (productId, indexId) => {
    const updatedProducts = selectedProducts?.map((product) =>
      product.id === productId && product.indexId === indexId
        ? clearCatalogInstallCost(product)
        : product,
    )

    setSelectedProducts(updatedProducts)
    setFieldValue('products', updatedProducts)
  }

  const handleDeleteGroup = (groupId, skipStateUpdate = false, productsToUse = null) => {
    const products = productsToUse || selectedProducts
    const sid = String(groupId)
    const list = products || []

    const groupMembers = list.filter((p) => String(p.group_id) === sid)
    
    if (!skipStateUpdate) {
      groupMembers.forEach(async (deletedProduct) => {
        if (deletedProduct?.inhouse == 7 && (deletedProduct?.status == 0 || deletedProduct?.status == 3)) {
          try {
            const productIdToDelete = deletedProduct?.product_id || deletedProduct?.id;
            if (productIdToDelete) {
              await axios.post(`${REST_API_END_POINT}product/delete-product?id=${productIdToDelete}&status=2`);
            }
          } catch (error) {
            console.error("Failed to permanently delete estimate catalog product:", error);
          }
        }
      });
    }
    const rawAnchor =
      groupMembers.length > 0 ? getGroupAnchorIndexId({ products: groupMembers }) : null
    const catalogAnchorIndexId =
      rawAnchor != null && rawAnchor !== '' && Number.isFinite(Number(rawAnchor))
        ? Number(rawAnchor)
        : null

    let firstGroupArrayIndex = null
    list.forEach((p, i) => {
      if (String(p.group_id) === sid) {
        firstGroupArrayIndex =
          firstGroupArrayIndex == null ? i : Math.min(firstGroupArrayIndex, i)
      }
    })

    const filtered = list.filter((p) => String(p.group_id) !== sid)

    let catalogInsertIndex = null
    if (firstGroupArrayIndex != null) {
      if (
        details?.is_request_estimate == 1 &&
        catalogAnchorIndexId != null
      ) {
        const a = catalogAnchorIndexId
        catalogInsertIndex = filtered.filter((p) => Number(p.indexId ?? 0) < a).length
      } else {
        catalogInsertIndex = list
          .slice(0, firstGroupArrayIndex)
          .filter((p) => String(p.group_id) !== sid).length
      }
    }
    let remainingProducts =
      details?.is_request_estimate == 1
        ? filtered
        : filtered.map((product, index) => ({ ...product, indexId: index + 1 }))

    const newIndexCounter =
      remainingProducts.length > 0
        ? Math.max(...remainingProducts.map((item) => Number(item.indexId) || 0))
        : 0

    if (!skipStateUpdate) {
      if (details?.is_request_estimate == 1) {
        const sorted = [...filtered].sort(
          (a, b) => (a?.indexId || 0) - (b?.indexId || 0),
        )
        const indexIdMap = {}
        sorted.forEach((p, idx) => {
          indexIdMap[String(p.indexId)] = idx + 1
        })
        remainingProducts = remapProductIndexIds(indexIdMap, filtered)
      } else {
        setFieldValue('products', remainingProducts)
        setSelectedProducts(remainingProducts)
        setIndexCounter(newIndexCounter)
      }

      // Cleanup marketing values
      const cleanMarketing = (prev) => {
        const next = { ...prev }
        delete next[groupId]
        delete next[String(groupId)]
        return next
      }
      setGroupProductMarketingValues(cleanMarketing)
      setGroupInstallMarketingValues(cleanMarketing)
      setCustomerOrderProductGroups((prev) =>
        (prev || []).filter((g) => String(g?.id ?? g?.group_id) !== sid),
      )

      // Cleanup services
      const filteredServices = selectedServices?.filter((service) => {
        return remainingProducts?.some(
          (product) =>
            product?.recipe_id === service?.recipe_id &&
            product?.id === service?.product_id &&
            product?.indexId === service?.productIndex,
        )
      })
      setSelectedServices(filteredServices)

      let initialServicesCost = 0
      if (remainingProducts.length > 0) {
        initialServicesCost = remainingProducts?.reduce((total, data) => {
          return (
            total +
            (Number(data?.quantity) || 0) *
              parseFloat(data?.expected_total_service_cost?.toFixed(2) || 0)
          )
        }, 0)
      }
      setInitialServiceCostInProductFormula(initialServicesCost)

      const patch = getInstallEndPatchFromLead(
        values,
        getBaseUnixForLeadTime(values),
        remainingProducts,
      )
      if (patch) setFieldValue(patch.field, patch.finalUnix)

      setRefreshCalculation?.((v) => !v)
    }

    return {
      remainingProducts,
      catalogInsertIndex,
      catalogAnchorIndexId,
    }
  }

  const currentRushFeePercentage = Number(data?.rush_fee_percentage) || 0;
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: currentRFQData.name || '',
      created_at: currentRFQData.created_at || null,
      po_number: currentRFQData.po_number || '',
      description: currentRFQData.description || '',
      notes: currentRFQData.notes || '',
      clients: currentRFQData.client || null,
      // skills: currentRFQData.skills || [],
      // workflow: currentRFQData.workflow || [],
      project_type: currentRFQData.project_type || null,
      sign_agreement: currentRFQData.sign_agreement || [],
      project_category: currentRFQData.project_category || null,
      community: currentRFQData.community || null,
      map_service: currentRFQData.map_service || null,
      start: currentRFQData.start || currentDate,
      end: currentRFQData.end || currentDate,
      installation_start_date: currentRFQData.installation_start_date || null,
      installation_end_date: currentRFQData.installation_end_date || null,
      // avatarUrl: currentRFQData.avatarUrl||'',
      products: currentRFQData.products || [],
      services: currentRFQData.services || [],
      markup_type: currentRFQData.markup_type || null,
      invoice_discount: currentRFQData.invoice_discount || '',
      welcome_message: currentRFQData.welcome_message || false,
      show_install_price: currentRFQData.show_install_price ?? 1,
      rush_fee: currentRFQData.rush_fee || 0,
      rush_fee_amount: currentRFQData.rush_fee_amount || 0,
      
      draft: currentRFQData.draft || false,
      total: currentRFQData.total || '',
      client_approve: (details?.is_request_estimate == 1) ? true : clientApprove == 0 ? false : true,
      // Default OFF; if user saved ON, keep it on re-edit (enableReinitialize must read saved value)
      manager_approval_required:
        Number(managerApprovalRequired) === 1 ||
        currentRFQData?.manager_approval_required === true ||
        currentRFQData?.manager_approval_required === 1 ||
        details?.manager_approval_required == 1,
      // Previous forced false and wiped saved ON on reinitialize:
      // manager_approval_required: false,
      // is_single_card: singleLocationCard  ? true : false,
      labour_cost: currentRFQData.labour_cost || 0,
      budget: currentRFQData.budget || 0,
      tax: 0,
      order_id: currentRFQData.order_id || '',
      subject: currentRFQData.subject || '',
      email_content: currentRFQData.email_content || '',
      rfp: null,
      estimate_id: currentRFQData?.estimate_id,
      customer_name: currentRFQData?.customer_name,
      editReq: true,
      is_split: isSplitOrder ? { id: 1, label: 'Split' } : null,
      split_catalog_type:
        splitOrderCatalogTypes.find(
          (type) => type.id === currentRFQData?.split_catalog_type,
        ) || splitOrderCatalogTypes.find((type) => type.id === 'all'),
      facility_type:
        typeof currentRFQData?.facility_type === 'string' &&
        currentRFQData.facility_type
          ? currentRFQData.facility_type
              .split(',')
              .map((id) => FacilityTypes.find((type) => type.id == id.trim()))
              .filter(Boolean)
          : Array.isArray(currentRFQData?.facility_type)
          ? currentRFQData.facility_type
          : isSplitOrder
          ? FacilityTypes?.filter((fac) => fac.default) || []
          : [],
      bill_to: currentRFQData.bill_to || '',
      ship_to: currentRFQData.ship_to || '',
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      if (isPreview) {
        setSubmitting(false)
        return
      }
      const isDraftSave = saveAsDraftRef.current === 1 || saveAsDraft === 1
      try {
        setIsSubmitted(true)
        // const hasEmptyProductName = selectedProducts?.some(
        //   (product) =>
        //     (product.name || product.product_name || '').trim() === '',
        // )
        const hasEmptyProductName = selectedProducts?.some((product) => {
          if (getProductEntryMode(product) === 'choose' && !product?.id && !product?.product_id) {
            return false
          }
          if (isBlankEstimateWriteRow(product)) return false
          return !(product.name || product.product_name || '').trim()
        })
        const hasEmptyServiceName = additionalSelectedServices?.some(
          (product) =>
            getServiceEntryMode(product) === 'write' &&
            (product.name || product.service_name || '').trim() === '',
        )
        const hasUnselectedChooseService = (additionalSelectedServices || []).some(
          (service) =>
            getServiceEntryMode(service) === 'choose' &&
            !estimateJobServiceRowHasAddedCatalog(service),
        )
        const hasEmptyMaterialName = selectedMaterials?.some(
          (product) =>
            (product.name || product.product_name || '').trim() === '',
        )

        if (
          details?.is_request_estimate == 0 &&
          selectedProducts?.length == 0 &&
          additionalSelectedServices?.length == 0 &&
          userType !== 3
        ) {
          enqueueSnackbar('Please add at least one product or service.', { variant: 'error' })
          return
        }
        const hasIncompleteChooseProductRow = (selectedProducts || []).some(
          (p) => getProductEntryMode(p) === 'choose' && !p?.id && !p?.product_id,
        )
        if (!isDraftSave && hasIncompleteChooseProductRow && userType !== 3) {
          enqueueSnackbar('Please select a product for each Choose row.', { variant: 'error' })
          return
        }
        if (!isDraftSave && hasUnselectedChooseService && userType !== 3) {
          enqueueSnackbar('Please select a service for each service row.', { variant: 'error' })
          return
        }
        if (
          !isDraftSave &&
          details?.is_request_estimate == 1 &&
          hasWriteProductRowMissingEstimateCatalog(selectedProducts) &&
          userType !== 3
        ) {
          enqueueSnackbar('Please add all estimate catalogs before submitting', { variant: 'error' })
          return
        }
        if (
          details?.is_request_estimate == 1 &&
          hasEmptyRequiredWriteProductName(selectedProducts)
        ) {
          enqueueSnackbar('Please fill in all required product names.', { variant: 'error' })
          return
        }
        if (
          !isDraftSave &&
          additionalSelectedServices?.length > 0 &&
          additionalSelectedServices?.some((item) =>
            shouldShowWriteServiceCatalogButtons(item),
          ) &&
          userType !== 3
        ) {
          enqueueSnackbar('Please add all services before submitting', { variant: 'error' })
          return
        }
        if (
          (details?.is_request_estimate == 1 && details?.estimate_job_status != 1) &&
          // selectedProducts?.length == 0 &&
          // additionalSelectedServices?.filter((item) => item?.service_type != 44)?.length == 0 &&
          (selectedProducts?.length == 0 &&
            additionalSelectedServices?.filter((item) => item?.service_type != 44)?.length == 0 )&&
          userType !== 3
        ) {
          enqueueSnackbar('Please add at least one product or service', { variant: 'error' })
          return
        }
        if (
          (details?.is_request_estimate == 1 && details?.estimate_job_status == 1 &&
          additionalSelectedServices?.filter((item) => item?.service_type == 44))?.length == 0 &&
          userType !== 3
        ) {
          enqueueSnackbar('Please choose an estimate service.', {
            variant: 'error',
          })
          return
        }
        if (
          selectedEstimators?.length <= 0 &&
          userType !== 3 &&
          !isClient &&
          details?.is_request_estimate == 1 && details?.estimate_job_status == 1
        ) {
          enqueueSnackbar('Please choose atleast one estimator', {
            variant: 'error',
          })
          return
        }
        if (details?.is_request_estimate == 0 && hasEmptyProductName) {
          enqueueSnackbar('Please fill in all required product names.', {
            variant: 'error',
          })
          return
        }
        if (details?.is_request_estimate == 0 && hasEmptyServiceName) {
          enqueueSnackbar('Please fill in all required service names.', {
            variant: 'error',
          })
          return
        }
        if (details?.is_request_estimate == 0 && hasEmptyMaterialName) {
          enqueueSnackbar('Please fill in all required material names.', {
            variant: 'error',
          })
          return
        }
        const hasInvalidProductName = selectedProducts
          ?.filter((item) => item?.isAdditionalProduct == true)
          ?.some((product) => {
            const newName = product.product_name || product.name
            const trimmedName = newName.trim()
            if (trimmedName === '.') {
              enqueueSnackbar('Product name cannot be just a dot.', {
                variant: 'error',
              })
              return true
            }
            if (trimmedName === '-') {
              enqueueSnackbar('Product name cannot be just a hyphen.', {
                variant: 'error',
              })
              return true
            }
            // if (!/^[a-zA-Z0-9\s-]+$/.test(trimmedName)) {
            //   enqueueSnackbar('Product name can only contain letters, numbers, and hyphens.', { variant: 'error' });
            //   return true;
            // }
            if (/[:]/.test(trimmedName)) {
              enqueueSnackbar('Product name cannot contain colon (:).', {
                variant: 'error',
              })
              return true
            }
            if (trimmedName[0] === '.') {
              enqueueSnackbar('Product name cannot start with a dot.', {
                variant: 'error',
              })
              return true
            }
            if (trimmedName[0] === '-') {
              enqueueSnackbar('Product name cannot start with a hyphen.', {
                variant: 'error',
              })
              return true
            }
            if (trimmedName === '') {
              enqueueSnackbar('Product name cannot be empty or just spaces.', {
                variant: 'error',
              })
              return true
            }
            return false
          })

        const hasInvalidServiceName = additionalSelectedServices
          ?.filter((item) => item?.isAdditionalProduct == true)
          ?.some((product) => {
            const trimmedName = product.name.trim()
            if (trimmedName === '.') {
              enqueueSnackbar('Service name cannot be just a dot.', {
                variant: 'error',
              })
              return true
            }
            if (trimmedName === '-') {
              enqueueSnackbar('Service name cannot be just a hyphen.', {
                variant: 'error',
              })
              return true
            }
            if (/[:]/.test(trimmedName)) {
              enqueueSnackbar('Service name cannot contain colon (:).', {
                variant: 'error',
              })
              return true
            }
            if (trimmedName[0] === '.') {
              enqueueSnackbar('Service name cannot start with a dot.', {
                variant: 'error',
              })
              return true
            }
            if (trimmedName[0] === '-') {
              enqueueSnackbar('Service name cannot start with a hyphen.', {
                variant: 'error',
              })
              return true
            }
            if (trimmedName === '') {
              enqueueSnackbar('Service name cannot be empty or just spaces.', {
                variant: 'error',
              })
              return true
            }
            return false
          })

        const hasInvalidMaterialName = selectedMaterials
          ?.filter((item) => item?.isAdditionalProduct == true)
          ?.some((product) => {
            const newName = product.product_name || product.name
            const trimmedName = newName.trim()
            if (trimmedName === '.') {
              enqueueSnackbar('Material name cannot be just a dot.', {
                variant: 'error',
              })
              return true
            }
            if (trimmedName === '-') {
              enqueueSnackbar('Material name cannot be just a hyphen.', {
                variant: 'error',
              })
              return true
            }
            if (/[:]/.test(trimmedName)) {
              enqueueSnackbar('Material name cannot contain colon (:).', {
                variant: 'error',
              })
              return true
            }
            if (trimmedName[0] === '.') {
              enqueueSnackbar('Material name cannot start with a dot.', {
                variant: 'error',
              })
              return true
            }
            if (trimmedName[0] === '-') {
              enqueueSnackbar('Material name cannot start with a hyphen.', {
                variant: 'error',
              })
              return true
            }
            if (trimmedName === '') {
              enqueueSnackbar('Material name cannot be empty or just spaces.', {
                variant: 'error',
              })
              return true
            }
            return false
          })

        if (
          hasInvalidProductName ||
          hasInvalidServiceName ||
          hasInvalidMaterialName
        ) {
          // enqueueSnackbar('Product names must contain letters or numbers.', { variant: 'error' });
          return
        }
        const clientsArray = values.clients ? [values.clients] : []
        values.clientsData = clientsArray
        values.userName = user.first_name
        values.bill_to = billToInputValue
        values.ship_to = shipToInputValue
        if (!values?.bill_to?.trim()) {
          values.bill_to = buildMultilineAddress(
            values?.clients?.name || values?.clients?.customer_name || '',
            values?.clients?.address || values?.clients?.customer_address || '',
            values?.clients?.city || values?.clients?.customer_city || '',
            values?.clients?.state || values?.clients?.customer_state || '',
            values?.clients?.zip || values?.clients?.customer_zipcode || values?.clients?.zip_code || '',
          )
        }
        if (!values?.ship_to?.trim()) {
          values.ship_to = buildMultilineAddress(
            values?.community?.name || '',
            values?.community?.address || '',
            values?.community?.city || '',
            values?.community?.state || '',
            values?.community?.zip || '',
          )
        }
        const request_id = id
        const allProductAttachmentUrls = Object.values(productAttachments)
          .flat()
          .map(attachmentFileKey)
          .filter(Boolean)
        const allServiceAttachmentUrls = Object.values(serviceAttachments)
          .flat()
          .map(attachmentFileKey)
          .filter(Boolean)
        const filteredAvatarUrl = avatarUrl.filter((file) => {
          const fileKey = attachmentFileKey(file)
          return fileKey && !allProductAttachmentUrls.includes(fileKey) && !allServiceAttachmentUrls.includes(fileKey)
        })
        values.avatarUrl = filteredAvatarUrl
        values.productAttachments = productAttachments
        values.serviceAttachments = serviceAttachments

        values.project_category =
          values.project_type?.name == 'TS'
            ? values.project_category || null
            : null
        values.map_service =
          values.project_type?.name == 'TS' &&
          values.project_category &&
          values.project_category?.id == 14
            ? values.map_service
            : null

        const isReqEst = details?.is_request_estimate == 1
        // ALL-815 backup - previous submit without normalize:
        // values.products = (selectedProducts || []).map((product) => {
        //   const isWrite =
        //     getProductEntryMode(product) === 'write' ||
        //     product?.is_product_row == 1
        //   const isWriteRow = isReqEst && isWrite
        //   const productWrite =
        //     Number(product?.product_write) === 1 || isWriteRow ? 1 : 0
        //   return {
        //     ...product,
        //     is_product_row: isWriteRow ? 1 : 0,
        //     isAdditionalProduct: isReqEst ? false : Boolean(product?.isAdditionalProduct),
        //     product_write: productWrite,
        //   }
        // })
        values.products = (selectedProducts || []).map((product) => {
          const isWrite =
            getProductEntryMode(product) === 'write' ||
            product?.is_product_row == 1
          const isWriteRow = isReqEst && isWrite
          const productWrite =
            Number(product?.product_write) === 1 || isWriteRow ? 1 : 0
          return {
            ...normalizeProductForSave(
              resolveGroupMemberMarketingForSave(product, markupType),
            ),
            is_product_row: isWriteRow ? 1 : 0,
            isAdditionalProduct: isReqEst ? false : Boolean(product?.isAdditionalProduct),
            product_write: productWrite,
            isaddedFromJob:
              Number(product?.isaddedFromJob) === 1 || product?.isNewlyAddedProductRow ? 1 : 0,
          }
        })
        const normalizedAdditionalServices = (additionalSelectedServices || []).map((service) => {
          const isServiceRow = resolveSubmitIsServiceRow(service, isReqEst)
          const hasCatalog = estimateJobServiceRowHasAddedCatalog(service)
          const isWriteRow = isReqEst && isServiceRow
          const serviceWrite =
            Number(service?.service_write) === 1 || isWriteRow ? 1 : 0
          return {
            ...service,
            is_service_row: isServiceRow,
            service_write: serviceWrite,
            is_line_catalog: hasCatalog ? 1 : service?.is_line_catalog ?? 0,
            isAdditionalProduct: isReqEst ? false : Boolean(service?.isAdditionalProduct),
            isaddedFromJob:
              Number(service?.isaddedFromJob) === 1 || service?.isNewlyAddedServiceRow ? 1 : 0,
          }
        })
        const hasSubmittedEstimateWriteRows =
          (values.products || []).some(
            (product) =>
              Number(product?.product_write) === 1 ||
              (Number(product?.is_product_row) === 1 &&
                Boolean((product?.product_name || product?.name || '').trim())),
          ) ||
          (normalizedAdditionalServices || []).some(
            (service) =>
              Number(service?.is_service_row) === 1 &&
              Boolean((service?.service_name || service?.name || '').trim()),
          )
        const allServices = [
          ...selectedServices.map((s) => ({ ...s, quantityDifference: 0 })),
          ...normalizedAdditionalServices,
        ]
        values.additionalSelectedServices = normalizedAdditionalServices
        const servicesIdArray = allServices?.map((service) => service.id)
        values.services = servicesIdArray?.join(',')
        values.totalMarkup = totalMarkup
        values.selectedServices = allServices
        values['labour_cost'] = totalLabourCost
        const data = {
          values,
          userId,
          userType,
          request_id,
          isEstimateJobFinalReview:
            details?.is_request_estimate == 1 &&
            details?.estimate_job_status == 3,
          groupProductMarketingData: groupedProducts ? groupedProducts.map((group) => ({
            group_id: group.id,
            group_name: group.name,
            group_description: group.description,
            quantity: group.groupQuantity || 1,
            adj_value_type: group.groupAdjValueType ?? true,
            adjustment: Number(group.groupAdjustment ?? 0),
            total_formula_each: Number((group.totalProductFormulaEach || 0).toFixed(2)),
            total_retail_each: Number((group.totalProductRetailEach || 0).toFixed(2)),
            adjusted_retail_each: Number((group.adjustedGroupRetailEach || 0).toFixed(2)),
            adjusted_subtotal: Number((group.adjustedGroupSubtotal || 0).toFixed(2)),
          })) : [],
          groupInstallMarketingData: groupedProducts ? groupedProducts.map((group) => ({
            group_id: group.id,
            group_name: group.name,
            group_description: group.description,
            quantity: group.groupInstallQuantity || 1,
            adj_value_type: group.groupInstallAdjValueType ?? true,
            adjustment: Number(group.groupInstallAdjustment ?? 0),
            total_formula_each: Number((group.totalInstallFormulaEach || 0).toFixed(2)),
            total_retail_each: Number((group.totalInstallRetailEach || 0).toFixed(2)),
            adjusted_retail_each: Number((group.adjustedGroupInstallRetailEach || 0).toFixed(2)),
            adjusted_subtotal: Number((group.adjustedGroupInstallSubtotal || 0).toFixed(2)),
          })) : [],
          avalara_transaction_id: details?.avalara_transaction_id,
          avalara_code: details?.avalara_code,
          jobLogActivities: pendingJobLogActivities,
          allLocationSame,
          rfpProducts: cart,
          taxCategory: selectedTaxCategory?.id || null,
          allRfpServiceLocationSame: allRfpServiceLocationSame,
          rfpServices: cartService,
          materials: selectedMaterials,
          produtFormulaMaterial: produtFormulaMaterial,
          estimate_qb_id : details?.estimate_id,
          address: selectedProducts
            .map((product) => withCommunityLocationIfMissing(product))
            .reduce((acc, product) => {
            return [
              ...acc,
              ...product.location.map((address) => ({
                ...address,
                productId: product.id,
                productIndex: product.indexId,
              })),
            ]
          }, []),
        }
        const isvalidationNotOk = selectedProducts
          .map((product) => withCommunityLocationIfMissing(product))
          .find((product) => {
          if (
            !isDraftSave &&
            product.location.length &&
            product.location.some((obj) =>
              [obj.address, obj.city, obj.state, obj.zip].some(
                (value) => value === '' || value === null,
              ),
            )
          ) {
            return true
          } else {
            return false
          }
        })
        values.total = totalsum
        values.taxAmount = taxAmount
        values.budget = budget
        values.sub_total = rfqSubTotal

        const submitProductsForLead = selectedProducts?.length > 0 ? selectedProducts : values.products || [];
        const submitIsRushFeeAutoLocked = isInstallBeforeRequiredLead(values, submitProductsForLead);
        const submitCanOverrideRushFeeLock = !!explodedPermissions?.some((permission) =>
          ['Override Rush Fee Estimate'].includes(permission),
        );
        const submitIsRushFeeChecked =
          Number(values?.rush_fee) === 1 ||
          (!!submitIsRushFeeAutoLocked && !submitCanOverrideRushFeeLock);
        
        values.rush_fee_amount = calcRushFeeAmount({
          enabled: submitIsRushFeeChecked,
          subtotal: totalsum || 0,
          percentage: currentRushFeePercentage,
          storedAmount: details?.rush_fee_amount || 0,
          preferStored: false
        });
        console.log('######isvalidationNotOk', isvalidationNotOk)
        console.log('######totalAmount', values.total)
        console.log('######totalAmountbudget', values.budget)

        // Convert end date from string format to timestamp if needed
        if (values.end && isNaN(values.end)) {
          values.end = Math.floor(new Date(values.end).getTime() / 1000)
        }
        // Convert start date from string format to timestamp if needed
        if (values.start && isNaN(values.start)) {
          values.start = Math.floor(new Date(values.start).getTime() / 1000)
        }

        data.quotation = 1
        data.isFromCreateEstimate = 1
        data.manager_approval_required = values.manager_approval_required === true || values.manager_approval_required === 1
        data.sessionNewEstimateCatalogIds = [...(sessionNewEstimateCatalogIdsRef.current || [])]
        data.saveAsDraft = isDraftSave
        data.draft_source = isDraftSave ? 2 : 0 // drafted from Estimate Job
        data.selectedEstimators = selectedEstimators
        data.collaborators = Array.isArray(collaborators) ? collaborators.map((c) => (typeof c === 'object' && c?.id != null ? c.id : c)).filter(Boolean).join(',') : (collaborators || '')
        data.customer_name = values.customer_name //new one
        data.all_sales_rep_ids=salesRepId
        data.salesRepName = salesRepName
        data.salesRepId = salesRepId

        // Toggle OFF: confirm before releasing catalogs that currently require manager approval
        if (!data.manager_approval_required && (managerApprovalRequired === 1 || managerApprovalRequired === true)) {
          const seenReleaseIds = new Set()
          const catalogsToRelease = []
          const catalogLookup = allProducts || []
          ;(selectedProducts || []).forEach((p) => {
            const catalogId = p?.product_id || p?.id
            const fromCatalog = catalogLookup.find(
              (ap) => String(ap?.id) === String(catalogId),
            )
            const inhouse = Number(fromCatalog?.inhouse ?? p?.inhouse)
            if (inhouse !== 7) return
            const status = Number(fromCatalog?.status ?? p?.status)
            const createdWithApproval = Number(
              fromCatalog?.created_with_approval ?? p?.created_with_approval,
            )
            // Match the UI warning logic: status 0 with createdWithApproval 1, or status 3
            if (!((status === 0 && createdWithApproval === 1) || status === 3)) return
            if (!catalogId || seenReleaseIds.has(String(catalogId))) return
            seenReleaseIds.add(String(catalogId))
            catalogsToRelease.push({
              id: catalogId,
              name:
                p?.product_name ||
                p?.name ||
                fromCatalog?.name ||
                `Catalog #${catalogId}`,
            })
          })
          if (catalogsToRelease.length > 0) {
            const confirmed = await new Promise((resolve) => {
              releaseApprovalConfirmRef.current = resolve
              setReleaseApprovalDialog({ open: true, catalogs: catalogsToRelease })
            })
            releaseApprovalConfirmRef.current = null
            if (!confirmed) {
              setSubmitting(false)
              return
            }
          }
        }

        const isvalidationNotOkRfp = cart?.find((product) => {
          console.log('Checking product:', product)

          if (
            product.location.length > 0 &&
            product.location.some((obj) =>
              [obj.address, obj.city, obj.state, obj.zip].some(
                (value) => value === '' || value === null,
              ),
            )
          ) {
            console.log('Validation failed for product:', product)
            return true
          } else {
            console.log('Validation passed for product:', product)
            return false
          }
        })
        if (isvalidationNotOk || isvalidationNotOkRfp) {
          enqueueSnackbar('Please fill all the address fields', {
            variant: 'error',
          })
        } else {
          // 🚀 PROGRESS TRACKING: Show progress modal and make API call
          const requestData = {
            ...data,
            quotation: data?.quotation || 1,
            processType: 'update_estimate',
            socketId: null, // Will be set by the progress modal
          }

          setProgressRequestData(requestData)
          setShowProgressModal(true)

          // Wait for socket connection to establish and stabilize
          await new Promise((resolve) => setTimeout(resolve, 2000))

          // Additional wait if socket is not ready yet
          if (!socketReady) {
            console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...')
            await new Promise((resolve) => setTimeout(resolve, 1000))
          }
          await axios
            .post(`${REST_API}webservice/edit-request`, data)
            .then(async (res) => {
              console.log('handleConvertToJob==details.is_request_estimate===', details.is_request_estimate)
              console.log('handleConvertToJob==res.data.status===', res.data.status)
              // if (res.data.status == 1 && isReqEst && !hasSubmittedEstimateWriteRows ) {
              //   await axios.post(`${REST_API}webservice/request/delete-estimate-job-if-no-write-rows`, { requestId: request_id, userId })
              //   navigate(`/dashboard/quick-bid/jobs`)
              // }
              // Edit Estimate Job: always keep/update job on save — job delete only from ViewQuotation edit.
              if (
                res.data.status == 1 &&
                details?.is_request_estimate == 1
              ) {
                if (res.data.checkProjectExist) {
                  await handleConvertToJob(res.data.checkProjectExist)
                } else {
                  await handleConvertToJob(false)
                }
              }
              if (res.data.status == 1) {
                sessionNewEstimateCatalogIdsRef.current = []
              }
              setJustSubmittedEstimate(true)
              setPendingJobLogActivities([])
              setRefreshRFQData(!refreshRFQData)
              setOpenEdit(false)

              setIsOpen(false)
              setCurrentRFQdata({}) // added on 3-01-2024
              resetForm()
              setSelectedProducts([])
              setSelectedMapserviceProducts([])
              setSelectedTaxCategory(null)
              setSelectedServices([])
              setAdditionalSelectedServices([])
              setFilteredServices([])
              setProductAttachments({})
              setServiceAttachments({})
              fetchRequestDetails()
              // if(edit){
              //   navigate(`/dashboard/quick-bid`)
              // }
              enqueueSnackbar(isDraftSave ? `Saved As Draft` : details?.is_create_estimate == 1 ? 'Updated successfully' : 'Created successfully', { variant: 'success' })
              // Close progress modal explicitly to ensure it closes in production
              setShowProgressModal(false)
              if (popupOn) {
                closeView()
                setRenderCards(!renderCards)
              } 
              setIsOpenEdit(false)
              if (edit) {
                edit = false
                setOpenEdit(false)
                setIsOpen(false)
              }
            })
            .catch((errors) => {
              console.log(errors, 'error')
              // Close progress modal on error as well
              setShowProgressModal(false)
            })
        }
      } catch (error) {
        console.error(error)
        // Close progress modal on error
        setShowProgressModal(false)
      } finally {
        saveAsDraftRef.current = 0
        setSaveAsDraft(0)
      }
    },
  })

  // Dynamic split catalog types based on selected facilities
  const getSplitCatalogTypes = () => {
    const selectedFacilities = values?.facility_type || []
    const hasOnlyCurrentFacility =
      selectedFacilities.length === 1 &&
      selectedFacilities.some(
        (facility) => Number(facility.id) === currentFacilityId,
      )

    // If only current facility is selected, exclude Split Catalog option
    if (hasOnlyCurrentFacility) {
      return splitOrderCatalogTypes.filter(
        (type) => type.id !== 'split_catalog',
      )
    }

    return splitOrderCatalogTypes
  }

  // const handleEstimateCount = async () => {
  //   try {
  //     const response = await axios.post(
  //       `${REST_API}webservice/estimate/reduce-tabs-count`,
  //       {
  //         userId,
  //         estimate_id: id,
  //       },
  //     )
  //   } catch (error) {
  //     console.error('Error reducing estimate count:', error)
  //   }
  // }

  // useEffect(() => {
  //   if (userType !== 3) {
  //     handleEstimateCount()
  //   }
  // }, [])

  // useEffect(()=>{
  //   // let currentUnix = moment(currentDate).unix()
  //   //  let requestSubmitDeadline = details?.submission_deadline

  //    if((user?.user_id == details?.partner_user_id)&& (details?.accept_status == 0)){
  //     setReqAcceptClient(true)
  //    }

  // },[details])

  const submissionDeadlineUnix = details?.submission_deadline
  const submissionDeadlineMoment = moment.unix(submissionDeadlineUnix)

  const current = moment()

  const daysLeft = submissionDeadlineMoment.diff(current, 'days')

  const handleAcceptorRejectInvoice = async (value) => {
    try {
      if (value === 2 && reason === '') {
        enqueueSnackbar('Please fill rejected reason ', { variant: 'warning' })
        return
      } else {
        let requestId = id
        let requestPartnerId = details?.rt_partner_id
        let acceptStatus = value
        let userId = user.user_id

        const data = {
          requestId,
          requestPartnerId,
          acceptStatus,
          userId,
          reason,
        }
        const res = await axios.post(
          `${REST_API}webservice/request/accept-or-reject-quotation`,
          data,
        )

        if (res.data.status == 1) {
          setOpenInvoice(false)
          setConfirmInvoice(false)
          enqueueSnackbar('Estimate Approved', { variant: 'success' })
          fetchRequestDetails()
          onDataChange()
        } else if (res.data.status == 2) {
          onDataChange()
          setOpenInvoice(false)
          setRejectInvoice(false)
          enqueueSnackbar('Estimate Rejected', { variant: 'error' })
          setReason('')
          navigate(PATH_DASHBOARD.quotation.root)
        } else {
          setOpenInvoice(false)
          setConfirmInvoice(false)
        }
        setRefresh(!refresh)
      }
    } catch (error) {
      console.log(error, 'error in accepting Estimate')
    }
  }
  const calculateServiceTotal = (
    price,
    quantity,
    discount,
    value,
    location = 1,
  ) => {
    const parsedQuantity = parseFloat(quantity ? quantity : value) || 0
    const parsedDiscount = parseFloat(discount) || 0
    const locationQuantity = parseFloat(location) || 1
    const subtotal = price * parsedQuantity * locationQuantity

    if (discount) {
      const totalDiscount = subtotal - discount
      return totalDiscount
    } else {
      return subtotal
    }
  }
  const handleReopeningRequest = async () => {
    try {
      let requestId = id
      let userId = user.user_id
      const data = { requestId, userId }
      const res = await axios.post(
        `${REST_API}webservice/quotation/reopen`,
        data,
      )
      if (res.data.status == 1) {
        enqueueSnackbar('Estimate reopened successfully', {
          variant: 'success',
        })
        setReopen(false)
        fetchRequestDetails()
      } else if (res.data.status == 0) {
        enqueueSnackbar('Estimate reopened failed', { variant: 'error' })
        setReopen(false)
      }
    } catch (error) {
      console.log(error, 'Error in reopen')
    }
  }

  const handleConvertToJob = async (existingJob = false) => {
    try {
      setCreateJob(true)
      if (existingJob) {
        setIsUpdating(true)
      }
      let requestId = id
      let requestPartnerId = details?.rt_partner_id
      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      const requestData = {
        requestId,
        requestPartnerId,
        userId,
        processType: 'estimate_job',
        socketId: null, // Will be set by the progress modal
      }

      // If modal is already open (from previous operation), just update the data and continue
      if (showProgressModal) {
        setProgressRequestData(requestData)
        // Don't close and reopen modal, just continue with new data
      } else {
        // setProgressHeading("Creating Estimate Job");
        setProgressRequestData(requestData)
        setShowProgressModal(true)
      }

      // Wait for socket connection to establish and stabilize
      await new Promise((resolve) => setTimeout(resolve, 2000))

      // Additional wait if socket is not ready yet
      if (!socketReady) {
        console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...')
        await new Promise((resolve) => setTimeout(resolve, 1000))
      }

      const data = { requestId, userId, requestPartnerId }
      const res = await axios.post(
        `${REST_API}webservice/request/create-or-update-estimate-job`,
        data,
      )

      if (res.data.status == 1) {
        setShowProgressModal(false)
        enqueueSnackbar(
          existingJob
            ? 'Estimate Job updated successfully'
            : 'Estimate Job created successfully',
          { variant: 'success' },
        )
        fetchRequestDetails()
      } else {
        setShowProgressModal(false)
        enqueueSnackbar(
          existingJob
            ? 'Failed to update estimate job'
            : 'Failed to create estimate job',
          { variant: 'error' },
        )
      }
    } catch (error) {
      console.log(error, 'error in creating estimate job')
      setShowProgressModal(false)
    } finally {
      setCreateJob(false)
    }
  }

  const convertToRFQ = async () => {
    try {
      let requestId = id
      let userId = user.user_id
      const data = { requestId, userId }

      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      const requestData = {
        requestId,
        userId,
        processType: 'convert_to_sales_order',
        socketId: null, // Will be set by the progress modal
      }

      setProgressRequestData(requestData)
      setShowProgressModal(true)

      // Wait for socket connection to establish and stabilize
      await new Promise((resolve) => setTimeout(resolve, 2000))

      // Additional wait if socket is not ready yet
      if (!socketReady) {
        console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...')
        await new Promise((resolve) => setTimeout(resolve, 1000))
      }

      const res = await axios.post(
        `${REST_API}webservice/quotation/convert-rfq`,
        data,
      )
      if (res.data.status == 1) {
        enqueueSnackbar('Estimate converted to Sales Order successfully', {
          variant: 'success',
        })
        setReopen(false)
        setShowProgressModal(false)
        sessionStorage.setItem(`salesOrderSkipRibbonDismiss_${requestId}`, '1')
        // navigate(PATH_DASHBOARD.official.root)
        navigate(`/dashboard/official-request/view/${id}`, { state: true })
        if (popupOn) {
          closeView()
        }
        // fetchQuotationDetails()
      } else if (res.data.status == 0) {
        enqueueSnackbar('Estimate failed to convert', { variant: 'error' })
        setReopen(false)
        setShowProgressModal(false)
      }
    } catch (error) {
      console.log(error, 'Error in reopen')
      setShowProgressModal(false)
    }
  }

  // Handle Save As Draft - calls formik's handleSubmit to execute all onSubmit logic
  const handleSaveDraft = () => {
    saveAsDraftRef.current = 1
    setSaveAsDraft(1)
    formik.handleSubmit()
  }

  const {
    errors,
    values,
    touched,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    getFieldProps,
  } = formik

  const applyLeadTimeInstallPatch = (baseUnix, productsList) => {
    const products =
      productsList ??
      (selectedProducts?.length > 0 ? selectedProducts : values.products || [])
    const patch = getInstallEndPatchFromLead(values, baseUnix, products)
    if (patch) setFieldValue(patch.field, patch.finalUnix)
  }

  const applyInstallationFromStartAndLead = (newStartUnix) => {
    applyLeadTimeInstallPatch(getBaseUnixForLeadTime(values, newStartUnix))
  }

  const buildAddressLine = useCallback((addressParts = []) => {
    return addressParts
      .map((part) => (part == null ? '' : String(part).trim()))
      .filter(Boolean)
      .join(', ')
  }, [])

  const buildMultilineAddress = useCallback((name, address, city, state, zip) => {
    const line1 = name == null ? '' : String(name).trim()
    const line2 = address == null ? '' : String(address).trim()
    const line3 = buildAddressLine([city, state, zip])
    return [line1, line2, line3].filter(Boolean).join('\n')
  }, [buildAddressLine])

  const clientAddressForBillTo = useMemo(() => {
    return buildMultilineAddress(
      values?.clients?.name || values?.clients?.customer_name || '',
      values?.clients?.address || values?.clients?.customer_address || '',
      values?.clients?.city || values?.clients?.customer_city || '',
      values?.clients?.state || values?.clients?.customer_state || '',
      values?.clients?.zip || values?.clients?.customer_zipcode || values?.clients?.zip_code || '',
    )
  }, [buildMultilineAddress, values?.clients])

  const projectAddressForShipTo = useMemo(() => {
    return buildMultilineAddress(
      values?.community?.name || '',
      values?.community?.address || '',
      values?.community?.city || '',
      values?.community?.state || '',
      values?.community?.zip || '',
    )
  }, [buildMultilineAddress, values?.community])

  const [isBillToDirty, setIsBillToDirty] = useState(false)
  const [isShipToDirty, setIsShipToDirty] = useState(false)
  const [billToInputValue, setBillToInputValue] = useState('')
  const [shipToInputValue, setShipToInputValue] = useState('')

  useEffect(() => {
    setIsBillToDirty(false)
  }, [values?.clients?.id, details?.id])

  useEffect(() => {
    setIsShipToDirty(false)
  }, [values?.community?.id, details?.id])

  useEffect(() => {
    if (isBillToDirty) return
    const nextValue = (values?.bill_to || '').trim()
      ? values.bill_to
      : clientAddressForBillTo || ''
    setBillToInputValue(nextValue)
  }, [isBillToDirty, values?.bill_to, clientAddressForBillTo, values?.clients?.id, details?.id])

  useEffect(() => {
    if (isShipToDirty) return
    const nextValue = (values?.ship_to || '').trim()
      ? values.ship_to
      : projectAddressForShipTo || ''
    setShipToInputValue(nextValue)
  }, [isShipToDirty, values?.ship_to, projectAddressForShipTo, values?.community?.id, details?.id])

  const productsForLeadRaw =
    selectedProducts?.length > 0
      ? selectedProducts
      : (values.products?.length > 0 ? values.products : []);
  const rushSyncCatalog =
    catalogProductsRef.current?.length > 0 ? catalogProductsRef.current : allProducts;
  const productsForLead = resolveProductsLeadTime(productsForLeadRaw, rushSyncCatalog);
  const isRushFeeAutoLockedForEffect = isInstallBeforeRequiredLead(values, productsForLead);

  const canManuallyToggleRushFee = !!explodedPermissions?.some((permission) =>
    ['Manage Rush Fee Toggle Estimate'].includes(permission),
  );
  const canOverrideRushFeeLock = !!explodedPermissions?.some((permission) =>
    ['Override Rush Fee Estimate'].includes(permission),
  );
  const canControlRushFee = canManuallyToggleRushFee || canOverrideRushFeeLock;

  useEffect(() => {
    runRushFeeLeadSync({
      values,
      products: productsForLeadRaw,
      catalog: rushSyncCatalog,
      canOverride: canOverrideRushFeeLock,
      setFieldValue,
      refs: rushFeeSyncRefs.current,
      enabled: openEdit,
      persistedOffWhileLocked:
        openEdit &&
        Number(details?.rush_fee ?? values?.rush_fee) === 0 &&
        isRushFeeAutoLockedForEffect,
    });
  }, [
    values?.end,
    values?.start,
    values?.installation_start_date,
    values?.installation_end_date,
    productsForLeadRaw,
    rushSyncCatalog,
    isRushFeeAutoLockedForEffect,
    canOverrideRushFeeLock,
    setFieldValue,
    openEdit,
    details?.rush_fee,
  ]);

  const isRushFeeChecked =
    Number(values?.rush_fee) === 1 ||
    (!!isRushFeeAutoLockedForEffect && !canOverrideRushFeeLock);
  const rushFeeAccessDenied =
    !canControlRushFee && !isRushFeeAutoLockedForEffect && !isRushFeeChecked;
  const rushFeeSwitchDisabled = rushFeeAccessDenied;
  const rushFeePercentage = Number(data?.rush_fee_percentage) || 0;
  const rushFeeAmount = calcRushFeeAmount({
    enabled: isRushFeeChecked,
    subtotal: totalsum || 0,
    percentage: rushFeePercentage,
    storedAmount: details?.rush_fee_amount || 0,
    preferStored: !openEdit,
  });
  values['rush_fee_amount'] = rushFeeAmount;

  const handleEstimateFormSubmit = (event) => {
    saveAsDraftRef.current = 0
    setSaveAsDraft(0)
    handleSubmit(event)
  }

  // Sync client into Formik separately — not only via addingInitialdataRFQ / enableReinitialize
  useEffect(() => {
    if (!openEdit) {
      editClientSyncedRef.current = null
      return
    }
    if (!details?.id) return
    if (!Array.isArray(allClientsEdit) || allClientsEdit.length === 0) return

    const customerId = customerData?.customer_id ?? details?.customer_id
    if (!customerId) return

    const syncKey = `${details.id}-${customerId}`
    if (editClientSyncedRef.current === syncKey) return

    const matchedClient = findEditClientByCustomerId(
      allClientsEdit,
      customerId,
    )
    if (!matchedClient) return

    editClientSyncedRef.current = syncKey

    if (
      !values.clients ||
      String(values.clients?.id) !== String(matchedClient.id)
    ) {
      setFieldValue('clients', matchedClient)
      fetchAllCommunityByClient(matchedClient)
    }

    if (
      !currentRFQData?.client ||
      String(currentRFQData?.client?.id) !== String(matchedClient.id)
    ) {
      setCurrentRFQdata((prev) => ({ ...prev, client: matchedClient }))
    }
  }, [
    openEdit,
    details?.id,
    details?.customer_id,
    customerData?.customer_id,
    allClientsEdit,
    values.clients?.id,
    setFieldValue,
  ])

  // Negative marketing adjustment logic for manager approval (no Job type on quotation)
  // Kept for future use - no longer auto-enables manager approval toggle
  /* const hasNegativeMarketingAdjustment = useMemo(
    () =>
      (selectedProducts || []).some(
        (p) => p?.adj_value_type === false || p?.install_adj_value_type === false,
      ) ||
      (additionalSelectedServices || []).some(
        (s) => s?.adj_value_type === false || s?.install_adj_value_type === false,
      ) ||
      (selectedMaterials || []).some((m) => m?.adj_value_type === false),
    [selectedProducts, additionalSelectedServices, selectedMaterials],
  ); */

  // Automatically enable manager_approval_required when the total exceeds the limit or a negative
  // marketing adjustment is applied. Disabled - toggle is manual ON/OFF only.
  /* useEffect(() => {
    const managerApprovalLimit = Number(data?.manager_approval_amount) || 5000;
    if (hasNegativeMarketingAdjustment || parseFloat(grandTotal) > managerApprovalLimit) {
      if (!values.manager_approval_required) {
        setFieldValue('manager_approval_required', true);
      }
    }
  }, [hasNegativeMarketingAdjustment, grandTotal, setFieldValue, data?.manager_approval_amount]); */

  const collaboratorOptions = useMemo(() => {
    const availableTeamMembers = Array.isArray(teamMembersOptions)
      ? teamMembersOptions
      : [];
  
    let collaboratorMembers = [...availableTeamMembers];
  
    // Keep already-selected collaborators even if they are missing
    // from the current teamMembersOptions list.
    if (collaborators?.length) {
      const availableMemberIds = new Set(
        collaboratorMembers
          .map((member) => member?.id ?? member?.user_id)
          .filter((id) => id != null)
          .map(String)
      );
  
      const missingSelections = collaborators.filter((member) => {
        const memberId = member?.id ?? member?.user_id;
  
        return (
          memberId != null &&
          !availableMemberIds.has(String(memberId))
        );
      });
  
      if (missingSelections.length) {
        collaboratorMembers = [
          ...collaboratorMembers,
          ...missingSelections,
        ];
      }
    }
  
    return collaboratorMembers;
  }, [teamMembersOptions, collaborators]);
  
  // const collaboratorOptions = useMemo(() => {
  //   const availableTeamMembers = Array.isArray(teamMembersOptions) ? teamMembersOptions : [];
  //   let filteredMembers = availableTeamMembers;
  //   const communitySalesRepIds = getCommunitySalesRepIds(values.community);

  //   if (values.community && communitySalesRepIds.length > 0) {
  //     const allowedIds = new Set(communitySalesRepIds.map((id) => String(id)));
  //     filteredMembers = availableTeamMembers.filter((member) => {
  //       const memberId = member?.id ?? member?.user_id;
  //       return memberId != null && allowedIds.has(String(memberId));
  //     });
  //   }

  //   if (collaborators?.length) {
  //     const filteredIds = new Set(
  //       filteredMembers.map((member) => String(member?.id ?? member?.user_id))
  //     );
  //     const missingSelections = collaborators.filter((member) => {
  //       const memberId = member?.id ?? member?.user_id;
  //       return memberId != null && !filteredIds.has(String(memberId));
  //     });
  //     if (missingSelections.length) {
  //       filteredMembers = [...filteredMembers, ...missingSelections];
  //     }
  //   }

  //   return filteredMembers;
  // }, [teamMembersOptions, values.community, collaborators]);

  useImperativeHandle(ref, () => ({
    submitForm: () => formik.handleSubmit(),
  }), [formik.handleSubmit])

  const setValuesToPreview = () => {
    setPreviewData(values)
  }

  // let  totalsum = 0
  // let DiscountTotal=0
  // let newTotalProductFormula1 = 0;
  // let newTotalWholesalePrice1 = 0;
  // let newTotalRetailPrice1 = 0;

  const calculateTotal = (
    price,
    quantity,
    discount,
    value,
    location = 1,
    adjustment = 0,
    markAdjType = 1,
    adj_value_type = true,
  ) => {
    const parsedQuantity = parseFloat(quantity ? quantity : value) || 1
    const parsedDiscount = parseFloat(discount) || 0
    const locationQuantity = parseFloat(location) || 1
    const newPrice = parseFloat(price) || 0

    // Price already reflects marketing adjustment (original + signed adjustment)
    let SPMA = newPrice

    if (markAdjType == 2 || markAdjType == 3) {
      SPMA = newPrice
    }

    let subtotal = SPMA * parsedQuantity * locationQuantity

    if (parsedDiscount) {
      subtotal -= parsedDiscount
    }

    return parseFloat(subtotal.toFixed(2))
  }

  const handleRetailPriceChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)
    const valueToApply = isBlur
      ? formatPriceToTwoDecimals(limitedValue)
      : limitedValue

    if (valueToApply === '' || valueToApply === '-') {
      if (isBlur) {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.indexId === indexId
              ? { ...product, retail_price_draft: undefined }
              : product,
          ),
        )
      } else {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.indexId === indexId
              ? { ...product, retail_price_draft: limitedValue }
              : product,
          ),
        )
      }
      return
    }

    if (!isBlur && Number.isNaN(parseFloat(valueToApply))) {
      setSelectedProducts((prevProducts) =>
        prevProducts.map((product) =>
          product.indexId === indexId
            ? { ...product, retail_price_draft: limitedValue }
            : product,
        ),
      )
      return
    }

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product.indexId !== indexId) return product

        const editResult = applyRetailPriceEdit(
          ensureCatalogBaselines(product),
          valueToApply,
          markupType,
          {
            hasNegativePermission: explodedPermissions?.some((permission) =>
              ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
            ),
          },
        )

        if (!editResult) {
          return { ...product, retail_price_draft: limitedValue }
        }

        if (editResult.error) {
          if (!isBlur) {
            return { ...product, retail_price_draft: limitedValue }
          }
          enqueueSnackbar(editResult.error, { variant: 'error' })
          return { ...product, retail_price_draft: undefined }
        }

        const reconciled = reconcileCatalogMarketingPrices({
          ...product,
          ...editResult,
          retail_price_draft: isBlur ? undefined : limitedValue,
          adjustment_draft: undefined,
        })

        const priceForTotal =
          markupType === 1
            ? reconciled.price
            : reconciled.install_cost && parseFloat(reconciled.install_cost) > 0
            ? reconciled.retail_price
            : reconciled.actual_retail_price

        const total = calculateTotal(
          priceForTotal,
          Number(product.quantity),
          product.discount || 0,
          product.quantity,
          product.locationQuantity,
          reconciled.adjustment,
          product.markAdjType,
          reconciled.adj_value_type,
        )

        return {
          ...reconciled,
          retail_price_draft: isBlur ? undefined : limitedValue,
          ...(markupType === 1 ? { product_price: reconciled.price } : {}),
          product_total: total,
        }
      }),
    )
    setRefreshCalculation((v) => !v)
  }

  const handleMarketingAdjustmentChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)

    if (limitedValue === '' || limitedValue === '-') {
      if (isBlur) {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) => {
            if (product.indexId !== indexId) return product
            const baselined = ensureCatalogBaselines(product)
            return reconcileCatalogMarketingPrices({
              ...baselined,
              adjustment: 0,
              adjustment_draft: undefined,
              retail_price_edited: false,
            })
          }),
        )
        setRefreshCalculation((v) => !v)
      } else {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) => {
            if (product.indexId !== indexId) return product
            const baselined = ensureCatalogBaselines(product)
            return reconcileCatalogMarketingPrices({
              ...baselined,
              adjustment: '',
              adjustment_draft: '',
              retail_price_edited: false,
              retail_price_draft: undefined,
            })
          }),
        )
        setRefreshCalculation((v) => !v)
      }
      return
    }

    if (!isBlur) {
      setSelectedProducts((prevProducts) =>
        prevProducts.map((product) => {
          if (product.indexId !== indexId) return product

          const hasPermission = explodedPermissions?.some((permission) =>
            ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
          )
          const maxNegative = getMaxNegativeAdjustment(product, hasPermission)
          if (
            Number(limitedValue) >= maxNegative &&
            (product.adj_value_type === false || product.adj_value_type === 0) &&
            hasPermission
          ) {
            enqueueSnackbar('Retail value cannot be zero or less', {
              variant: 'error',
            })
            return product
          }
          if (
            Number(limitedValue) > maxNegative &&
            (product.adj_value_type === false || product.adj_value_type === 0) &&
            !hasPermission
          ) {
            enqueueSnackbar(
              `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
              { variant: 'error' },
            )
            return product
          }

          const numAdjustment = Number(limitedValue) || 0
          const baselined = ensureCatalogBaselines(product)
          const reconciled = reconcileCatalogMarketingPrices({
            ...baselined,
            adjustment: limitedValue,
            retail_price_edited: numAdjustment !== 0,
          })

          return {
            ...reconciled,
            adjustment_draft: limitedValue,
            adjustment: limitedValue,
            retail_price_draft: undefined,
          }
        }),
      )
      setRefreshCalculation((v) => !v)
      return
    }

    const normalizedValue = formatPriceToTwoDecimals(limitedValue)
    const numValue = Number(normalizedValue) || 0

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product.indexId !== indexId) return product

        const hasPermission = explodedPermissions?.some((permission) =>
          ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
        )
        const maxNegative = getMaxNegativeAdjustment(product, hasPermission)
        if (
          numValue >= maxNegative &&
          (product.adj_value_type === false || product.adj_value_type === 0) &&
          hasPermission
        ) {
          enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
          return { ...product, adjustment_draft: undefined }
        }
        if (
          numValue > maxNegative &&
          (product.adj_value_type === false || product.adj_value_type === 0) &&
          !hasPermission
        ) {
          enqueueSnackbar(
            `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
            { variant: 'error' },
          )
          return { ...product, adjustment_draft: undefined }
        }

        return reconcileCatalogMarketingPrices({
          ...ensureCatalogBaselines(product),
          adjustment: numValue,
          adj_value_type: numValue === 0 ? true : product.adj_value_type ?? true,
          retail_price_edited: numValue !== 0,
          adjustment_draft: undefined,
          retail_price_draft: undefined,
        })
      }),
    )
    setRefreshCalculation((v) => !v)
  }

  const handleInstallMarketingAdjustmentChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)

    if (limitedValue === '' || limitedValue === '-') {
      if (isBlur) {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) => {
            if (product.indexId !== indexId) return product
            const baselined = ensureCatalogBaselines(product)
            return reconcileCatalogMarketingPrices({
              ...baselined,
              install_adjustment: 0,
              install_adjustment_draft: undefined,
              install_price_edited: false,
            })
          }),
        )
        setRefreshCalculation((v) => !v)
      } else {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) => {
            if (product.indexId !== indexId) return product
            const baselined = ensureCatalogBaselines(product)
            return reconcileCatalogMarketingPrices({
              ...baselined,
              install_adjustment: '',
              install_adjustment_draft: '',
              install_price_edited: false,
              install_price_draft: undefined,
            })
          }),
        )
        setRefreshCalculation((v) => !v)
      }
      return
    }

    if (!isBlur) {
      setSelectedProducts((prevProducts) =>
        prevProducts.map((product) => {
          if (product.indexId !== indexId) return product

          const hasPermission = explodedPermissions?.some((permission) =>
            ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
          )
          const maxNegative = getMaxNegativeInstallAdjustment(product, hasPermission)
          if (
            Number(limitedValue) >= maxNegative &&
            (product.install_adj_value_type === false || product.install_adj_value_type === 0) &&
            hasPermission
          ) {
            enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
            return product
          }
          if (
            Number(limitedValue) > maxNegative &&
            (product.install_adj_value_type === false || product.install_adj_value_type === 0) &&
            !hasPermission
          ) {
            enqueueSnackbar(
              `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
              { variant: 'error' },
            )
            return product
          }

          const numAdjustment = Number(limitedValue) || 0
          const baselined = ensureCatalogBaselines(product)
          const reconciled = reconcileCatalogMarketingPrices({
            ...baselined,
            install_adjustment: limitedValue,
            install_price_edited: numAdjustment !== 0,
          })

          return {
            ...reconciled,
            install_adjustment_draft: limitedValue,
            install_adjustment: limitedValue,
            install_price_draft: undefined,
          }
        }),
      )
      setRefreshCalculation((v) => !v)
      return
    }

    const normalizedValue = formatPriceToTwoDecimals(limitedValue)
    const numValue = Number(normalizedValue) || 0

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product.indexId !== indexId) return product

        const hasPermission = explodedPermissions?.some((permission) =>
          ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
        )
        const maxNegative = getMaxNegativeInstallAdjustment(product, hasPermission)
        if (
          numValue >= maxNegative &&
          (product.install_adj_value_type === false || product.install_adj_value_type === 0) &&
          hasPermission
        ) {
          enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
          return { ...product, install_adjustment_draft: undefined }
        }
        if (
          numValue > maxNegative &&
          (product.install_adj_value_type === false || product.install_adj_value_type === 0) &&
          !hasPermission
        ) {
          enqueueSnackbar(
            `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
            { variant: 'error' },
          )
          return { ...product, install_adjustment_draft: undefined }
        }

        return reconcileCatalogMarketingPrices({
          ...ensureCatalogBaselines(product),
          install_adjustment: numValue,
          install_adj_value_type:
            numValue === 0 ? true : product.install_adj_value_type ?? true,
          install_price_edited: numValue !== 0,
          install_adjustment_draft: undefined,
          install_price_draft: undefined,
        })
      }),
    )
    setRefreshCalculation((v) => !v)
  }

  const handleInstallPriceChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)
    const valueToApply = isBlur
      ? formatPriceToTwoDecimals(limitedValue)
      : limitedValue

    if (valueToApply === '' || valueToApply === '-') {
      if (isBlur) {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.indexId === indexId
              ? { ...product, install_price_draft: undefined }
              : product,
          ),
        )
      } else {
        setSelectedProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.indexId === indexId
              ? { ...product, install_price_draft: limitedValue }
              : product,
          ),
        )
      }
      return
    }

    if (!isBlur && Number.isNaN(parseFloat(valueToApply))) {
      setSelectedProducts((prevProducts) =>
        prevProducts.map((product) =>
          product.indexId === indexId
            ? { ...product, install_price_draft: limitedValue }
            : product,
        ),
      )
      return
    }

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product.indexId !== indexId) return product

        const editResult = applyInstallPriceEdit(
          ensureCatalogBaselines(product),
          valueToApply,
          {
            hasNegativePermission: explodedPermissions?.some((permission) =>
              [
                'Allow Negative Marketing Adjustment Sales Order',
                'Allow Negative Marketing Adjustment Estimate',
              ].includes(permission),
            ),
          },
        )

        if (!editResult) {
          return { ...product, install_price_draft: limitedValue }
        }

        if (editResult.error) {
          if (!isBlur) {
            return { ...product, install_price_draft: limitedValue }
          }
          enqueueSnackbar(editResult.error, { variant: 'error' })
          return { ...product, install_price_draft: undefined }
        }

        const normalized = normalizeProductForSave({
          ...product,
          ...editResult,
        })

        const total = calculateTotal(
          normalized.retail_price,
          Number(product.quantity),
          product.discount || 0,
          product.quantity,
          product.locationQuantity,
          normalized.adjustment,
          product.markAdjType,
          normalized.adj_value_type,
        )

        return {
          ...normalized,
          install_price_draft: isBlur ? undefined : limitedValue,
          install_adjustment_draft: undefined,
          product_total: total,
        }
      }),
    )
    setRefreshCalculation((v) => !v)
  }

  const handleInstallAdjustmentChange = (indexId, rawValue) => {
    let newValue = limitDecimalInput(rawValue)
    const numValue = parseFloat(newValue) || 0
    if (numValue < 0) {
      newValue = '0'
    } else if (newValue !== '' && !Number.isNaN(numValue)) {
      newValue = String(numValue)
    }

    if (newValue.includes('.')) {
      const parts = newValue.split('.')
      if (parts[1].length > 2) {
        newValue = `${parts[0]}.${parts[1].slice(0, 2)}`
      }
    }

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) => {
        if (product.indexId !== indexId) return product

        const hasMarketingPermission = explodedPermissions?.some((permission) =>
          ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
        )
        const isPositiveInstallAdj =
          product.install_adj_value_type !== false &&
          product.install_adj_value_type !== 0
        const baseInstall = resolveInstallBaseline(product)
        const formulaEach = Number(product?.expected_install_labor_cost_with_markup || 0)
        const maxNegative = getMaxNegativeInstallAdjustment(
          product,
          hasMarketingPermission,
        )
        const adjNum = Number(newValue) || 0

        if (
          !isPositiveInstallAdj &&
          adjNum >= maxNegative &&
          hasMarketingPermission
        ) {
          enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
          return product
        }
        if (
          !isPositiveInstallAdj &&
          adjNum > maxNegative &&
          !hasMarketingPermission
        ) {
          enqueueSnackbar(
            `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
            { variant: 'error' },
          )
          return product
        }

        const newInstallCost = baseInstall
          ? computeInstallCostFromAdjustment(
              baseInstall,
              newValue,
              isPositiveInstallAdj,
            )
          : null

        if (
          baseInstall &&
          !isInstallRetailPriceAllowed(
            newInstallCost,
            formulaEach,
            hasMarketingPermission,
          )
        ) {
          if (hasMarketingPermission) {
            enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
          } else {
            enqueueSnackbar(
              `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
              { variant: 'error' },
            )
          }
          return product
        }

        return normalizeProductForSave({
          ...product,
          install_adjustment: newValue,
          install_adjustment_draft: newValue,
          install_cost: newInstallCost,
          original_install_cost: product.original_install_cost ?? baseInstall,
          retail_price: Number(
            (
              (Number(product.actual_retail_price) || 0) +
              (Number(newInstallCost) || 0)
            ).toFixed(2),
          ),
          install_price_draft: undefined,
        })
      }),
    )
    setRefreshCalculation((v) => !v)
  }

  const getProductGroupId = (product) =>
    product?.group_id ?? product?.customer_order_product_group_id ?? product?.groupId ?? null

  const groupedProducts = useMemo(
    () =>
      computeGroupedProducts({
        selectedProducts,
        markupType,
        customerOrderProductGroups,
        groupProductMarketingValues,
        groupInstallMarketingValues,
        groupQuantityMode: GROUP_QUANTITY_MODE_SET_MULTIPLIER,
      }),
    [
      selectedProducts,
      markupType,
      customerOrderProductGroups,
      groupProductMarketingValues,
      groupInstallMarketingValues,
    ],
  )

  const groupedProductsMap = useMemo(() => {
    return new Map((groupedProducts || []).map((g) => [String(g.id), g]))
  }, [groupedProducts])

  useEffect(() => {
    if (!groupedProducts?.length) return

    let productChanged = false
    let installChanged = false

    const nextProductMarketing = { ...groupProductMarketingValues }
    const nextInstallMarketing = { ...groupInstallMarketingValues }

    groupedProducts.forEach((group) => {
      const key = String(group.id)
      const totalProductFormula = Number(group.totalProductFormulaEach || 0)
      const prevProductFormula = prevGroupFormulaTotalsRef.current.product[key]

      if (
        prevProductFormula !== undefined &&
        Math.abs(prevProductFormula - totalProductFormula) > 0.004
      ) {
        const formulaDelta = Number(
          (totalProductFormula - prevProductFormula).toFixed(2),
        )
        const productMarketing = nextProductMarketing[key] || {}
        const adjValueType =
          productMarketing.adjValueType ?? group.groupAdjValueType ?? true
        const isPositive =
          adjValueType !== false && Number(adjValueType) !== 0
        const currentAdjustment = resolveGroupProductMarketingAdjustment(
          productMarketing,
          group.groupMeta || {},
        )
        const newAdjustment = isPositive
          ? Math.max(0, Number((currentAdjustment - formulaDelta).toFixed(2)))
          : Math.max(0, Number((currentAdjustment + formulaDelta).toFixed(2)))

        nextProductMarketing[key] = {
          ...productMarketing,
          adjustment: newAdjustment,
          adjValueType,
        }
        productChanged = true
      }
      prevGroupFormulaTotalsRef.current.product[key] = totalProductFormula

      const totalInstallFormula = Number(group.totalInstallFormulaEach || 0)
      const prevInstallFormula = prevGroupFormulaTotalsRef.current.install[key]

      if (
        prevInstallFormula !== undefined &&
        Math.abs(prevInstallFormula - totalInstallFormula) > 0.004 &&
        Number(group.totalInstallRetailEach || 0) > 0
      ) {
        const formulaDelta = Number(
          (totalInstallFormula - prevInstallFormula).toFixed(2),
        )
        const installMarketing = nextInstallMarketing[key] || {}
        const adjValueType =
          installMarketing.adjValueType ?? group.groupInstallAdjValueType ?? true
        const isPositive =
          adjValueType !== false && Number(adjValueType) !== 0
        const currentAdjustment = resolveGroupInstallMarketingAdjustment(
          installMarketing,
          group.groupMeta || {},
        )
        const newAdjustment = isPositive
          ? Math.max(0, Number((currentAdjustment - formulaDelta).toFixed(2)))
          : Math.max(0, Number((currentAdjustment + formulaDelta).toFixed(2)))

        nextInstallMarketing[key] = {
          ...installMarketing,
          adjustment: newAdjustment,
          adjValueType,
        }
        installChanged = true
      }
      prevGroupFormulaTotalsRef.current.install[key] = totalInstallFormula
    })

    if (productChanged) {
      setGroupProductMarketingValues(nextProductMarketing)
    }
    if (installChanged) {
      setGroupInstallMarketingValues(nextInstallMarketing)
    }
    if (productChanged || installChanged) {
      setRefreshCalculation((v) => !v)
    }
  }, [groupedProducts, groupProductMarketingValues, groupInstallMarketingValues])

  const getGroupMemberIndexIdsByProductIndexId = useCallback(
    (productIndexId) => {
      const numId = Number(productIndexId)
      if (Number.isNaN(numId)) return []

      // Prefer group map membership so nested rows always resolve siblings,
      // even if selectedProducts has duplicate/stale indexId entries.
      for (const group of groupedProductsMap.values()) {
        const ids = (group?.products || [])
          .map((p) => Number(p.indexId))
          .filter((id) => !Number.isNaN(id))
        if (ids.includes(numId) && ids.length) return ids
      }

      const product = (selectedProducts || []).find((p) => Number(p?.indexId) === numId)
      const gid = getProductGroupId(product)
      if (gid == null || gid === '') return [numId]
      const group = groupedProductsMap.get(String(gid))
      if (group?.products?.length) {
        const ids = group.products
          .map((p) => Number(p.indexId))
          .filter((id) => !Number.isNaN(id))
        if (ids.length) return ids
      }
      const ids = (selectedProducts || [])
        .filter((p) => String(getProductGroupId(p) || '') === String(gid))
        .map((p) => Number(p.indexId))
        .filter((id) => !Number.isNaN(id))
      return ids.length ? ids : [numId]
    },
    [selectedProducts, groupedProductsMap],
  )

  const getProductAttachmentsList = useCallback(
    (productIndexId) => {
      const numId = Number(productIndexId)
      const memberIds = getGroupMemberIndexIdsByProductIndexId(numId)
      if (memberIds.length <= 1) {
        return productAttachments[numId] || productAttachments[String(numId)] || []
      }
      const seen = new Set()
      const merged = []
      memberIds.forEach((mid) => {
        const list = productAttachments[mid] || productAttachments[String(mid)] || []
        list.forEach((f, fileIdx) => {
          const key = attachmentFileKey(f) || `__group_att_${mid}_${fileIdx}`
          if (!seen.has(key)) {
            seen.add(key)
            merged.push(f)
          }
        })
      })
      return merged
    },
    [productAttachments, getGroupMemberIndexIdsByProductIndexId],
  )

  // Merge API groups + locally-created groups so "Add to Existing Group" shows new groups too
  const addToGroupOptions = useMemo(
    () =>
      getAddToGroupOptions({
        groupedProducts,
        customerOrderProductGroups,
        selectedProducts,
      }),
    [customerOrderProductGroups, groupedProducts, selectedProducts],
  )

  useEffect(() => {
    setGroupSelectedProductIds((prev) => {
      const isEditingGroup = Object.values(groupEditMode || {}).some(Boolean)
      const next = isEditingGroup
        ? (prev || []).filter((id) =>
            (selectedProducts || []).some(
              (product) =>
                Number(product?.indexId) === Number(id) &&
                isQuotationChooseCatalogRow(product),
            ),
          )
        : getValidUngroupedSelectionIds(selectedProducts, prev)
      if (
        next.length === (prev || []).length &&
        next.every((id, i) => Number(id) === Number(prev[i]))
      ) {
        return prev
      }
      return next
    })
  }, [selectedProducts, groupEditMode])

  const firstIndexIdByGroupId = useMemo(() => {
    const first = {}
    ;(selectedProducts || [])
      .slice()
      .sort((a, b) => a.indexId - b.indexId)
      .forEach((p) => {
        if (!p?.group_id) return
        const gid = String(p.group_id)
        if (first[gid] == null) first[gid] = p.indexId
      })
    return first
  }, [selectedProducts])

  const getBlankLocationAddress = (id = 0) => ({
    id,
    address: '',
    city: '',
    state: '',
    zip: '',
  })

  const buildGroupAddressesForProduct = (product, sourceAddresses, overrides = {}) => {
    const nextAllLocationSame = overrides.allLocationSame ?? product?.allLocationSame
    const nextIsSingleCard = overrides.isSingleCard ?? product?.is_single_card
    const targetCount = nextIsSingleCard ? 1 : Math.max(1, Number(product?.locationQuantity || 1))
    const normalizedSource =
      sourceAddresses && sourceAddresses.length > 0
        ? sourceAddresses
        : [getBlankLocationAddress(0)]

    if (nextAllLocationSame) {
      const baseAddress = normalizedSource[0] || getBlankLocationAddress(0)
      return Array(targetCount)
        .fill(null)
        .map((_, i) => ({
          ...getBlankLocationAddress(i),
          ...baseAddress,
          id: i,
          req_loc_id: (product?.location || product?.addresses)?.[i]?.req_loc_id ?? null,
        }))
    }

    return Array(targetCount)
      .fill(null)
      .map((_, i) => ({
        ...getBlankLocationAddress(i),
        ...(normalizedSource[i] || {}),
        id: i,
        req_loc_id: (product?.location || product?.addresses)?.[i]?.req_loc_id ?? null,
      }))
  }

  const isSameGroupId = (a, b) => a != null && b != null && String(a) === String(b)

  const handleGroupFieldChange = (groupId, field, value) => {
    setSelectedProducts((prev) =>
      (prev || []).map((product) => {
        if (!isSameGroupId(product.group_id, groupId)) return product

        if (field === 'name') {
          return { ...product, group_name: value }
        }
        if (field === 'description') {
          return { ...product, group_description: value }
        }
        return product
      })
    )
    setCustomerOrderProductGroups((prev) =>
      (prev || []).map((g) => {
        if (String(g?.id ?? g?.group_id) !== String(groupId)) return g
        if (field === 'name') return { ...g, group_name: value, name: value }
        if (field === 'description') return { ...g, group_description: value, description: value }
        return g
      }),
    )
  }
  const handleGroupQuantityChange = (groupId, value) => {
    let newValue = String(value ?? '')
    if (newValue.startsWith('-')) newValue = newValue.slice(1)
    newValue = newValue.replace(/[^0-9]/g, '')
    if (newValue === '' || Number(newValue) <= 0) newValue = 1
    else newValue = Number(newValue)

    setCustomerOrderProductGroups((prev) => {
      const list = prev || []
      const idx = list.findIndex((group) =>
        isSameGroupId(group?.id ?? group?.group_id, groupId),
      )
      const existingGroup = idx >= 0 ? list[idx] : null
      const existingProdQty = Number(
        existingGroup?.product_marketing_quantity ??
          existingGroup?.productMarketingQuantity ??
          0,
      )
      const existingInstQty = Number(
        existingGroup?.install_marketing_quantity ??
          existingGroup?.installMarketingQuantity ??
          0,
      )
      const hasManualInstallQty =
        Boolean(existingGroup?.install_qty_manually_set) ||
        (existingProdQty > 0 &&
          existingInstQty > 0 &&
          existingProdQty !== existingInstQty) ||
        (selectedProducts || []).some(
          (product) =>
            isSameGroupId(product.group_id, groupId) &&
            product?.manually_updated_install_quantity,
        )
      if (idx === -1) {
        return [
          ...list,
          {
            id: groupId,
            group_id: groupId,
            product_marketing_quantity: Number(newValue),
            ...(hasManualInstallQty
              ? {}
              : { install_marketing_quantity: Number(newValue) }),
          },
        ]
      }
      return list.map((group, groupIndex) =>
        groupIndex !== idx
          ? group
          : {
              ...group,
              product_marketing_quantity: Number(newValue),
              ...(hasManualInstallQty
                ? {}
                : { install_marketing_quantity: Number(newValue) }),
            },
      )
    })
    setRefreshCalculation?.((v) => !v)
  }

  const normalizeGroupLineQuantity = (value) => {
    let newValue = String(value ?? '')
    if (newValue.startsWith('-')) newValue = newValue.slice(1)
    newValue = newValue.replace(/[^0-9]/g, '')
    if (newValue === '' || Number(newValue) <= 0) return 1
    return Number(newValue)
  }

  const handleGroupLineQuantityDraftChange = (productIndexId, field, value) => {
    const key = String(productIndexId)
    setGroupProductQuantityDrafts((prev) => ({
      ...prev,
      [key]: {
        ...(prev[key] || {}),
        [field]: normalizeGroupLineQuantity(value),
      },
    }))
  }

  const clearGroupLineQuantityDrafts = (products = []) => {
    setGroupProductQuantityDrafts((prev) => {
      const next = { ...prev }
      ;(products || []).forEach((product) => {
        delete next[String(product.indexId)]
      })
      return next
    })
  }

  const handleGroupLocationFieldChange = (groupId, locationIndex, field, value) => {
    setSelectedProducts((prevProducts) => {
      const groupedProducts = (prevProducts || []).filter((product) =>
        isSameGroupId(product.group_id, groupId),
      )
      if (groupedProducts.length === 0) return prevProducts

      const representative = groupedProducts[0]
      const sourceAddr = representative?.location || representative?.addresses || []
      let templateAddresses = buildGroupAddressesForProduct(
        representative,
        sourceAddr,
        {
          allLocationSame: representative?.allLocationSame,
          isSingleCard: representative?.is_single_card,
        },
      )

      if (representative?.allLocationSame) {
        const nextBase = {
          ...(templateAddresses[0] || getBlankLocationAddress(0)),
          [field]: value,
        }
        templateAddresses = templateAddresses.map((address, index) => ({
          ...address,
          ...nextBase,
          id: index,
        }))
      } else {
        templateAddresses[locationIndex] = {
          ...(templateAddresses[locationIndex] || getBlankLocationAddress(locationIndex)),
          [field]: value,
          id: locationIndex,
        }
      }

      return (prevProducts || []).map((product) =>
        !isSameGroupId(product.group_id, groupId)
          ? product
          : {
              ...product,
              location: buildGroupAddressesForProduct(product, templateAddresses, {
                allLocationSame: product?.allLocationSame,
                isSingleCard: product?.is_single_card,
              }),
            },
      )
    })
  }

  const handleGroupAllLocationSameChange = (groupId) => {
    setSelectedProducts((prevProducts) => {
      const groupedProducts = (prevProducts || []).filter((product) =>
        isSameGroupId(product.group_id, groupId),
      )
      if (groupedProducts.length === 0) return prevProducts

      const representative = groupedProducts[0]
      const nextAllLocationSame = !representative?.allLocationSame
      const sourceAddr = representative?.location || representative?.addresses || []
      const templateAddresses = buildGroupAddressesForProduct(
        representative,
        sourceAddr,
        {
          allLocationSame: nextAllLocationSame,
          isSingleCard: representative?.is_single_card,
        },
      )

      return (prevProducts || []).map((product) =>
        !isSameGroupId(product.group_id, groupId)
          ? product
          : {
              ...product,
              allLocationSame: nextAllLocationSame,
              location: buildGroupAddressesForProduct(product, templateAddresses, {
                allLocationSame: nextAllLocationSame,
                isSingleCard: product?.is_single_card,
              }),
            },
      )
    })
  }

  const handleGroupSingleCardChange = (groupId, checked) => {
    setSelectedProducts((prevProducts) => {
      const groupedProducts = (prevProducts || []).filter((product) =>
        isSameGroupId(product.group_id, groupId),
      )
      if (groupedProducts.length === 0) return prevProducts

      const representative = groupedProducts[0]
      const sourceAddr = representative?.location || representative?.addresses || []
      const templateAddresses = buildGroupAddressesForProduct(
        representative,
        sourceAddr,
        {
          allLocationSame: representative?.allLocationSame,
          isSingleCard: checked,
        },
      )

      return (prevProducts || []).map((product) =>
        !isSameGroupId(product.group_id, groupId)
          ? product
          : {
              ...product,
              is_single_card: checked,
              locationQuantity: checked ? 1 : product.locationQuantity,
              location: buildGroupAddressesForProduct(product, templateAddresses, {
                allLocationSame: product?.allLocationSame,
                isSingleCard: checked,
              }),
            },
      )
    })
  }

  const handleGroupInstallQuantityChange = (groupId, value) => {
    let newValue = String(value ?? '')
    if (newValue.startsWith('-')) newValue = newValue.slice(1)
    newValue = newValue.replace(/[^0-9]/g, '')
    if (newValue === '' || Number(newValue) <= 0) newValue = 1
    else newValue = Number(newValue)

    setCustomerOrderProductGroups((prev) => {
      const list = prev || []
      const idx = list.findIndex((group) =>
        isSameGroupId(group?.id ?? group?.group_id, groupId),
      )
      if (idx === -1) {
        return [
          ...list,
          {
            id: groupId,
            group_id: groupId,
            install_marketing_quantity: Number(newValue),
            install_qty_manually_set: true,
          },
        ]
      }
      return list.map((group, groupIndex) =>
        groupIndex !== idx
          ? group
          : {
              ...group,
              install_marketing_quantity: Number(newValue),
              install_qty_manually_set: true,
            },
      )
    })
    setRefreshCalculation?.((v) => !v)
  }

  const handleProductMarketingTypeChange = (indexId, newValue, data) => {
    const hasMarketingPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
    )
    if (!hasMarketingPermission && newValue === false) {
      const formulaEach = getSingleProductFormulaCostEach(data)
      const retailEachBase = Math.max(
        0,
        Number(
          data.original_actual_retail_price ??
            data.original_retail_price ??
            data.actual_retail_price ??
            data.retail_price ??
            data.product_retail_price ??
            0,
        ),
      )
      if (retailEachBase <= formulaEach) {
        enqueueSnackbar(
          'To apply a negative marketing adjustment, Retail Price Each must be higher than the Product formula cost Each.',
          { variant: 'error' },
        )
        return
      }
    }
    const maxNegative = getMaxNegativeAdjustment(data, hasMarketingPermission)
    const adjustment = Number(data.adjustment) || 0
    if (Number(adjustment) >= maxNegative && newValue === false && hasMarketingPermission) {
      enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
      return
    }
    if (adjustment > maxNegative && newValue === false && !hasMarketingPermission) {
      enqueueSnackbar(
        `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
        { variant: 'error' },
      )
      return
    }

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.indexId === indexId
          ? applyProductAdjValueTypeChange(product, newValue, { markupType })
          : product,
      ),
    )
    setRefreshCalculation((v) => !v)
  }

  const handleInstallMarketingTypeChange = (indexId, newValue, data) => {
    const hasMarketingPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
    )
    if (!hasMarketingPermission && newValue === false) {
      const formulaEach = Number(data?.expected_install_labor_cost_with_markup || 0)
      const retailEachBase = Math.max(
        0,
        Number(
          data.original_install_cost ??
            data.install_cost ??
            0,
        ),
      )
      if (retailEachBase <= formulaEach) {
        enqueueSnackbar(
          'To apply a negative marketing adjustment, Install Price Each must be higher than the Install formula cost Each.',
          { variant: 'error' },
        )
        return
      }
    }
    const maxNegative = getMaxNegativeInstallAdjustment(data, hasMarketingPermission)
    const adjustment = Number(data.install_adjustment) || 0
    const formulaEach = Number(data?.expected_install_labor_cost_with_markup || 0)
    const baseInstall = resolveInstallBaseline(data)
    const resultingInstallCost = computeInstallCostFromAdjustment(
      baseInstall,
      adjustment,
      newValue,
    )
    if (newValue === false) {
      if (
        !isInstallRetailPriceAllowed(
          resultingInstallCost,
          formulaEach,
          hasMarketingPermission,
        )
      ) {
        if (hasMarketingPermission) {
          enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
        } else {
          enqueueSnackbar(
            `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(2)} (Install Formula Limit)`,
            { variant: 'error' },
          )
        }
        return
      }
    }

    setSelectedProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.indexId === indexId
          ? applyInstallAdjValueTypeChange(product, newValue)
          : product,
      ),
    )
    setRefreshCalculation((v) => !v)
  }

  const handleGroupMarketingTypeChange = (groupId, newValue, totalProductFormulaEach = 0, totalProductRetailEach = 0, currentGroupAdjustment) => {
    const groupKey = String(groupId)
    const hasMarketingPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
    )

    const currentValues = groupProductMarketingValues?.[groupKey] || {}
    const currentAdjustment = Number(currentValues.adjustment ?? currentGroupAdjustment ?? 0) || 0
    const formulaEach = Number(totalProductFormulaEach || 0)
    const retailEach = Number(totalProductRetailEach || 0)
    const maxNegative = hasMarketingPermission
      ? retailEach
      : Math.max(0, retailEach - formulaEach)

    if (newValue === false) {
      if (!hasMarketingPermission && retailEach <= formulaEach) {
        return enqueueSnackbar(
          'Total Retail Price Each cannot be lower than or equal to Total Product formula cost Each for a negative group marketing adjustment.',
          { variant: 'error' },
        )
      }
      if (Number(currentAdjustment) >= maxNegative && hasMarketingPermission) {
        return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
      } else if (currentAdjustment > maxNegative && !hasMarketingPermission) {
        return enqueueSnackbar(
          `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
          { variant: 'error' },
        )
      }
    }

    setGroupProductMarketingValues((prev) => ({
      ...prev,
      [groupKey]: {
        ...(prev[groupKey] || {}),
        adjValueType: newValue,
        adjustment: currentAdjustment,
      },
    }))
    setRefreshCalculation((v) => !v)
  }

  const handleGroupMarketingAdjustmentChange = (
    groupId,
    value,
    totalFormulaEach = 0,
    totalRetailEach = 0,
    groupAdjValueType,
  ) => {
    let newValue = String(value ?? '')
    const currentValues = groupProductMarketingValues?.[groupId] || {}
    if (newValue === '') {
      setGroupProductMarketingValues((prev) => ({
        ...prev,
        [String(groupId)]: {
          ...(prev[String(groupId)] || {}),
          adjValueType: currentValues.adjValueType ?? groupAdjValueType ?? true,
          adjustment: 0,
        },
      }))
      setRefreshCalculation((v) => !v)
      return
    }
    let numValue = parseFloat(newValue) || 0
    if (numValue < 0) numValue = 0

    const adjValueType =
      currentValues.adjValueType ?? groupAdjValueType ?? true
    const isNegative =
      adjValueType === false || Number(adjValueType) === 0
    if (isNegative) {
      const hasMarketingPermission = explodedPermissions?.some((permission) =>
        ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
      )
      const formulaEach = Number(totalFormulaEach || 0)
      const retailEachBase = Math.max(0, Number(totalRetailEach || 0))
      const maxNegative = hasMarketingPermission
        ? retailEachBase
        : Math.max(0, retailEachBase - formulaEach)
      if (numValue >= maxNegative && hasMarketingPermission) {
        enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
        return
      } else if (numValue > maxNegative && !hasMarketingPermission) {
        enqueueSnackbar(
          `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
          { variant: 'error' },
        )
        return
      }
    }

    newValue = numValue.toFixed(2)

    setGroupProductMarketingValues((prev) => ({
      ...prev,
      [String(groupId)]: {
        ...(prev[String(groupId)] || {}),
        adjValueType: currentValues.adjValueType ?? groupAdjValueType ?? true,
        adjustment: numValue,
      },
    }))
    setRefreshCalculation((v) => !v)
  }

  const handleGroupInstallMarketingTypeChange = (
    groupId,
    newValue,
    totalInstallFormulaEach = 0,
    totalInstallRetailEach = 0,
    currentGroupInstallAdjustment,
  ) => {
    const groupKey = String(groupId)
    const hasMarketingPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
    )

    const currentValues = groupInstallMarketingValues?.[groupKey] || {}
    const currentAdjustment =
      Number(currentValues.adjustment ?? currentGroupInstallAdjustment ?? 0) || 0
    const formulaEach = Number(totalInstallFormulaEach || 0)
    const retailEach = Number(totalInstallRetailEach || 0)
    const maxNegative = hasMarketingPermission
      ? retailEach
      : Math.max(0, retailEach - formulaEach)

    if (newValue === false) {
      if (!hasMarketingPermission && retailEach <= formulaEach) {
        return enqueueSnackbar(
          'Total Install Retail Price Each cannot be lower than or equal to Total Install formula cost Each for a negative group marketing adjustment.',
          { variant: 'error' },
        )
      }
      if (Number(currentAdjustment) >= maxNegative && hasMarketingPermission) {
        return enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
      } else if (currentAdjustment > maxNegative && !hasMarketingPermission) {
        return enqueueSnackbar(
          `Negative Adjustment Amount cannot reduce total below Install Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
          { variant: 'error' },
        )
      }
    }

    setGroupInstallMarketingValues((prev) => ({
      ...prev,
      [groupKey]: {
        ...(prev[groupKey] || {}),
        adjValueType: newValue,
        adjustment: currentAdjustment,
      },
    }))
    setRefreshCalculation((v) => !v)
  }

  const handleGroupInstallMarketingAdjustmentChange = (
    groupId,
    value,
    totalInstallFormulaEach = 0,
    totalInstallRetailEach = 0,
    groupInstallAdjValueType,
  ) => {
    let newValue = String(value ?? '')
    const currentValues = groupInstallMarketingValues?.[groupId] || {}
    if (newValue === '') {
      setGroupInstallMarketingValues((prev) => ({
        ...prev,
        [String(groupId)]: {
          ...(prev[String(groupId)] || {}),
          adjValueType: currentValues.adjValueType ?? groupInstallAdjValueType ?? true,
          adjustment: 0,
        },
      }))
      setRefreshCalculation((v) => !v)
      return
    }
    let numValue = parseFloat(newValue) || 0
    if (numValue < 0) numValue = 0

    const adjValueType =
      currentValues.adjValueType ?? groupInstallAdjValueType ?? true
    const isNegative =
      adjValueType === false || Number(adjValueType) === 0
    if (isNegative) {
      const hasMarketingPermission = explodedPermissions?.some((permission) =>
        ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
      )
      const formulaEach = Number(totalInstallFormulaEach || 0)
      const retailEachBase = Math.max(0, Number(totalInstallRetailEach || 0))
      const maxNegative = hasMarketingPermission
        ? retailEachBase
        : Math.max(0, retailEachBase - formulaEach)
      if (numValue >= maxNegative && hasMarketingPermission) {
        enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
        return
      } else if (numValue > maxNegative && !hasMarketingPermission) {
        enqueueSnackbar(
          `Negative Adjustment Amount cannot reduce total below Install Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
          { variant: 'error' },
        )
        return
      }
    }

    newValue = numValue.toFixed(2)

    setGroupInstallMarketingValues((prev) => ({
      ...prev,
      [String(groupId)]: {
        ...(prev[String(groupId)] || {}),
        adjValueType: currentValues.adjValueType ?? groupInstallAdjValueType ?? true,
        adjustment: numValue,
      },
    }))
    setRefreshCalculation((v) => !v)
  }

  const findCustProductRowForLineCatalog = (product) => {
    const rows = invoice?.cust_product
    if (!product || !Array.isArray(rows) || rows.length === 0) return null
    const byIndex =
      product.indexId != null
        ? rows.find((r) => Number(r?.product_index) === Number(product.indexId))
        : null
    if (byIndex) return byIndex
    if (product.backendId != null) {
      return rows.find((r) => r?.id != null && String(r.id) === String(product.backendId)) || null
    }
    return null
  }

  const isProductLineCatalog = (product) => {
    if (!product) return false
    if (Number(product.is_line_catalog) === 1) return true
    const row = findCustProductRowForLineCatalog(product)
    return Number(row?.is_line_catalog) === 1
  }

  const isProductWriteRow = (product) => {
    if (!product) return false
    if (Number(product.product_write) === 1) return true
    const row = findCustProductRowForLineCatalog(product)
    return Number(row?.product_write) === 1
  }

  /** Catalog line or write row — eligible as group catalog source / validation count. */
  const countsAsGroupCatalogEligible = (product) =>
    isProductLineCatalog(product) || isProductWriteRow(product)

  const isServiceLineCatalog = (service) => {
    if (!service) return false
    if (Number(service.is_line_catalog) === 1) return true
    if (!isEstimateJobWriteService(service)) return false
    const labourId = service?.labour_cost_service_id ?? service?.productId
    return labourId != null && Number(labourId) > 0
  }

  const shouldShowWriteServiceCatalogButtons = (row) =>
    isEstimateJobWriteService(row) && !isServiceLineCatalog(row)

  const getCommunityLocationForProducts = (communityOverride) => {
    const {
      address = '',
      city = '',
      state = '',
      zip = '',
    } = communityOverride ?? values?.community ?? {}
    return { address, city, state, zip }
  }

  const hasProductLocationPresent = (product) => {
    const locations = Array.isArray(product?.location) ? product.location : []
    if (!locations.length) return false
    return locations.some((loc) =>
      [loc?.address, loc?.city, loc?.state, loc?.zip].some(
        (value) => value != null && String(value).trim() !== '',
      ),
    )
  }

  const getDefaultProductLocationEntries = (
    locationQuantity = 1,
    communityOverride,
  ) => {
    const communityLocation = getCommunityLocationForProducts(communityOverride)
    const qty = Math.max(1, Number(locationQuantity) || 1)
    const hasCompleteCommunity =
      communityLocation.address &&
      communityLocation.city &&
      communityLocation.state &&
      communityLocation.zip
    if (hasCompleteCommunity) {
      return Array.from({ length: qty }, (_, i) => ({
        id: i,
        ...communityLocation,
      }))
    }
    return Array.from({ length: qty }, (_, i) => ({
      id: i,
      address: '',
      city: '',
      state: '',
      zip: '',
    }))
  }

  const withCommunityLocationIfMissing = (product, communityOverride) => {
    if (!product || hasProductLocationPresent(product)) return product
    const locationQuantity = Number(product?.locationQuantity) || 1
    return {
      ...product,
      location: getDefaultProductLocationEntries(
        locationQuantity,
        communityOverride,
      ),
    }
  }

  /** Line-catalog row anchors the group in the table; explicit anchor from “Choose Catalog Source” wins. */
  const getGroupAnchorIndexId = (group) => {
    const products = group?.products || []
    const explicit = products.find((p) => p?.group_catalog_anchor_index_id != null)
    if (explicit) {
      const aid = Number(explicit.group_catalog_anchor_index_id)
      if (!Number.isNaN(aid) && products.some((p) => Number(p.indexId) === aid)) {
        return aid
      }
    }
    const line = products.find((p) => isProductLineCatalog(p))
    if (line?.indexId != null) return line.indexId
    const ids = products
      .map((p) => Number(p.indexId))
      .filter((n) => !Number.isNaN(n))
    return ids.length ? Math.min(...ids) : null
  }

  /** Interleave ungrouped rows and group blocks at the line-catalog (anchor) row position. */
  const productTableBodyRenderOrder = useMemo(() => {
    const groupMap = new Map((groupedProducts || []).map((g) => [String(g.id), g]))
    const sorted = [...(selectedProducts || [])].sort(
      (a, b) => (a?.indexId || 0) - (b?.indexId || 0),
    )
    const groupMemberIndexIds = new Set()
    ;(groupedProducts || []).forEach((g) => {
      ;(g.products || []).forEach((p) => {
        if (p?.indexId != null) groupMemberIndexIds.add(Number(p.indexId))
      })
    })
    const out = []
    const seenGroups = new Set()
    for (const p of sorted) {
      const gidRaw = getProductGroupId(p)
      if (gidRaw == null || gidRaw === '') {
        out.push({ type: 'product', indexId: p.indexId })
        continue
      }
      const gid = String(gidRaw)
      if (seenGroups.has(gid)) continue
      const group = groupMap.get(gid)
      if (!group) continue
      const anchorId = getGroupAnchorIndexId(group)
      if (anchorId == null || Number(p.indexId) !== Number(anchorId)) continue
      seenGroups.add(gid)
      out.push({ type: 'group', groupId: gid, indexId: anchorId })
    }
    return out.filter((item) => {
      if (item.type !== 'product') return true
      return !groupMemberIndexIds.has(Number(item.indexId))
    })
  }, [selectedProducts, groupedProducts, invoice])

  const remapProductIndexIds = useCallback(
    (indexIdMap, productsSnapshot, options = {}) => {
      const {
        removeProductRowBackendIds = [],
        removeIndexKeys = [],
      } = options
      const removeKeySet = new Set(removeIndexKeys.map(String))
      const removeBackendIdSet = new Set(removeProductRowBackendIds.map(String))
      const remapKey = (oldKey) => {
        if (removeKeySet.has(String(oldKey))) return null
        const mapped = indexIdMap[String(oldKey)]
        return mapped !== undefined ? String(mapped) : String(oldKey)
      }

      const remappedProducts = (productsSnapshot || []).map((product) => {
        const newId = indexIdMap[String(product.indexId)]
        if (newId === undefined) return product
        const anchorKey =
          product.group_catalog_anchor_index_id != null
            ? String(product.group_catalog_anchor_index_id)
            : null
        return {
          ...product,
          indexId: newId,
          product_index: newId,
          ...(anchorKey && indexIdMap[anchorKey] !== undefined
            ? { group_catalog_anchor_index_id: indexIdMap[anchorKey] }
            : {}),
        }
      })

      setSelectedProducts(remappedProducts)
      setFieldValue('products', remappedProducts)

      setProductAttachments((prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const newKey = remapKey(oldKey)
          if (!newKey) return
          next[newKey] = (prev[oldKey] || []).map((f) => ({
            ...f,
            product_index_id: newKey,
          }))
        })
        return next
      })

      setAttachmentTabValue((prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const newKey = remapKey(oldKey)
          if (newKey && prev[oldKey] !== undefined) next[newKey] = prev[oldKey]
        })
        return next
      })
      const remapKeyedStateWithRemove = (prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const newKey = remapKey(oldKey)
          if (newKey && prev[oldKey] !== undefined) next[newKey] = prev[oldKey]
        })
        return next
      }
      setSelectedUploadedImages(remapKeyedStateWithRemove)
      setOpenProductAttachment(remapKeyedStateWithRemove)

      setSelectedServices((prev) =>
        (prev || []).map((service) => ({
          ...service,
          productIndex:
            indexIdMap[String(service.productIndex)] ?? service.productIndex,
          indexId: indexIdMap[String(service.indexId)] ?? service.indexId,
          newIndexId:
            indexIdMap[String(service.newIndexId)] ?? service.newIndexId,
          product_index:
            indexIdMap[String(service.product_index)] ?? service.product_index,
        })),
      )

      setSelectedMaterials((prev) =>
        (prev || []).map((material) => ({
          ...material,
          newIndexId:
            indexIdMap[String(material.newIndexId)] ?? material.newIndexId,
          product_index:
            indexIdMap[String(material.product_index)] ?? material.product_index,
        })),
      )

      setProductRows((prev) => {
        const hasRemoveFilters =
          removeKeySet.size > 0 || removeBackendIdSet.size > 0
        const rows = hasRemoveFilters
          ? (prev || []).filter((row) => {
              const rowBackendId = String(row?.backendId ?? row?.id ?? '')
              if (rowBackendId && removeBackendIdSet.has(rowBackendId)) return false
              if (removeKeySet.has(String(row.indexId))) return false
              return true
            })
          : prev || []
        const remapped = rows.map((row) => ({
          ...row,
          indexId: indexIdMap[String(row.indexId)] ?? row.indexId,
        }))
        if (hasRemoveFilters && remapped.length === 0) {
          setTimeout(() => setProductRowsIndexCounter(0), 0)
          return [
            {
              indexId: 0,
              product_name: '',
              product_desc: '',
              is_product_row: 1,
              backendId: null,
            },
          ]
        }
        if (hasRemoveFilters) {
          setTimeout(() => setProductRowsIndexCounter(remapped.length), 0)
        }
        return remapped
      })

      setGroupSelectedProductIds((prev) =>
        (prev || []).map((pid) => indexIdMap[String(pid)] ?? pid),
      )

      const maxIndex =
        remappedProducts.length > 0
          ? Math.max(...remappedProducts.map((p) => Number(p.indexId) || 0))
          : 0
      setIndexCounter(maxIndex)

      return remappedProducts
    },
    [setFieldValue],
  )

  const handleProductTableDragEnd = useCallback(
    async (result) => {
      if (!result.destination || result.destination.index === result.source.index) {
        return
      }
      if (isPreview || !openEdit) return

      const renderOrder = [...productTableBodyRenderOrder]
      const [moved] = renderOrder.splice(result.source.index, 1)
      renderOrder.splice(result.destination.index, 0, moved)

      const orderedOldIds = []
      renderOrder.forEach((item) => {
        if (item.type === 'product') {
          orderedOldIds.push(item.indexId)
        } else if (item.type === 'group') {
          const group = groupedProductsMap.get(item.groupId)
          const groupProducts = [...(group?.products || [])].sort(
            (a, b) => (Number(a?.indexId) || 0) - (Number(b?.indexId) || 0),
          )
          groupProducts.forEach((p) => orderedOldIds.push(p.indexId))
        }
      })

      const orderedSet = new Set(orderedOldIds.map(String))
      ;(selectedProducts || []).forEach((p) => {
        if (p?.indexId != null && !orderedSet.has(String(p.indexId))) {
          orderedOldIds.push(p.indexId)
        }
      })

      const indexIdMap = {}
      orderedOldIds.forEach((oldId, idx) => {
        indexIdMap[String(oldId)] = idx + 1
      })

      const remappedProducts = remapProductIndexIds(indexIdMap, selectedProducts)

      if (id) {
        try {
          await axios.post(`${REST_API_END_POINT}request/reorder-estimate-products`, {
            requestId: id,
            indexMapping: indexIdMap,
            userId: user?.user_id,
          })
        } catch (error) {
          console.error('Error saving product order:', error)
          enqueueSnackbar('Failed to save product order', { variant: 'error' })
        }
      }
    },
    [
      productTableBodyRenderOrder,
      groupedProductsMap,
      selectedProducts,
      isPreview,
      openEdit,
      id,
      user?.user_id,
      remapProductIndexIds,
      enqueueSnackbar,
    ],
  )

  const getServiceLineKey = (service) =>
    String(service?.newIndexId ?? service?.indexId ?? service?.product_index ?? '')

  const remapServiceIndexIds = useCallback((indexIdMap) => {
    const remapKey = (oldKey) => {
      const mapped = indexIdMap[String(oldKey)]
      return mapped !== undefined ? String(mapped) : String(oldKey)
    }

    const remapKeyedState = (prev) => {
      const next = {}
      Object.keys(prev || {}).forEach((oldKey) => {
        const newKey = remapKey(oldKey)
        next[newKey] = prev[oldKey]
      })
      return next
    }

    const remapService = (service) => {
      const oldKey = getServiceLineKey(service)
      const newId = indexIdMap[oldKey]
      if (newId === undefined) return service
      return {
        ...service,
        newIndexId: newId,
        indexId: newId,
        product_index: newId,
      }
    }

    setAdditionalSelectedServices((prev) => (prev || []).map(remapService))

    setServiceRows((prev) =>
      (prev || []).map((row) => {
        const newId = indexIdMap[String(row.indexId)]
        if (newId === undefined) return row
        return { ...row, indexId: newId, product_index: newId }
      }),
    )

    setServiceAttachments((prev) => {
      const next = {}
      Object.keys(prev || {}).forEach((oldKey) => {
        const newKey = remapKey(oldKey)
        next[newKey] = (prev[oldKey] || []).map((f) => ({
          ...f,
          service_index_id: newKey,
        }))
      })
      return next
    })

    setAttachmentTabValueService(remapKeyedState)
    setSelectedUploadedImagesService(remapKeyedState)
    setOpenServiceAttachment(remapKeyedState)
    setIsUploadingService(remapKeyedState)
    setOpenServiceNote(remapKeyedState)
  }, [])

  const handleServiceTableDragEnd = useCallback(
    async (result) => {
      if (!result.destination || result.destination.index === result.source.index) {
        return
      }
      if (isPreview || !openEdit) return

      const sorted = [...(additionalSelectedServices || [])].sort(
        (a, b) =>
          (Number(a?.newIndexId ?? a?.indexId ?? a?.product_index) || 0) -
          (Number(b?.newIndexId ?? b?.indexId ?? b?.product_index) || 0),
      )
      const [moved] = sorted.splice(result.source.index, 1)
      sorted.splice(result.destination.index, 0, moved)

      const indexIdMap = buildServiceIndexMapping(sorted)

      remapServiceIndexIds(indexIdMap)

      if (id) {
        try {
          const res = await axios.post(`${REST_API_END_POINT}request/reorder-estimate-services`, {
            requestId: id,
            indexMapping: indexIdMap,
            userId: user?.user_id,
          })
          if (res?.data?.status !== 1) {
            enqueueSnackbar(res?.data?.message || 'Failed to save service order', { variant: 'error' })
          }
        } catch (error) {
          console.error('Error saving service order:', error)
          enqueueSnackbar('Failed to save service order', { variant: 'error' })
        }
      }
    },
    [
      additionalSelectedServices,
      isPreview,
      openEdit,
      id,
      user?.user_id,
      remapServiceIndexIds,
      enqueueSnackbar,
    ],
  )

  const renderGroupTableBelowSummaryRow = (group, isGroupOpen, groupInstallLosingMoneyRowSx) => {
  const groupAttachmentIndicatorId = getGroupAnchorIndexId(group)
  const groupHasAttachments =
    groupAttachmentIndicatorId != null &&
    getProductAttachmentsList(groupAttachmentIndicatorId).length > 0
  const groupInstallNotes =
    (group?.products || []).find(
      (p) => p?.install_notes != null && String(p.install_notes).trim() !== '',
    )?.install_notes || ''
  const groupHasInstallNotes = Boolean(groupInstallNotes && String(groupInstallNotes).trim())

  return (
  <>
  {/* Install Price summary row for group */}
{Number(group.totalInstallSubtotal || 0) > 0 ? (
  <TableRow sx={groupInstallLosingMoneyRowSx}>
    <TableCell />
    <TableCell />
    <TableCell sx={{ fontWeight: 600 }}>—</TableCell>
    <TableCell />
    <TableCell sx={{ fontWeight: 600 }}>Install Price</TableCell>
    <TableCell />
    <TableCell />
    <TableCell />
    <TableCell />
    <TableCell />
    <TableCell sx={{ fontWeight: 600 }}>
      {Number(group.baseInstallFormulaEach || 0).toFixed(2)}
    </TableCell>
    <TableCell align="center" sx={{ fontWeight: 600 }}>
      -
    </TableCell>
    <TableCell sx={{ fontWeight: 600 }}>
      {hasMarkupPermission && markupType == 2
        ? Number(group.adjustedGroupInstallRetailEach || 0).toFixed(2)
        : null}
    </TableCell>
    <TableCell sx={{ fontWeight: 600 }}>
      {hasMarkupPermission && markupType == 1
        ? Number(group.adjustedGroupInstallRetailEach || 0).toFixed(2)
        : null}
    </TableCell>
    <TableCell sx={{ fontWeight: 600, width: 110 }}>
      <TextField
        // disabled={!openEdit}
        type="number"
        size="small"
        fullWidth
        label="Qty"
        value={Number(group.groupInstallQuantity || 1)}
        onKeyPress={(event) => {
          if (
            (event.key === '0' && event.target.value === '') ||
            event.key === '-' ||
            event.key === '.'
          ) {
            event.preventDefault()
          }
        }}
        onChange={(event) =>
          handleGroupInstallQuantityChange(
            group.id,
            event.target.value,
          )
        }
      />
    </TableCell>
    <TableCell align="center" sx={{ fontWeight: 600, color: 'text.secondary' }}>
      -
    </TableCell>
    <TableCell sx={{ color: 'text.secondary', width: 150 }}>
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="center"
      >
        <Remove
          fontSize="small"
          style={{ cursor: 'pointer' }}
          onClick={() =>
            handleGroupInstallMarketingTypeChange(
              group.id,
              false,
              group.totalInstallFormulaEach,
              group.totalInstallRetailEach,
              group.groupInstallAdjustment,
            )
          }
        />
        <FormControlLabel
          control={
            <Switch
              checked={
                group.groupInstallAdjValueType !== false &&
                group.groupInstallAdjValueType !== 0
              }
              onChange={(event) =>
                handleGroupInstallMarketingTypeChange(
                  group.id,
                  event.target.checked,
                  group.totalInstallFormulaEach,
                  group.totalInstallRetailEach,
                  group.groupInstallAdjustment,
                )
              }
            />
          }
          label=""
        />
        <Add
          fontSize="small"
          style={{ cursor: 'pointer' }}
          onClick={() =>
            handleGroupInstallMarketingTypeChange(
              group.id,
              true,
              group.totalInstallFormulaEach,
              group.totalInstallRetailEach,
              group.groupInstallAdjustment,
            )
          }
        />
      </Stack>
    </TableCell>
    <TableCell sx={{ fontWeight: 600, width: 120 }}>
      <TextField
        type="number"
        size="small"
        fullWidth
        inputProps={{ min: 0 }}
        label="$"
        InputLabelProps={{ shrink: true }}
        value={getGroupInstallMarketingAdjustmentDisplay(
          groupInstallMarketingValues?.[group.id] || {},
          group.groupInstallAdjustment,
        )}
        onWheel={(e) => e.target.blur()}
        onBeforeInput={(e) => {
          const nextValue = e.target.value
          const adjValueType =
            groupInstallMarketingValues?.[group.id]?.adjValueType ??
            group.groupInstallAdjValueType ??
            true
          const isNegative =
            adjValueType === false || Number(adjValueType) === 0
          if (!isNegative) return
          const hasMarketingPermission = explodedPermissions?.some((permission) =>
            ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
          )
          const formulaEach = Number(group.totalInstallFormulaEach || 0)
          const retailEach = Number(group.totalInstallRetailEach || 0)
          const maxNegative = hasMarketingPermission
            ? retailEach
            : Math.max(0, retailEach - formulaEach)
          if (Number(nextValue) >= maxNegative && hasMarketingPermission) {
            e.preventDefault()
            enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
          } else if (Number(nextValue) > maxNegative && !hasMarketingPermission) {
            e.preventDefault()
            enqueueSnackbar(
              `Negative Adjustment Amount cannot reduce total below Install Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
              { variant: 'error' },
            )
          }
        }}
        onChange={(event) =>
          handleGroupInstallMarketingAdjustmentChange(
            group.id,
            event.target.value,
            group.totalInstallFormulaEach,
            group.totalInstallRetailEach,
            group.groupInstallAdjValueType,
          )
        }
        onKeyDown={(event) => {
          if (event.key === '-' || event.key === '+') {
            event.preventDefault()
          }
          if (event.key === 'ArrowDown') {
            const currentValue = parseFloat(event.target.value) || 0
            const step = parseFloat(event.target.step) || 1
            if (currentValue - step < 0) {
              event.preventDefault()
            }
          }
        }}
      />
    </TableCell>
    <TableCell sx={{ fontWeight: 600 }}>
      {Number(group.adjustedGroupInstallSubtotal || 0).toFixed(2)}
    </TableCell>
    <TableCell sx={{ fontWeight: 600 }}>
      {Number(group.adjustedGroupTotal || 0).toFixed(2)}
    </TableCell>
    <TableCell align="center" sx={QUOTATION_ROW_DELETE_CELL_SX}>
      {openEdit ? (
      <Box sx={QUOTATION_ROW_ACTIONS_BOX_SX}>
        <Box sx={QUOTATION_ROW_ACTIONS_LEADING_SLOT_SX} />
        <IconButton
          size="small"
          color="error"
          onClick={() => {
            setSelectedProducts((prev) =>
              prev.map((p) =>
                String(p.group_id) === String(group.id)
                  ? { ...p, install_cost: null, install_adjustment: null, install_quantity: null, original_install_cost: null }
                  : p
              )
            )
            setRefreshCalculation?.((v) => !v)
          }}
        >
          <Delete />
        </IconButton>
        </Box>
      ) : null}
    </TableCell>
  </TableRow>
) : null}

{/* Collapsible section with nested products table */}
<TableRow>
  <TableCell colSpan={100} sx={{ p: 0 }}>
    <Collapse in={isGroupOpen} timeout="auto" unmountOnExit>
      <Box sx={{ px: 2, py: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox" />
              {VALUE?.map((val) => {
                if (val.value === null) return null
                if (val.id === 16 && !isSplitOrder) return null
                return val.id === 4 ? (
                  <Tooltip key={val.id} title="Product Formula Cost Per Unit * Quantity">
                    <TableCell>{val.value}</TableCell>
                  </Tooltip>
                ) : val.id === 14 ? (
                  <Tooltip key={val.id} title="Selling Price With Marketing Adjustment">
                    <TableCell>{val.value}</TableCell>
                  </Tooltip>
                ) : (
                  <TableCell key={`h-${val.id}`}>{val.value}</TableCell>
                )
              })}
              <TableCell padding="checkbox" />
            </TableRow>
          </TableHead>
          <TableBody>
            {(group?.products || []).map((data, groupProductIndex) => {
              // Calculate values for display
              const quantityDraft = groupProductQuantityDrafts[String(data.indexId)] || {}
              const productLocQty =
                Number(
                  quantityDraft.group_product_quantity ?? getGroupMemberProductQty(data),
                ) || 1
              const installQty =
                Number(
                  quantityDraft.group_install_quantity ?? getGroupMemberInstallQty(data),
                ) || 1
              const installRetailEach = Number(data?.install_cost) || 0
                                                                
              // The effective retail each (includes markup and any saved adjustments)
              const retailEach = markupType == 1 
                ? Number(data?.price || data?.product_price || 0)
                : Number(data?.actual_retail_price || data?.retail_price || data?.product_retail_price || 0)
                                                                  
              const productSubTotal = retailEach * productLocQty
              const installSubTotal = installRetailEach * installQty
              const discountAmount = Number(data?.discount || 0)
              const cellProductTotal = Math.max(0, productSubTotal + installSubTotal - discountAmount)
              const { isProductLosingMoney, isInstallLosingMoney } =
                getNestedLineLosingMoneyFlags(data, markupType)
              const nestedProductRowSx = getLosingMoneyRowSx(isProductLosingMoney)
              const nestedInstallRowSx = getLosingMoneyRowSx(isInstallLosingMoney)

              return (
                <React.Fragment key={`gp-${data.id || data.indexId}`}>
                  <TableRow
                    // onDragOver={(e) => handleProductIconDragOver(e, data.indexId)}
                    // onDragLeave={(e) => handleProductIconDragLeave(e, data.indexId)}
                    // onDrop={(e) => handleProductIconDrop(e, data.indexId)}
                    sx={{
                      '& > *': { borderBottom: 'unset' },
                      ...nestedProductRowSx,
                      // ...(productAttachmentDragOver[data.indexId] && {
                      //   backgroundColor: 'action.hover',
                      //   outline: `2px dashed ${theme.palette.primary.main}`,
                      //   outlineOffset: -2,
                      // }),
                    }}
                  >
                    <TableCell padding="checkbox">
                      {groupEditMode?.[group.id] ? (
                        <Checkbox
                          checked={isIndexIdInList(groupSelectedProductIds, data.indexId)}
                          onChange={() => {
                            toggleGroupProductSelection(data)
                          }}
                        />
                      ) : null}
                    </TableCell>
                                                                      
                    {VALUE?.map((val) => {
                      if (val.value === null) return null
                      if (val.id === 16 && !isSplitOrder) return null

                      if (val.id === 0)
                        return (
                          <TableCell key={`c0-${val.id}`}>
                            {groupProductIndex + 1}
                          </TableCell>
                        )
                      if (val.id === 1) return <TableCell key={`c1-${val.id}`}>{data.product_name || data.name}</TableCell>
                      if (val.id === 2) return (
                        <TableCell key={`c2-${val.id}`}>
                          <IconButton data-preview-allow onClick={() => handleOpenNote(data.indexId, getProductLineNote(data))}>
                            <NoteAdd sx={{ color: !getProductLineNote(data) ? '' : theme.palette.primary.main }} />
                          </IconButton>
                          {/* <IconButton disabled={isPreview ? true : false} onClick={() => handleOpenNote(data.indexId, data.product_notes)}>
                            <NoteAdd sx={{ color: (!data?.product_notes || data?.product_notes === '') ? '' : theme.palette.primary.main }} />
                          </IconButton> */}
                        </TableCell>
                      )
                      if (val.id === 19) return (
                        <TableCell key={`c19-${val.id}`}>
                          <IconButton disabled size="small">
                            <UploadFile
                              sx={{
                                color: groupHasAttachments
                                  ? theme.palette.primary.main
                                  : 'error.main',
                              }}
                            />
                          </IconButton>
                          {/* <Tooltip title="Drop files on row or click to open attachments">
                            <IconButton
                              data-preview-allow
                              onClick={() => handleOpenAttachment(data.indexId)}
                            >
                              {isUploadingProduct[String(data.indexId)] ? (
                                <CircularProgress size={34} />
                              ) : (
                                <UploadFile
                                  sx={{
                                    color: groupHasAttachments
                                      ? theme.palette.primary.main
                                      : 'error.main',
                                  }}
                                />
                              )}
                            </IconButton>
                          </Tooltip> */}
                        </TableCell>
                      )
                      if (val.id === 7) {
                        return (
                          <TableCell key={`c7-${val.id}`}>
                            {canShowProductFormulaIcon(data, currentFacilityId) ? (
                              <Tooltip title="Product Formula">
                                <IconButton data-preview-allow onClick={() => handleOpenProductFormula(data.recipe_id)}>
                                  <span className="heroicons-solid--beaker"></span>
                                </IconButton>
                              </Tooltip>
                            ) : '-'}
                          </TableCell>
                        )
                      }
                      if (val.id === 3) {
                        if (val.value === '') return <TableCell key={`c3a-${val.id}`} />
                        return <TableCell key={`c3b-${val.id}`}>{data.product_desc || data.description || ''}</TableCell>
                      }
                      if (val.id === 4) return <TableCell key={`c4-${val.id}`}>{
                        getSingleProductFormulaCostEach(data).toFixed(2)
                      }</TableCell>
                      if (val.id === 20) return <TableCell key={`c20-${val.id}`}>
                        {/* {data.markup || 0} */}
                        {data.inhouse === 0 ? (data?.sub_contract_markup != null && data?.sub_contract_markup !== '' ? `${Number(data.sub_contract_markup).toFixed(2)}` : '-') : '-'}
                        </TableCell>
                      if (val.id === 16) return <TableCell key={`c16-${val.id}`}>{data.splitMarkup || 0}</TableCell>
                      if (val.id === 5 || val.id === 6) return <TableCell key={`c56-${val.id}`}>{retailEach.toFixed(2)}</TableCell>
                      if (val.id === 9) return (
                        <TableCell key={`c9-${val.id}`} align="center">
                          {Number(productLocQty)}
                          {/* {groupEditMode?.[group.id] ? (
                            <TextField
                              type="number"
                              size="small"
                              value={productLocQty}
                              label="Qty"
                              disabled={isPreview ? true : false}
                              onKeyPress={(event) => {
                                if (
                                  (event.key === '0' && event.target.value === '') ||
                                  event.key === '-' ||
                                  event.key === '.'
                                ) {
                                  event.preventDefault()
                                }
                              }}
                              onChange={(event) =>
                                handleGroupLineQuantityDraftChange(
                                  data.indexId,
                                  'group_product_quantity',
                                  event.target.value,
                                )
                              }
                              sx={{ width: 80 }}
                            />
                          ) : Number(productLocQty)} */}
                        </TableCell>
                      )
                      if (val.id === 10) return (
                        <TableCell key={`c10-${val.id}`} align="center">
                          <Tooltip title={data?.location?.map(loc => loc.address).filter(Boolean).join(', ') || 'No locations'}>
                            <LocationOn sx={{ color: data?.location?.length ? theme.palette.primary.main : '' }} />
                          </Tooltip>
                        </TableCell>
                      )
                      if (val.id === 11) return (
                        <TableCell key={`c11-${val.id}`}>
                          <Stack direction="row" spacing={1} alignItems="center" sx={{ color: 'text.secondary', opacity: 0.7 }}>
                            <Remove fontSize="small" />
                            <Switch
                              checked={getNestedLineMarketingAdjValueType(data, markupType, 'product')}
                              disabled
                            />
                            <Add fontSize="small" />
                          </Stack>
                        </TableCell>
                      )
                      if (val.id === 15) return (
                        <TableCell key={`c15-${val.id}`} align="center">
                          {formatNestedMarketingAdjustmentDisplay(
                            getNestedLineMarketingAdjustmentValue(data, markupType, 'product'),
                          )}
                        </TableCell>
                      )
                      if (val.id === 12) return <TableCell key={`c12-${val.id}`}>${fUSPrice(productSubTotal.toFixed(2))}</TableCell>
                      if (val.id === 14) {
                        return (
                          <TableCell key={`c14-${val.id}`}>
                            {Number(data?.install_cost || 0) > 0
                              ? ''
                              : `$${fUSPrice(cellProductTotal.toFixed(2))}`}
                          </TableCell>
                        )
                      }
                      if (val.id === 13) return <TableCell key={`c13-${val.id}`} />
                                                                        
                      return <TableCell key={`cx-${val.id}`} />
                    })}
                    {/* <TableCell padding="checkbox">
                      <IconButton size="small"
                        color="error"
                        disabled={true}
                        onClick={() => {
                          if (!openEdit) return
                          // Remove from group
                          setSelectedProducts((prev) => prev.map((p) => 
                            p.indexId === data.indexId 
                              ? { ...p, group_id: null, group_name: null, group_description: null, group_catalog_anchor_index_id: null }
                              : p
                          ))
                          setRefreshCalculation?.((v) => !v)
                        }}
                      >
                        <Delete fontSize="small" />
                      </IconButton>
                    </TableCell> */}
                  </TableRow>

                  {/* Install Cost Row for nested product */}
                  {Number(data?.install_cost || 0) > 0 ? (
                    <TableRow sx={nestedInstallRowSx}>
                      <TableCell padding="checkbox" /> {/* spacer for checkbox column */}
                      {VALUE?.map((val) => {
                        if (val.value === null) return null
                        if (val.id === 16 && !isSplitOrder) return null

                        if (val.id === 0) return <TableCell key={`i0-${val.id}`} />
                        if (val.id === 1) return <TableCell key={`i1-${val.id}`}>Install Price</TableCell>
                        if (val.id === 2) {
                          return (
                            <TableCell key={`i2-${val.id}`}>
                              <IconButton disabled size="small">
                                <NoteAdd
                                  sx={{
                                    color: groupHasInstallNotes
                                      ? theme.palette.primary.main
                                      : '',
                                  }}
                                />
                              </IconButton>
                              {/* <IconButton
                                onClick={() =>
                                  handleOpenInstallNote(data.indexId, data.install_notes)
                                }
                              >
                                <NoteAdd
                                  sx={{
                                    color:
                                      !data?.install_notes || data?.install_notes === ''
                                        ? ''
                                        : theme.palette.primary.main,
                                  }}
                                />
                              </IconButton> */}
                            </TableCell>
                          )
                        }
                        if (val.id === 3 || val.id === 20 || val.id === 16 || val.id === 7 || val.id === 19) {
                           if (val.value === '') return <TableCell key={`iempty-${val.id}`} />
                           return <TableCell key={`ix1-${val.id}`} />
                        }
                                                                          
                        if (val.id === 4) return <TableCell key={`i4-${val.id}`}>{
                          data?.install_formula_cost_each != null && data?.install_formula_cost_each !== ''
                            ? Number(data.install_formula_cost_each).toFixed(2)
                            : (data?.expected_install_labor_cost_with_markup?.toFixed(2) || 0)
                        }</TableCell>
                        if (val.id === 5 || val.id === 6) return <TableCell key={`i56-${val.id}`}>{installRetailEach.toFixed(2)}</TableCell>
                        if (val.id === 9) return (
                          <TableCell key={`i9-${val.id}`} align="center">
                            {installQty}
                            {/* {groupEditMode?.[group.id] ? (
                              <TextField
                                type="number"
                                size="small"
                                value={installQty}
                                label="Qty"
                                disabled={isPreview ? true : false}
                                onKeyPress={(event) => {
                                  if (
                                    (event.key === '0' && event.target.value === '') ||
                                    event.key === '-' ||
                                    event.key === '.'
                                  ) {
                                    event.preventDefault()
                                  }
                                }}
                                onChange={(event) =>
                                  handleGroupLineQuantityDraftChange(
                                    data.indexId,
                                    'group_install_quantity',
                                    event.target.value,
                                  )
                                }
                                sx={{ width: 80 }}
                              />
                            ) : installQty} */}
                          </TableCell>
                        )
                        if (val.id === 10) return <TableCell key={`i10-${val.id}`} align="center">-</TableCell>
                        if (val.id === 11) return (
                          <TableCell key={`i11-${val.id}`}>
                            <Stack direction="row" spacing={1} alignItems="center" sx={{ color: 'text.secondary', opacity: 0.7 }}>
                              <Remove fontSize="small" />
                              <Switch
                                checked={getNestedLineMarketingAdjValueType(data, markupType, 'install')}
                                disabled
                              />
                              <Add fontSize="small" />
                            </Stack>
                          </TableCell>
                        )
                        if (val.id === 15) return (
                          <TableCell key={`i15-${val.id}`} align="center">
                            {formatNestedMarketingAdjustmentDisplay(
                              getNestedLineMarketingAdjustmentValue(data, markupType, 'install'),
                            )}
                          </TableCell>
                        )
                        if (val.id === 12) return <TableCell key={`i12-${val.id}`}>{(installRetailEach * installQty).toFixed(2)}</TableCell>
                        if (val.id === 14) return <TableCell key={`i14-${val.id}`}>${fUSPrice(cellProductTotal.toFixed(2))}</TableCell>
                        // if (val.id === 13) return <TableCell key={`i13-${val.id}`} />
                        if (val.id === 13) return null
                                                                          
                        return <TableCell key={`ix2-${val.id}`} />
                      })}
                      {/* <TableCell padding="checkbox">
                        <IconButton
                          size="small"
                          color="error"
                          disabled={!openEdit}
                          onClick={() => {
                            if (!openEdit) return
                            setSelectedProducts((prev) => prev.map((p) =>
                              p.indexId === data.indexId
                                ? { ...p, install_cost: null, install_adjustment: null, install_quantity: null, original_install_cost: null }
                                : p
                            ))
                            setRefreshCalculation?.((v) => !v)
                          }}
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                      </TableCell> */}
                    </TableRow>
                  ) : null}
                </React.Fragment>
              )
            })}
          </TableBody>
        </Table>
      </Box>
    </Collapse>
  </TableCell>
</TableRow>
<Modal
  open={groupLocationStates[group.id]}
  handleClose={() => {
    setGroupLocationStates((prev) => ({
      ...prev,
      [group.id]: false,
    }))
  }}
>
  <Stack
    direction={{ xs: "column", sm: "row" }}
    justifyContent="space-between"
    alignItems="center"
  >
    <FormControlLabel
      control={
        <Switch
          checked={group.groupAllLocationSame}
          onChange={() => handleGroupAllLocationSameChange(group.id)}
        />
      }
      label="All Locations Same"
    />
    {values.project_category?.id !== 14 ? (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '50%',
          alignItems: 'center',
          mt: 2,
        }}
      >
        <LabelStyle>Qty Location Settings</LabelStyle>
        <Box display="flex" alignItems="center" gap={1} mt={1}>
          <Typography variant="subtitle2">Multiple</Typography>
          <Switch
            color="primary"
            checked={group.groupIsSingleCard}
            onChange={(event) =>
              handleGroupSingleCardChange(group.id, event.target.checked)
            }
          />
          <Typography variant="subtitle2">Single</Typography>
        </Box>
      </Box>
    ) : null}
  </Stack>
  <Grid
    container
    spacing={3}
    sx={{ justifyContent: 'center', width: '100%' }}
  >
    {(group.groupAddresses || []).map((addr, i) => (
      <Grid item xs={12} key={`group-location-${group.id}-${i}`}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Location {i + 1}
        </Typography>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={{ xs: 3, sm: 2 }}
          sx={{ mb: 2 }}
        >
          <TextField
            fullWidth
            label="Address"
            size="small"
            value={addr?.address || ''}
            disabled={i !== 0 && group.groupAllLocationSame}
            onChange={(event) =>
              handleGroupLocationFieldChange(
                group.id,
                i,
                'address',
                event.target.value,
              )
            }
          />
        </Stack>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={{ xs: 3, sm: 2 }}
          sx={{ mb: 2 }}
        >
          <TextField
            fullWidth
            label="City"
            size="small"
            value={addr?.city || ''}
            disabled={i !== 0 && group.groupAllLocationSame}
            onChange={(event) =>
              handleGroupLocationFieldChange(
                group.id,
                i,
                'city',
                event.target.value,
              )
            }
          />
          <TextField
            fullWidth
            label="State"
            size="small"
            value={addr?.state || ''}
            disabled={i !== 0 && group.groupAllLocationSame}
            onChange={(event) =>
              handleGroupLocationFieldChange(
                group.id,
                i,
                'state',
                event.target.value,
              )
            }
          />
          <TextField
            fullWidth
            label="Zip"
            size="small"
            value={addr?.zip || ''}
            disabled={i !== 0 && group.groupAllLocationSame}
            onChange={(event) =>
              handleGroupLocationFieldChange(
                group.id,
                i,
                'zip',
                event.target.value,
              )
            }
          />
        </Stack>
      </Grid>
    ))}
    <Grid item xs={12}>
      <Box display="flex" justifyContent="flex-end" mt={2}>
        <LoadingButton
          variant="contained"
          onClick={() => {
            setGroupLocationStates((prev) => ({
              ...prev,
              [group.id]: false,
            }))
          }}
        >
          Save
        </LoadingButton>
      </Box>
    </Grid>
  </Grid>
</Modal>
  </>
  )
  }


  const getSelectedLineCatalogCount = (selectedIds = []) => {
    const selectedIdSet = new Set((selectedIds || []).map((id) => String(id)))
    return (selectedProducts || []).reduce((count, product) => {
      if (
        selectedIdSet.has(String(product?.indexId)) &&
        countsAsGroupCatalogEligible(product)
      ) {
        return count + 1
      }
      return count
    }, 0)
  }

  const getSelectedLineCatalogProducts = (selectedIds = []) => {
    const selectedIdSet = new Set((selectedIds || []).map((id) => String(id)))
    return (selectedProducts || []).filter(
      (product) => selectedIdSet.has(String(product?.indexId)),
    )
  }

  const getLineProductLabel = (product) =>
    (product?.product_name || product?.name || product?.product_desc || 'Product').trim()

  const queueProductGroupJobLog = (activity) => {
    const text = (activity || '').trim()
    if (!text) return
    setPendingJobLogActivities((prev) => [...prev, text])
  }

  const buildGroupFromSelection = (selectedLineCatalogProduct, overrides = {}) => {
    // Client request: remove restriction that prevents grouping when there are no catalog ("choose") rows.
    // Fallback to any selected member as the anchor for group name/notes.
    const anchorProduct =
      selectedLineCatalogProduct ||
      (selectedProducts || []).find((p) => groupSelectedProductIds.includes(p.indexId)) ||
      (selectedProducts || [])[0] ||
      null

    if (!anchorProduct) {
      enqueueSnackbar('Grouping requires at least one selected product.', { variant: 'error' })
      return false
    }

    const derivedGroupName = (overrides?.name ??
      anchorProduct?.product_name ??
      anchorProduct?.name ??
      '').trim()
    const derivedGroupDescription = (overrides?.description ??
      anchorProduct?.product_desc ??
      anchorProduct?.description ??
      '')

    if (!derivedGroupName) {
      enqueueSnackbar(
        'Group name is required to create a group.',
        { variant: 'error' },
      )
      return false
    }

    const newGroupId = Date.now()
    const anchorIndexId = anchorProduct?.indexId
    const groupedProductNames = (selectedProducts || [])
      .filter((product) => isIndexIdInList(groupSelectedProductIds, product.indexId))
      .map(getLineProductLabel)
      .filter(Boolean)
    if (groupedProductNames.length) {
      queueProductGroupJobLog(
        `Grouped products <strong>${groupedProductNames.join(', ')}</strong> into group <strong>${derivedGroupName}</strong>.`,
      )
    }

    setSelectedProducts((prev) =>
      (prev || []).map((product) => {
        if (!isIndexIdInList(groupSelectedProductIds, product.indexId)) return product
        const memberInstallQty = product.install_quantity || 1
        return {
          ...product,
          ...snapshotGroupMemberMarketing(product),
          group_id: newGroupId,
          group_name: derivedGroupName,
          group_description: derivedGroupDescription,
          group_catalog_anchor_index_id: anchorIndexId,
          group_product_quantity: product.locationQuantity || 1,
          group_install_quantity: memberInstallQty,
          manually_updated_install_quantity: Boolean(
            product.manually_updated_install_quantity &&
              Number(product.install_quantity || 0) !== Number(product.locationQuantity || 0),
          ),
          adjustment: 0,
          adj_value_type: true,
          install_adjustment: 0,
          install_adj_value_type: true,
        }
      })
    )

    setCustomerOrderProductGroups((prev) => [
      ...(prev || []),
      {
        id: newGroupId,
        group_id: newGroupId,
        group_name: derivedGroupName,
        group_description: derivedGroupDescription,
        product_marketing_quantity: 1,
        install_marketing_quantity: 1,
      },
    ])

    setGroupSelectedProductIds([])
    setGroupCatalogSourceIndexId(null)
    setGroupCatalogCustomSourceId(null)
    setGroupCatalogSourceInputValue('')
    setShowGroupCatalogCreateForm(false)
    setGroupCatalogCustomName('')
    setGroupCatalogCustomDescription('')
    setGroupCatalogCreateError('')
    setOpenGroupCatalogSourceModal(false)
    return true
  }

  const resetGroupCatalogSourceModal = () => {
    setOpenGroupCatalogSourceModal(false)
    setGroupCatalogSourceIndexId(null)
    setGroupCatalogCustomSourceId(null)
    setGroupCatalogSourceInputValue('')
    setShowGroupCatalogCreateForm(false)
    setGroupCatalogCustomName('')
    setGroupCatalogCustomDescription('')
    setGroupCatalogCreateError('')
  }

  const handleCancelGroupCatalogCreate = () => {
    setShowGroupCatalogCreateForm(false)
    setGroupCatalogCustomName('')
    setGroupCatalogCustomDescription('')
    setGroupCatalogCreateError('')
  }

  const getCatalogSourceDropdownOptionsForModal = (inputValue = '') =>
    getCatalogSourceDropdownOptions({
      selectedProducts,
      groupSelectedProductIds,
      customCatalogGroupSources,
      customerOrderProductGroups,
      inputValue,
    })

  const handleCreateCustomCatalogGroup = () => {
    const name = groupCatalogCustomName.trim()
    const description = groupCatalogCustomDescription.trim()

    if (!name) {
      setGroupCatalogCreateError('Group name is required.')
      return
    }

    if (
      quotationGroupNameExists({
        name,
        customerOrderProductGroups,
        selectedProducts,
        customCatalogGroupSources,
      })
    ) {
      setGroupCatalogCreateError('A group with this name already exists.')
      return
    }

    const customSource = {
      id: `custom-${Date.now()}`,
      isCustomGroupSource: true,
      name,
      description,
    }

    const anchorProduct = getSelectedLineCatalogProducts(groupSelectedProductIds)[0]
    const success = buildGroupFromSelection(anchorProduct, { name, description })
    if (success) {
      setCustomCatalogGroupSources((prev) => [...(prev || []), customSource])
    }
  }

  const toggleGroupProductSelection = (product) => {
    if (!product?.indexId) return
    const idStr = String(product.indexId)
    setGroupSelectedProductIds((prev) => {
      const alreadySelected = (prev || []).some((id) => String(id) === idStr)
      if (alreadySelected) {
        return (prev || []).filter((id) => String(id) !== idStr)
      }
      return [...(prev || []), product.indexId]
    })
  }

  const resetGroupMarketingAdjustments = useCallback((groupId) => {
    const key = String(groupId)
    setGroupProductMarketingValues((prev) => {
      const next = { ...prev }
      delete next[groupId]
      delete next[key]
      return next
    })
    setGroupInstallMarketingValues((prev) => {
      const next = { ...prev }
      delete next[groupId]
      delete next[key]
      return next
    })
    // Membership changes alter formula totals; without resetting the baseline the
    // auto-adjust effect treats the delta as a marketing adjustment.
    delete prevGroupFormulaTotalsRef.current.product[key]
    delete prevGroupFormulaTotalsRef.current.install[key]
    setRefreshCalculation((v) => !v)
  }, [])

  const handleEstimateGroupEditClick = (group) => {
    setGroupEditMode({ [group.id]: true })
    setGroupSelectedProductIds(
      (group?.products || [])
        .filter((p) => isQuotationChooseCatalogRow(p))
        .map((p) => p.indexId),
    )
    clearGroupLineQuantityDrafts(group?.products)
  }

  const handleEstimateGroupCancelEditClick = (group) => {
    setGroupEditMode({})
    setGroupSelectedProductIds([])
    clearGroupLineQuantityDrafts(group?.products)
  }

  const handleEstimateGroupUpdateClick = (group) => {
    const productIdsInGroup = (group?.products || []).map((p) => p.indexId)
    const remainingIds = productIdsInGroup.filter((id) =>
      isIndexIdInList(groupSelectedProductIds, id),
    )
    if (remainingIds.length < 2) {
      enqueueSnackbar('A group must contain at least 2 products.', {
        variant: 'error',
      })
      return
    }
    const remainingLineCatalogCount = getSelectedLineCatalogCount(remainingIds)
    // Client request: remove restriction that blocks grouping when there are no catalog ("choose") rows.
    // if (remainingLineCatalogCount === 0) {
    //   enqueueSnackbar('A group must contain at least one catalog line item.', {
    //     variant: 'error',
    //   })
    //   return
    // }
    const idsToRemove = productIdsInGroup.filter(
      (id) => !isIndexIdInList(groupSelectedProductIds, id),
    )
    const idsToAdd = groupSelectedProductIds.filter(
      (id) => !isIndexIdInList(productIdsInGroup, id),
    )
    if (idsToRemove.length > 0 || idsToAdd.length > 0) {
      resetGroupMarketingAdjustments(group.id)
      setSelectedProducts((prev) => {
        const existingAnchor = (prev || []).find(
          (x) =>
            String(x.group_id) === String(group.id) &&
            x.group_catalog_anchor_index_id != null,
        )?.group_catalog_anchor_index_id
        const nextProducts = (prev || []).map((p) => {
          if (isIndexIdInList(idsToRemove, p.indexId)) {
            const hasPermission = explodedPermissions?.some((permission) =>
              [
                'Allow Negative Marketing Adjustment Sales Order',
                'Allow Negative Marketing Adjustment Estimate',
              ].includes(permission),
            )
            return restoreUngroupedProductMarketing(p, markupType, {
              hasNegativePermission: hasPermission,
            })
          }
          if (isIndexIdInList(idsToAdd, p.indexId)) {
            const existingMembers = (prev || []).filter(
              (x) =>
                String(x.group_id) === String(group.id) &&
                !isIndexIdInList(idsToAdd, x.indexId),
            )
            return withInheritedGroupNotes(
              {
                ...p,
                ...snapshotGroupMemberMarketing(p),
                group_id: group.id,
                group_name: group.name || 'Group',
                group_description: group.description || '',
                group_catalog_anchor_index_id:
                  existingAnchor ?? p.group_catalog_anchor_index_id,
                adjustment: 0,
                adj_value_type: true,
                install_adjustment: 0,
                install_adj_value_type: true,
              },
              existingMembers,
            )
          }
          if (String(p.group_id) === String(group.id)) {
            return {
              ...p,
              ...ensureGroupMemberMarketingSnapshot(p),
              adjustment: 0,
              adj_value_type: true,
              install_adjustment: 0,
              install_adj_value_type: true,
            }
          }
          return p
        })
        setFieldValue('products', nextProducts)
        return nextProducts
      })
    }
    const groupProductIds = new Set(
      (group?.products || []).map((p) => String(p.indexId)),
    )
    const hasLineQuantityDrafts = Object.keys(groupProductQuantityDrafts || {}).some(
      (productIndexId) => groupProductIds.has(String(productIndexId)),
    )
    if (hasLineQuantityDrafts) {
      setSelectedProducts((prev) => {
        const withDrafts = (prev || []).map((product) => {
          if (!groupProductIds.has(String(product.indexId))) {
            return product
          }
          const draft = groupProductQuantityDrafts[String(product.indexId)]
          if (!draft) return product
          return {
            ...product,
            group_product_quantity:
              draft.group_product_quantity ?? product.group_product_quantity ?? 1,
            group_install_quantity:
              draft.group_install_quantity ?? product.group_install_quantity ?? 1,
          }
        })
        setFieldValue('products', withDrafts)
        return withDrafts
      })
      clearGroupLineQuantityDrafts(group?.products)
    }
    setGroupEditMode({})
    setGroupSelectedProductIds([])
  }

  const handleCreateGroupFromSelection = async () => {
    if (groupSelectedProductIds.length < 2) return
    const selectedLineCatalogCount = getSelectedLineCatalogCount(groupSelectedProductIds)

    // Client request: remove restriction that blocks grouping when there are no catalog ("choose") rows.
    // if (selectedLineCatalogCount === 0) {
    //   enqueueSnackbar(
    //     'A group must contain at least one catalog line item.',
    //     { variant: 'error' },
    //   )
    //   return
    // }

    const selectedLineCatalogProducts = getSelectedLineCatalogProducts(groupSelectedProductIds)
    if (selectedLineCatalogProducts.length >= 1) {
      // Don't auto-select an initial value; let the user choose explicitly.
      setGroupCatalogSourceIndexId(null)
      setGroupCatalogCustomSourceId(null)
      setShowGroupCatalogCreateForm(false)
      setGroupCatalogSourceInputValue('')
      setGroupCatalogCustomName('')
      setGroupCatalogCustomDescription('')
      setGroupCatalogCreateError('')
      setOpenGroupCatalogSourceModal(true)
      return
    }

    buildGroupFromSelection(selectedLineCatalogProducts?.[0])
  }

  const handleAddToExistingGroup = () => {
    if (!addToGroupId) return

    const groupMeta =
      (customerOrderProductGroups || []).find((g) => String(g?.id) === String(addToGroupId)) ||
      (groupedProducts || []).find((g) => String(g.id) === String(addToGroupId))
    const group = groupMeta
    if (!group) return

    const groupName = group.group_name || group.name || 'Group'
    const addedProductNames = (selectedProducts || [])
      .filter((product) => isIndexIdInList(groupSelectedProductIds, product.indexId))
      .map(getLineProductLabel)
      .filter(Boolean)
    if (addedProductNames.length) {
      queueProductGroupJobLog(
        `Added <strong>${addedProductNames.join(', ')}</strong> to existing group <strong>${groupName}</strong>.`,
      )
    }

    const selectedLineCatalogCount = getSelectedLineCatalogCount(groupSelectedProductIds)
    const existingGroupLineCatalogCount = (selectedProducts || []).filter(
      (product) =>
        String(product?.group_id) === String(group.id) &&
        isProductLineCatalog(product),
    ).length
    const totalLineCatalogCountAfterAdd =
      selectedLineCatalogCount + existingGroupLineCatalogCount
    // if (totalLineCatalogCountAfterAdd === 0) {
    //   enqueueSnackbar(
    //     'A group must contain at least one catalog line item.',
    //     { variant: 'error' },
    //   )
    //   return
    // }

    resetGroupMarketingAdjustments(group.id)

    setSelectedProducts((prev) => {
      const isSameGroupId = (id1, id2) => String(id1) === String(id2)
      const existingBeforeAdd = (prev || []).filter((p) =>
        isSameGroupId(p.group_id, group.id) && !isIndexIdInList(groupSelectedProductIds, p.indexId),
      )
      const inheritedAnchor =
        existingBeforeAdd.find((p) => p?.group_catalog_anchor_index_id != null)?.group_catalog_anchor_index_id ??
        existingBeforeAdd[0]?.group_catalog_anchor_index_id

      let nextProducts = (prev || []).map((product) => {
        if (!isIndexIdInList(groupSelectedProductIds, product.indexId)) return product
        const memberInstallQty = product.install_quantity || 1
        return withInheritedGroupNotes(
          {
            ...product,
            ...snapshotGroupMemberMarketing(product),
            group_id: group.id,
            group_name: group.group_name || group.name || 'Group',
            group_description: group.group_description || group.description || '',
            group_catalog_anchor_index_id:
              inheritedAnchor != null ? inheritedAnchor : product.group_catalog_anchor_index_id,
            group_product_quantity: product.locationQuantity || 1,
            group_install_quantity: memberInstallQty,
            adjustment: 0,
            adj_value_type: true,
            install_adjustment: 0,
            install_adj_value_type: true,
          },
          existingBeforeAdd,
        )
      })

      return nextProducts
    })

    setOpenAddToGroupModal(false)
    setAddToGroupId('')
    setGroupSelectedProductIds([])
  }
const addGroupcatalogeProducts = async (group) => {
  console.log('group------', group)
  let productIds = group.products.map(product => product.id);
  let workflowIds = group.products.map(product => product.workflow);
  let recipeIds = group.products.map(product => product.recipe_id);
  let groupData = {
    group_name: group.name,
    group_description: group.description,
    group_addresses: group.groupAddresses ? JSON.stringify(group.groupAddresses) : null,
    product_marketing: {
      quantity: group.groupQuantity,
      adj_value_type: group.groupAdjValueType,
      adjustment: group.groupAdjustment,
      total_formula_each: Number((group.baseProductFormulaEach || 0).toFixed(2)),
      total_retail_each: Number((group.baseProductEach || 0).toFixed(2)),
      adjusted_retail_each: Number((group.adjustedGroupRetailEach || 0).toFixed(2)),
      adjusted_subtotal: Number((group.adjustedGroupSubtotal || 0).toFixed(2)),
    },
    install_marketing: {
      quantity: group.groupInstallQuantity,
      adj_value_type: group.groupInstallAdjValueType,
      adjustment: group.groupInstallAdjustment,
      total_formula_each: Number((group.baseInstallFormulaEach || 0).toFixed(2)),
      total_retail_each: Number((group.baseInstallEach || 0).toFixed(2)),
      adjusted_retail_each: Number((group.adjustedGroupInstallRetailEach || 0).toFixed(2)),
      adjusted_subtotal: Number((group.adjustedGroupInstallSubtotal || 0).toFixed(2)),
    },
  }
  console.log('group------', productIds)
  try {
    const response = await axios.post(`${REST_API_END_POINT}product/combine-group-catalog-workflow`, {
      // groupId: group.id,
      productIds: productIds,
      groupData: groupData,
      request_id: id,
      workflowIds: workflowIds,
      recipeIds:recipeIds,
      combaineWorkflow:false,

    });
    if (response.data.status === 200) {
      enqueueSnackbar('Products added to group successfully', { variant: 'success' });
      let data = response.data.data
      setSelectedGroupIdForCatalog(group.id);
      setOpenCatalogModal(true);
      setSelectedProductForCatalog({
        ...data,
        groupId:Number(group.id) || null,
        requestId:id|| null,
        actual_retail_price: group.adjustedGroupRetailEach,
        install_cost: group.adjustedGroupInstallRetailEach,
        expected_cost: group.baseProductFormulaEach,
        description: group.description,
        name: group.name,
        workflow:data.workflow,
        recipe_id:data.recipe_id,
        productIds: productIds,
        recipeIds:recipeIds,
        workflowIds:workflowIds,
      });
    } else {
      enqueueSnackbar('Failed to add products to group', { variant: 'error' });
    }
  } catch (error) {
    enqueueSnackbar('Failed to add products to group', { variant: 'error' });
  }
}
const mergeGroup = async (group) => {
  console.log('group------', group)
}
  // ---------------- Grouping dialogs (mirrors ViewOfficialRequest) ----------------
  const renderGroupDialogs = () => (
    <>
      {/* Add to Existing Group Modal */}
      <Dialog
        open={openAddToGroupModal}
        onClose={() => setOpenAddToGroupModal(false)}
        fullWidth
        maxWidth="sm"
        disableScrollLock
      >
        <DialogTitle>Add Products to Existing Group</DialogTitle>
        <DialogContent>
          <Autocomplete
            fullWidth
            sx={{ mt: 1 }}
            options={addToGroupOptions}
            getOptionLabel={(option) => option?.group_name ?? option?.name ?? option?.groupName ?? (option?.id != null ? `Group ${option.id}` : '')}
            value={
              addToGroupOptions?.find((g) => String(g?.id ?? g?.group_id) === String(addToGroupId)) ||
              null
            }
            onChange={(_, newValue) => {
              setAddToGroupId(newValue ? (newValue.id ?? newValue.group_id) : '')
            }}
            renderInput={(params) => <TextField {...params} label="Select Group" />}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAddToGroupModal(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleAddToExistingGroup}
            disabled={!addToGroupId || groupSelectedProductIds.length === 0}
          >
            Add to Group
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openGroupCatalogSourceModal}
        onClose={resetGroupCatalogSourceModal}
        fullWidth
        maxWidth="sm"
        disableScrollLock
      >
        <DialogTitle>Choose Catalog Source</DialogTitle>
        <DialogContent>
          {showGroupCatalogCreateForm ? (
            <Stack spacing={2} sx={{ mt: 1 }}>
              <TextField
                fullWidth
                required
                label="Name"
                value={groupCatalogCustomName}
                error={Boolean(groupCatalogCreateError)}
                helperText={groupCatalogCreateError || undefined}
                onChange={(event) => {
                  setGroupCatalogCustomName(event.target.value)
                  if (groupCatalogCreateError) setGroupCatalogCreateError('')
                }}
              />
              <TextField
                fullWidth
                label="Description"
                value={groupCatalogCustomDescription}
                onChange={(event) => setGroupCatalogCustomDescription(event.target.value)}
                multiline
                minRows={2}
              />
            </Stack>
          ) : (
            <Autocomplete
              fullWidth
              sx={{ mt: 1 }}
              openOnFocus
              clearOnBlur={false}
              options={getCatalogSourceDropdownOptionsForModal(groupCatalogSourceInputValue)}
              filterOptions={(options) => options}
              inputValue={groupCatalogSourceInputValue}
              onInputChange={(_, value, reason) => {
                setGroupCatalogSourceInputValue(value)
                if (reason === 'input') {
                  setGroupCatalogSourceIndexId(null)
                  setGroupCatalogCustomSourceId(null)
                }
              }}
              getOptionLabel={getCatalogSourceOptionLabel}
              value={(() => {
                if (groupCatalogCustomSourceId) {
                  return (
                    customCatalogGroupSources.find(
                      (source) => String(source?.id) === String(groupCatalogCustomSourceId),
                    ) || null
                  )
                }
                return (
                  getSelectedLineCatalogProducts(groupSelectedProductIds).find(
                    (item) => String(item?.indexId) === String(groupCatalogSourceIndexId),
                  ) || null
                )
              })()}
              onChange={(_, newValue) => {
                if (newValue?.isCreateNew) {
                  setGroupCatalogCustomName((newValue.name || '').trim())
                  setGroupCatalogCustomDescription('')
                  setGroupCatalogCreateError('')
                  setShowGroupCatalogCreateForm(true)
                  setGroupCatalogSourceIndexId(null)
                  setGroupCatalogCustomSourceId(null)
                  return
                }
                if (newValue?.isCustomGroupSource) {
                  setGroupCatalogCustomSourceId(newValue.id)
                  setGroupCatalogSourceIndexId(null)
                  setGroupCatalogSourceInputValue((newValue.name || '').trim())
                  return
                }
                setGroupCatalogSourceIndexId(newValue?.indexId ?? null)
                setGroupCatalogCustomSourceId(null)
                setGroupCatalogSourceInputValue(newValue ? getLineProductLabel(newValue) : '')
              }}
              isOptionEqualToValue={(option, value) => {
                if (option?.isCreateNew || value?.isCreateNew) return false
                if (option?.isCustomGroupSource || value?.isCustomGroupSource) {
                  return String(option?.id) === String(value?.id)
                }
                return String(option?.indexId) === String(value?.indexId)
              }}
              renderOption={(props, option) => (
                <li {...props}>
                  {option.isCreateNew ? (
                    <Typography color="primary" sx={{ fontWeight: 500 }}>
                      {getCatalogSourceCreateOptionLabel(option.name)}
                    </Typography>
                  ) : (
                    getCatalogSourceOptionLabel(option)
                  )}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Catalog item for group name/description" />
              )}
            />
          )}
        </DialogContent>
        <DialogActions>
          {showGroupCatalogCreateForm ? (
            <>
              <Button onClick={handleCancelGroupCatalogCreate}>Cancel</Button>
              <Button variant="contained" onClick={handleCreateCustomCatalogGroup}>
                Create
              </Button>
            </>
          ) : (
            <>
              <Button
                onClick={resetGroupCatalogSourceModal}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  const lineCatalogProducts = getSelectedLineCatalogProducts(groupSelectedProductIds)
                  const anchorProduct = lineCatalogProducts[0]
                  if (groupCatalogCustomSourceId) {
                    const customSource = customCatalogGroupSources.find(
                      (source) => String(source?.id) === String(groupCatalogCustomSourceId),
                    )
                    buildGroupFromSelection(anchorProduct, {
                      name: customSource?.name,
                      description: customSource?.description || '',
                    })
                    return
                  }

                  const chosenProduct = lineCatalogProducts.find(
                    (item) => String(item?.indexId) === String(groupCatalogSourceIndexId),
                  )
                  // If no product option is chosen, buildGroupFromSelection will fall back to a selected member.
                  buildGroupFromSelection(chosenProduct)
                }}
              >
                Continue
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  )
  let sum = 0
  let taxAmountData = 0
  let grandTotalData = 0
  let totalJobcostSum = 0
  let newTaxSum = 0
  // useEffect(() => {
  //   try {
  //     console.log('selectedProducts-----', selectedProducts)
  //     // if(selectedProducts?.length > 0 || selectedServices?.length > 0 || additionalSelectedServices?.length > 0){
  //     let selectedProductsTotalDiscount = selectedProducts?.reduce(
  //       (total, data, index) => {
  //         let quantityFieldName = `quantity_${
  //           data.product_id ? data.product_id : data.id
  //         }`
  //         let discountFieldName = `discount_${
  //           data.product_id ? data.product_id : data.id
  //         }`
  //         const dataRetailPrice = data.product_retail_price || data.retail_price
  //         console.log('selectedProductsTotalDiscount--data----1234', data)
  //         console.log(
  //           'selectedProductsTotalDiscount--dataRetailPrice----1234',
  //           dataRetailPrice,
  //         )
  //         const dataWholesalePrice = data.product_price || data.price
  //         console.log(
  //           'selectedProductsTotalDiscount--dataWholesalePrice----1234',
  //           dataWholesalePrice,
  //         )
  //         // const dataQuantity = values[quantityFieldName]?values[quantityFieldName]:(data?.quantity||1)

  //         // const dataDiscount = values[discountFieldName]?values[discountFieldName]:(data?.discount||0);
  //         const dataQuantity = data?.quantity || 1

  //         const dataDiscount = data?.discount || 0

  //         const productTotal = calculateTotal(
  //           markupType == 1
  //             ? dataWholesalePrice
  //             : markupType == 2
  //             ? dataRetailPrice
  //             : 0,
  //           dataQuantity,
  //           dataDiscount,
  //           null,
  //           data?.locationQuantity,
  //           Number(data?.adjustment),
  //           data.markAdjType,
  //         )
  //         console.log(
  //           'selectedProductsTotalDiscount--productTotal----',
  //           productTotal,
  //         )
  //         const fixedProductTotal = parseFloat(productTotal).toFixed(2)
  //         return total + parseFloat(fixedProductTotal)
  //       },
  //       0,
  //     )
  //     const selectedProductsTotalDiscountForJobCost = selectedProducts?.reduce(
  //       (total, data, index) => {
  //         const quantityFieldName = `quantity_${data.product_id || data.id}`
  //         const discountFieldName = `discount_${data.product_id || data.id}`
  //         const quantityVal = values[quantityFieldName]
  //           ? values[quantityFieldName]
  //           : 1
  //         const discountVal = values[discountFieldName]
  //           ? values[discountFieldName]
  //           : 0
  //         console.log('###############quantityVal', quantityVal)
  //         console.log('###############quantityValdata', data)
  //         // const productTotal = calculateTotal(data.expected_material_cost, data.quantity, discountVal);
  //         const productTotal = calculateTotal(
  //           parseFloat(data.expected_material_cost),
  //           data.quantity,
  //           0,
  //           null,
  //           data.locationQuantity,
  //           0,
  //         )
  //         console.log('###############product formula', productTotal)
  //         return total + productTotal
  //       },
  //       0,
  //     )
  //     // const allServices = [...selectedServices, ...additionalSelectedServices];
  //     const allServices = [...additionalSelectedServices]
  //     let selectedServicesCost = allServices?.reduce(
  //       (total, service, index) => {
  //         // const quantityFieldName = `service_quantity_${index}`;
  //         // const quantityVal = values[quantityFieldName]?values[quantityFieldName]:1
  //         const quantityVal = service?.quantity ? Number(service?.quantity) : 0
  //         const serviceTotal = calculateServiceTotal(
  //           service.cost,
  //           quantityVal,
  //           0,
  //         )

  //         console.log('############SSSSSSSSSSSer', serviceTotal)

  //         // let selectedQuantity=selectedProducts.filter(product=>product.id===service.product_id)
  //         // console.log("############SSSSSSSSSSSer",selectedQuantity);
  //         // let quantity=selectedQuantity[0].quantity
  //         // return total + (serviceTotal*quantity);
  //         return total + serviceTotal
  //       },
  //       0,
  //     )
  //     // selectedServicesCost = selectedServicesCost - initialServiceCostInProductFormula
  //     console.log('allServices-----------', allServices)

  //     let selectedServicesTotalCost = allServices?.reduce(
  //       (total, service, index) => {
  //         const quantityVal = service?.quantity ? Number(service?.quantity) : 0
  //         const costVal = service?.unit_cost
  //           ? Number(service?.unit_cost)
  //           : Number(service?.total_cost)
  //         const serviceTotal = calculateServiceTotal(costVal, quantityVal, 0)
  //         // const roundedServiceTotal = Math.round(serviceTotal * 100) / 100;
  //         return total + serviceTotal
  //       },
  //       0,
  //     )
  //     let initialServicesCost = 0
  //     //  selectedProducts?.reduce((total, data, index) => {
  //     //   const serviceTotal = (data?.quantity) * (parseFloat(data?.expected_total_service_cost?.toFixed(2))) * (data?.locationQuantity || 1) || 0;
  //     //   // const roundedServiceTotal = Math.round(serviceTotal * 100) / 100;
  //     //   return total + serviceTotal;
  //     // }, 0);

  //     const productMaterial = selectedProducts?.reduce((materials, product) => {
  //       if (product.materials && product.materials.length > 0) {
  //         return materials.concat(
  //           product.materials.map((material) => {
  //             console.log('materialsssssss', material)
  //             const price = parseFloat(material.max_unit_cost || 0)
  //             const quantity = parseFloat(material.quantity || 1)
  //             const retail_price = parseFloat(material.retail_price || 0)

  //             const subtotal = price * quantity
  //             const markup = (subtotal * retail_price) / 100
  //             const total =
  //               (subtotal + markup) * (product.locationQuantity || 1)

  //             console.log(
  //               '✅ total, subtotal, markup:',
  //               total,
  //               subtotal,
  //               markup,
  //             )
  //             console.log(
  //               '✅ price, quantity, retail_price:',
  //               price,
  //               quantity,
  //               retail_price,
  //             )

  //             return {
  //               ...material,
  //               totalCost: total.toFixed(2),
  //             }
  //           }),
  //         )
  //       }
  //       return materials
  //     }, [])

  //     setProductFormulaMaterial(productMaterial)

  //     const getTotalCostSum = (productMaterial) => {
  //       return productMaterial
  //         .reduce((sum, item) => {
  //           console.log('itemmmmmm', item)
  //           // Only include if taxable == 0 (string or number)
  //           if (Number(item.taxable) !== 0) return sum

  //           const cost = parseFloat(item.totalCost || 0)
  //           return sum + cost
  //         }, 0)
  //         .toFixed(2)
  //     }

  //     const totalCostSum = getTotalCostSum(productMaterial)
  //     // setTotalMinusMaterialTax(totalCostSum)
  //     console.log('🧾 Total cost sum of all materials:', totalCostSum)

  //     let selectedTaxServicesTotalCost = allServices?.reduce(
  //       (total, service, index) => {
  //         // Skip non-taxable services
  //         if (service?.taxable === 0) return total

  //         const quantityVal = service?.quantity ? Number(service?.quantity) : 0
  //         const costVal = service?.unit_cost
  //           ? Number(service?.unit_cost)
  //           : Number(service?.total_cost)
  //         const serviceTotal = calculateServiceTotal(costVal, quantityVal, 0)

  //         return total + serviceTotal
  //       },
  //       0,
  //     )

  //     // const productServices = selectedProducts?.reduce((services, product) => {
  //     //   if (product.services?.length > 0) {
  //     //     return services.concat(
  //     //       product.services.map((service) => {
  //     //         const cost = parseFloat(service.unit_cost ?? service.total_cost ?? 0);
  //     //         const quantity = parseFloat(service.quantity ?? 1);
  //     //         const retail_price = parseFloat(service.retail_price ?? 0);
  //     //         const locationQty = parseFloat(product.locationQuantity ?? 1);

  //     //         const subtotal = cost * quantity;
  //     //         const markup = (subtotal * retail_price) / 100;
  //     //         const total = (subtotal + markup) * locationQty;

  //     //         return {
  //     //           ...service,
  //     //           totalCost: total.toFixed(2),
  //     //         };
  //     //       })
  //     //     );
  //     //   }
  //     //   return services;
  //     // }, []);
  //     // console.log('productServicesproductServices', productServices)
  //     // const getTotalServiceCostSum = (services) => {
  //     //   return parseFloat(
  //     //     services.reduce((sum, item) => {
  //     //       console.log('itemservices', item);
  //     //       if (item.id !== 10) return sum;
  //     //       const cost = parseFloat(item.totalCost ?? 0);
  //     //       return sum + cost;
  //     //     }, 0).toFixed(2)
  //     //   );
  //     // };

  //     // const totalInstallServiceCostSum = getTotalServiceCostSum(productServices);

  //     // console.log("productServices ", productServices)

  //     const installCost = selectedProducts?.map((product) => {
  //       console.log('product----11111', product)
  //       const retailPrice = parseFloat(product.install_cost || 0)
  //       const locationQuantity = parseFloat(product.locationQuantity || 1)
  //       // const locationQuantity = parseFloat(product?.install_quantity || 1)

  //       const total = retailPrice * locationQuantity

  //       return {
  //         ...product,
  //         totalCost: total.toFixed(2),
  //       }
  //     })
  //     console.log('🧾 installCost', installCost)

  //     const getTotalInstallCostSum = (installCost = []) => {
  //       return installCost
  //         .reduce((sum, item) => {
  //           const cost = parseFloat(item.totalCost || 0)
  //           return sum + cost
  //         }, 0)
  //         .toFixed(2)
  //     }

  //     const totalInstallCostSum = getTotalInstallCostSum(installCost)
  //     console.log('🧾 Total cost production costtt', totalInstallCostSum)
  //     setInstallCost(totalInstallCostSum)

  //     console.log('selected serviceee old ', selectedServicesTotalCost)
  //     console.log('selected serviceee new ', selectedTaxServicesTotalCost)

  //     console.log(
  //       '###################1111selectedServicesTotalCost-1',
  //       selectedServicesTotalCost,
  //     )
  //     console.log(
  //       '###################1111initialServicesCost-1',
  //       initialServicesCost,
  //     )

  //     const roundToThreeDecimals = (num) => Math.round(num * 1000) / 1000
  //     const roundToTwoDecimals = (num) => Math.round(num * 100) / 100
  //     selectedServicesTotalCost = roundToThreeDecimals(
  //       selectedServicesTotalCost,
  //     )
  //     selectedTaxServicesTotalCost = roundToTwoDecimals(
  //       selectedTaxServicesTotalCost,
  //     )
  //     initialServicesCost = roundToThreeDecimals(initialServicesCost)

  //     console.log(
  //       '###################1111selectedServicesTotalCost-2',
  //       selectedServicesTotalCost,
  //     )
  //     console.log(
  //       '###################1111initialServicesCost-2',
  //       initialServicesCost,
  //     )
  //     const selectedServicesSubTotal = roundToTwoDecimals(
  //       selectedServicesTotalCost - initialServicesCost,
  //     )
  //     const selectedNewTaxServicesSubTotal = roundToTwoDecimals(
  //       selectedTaxServicesTotalCost - initialServicesCost,
  //     )
  //     setTotalLabourCost(selectedServicesSubTotal)
  //     setTotalProductLabourCost(selectedServicesSubTotal)
  //     // setTotalProductInstallCost(totalInstallServiceCostSum)
  //     console.log(
  //       '###################1111selectedServicesSubTotal',
  //       selectedServicesSubTotal,
  //     )

  //     const newSum =
  //       selectedProductsTotalDiscount +
  //       selectedServicesTotalCost -
  //       (values['invoice_discount'] ? values['invoice_discount'] : 0)
  //     // setRFQSubTotal(newSum)
  //     console.log(
  //       '###################1selectedProductsTotalDiscount',
  //       selectedProductsTotalDiscount,
  //     )
  //     const selectedRfpProduct = cart?.reduce((total, data, index) => {
  //       let markup = markupType
  //         ? markupType === 1
  //           ? data.WholesaleMarkup || data.product_markup
  //           : data.RetailMarkup || data.product_markup
  //         : 0

  //       let productTotal =
  //         parseFloat(
  //           (data.product_price + (data.product_price * markup) / 100)?.toFixed(
  //             2,
  //           ),
  //         ) *
  //         data.quantity *
  //         data.location_quantity
  //       productTotal = parseFloat(productTotal.toFixed(2)) // Ensure two decimal places and parse back to float

  //       console.log('#####################ProductTotal', productTotal)
  //       return total + productTotal
  //     }, 0)

  //     const selectedRfpProductJobCost = cart?.reduce((total, data, index) => {
  //       let productTotal =
  //         data.product_price * data.quantity * data.location_quantity
  //       productTotal = parseFloat(productTotal.toFixed(2)) // Ensure two decimal places and parse back to float

  //       console.log('#####################ProductTotal', productTotal)
  //       return total + productTotal
  //     }, 0)

  //     const selectedRfpServices = cartService?.reduce((total, data, index) => {
  //       let markup = data.originalMarkup
  //       data.sellingPrice = data.sellingPrice || data.unit_cost

  //       let productTotal =
  //         (data.sellingPrice + (data.sellingPrice * markup) / 100) * data.qty
  //       productTotal = parseFloat(productTotal.toFixed(2)) // Ensure two decimal places and parse back to float

  //       console.log('#####################ProductTotal', productTotal)
  //       return total + productTotal
  //     }, 0)
  //     const selectedNonTaxRfpServices = cartService?.reduce(
  //       (total, data, index) => {
  //         if (data?.taxable === 0) return total
  //         let markup = data.originalMarkup
  //         data.sellingPrice = data.sellingPrice || data.unit_cost

  //         let productTotal =
  //           (data.sellingPrice + (data.sellingPrice * markup) / 100) * data.qty
  //         productTotal = parseFloat(productTotal.toFixed(2)) // Ensure two decimal places and parse back to float

  //         console.log('#####################ProductTotal', productTotal)
  //         return total + productTotal
  //       },
  //       0,
  //     )

  //     const selectedRfpServicesJobCost = cartService?.reduce(
  //       (total, data, index) => {
  //         let markup = data.originalMarkup
  //         data.sellingPrice = data.sellingPrice || data.unit_cost

  //         let productTotal = data.sellingPrice * data.qty
  //         productTotal = parseFloat(productTotal.toFixed(2)) // Ensure two decimal places and parse back to float

  //         console.log('#####################ProductTotal', productTotal)
  //         return total + productTotal
  //       },
  //       0,
  //     )
  //     const selectedMaterialCostJobCost = selectedMaterials?.reduce(
  //       (total, data, index) => {
  //         let productTotal =
  //           (data.product_price || data.price) * (data.quantity || 0)
  //         productTotal = parseFloat(productTotal.toFixed(2)) // Ensure two decimal places and parse back to float
  //         console.log('#####################ProductTotalewwww1', data)
  //         console.log('#####################ProductTotalewwww1', productTotal)
  //         return total + productTotal
  //       },
  //       0,
  //     )
  //     const selectedMaterialCost = selectedMaterials?.reduce(
  //       (total, data, index) => {
  //         let markup = data?.product_markup || data?.markup || 0
  //         let markUpCost =
  //           data.price +
  //           (parseFloat(data.price) * parseFloat(markup || 0)) / 100
  //         markUpCost = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0
  //         let productTotal =
  //           (markUpCost || data.product_retail_price) * (data.quantity || 0)
  //         productTotal = parseFloat(productTotal.toFixed(2)) // Ensure two decimal places and parse back to float
  //         console.log('#####################ProductTotalewwww2', data)
  //         console.log('#####################ProductTotalewwww2', markUpCost)
  //         console.log('#####################ProductTotalewwww2', productTotal)
  //         return total + productTotal
  //       },
  //       0,
  //     )
  //     const selectedNonTaxMaterialCost = selectedMaterials?.reduce(
  //       (total, data, index) => {
  //         if (data?.taxable === 0) return total
  //         let markUpCost =
  //           data.price +
  //           (parseFloat(data.price) * parseFloat(data.product_markup || 0)) /
  //             100
  //         markUpCost = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0
  //         let productTotal =
  //           (markUpCost || data.product_retail_price) * (data.quantity || 0)
  //         productTotal = parseFloat(productTotal.toFixed(2)) // Ensure two decimal places and parse back to float
  //         console.log('#####################ProductTotalewwww2', data)
  //         console.log('#####################ProductTotalewwww2', markUpCost)
  //         console.log('#####################ProductTotalewwww2', productTotal)
  //         return total + productTotal
  //       },
  //       0,
  //     )
  //     console.log(
  //       '#####################Labour cost',
  //       selectedServicesSubTotal + selectedRfpServices,
  //     )
  //     setTotalLabourCost(selectedServicesSubTotal + selectedRfpServices)
  //     console.log(
  //       '#####################selectedRfpServices',
  //       selectedRfpServices,
  //     )
  //     console.log('#####################selectedRfpProduct', selectedRfpProduct)
  //     sum =
  //       selectedProductsTotalDiscount +
  //       selectedServicesSubTotal +
  //       selectedRfpServices +
  //       selectedMaterialCost +
  //     //  parseFloat(Number(totalInstallCostSum)) +
  //       selectedRfpProduct -
  //       (values['invoice_discount'] ? values['invoice_discount'] : 0)
  //     newTaxSum =
  //       selectedProductsTotalDiscount +
  //       selectedNewTaxServicesSubTotal +
  //       selectedNonTaxRfpServices +
  //       selectedNonTaxMaterialCost +
  //       selectedRfpProduct -
  //       (values['invoice_discount'] ? values['invoice_discount'] : 0) -
  //       totalCostSum
  //     console.log(
  //       'sumsumsum--values[invoice_discount]',
  //       values['invoice_discount'],
  //     )
  //     console.log('sumsumsum--selectedRfpProduct', selectedRfpProduct)
  //     console.log('sumsumsum--selectedMaterialCost', selectedMaterialCost)
  //     console.log('sumsumsum--selectedRfpServices', selectedRfpServices)
  //     console.log(
  //       'sumsumsum--selectedServicesSubTotal',
  //       selectedServicesSubTotal,
  //     )
  //     console.log(
  //       'sumsumsum--selectedProductsTotalDiscount',
  //       selectedProductsTotalDiscount,
  //     )
  //     console.log('sumsumsum--sum', sum)
  //     taxAmountData = selectedTaxCategory
  //       ? selectedTaxCategory.type === 1
  //         ? (sum * (selectedTaxCategory.value || 0)) / 100
  //         : selectedTaxCategory.value || 0
  //       : 0
  //     const newTaxAmountData = selectedTaxCategory
  //       ? selectedTaxCategory.type === 1
  //         ? (newTaxSum * (selectedTaxCategory.value || 0)) / 100
  //         : selectedTaxCategory.value || 0
  //       : 0
  //     const taxAmountToFixed = parseFloat(
  //       parseFloat(newTaxAmountData).toFixed(2),
  //     )
  //     console.log('taxAmounttttt old >', taxAmountData)
  //     console.log('taxAmounttttt new >', newTaxAmountData)
  //     if (!details?.avalara_code) {
  //       grandTotalData = (parseFloat(sum) + parseFloat(taxAmount)).toFixed(2) // old total
  //       //  grandTotalData = (parseFloat(sum) + parseFloat(taxAmountData)).toFixed(2);// old total
  //       // grandTotalData = (parseFloat(sum) + parseFloat(taxAmountToFixed)).toFixed(2); //new tax grand total
  //     } else {
  //       grandTotalData = (parseFloat(sum) + parseFloat(taxAmount)).toFixed(2) //new avalara tax grand total with
  //     }
  //     console.log(
  //       '#####################selectedRfpServices',
  //       selectedRfpServices,
  //     )
  //     setTotalSum(sum)
  //     // setTaxAmount(taxAmountData);
  //     //  if(!details?.avalara_code){
  //     //     setTaxAmount(taxAmountData); no additional tax needed
  //     //   }
  //     // setTaxAmount(taxAmountToFixed);
  //     setGrandTotal(grandTotalData)

  //     let selectedProductsTotalProductFormula = selectedProducts?.reduce(
  //       (total, data) => {
  //         let quantityFieldName = `quantity_${
  //           data.product_id ? data.product_id : data.id
  //         }`
  //         let discountFieldName = `discount_${
  //           data.product_id ? data.product_id : data.id
  //         }`
  //         const dataRetailPrice = data.product_retail_price || data.retail_price
  //         const dataWholesalePrice = data.product_price || data.price
  //         const dataQuantity = values[quantityFieldName]
  //           ? values[quantityFieldName]
  //           : data?.quantity || 1

  //         let newTotalProductFormula =
  //           parseFloat(data.expected_cost?.toFixed(2)) *
  //           data.quantity *
  //           data.locationQuantity
  //         newTotalProductFormula = newTotalProductFormula
  //           ? Number(newTotalProductFormula)
  //           : 0

  //         console.log('newTotalProductFormula--', newTotalProductFormula)

  //         return total + newTotalProductFormula
  //       },
  //       0,
  //     )
  //     console.log('###############jobcost', selectedRfpProductJobCost)
  //     selectedProductsTotalProductFormula = selectedProductsTotalProductFormula
  //       ? Number(selectedProductsTotalProductFormula)
  //       : 0

  //     setTotalProductFormula(selectedProductsTotalProductFormula)

  //     let selectedProductsTotalWholesalePrice = selectedProducts?.reduce(
  //       (total, data, index) => {
  //         let quantityFieldName = `quantity_${
  //           data.product_id ? data.product_id : data.id
  //         }`
  //         let discountFieldName = `discount_${
  //           data.product_id ? data.product_id : data.id
  //         }`
  //         const dataRetailPrice = data.product_retail_price || data.retail_price
  //         const dataWholesalePrice = data.product_price || data.price
  //         const dataQuantity = values[quantityFieldName]
  //           ? values[quantityFieldName]
  //           : data?.quantity || 1

  //         let newTotalWholesalePrice =
  //           dataWholesalePrice * data.quantity * data.locationQuantity
  //         if (data?.adjustment) {
  //           newTotalWholesalePrice = newTotalWholesalePrice
  //             ? newTotalWholesalePrice +
  //               (newTotalWholesalePrice * Number(data?.adjustment)) / 100
  //             : 0
  //         }
  //         newTotalWholesalePrice = newTotalWholesalePrice
  //           ? Number(newTotalWholesalePrice)
  //           : 0

  //         console.log('newTotalWholesalePrice--', newTotalWholesalePrice)

  //         return total + newTotalWholesalePrice
  //       },
  //       0,
  //     )
  //     selectedProductsTotalWholesalePrice = selectedProductsTotalWholesalePrice
  //       ? Number(selectedProductsTotalWholesalePrice)
  //       : 0

  //     let selectedServicesTotalWholesalePrice = selectedServices?.reduce(
  //       (total, data, index) => {
  //         let newTotalWholesalePrice = (
  //           data?.unit_cost * data?.quantityDifference
  //         )?.toFixed(2)
  //         newTotalWholesalePrice = newTotalWholesalePrice
  //           ? Number(newTotalWholesalePrice)
  //           : 0
  //         return total + newTotalWholesalePrice
  //       },
  //       0,
  //     )
  //     selectedServicesTotalWholesalePrice = selectedServicesTotalWholesalePrice
  //       ? Number(selectedServicesTotalWholesalePrice)
  //       : 0

  //     let selectedAddlServicesTotalWholesalePrice =
  //       additionalSelectedServices?.reduce((total, data, index) => {
  //         let newTotalWholesalePrice = data?.total
  //         newTotalWholesalePrice = newTotalWholesalePrice
  //           ? Number(newTotalWholesalePrice)
  //           : 0
  //         return total + newTotalWholesalePrice
  //       }, 0)
  //     selectedAddlServicesTotalWholesalePrice =
  //       selectedAddlServicesTotalWholesalePrice
  //         ? Number(selectedAddlServicesTotalWholesalePrice)
  //         : 0

  //     let selectedCartTotalWholesalePrice = cart?.reduce(
  //       (total, data, index) => {
  //         let markup = markupType
  //           ? markupType === 1
  //             ? data.WholesaleMarkup || data.product_markup
  //             : data.RetailMarkup || data.product_markup
  //           : 0
  //         let newTotalWholesalePrice = (
  //           data.location_quantity *
  //           data.quantity *
  //           (data.product_price + (data.product_price * markup) / 100)
  //         ).toFixed(2)
  //         newTotalWholesalePrice = newTotalWholesalePrice
  //           ? Number(newTotalWholesalePrice)
  //           : 0
  //         return total + newTotalWholesalePrice
  //       },
  //       0,
  //     )

  //     selectedCartTotalWholesalePrice = selectedCartTotalWholesalePrice
  //       ? Number(selectedCartTotalWholesalePrice)
  //       : 0

  //     let selectedCartServicesTotalWholesalePrice = cartService?.reduce(
  //       (total, data, index) => {
  //         let newTotalWholesalePrice = (
  //           data.qty *
  //           (data.sellingPrice +
  //             (data.sellingPrice * data.originalMarkup) / 100)
  //         )?.toFixed(2)
  //         newTotalWholesalePrice = newTotalWholesalePrice
  //           ? Number(newTotalWholesalePrice)
  //           : 0
  //         return total + newTotalWholesalePrice
  //       },
  //       0,
  //     )
  //     selectedCartServicesTotalWholesalePrice =
  //       selectedCartServicesTotalWholesalePrice
  //         ? Number(selectedCartServicesTotalWholesalePrice)
  //         : 0

  //     let selectedMaterialsTotalWholesalePrice = selectedMaterials?.reduce(
  //       (total, data, index) => {
  //         let newTotalWholesalePrice = (
  //           (data.markUpCost || 0) * (data.quantity || 1)
  //         )?.toFixed(2)
  //         newTotalWholesalePrice = newTotalWholesalePrice
  //           ? Number(newTotalWholesalePrice)
  //           : 0
  //         return total + newTotalWholesalePrice
  //       },
  //       0,
  //     )
  //     selectedMaterialsTotalWholesalePrice =
  //       selectedMaterialsTotalWholesalePrice
  //         ? Number(selectedMaterialsTotalWholesalePrice)
  //         : 0

  //     let newTotalWholesalePrice =
  //       selectedProductsTotalWholesalePrice +
  //       selectedServicesTotalWholesalePrice +
  //       selectedAddlServicesTotalWholesalePrice +
  //       selectedCartTotalWholesalePrice +
  //       selectedCartServicesTotalWholesalePrice +
  //       selectedMaterialsTotalWholesalePrice
  //     setTotalWholesalePrice(newTotalWholesalePrice)

  //     let selectedProductsTotalRetailPrice = selectedProducts?.reduce(
  //       (total, data, index) => {
  //         let quantityFieldName = `quantity_${
  //           data.product_id ? data.product_id : data.id
  //         }`
  //         let discountFieldName = `discount_${
  //           data.product_id ? data.product_id : data.id
  //         }`
  //         const dataRetailPrice = data.product_retail_price || data.retail_price
  //         const dataWholesalePrice = data.product_price || data.price
  //         const dataQuantity = values[quantityFieldName]
  //           ? values[quantityFieldName]
  //           : data?.quantity || 1

  //         let newTotalRetailPrice =
  //           dataRetailPrice * data.quantity * data.locationQuantity
  //         if (data?.adjustment) {
  //           newTotalRetailPrice = newTotalRetailPrice
  //             ? newTotalRetailPrice +
  //               (newTotalRetailPrice * Number(data?.adjustment)) / 100
  //             : 0
  //         }
  //         newTotalRetailPrice = newTotalRetailPrice
  //           ? Number(newTotalRetailPrice)
  //           : 0

  //         console.log('newTotalRetailPrice--', newTotalRetailPrice)

  //         return total + newTotalRetailPrice
  //       },
  //       0,
  //     )
  //     selectedProductsTotalRetailPrice = selectedProductsTotalRetailPrice
  //       ? Number(selectedProductsTotalRetailPrice)
  //       : 0

  //     let newTotalRetailPrice =
  //       selectedProductsTotalRetailPrice +
  //       selectedServicesTotalWholesalePrice +
  //       selectedAddlServicesTotalWholesalePrice +
  //       selectedCartTotalWholesalePrice +
  //       selectedCartServicesTotalWholesalePrice +
  //       selectedMaterialsTotalWholesalePrice
  //     setTotalRetailPrice(newTotalRetailPrice)

  //     //discount count
  //     let selectedProductDiscount = selectedProducts?.reduce(
  //       (acc, data, index) => {
  //         // const discountFieldName = `discount_${data.product_id?data.product_id:data.id}`;
  //         // const discountVal = values[discountFieldName]?values[discountFieldName]:(data?.discount||0);
  //         const discountVal = data.discount ? data.discount : 0
  //         let productDiscount = +discountVal || 0
  //         return acc + productDiscount
  //       },
  //       0,
  //     )
  //     const newDiscountTotal =
  //       selectedProductDiscount + (parseFloat(values['invoice_discount']) || 0)
  //     setDiscountTotal(
  //       selectedProductDiscount + (parseFloat(values['invoice_discount']) || 0),
  //     )

  //     console.log(
  //       '#############selectedProductsTotalProductFormula',
  //       selectedProductsTotalProductFormula,
  //     )
  //     console.log(
  //       '#############selectedTotalWholesalePrice',
  //       newTotalWholesalePrice,
  //     )
  //     console.log('#############selectedTotalRetailPrice', newTotalRetailPrice)
  //     console.log('####################selectedMaterials', selectedMaterials)

  //     totalJobcostSum =
  //       selectedProductsTotalDiscountForJobCost +
  //       selectedServicesCost +
  //       selectedMaterialCostJobCost +
  //       selectedRfpProductJobCost +
  //       selectedRfpServicesJobCost
  //     console.log('total job cost------- budget', totalJobcostSum)
  //     values['total'] = sum
  //     values['taxAmount'] = taxAmountData
  //     values['budget'] = totalJobcostSum
  //     console.log('################Budget', totalJobcostSum)
  //     setBudget(totalJobcostSum)
  //     let subTotal =
  //       markupType == 1
  //         ? selectedProductsTotalWholesalePrice -
  //           newDiscountTotal +
  //           selectedRfpProduct +
  //           selectedMaterialCost
  //         : markupType == 2
  //         ? selectedProductsTotalRetailPrice -
  //           newDiscountTotal +
  //           selectedRfpProduct
  //         : 0
  //     console.log('################subTotal', subTotal)
  //     setRFQSubTotal(subTotal)
  //     // let selectedProductsTotalMarkupAmount = markupType == 1 ? ((selectedProductsTotalWholesalePrice - newDiscountTotal) - selectedProductsTotalProductFormula)
  //     //   : (markupType == 2 ? ((selectedProductsTotalRetailPrice - newDiscountTotal) - selectedProductsTotalProductFormula) : 0);
  //     // setTotalMarkupAmount(selectedProductsTotalMarkupAmount)
  //     let selectedProductsTotalMarkupAmount = sum - totalJobcostSum
  //     setTotalMarkupAmount(selectedProductsTotalMarkupAmount)

  //     let selectedProductsTotalMarkup =
  //       (selectedProductsTotalMarkupAmount / totalJobcostSum) * 100
  //     setTotalMarkupPercentage(selectedProductsTotalMarkup)

  //     console.log(
  //       'selectedProductsTotalMarkup-------',
  //       selectedProductsTotalMarkup,
  //     )

  //     console.log(
  //       'initialServiceCost In ProductFormula-----',
  //       initialServicesCost,
  //     )
  //     setInitialServiceCostInProductFormula(initialServicesCost)
  //     // }else{
  //     //   console.log('eeeeeeeeeeeeeeeeee');
  //     // }
  //   } catch (error) {
  //     console.log('Error--------------', error)
  //   }
  // }, [
  //   currentRFQData,
  //   selectedTaxCategory,
  //   selectedProducts,
  //   selectedMaterials,
  //   selectedServices,
  //   additionalSelectedServices,
  //   values.markup_type,
  //   values.invoice_discount,
  //   refreshData,
  //   cartService,
  //   cart,
  // ])
  useEffect(() => {
    try {
      console.log('selectedProducts-----', selectedProducts);
      // if(selectedProducts?.length > 0 || selectedServices?.length > 0 || additionalSelectedServices?.length > 0){
      // Separate ungrouped products and grouped products (using adjusted group totals)
      const ungroupedProductsTotal = (selectedProducts || []).reduce((total, data) => {
        const gidRaw = getProductGroupId(data)
        if (gidRaw != null && String(gidRaw) !== '') return total

        const locQty = Number(data?.locationQuantity) || 1
        const productSubTotal =
          markupType == 1
            ? (Number(data?.price) || 0) * locQty
            : markupType == 2
            ? (Number(data?.actual_retail_price || data?.retail_price || 0)) * locQty
            : 0

        const installQty = Number(data?.install_quantity) || 1
        const installSubTotal = (Number(data?.install_cost) || 0) * installQty

        const dataDiscount = data?.discount || 0
        const productTotal = Math.max(0, productSubTotal + installSubTotal - dataDiscount)
        return total + Number(productTotal.toFixed(2))
      }, 0)

      const groupProductsTotal = (groupedProducts || []).reduce((total, group) => {
        return total + (Number(group.adjustedGroupTotal) || 0)
      }, 0)

      let selectedProductsTotalDiscount = Number((ungroupedProductsTotal + groupProductsTotal).toFixed(2))
  
      const selectedProductsTotalDiscountForJobCost = selectedProducts?.reduce((total, data, index) => {
        const quantityFieldName = `quantity_${data.product_id || data.id}`;
        const discountFieldName = `discount_${data.product_id || data.id}`;
        const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1
        const discountVal = values[discountFieldName] ? values[discountFieldName] : 0
        console.log("###############quantityVal", quantityVal)
        console.log("###############quantityValdata", data)
        // const productTotal = calculateTotal(data.expected_material_cost, data.quantity, discountVal);
        const productTotal = calculateTotal(parseFloat(data.expected_material_cost), data.quantity, 0, null, data.locationQuantity,data.adjustment,data.markAdjType,data.adj_value_type);
        console.log("###############product formula", productTotal)
        return total + productTotal;
      }, 0);
      // const allServices = [...selectedServices, ...additionalSelectedServices];
      const allServices = [ ...additionalSelectedServices];
      let selectedServicesCost = allServices?.reduce((total, service, index) => {
        // const quantityFieldName = `service_quantity_${index}`;
        // const quantityVal = values[quantityFieldName]?values[quantityFieldName]:1
        const quantityVal = service?.quantity ? Number(service?.quantity) : 0
        const serviceTotal = calculateServiceTotal(service.cost, quantityVal, 0);
  
        console.log("############SSSSSSSSSSSer", serviceTotal);
  
        // let selectedQuantity=selectedProducts.filter(product=>product.id===service.product_id)
        // console.log("############SSSSSSSSSSSer",selectedQuantity);
        // let quantity=selectedQuantity[0].quantity
        // return total + (serviceTotal*quantity);
        return total + serviceTotal;
      }, 0);
      // selectedServicesCost = selectedServicesCost - initialServiceCostInProductFormula
      console.log('allServices-----------', allServices);
  
      let selectedServicesTotalCost = allServices?.reduce((total, service, index) => {
        const quantityVal = service?.quantity ? Number(service?.quantity) : 0
        const costVal = service?.unit_cost ? Number(service?.unit_cost) : Number(service?.total_cost)
        const serviceTotal = calculateServiceTotal(costVal, quantityVal, 0);
        // const roundedServiceTotal = Math.round(serviceTotal * 100) / 100;
        return total + serviceTotal;
      }, 0);
      let initialServicesCost =0
      //  selectedProducts?.reduce((total, data, index) => {
      //   const serviceTotal = (data?.quantity) * (parseFloat(data?.expected_total_service_cost?.toFixed(2))) * (data?.locationQuantity || 1) || 0;
      //   // const roundedServiceTotal = Math.round(serviceTotal * 100) / 100;
      //   return total + serviceTotal;
      // }, 0);
  
      const productMaterial = selectedProducts?.reduce((materials, product) => {
          if (product.materials && product.materials.length > 0) {
            return materials.concat(
              product.materials
                .map((material) => {
                  console.log('materialsssssss',material)
                  const price = parseFloat(material.max_unit_cost || 0);
                  const quantity = parseFloat(material.quantity || 1);
                  const retail_price = parseFloat(material.retail_price || 0);
  
                  const subtotal = price * quantity;
                  const markup = (subtotal * retail_price) / 100;
                  const total = (subtotal + markup) * (product.locationQuantity || 1)
  
                  console.log('✅ total, subtotal, markup:', total, subtotal, markup);
                  console.log('✅ price, quantity, retail_price:', price, quantity, retail_price);
  
                  return {
                    ...material,
                    totalCost: total.toFixed(2),
                  };
                })
            );
          }
          return materials;
        }, []);
  
        setProductFormulaMaterial(productMaterial)
  
        const getTotalCostSum = (productMaterial) => {
          return productMaterial.reduce((sum, item) => {
                    console.log('itemmmmmm',item)
            // Only include if taxable == 0 (string or number)
            if (Number(item.taxable) !== 0) return sum;
  
            const cost = parseFloat(item.totalCost || 0);
            return sum + cost;
          }, 0).toFixed(2);
        };
  
        const totalCostSum = getTotalCostSum(productMaterial);
        // setTotalMinusMaterialTax(totalCostSum)
        console.log('🧾 Total cost sum of all materials:', totalCostSum);
  
      let selectedTaxServicesTotalCost = allServices?.reduce((total, service, index) => {
        // Skip non-taxable services
        if (service?.taxable === 0) return total;
  
        const quantityVal = service?.quantity ? Number(service?.quantity) : 0;
        const costVal = service?.unit_cost ? Number(service?.unit_cost) : Number(service?.total_cost);
        const serviceTotal = calculateServiceTotal(costVal, quantityVal, 0);
  
        return total + serviceTotal;
      }, 0);
  
      // const productServices = selectedProducts?.reduce((services, product) => {
      //   if (product.services?.length > 0) {
      //     return services.concat(
      //       product.services.map((service) => {
      //         const cost = parseFloat(service.unit_cost ?? service.total_cost ?? 0);
      //         const quantity = parseFloat(service.quantity ?? 1);
      //         const retail_price = parseFloat(service.retail_price ?? 0);
      //         const locationQty = parseFloat(product.locationQuantity ?? 1);
  
      //         const subtotal = cost * quantity;
      //         const markup = (subtotal * retail_price) / 100;
      //         const total = (subtotal + markup) * locationQty;
  
      //         return {
      //           ...service,
      //           totalCost: total.toFixed(2),
      //         };
      //       })
      //     );
      //   }
      //   return services;
      // }, []);
      // console.log('productServicesproductServices', productServices)
      // const getTotalServiceCostSum = (services) => {
      //   return parseFloat(
      //     services.reduce((sum, item) => {
      //       console.log('itemservices', item);
      //       if (item.id !== 10) return sum;
      //       const cost = parseFloat(item.totalCost ?? 0);
      //       return sum + cost;
      //     }, 0).toFixed(2)
      //   );
      // };
  
  
      // const totalInstallServiceCostSum = getTotalServiceCostSum(productServices);
  
      // console.log("productServices ", productServices)
  
          const installCost = selectedProducts?.map((product) => {
        const retailPrice = parseFloat(product.install_cost  || 0);
        const locationQuantity = parseFloat(product.locationQuantity || 1);
  
        const total = retailPrice * locationQuantity;
  
        return {
          ...product,
          totalCost: total.toFixed(2),
        };
      });
          console.log('🧾 installCost', installCost);
  
      const getTotalInstallCostSum = (installCost = []) => {
        return installCost.reduce((sum, item) => {
          const cost = parseFloat(item.totalCost || 0);
          return sum + cost;
        }, 0).toFixed(2);
      };
  
      const totalInstallCostSum = getTotalInstallCostSum(installCost);
      console.log('🧾 Total cost production costtt', totalInstallCostSum);
      setInstallCost(totalInstallCostSum)
  
       console.log("selected serviceee old ",selectedServicesTotalCost)
      console.log("selected serviceee new ",selectedTaxServicesTotalCost)
  
  
      console.log("###################1111selectedServicesTotalCost-1", selectedServicesTotalCost);
      console.log("###################1111initialServicesCost-1", initialServicesCost);
  
      const roundToThreeDecimals = (num) => Math.round(num * 1000) / 1000;
      const roundToTwoDecimals = (num) => Math.round(num * 100) / 100;
      selectedServicesTotalCost = roundToThreeDecimals(selectedServicesTotalCost);
      selectedTaxServicesTotalCost = roundToTwoDecimals(selectedTaxServicesTotalCost);
      initialServicesCost = roundToThreeDecimals(initialServicesCost);
  
      console.log("###################1111selectedServicesTotalCost-2", selectedServicesTotalCost);
      console.log("###################1111initialServicesCost-2", initialServicesCost);
      const selectedServicesSubTotal = roundToTwoDecimals(selectedServicesTotalCost - initialServicesCost)
      const selectedNewTaxServicesSubTotal = roundToTwoDecimals(selectedTaxServicesTotalCost - initialServicesCost)
      setTotalLabourCost(selectedServicesSubTotal)
      setTotalProductLabourCost(selectedServicesSubTotal)
      // setTotalProductInstallCost(totalInstallServiceCostSum)
      console.log("###################1111selectedServicesSubTotal", selectedServicesSubTotal);
  
      const newSum = (selectedProductsTotalDiscount + selectedServicesTotalCost) - (values['invoice_discount'] ? values['invoice_discount'] : 0)
      // setRFQSubTotal(newSum)
      console.log("###################1selectedProductsTotalDiscount", selectedProductsTotalDiscount);
      const selectedRfpProduct = cart?.reduce((total, data, index) => {
        let markup = markupType ? (markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup) : 0;
  
        let productTotal = parseFloat((data.product_price + data.product_price * markup / 100)?.toFixed(2)) * data.quantity * data.location_quantity;
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
  
        console.log("#####################ProductTotal", productTotal);
        return total + productTotal;
      }, 0);
  
      const selectedRfpProductJobCost = cart?.reduce((total, data, index) => {
        let productTotal = data.product_price * data.quantity * data.location_quantity;
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
  
        console.log("#####################ProductTotal", productTotal);
        return total + productTotal;
      }, 0);
  
      const selectedRfpServices = cartService?.reduce((total, data, index) => {
        let markup = Number(data.originalMarkup) || 0;
        data.sellingPrice = Number(data.sellingPrice || data.unit_cost) || 0;
  
        let productTotal = (data.sellingPrice + (data.sellingPrice * markup / 100)) * (Number(data.qty) || 0);
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
  
        console.log("#####################ProductTotal", productTotal);
        return total + productTotal;
      }, 0);
      const selectedNonTaxRfpServices = cartService?.reduce((total, data, index) => {
            if (data?.taxable === 0) return total;
        let markup = Number(data.originalMarkup) || 0;
        data.sellingPrice = Number(data.sellingPrice || data.unit_cost) || 0;
  
        let productTotal = (data.sellingPrice + (data.sellingPrice * markup / 100)) * (Number(data.qty) || 0);
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
  
        console.log("#####################ProductTotal", productTotal);
        return total + productTotal;
      }, 0);
  
      const selectedRfpServicesJobCost = cartService?.reduce((total, data, index) => {
        let markup = Number(data.originalMarkup) || 0;
        data.sellingPrice = Number(data.sellingPrice || data.unit_cost) || 0;
  
        let productTotal = data.sellingPrice * (Number(data.qty) || 0);
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
  
        console.log("#####################ProductTotal", productTotal);
        return total + productTotal;
      }, 0);
      const selectedMaterialCostJobCost = selectedMaterials?.reduce((total, data, index) => {
        let productTotal = (data.product_price||data.price) * (data.quantity||0) ;
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
        console.log("#####################ProductTotalewwww1",data);
        console.log("#####################ProductTotalewwww1", productTotal);
        return total + productTotal;
      }, 0);
      const selectedMaterialCost = selectedMaterials?.reduce((total, data, index) => {
        let markup =data?.product_markup || data?.markup || 0;
        let markUpCost = data.price + ((parseFloat(data.price) * parseFloat(markup || 0)) / 100)
        markUpCost = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0;
        let productTotal = (markUpCost || data.product_retail_price) * (data.quantity||0) ;
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
        console.log("#####################ProductTotalewwww2",data);
        console.log("#####################ProductTotalewwww2",markUpCost);
        console.log("#####################ProductTotalewwww2", productTotal);
        return total + productTotal;
      }, 0);
      const selectedNonTaxMaterialCost = selectedMaterials?.reduce((total, data, index) => {
        if (data?.taxable === 0) return total;
        let markUpCost = data.price + ((parseFloat(data.price) * parseFloat(data.product_markup || 0)) / 100)
        markUpCost = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0;
        let productTotal = (markUpCost || data.product_retail_price) * (data.quantity||0) ;
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
        console.log("#####################ProductTotalewwww2",data);
        console.log("#####################ProductTotalewwww2",markUpCost);
        console.log("#####################ProductTotalewwww2", productTotal);
        return total + productTotal;
      }, 0);
      console.log("#####################Labour cost", selectedServicesSubTotal + selectedRfpServices);
      setTotalLabourCost(selectedServicesSubTotal + selectedRfpServices)
      console.log("#####################selectedRfpServices", selectedRfpServices);
      console.log("#####################selectedRfpProduct", selectedRfpProduct);
      sum = (selectedProductsTotalDiscount + selectedServicesSubTotal + selectedRfpServices+selectedMaterialCost + selectedRfpProduct) - (values['invoice_discount'] ? values['invoice_discount'] : 0)
      newTaxSum = (selectedProductsTotalDiscount + selectedNewTaxServicesSubTotal + selectedNonTaxRfpServices+selectedNonTaxMaterialCost + selectedRfpProduct) - (values['invoice_discount'] ? values['invoice_discount'] : 0) - totalCostSum ;
      console.log('sumsumsum--values[invoice_discount]', values['invoice_discount'])
      console.log('sumsumsum--selectedRfpProduct', selectedRfpProduct)
      console.log('sumsumsum--selectedMaterialCost', selectedMaterialCost)
      console.log('sumsumsum--selectedRfpServices', selectedRfpServices)
      console.log('sumsumsum--selectedServicesSubTotal', selectedServicesSubTotal)
      console.log('sumsumsum--selectedProductsTotalDiscount', selectedProductsTotalDiscount)
      console.log('sumsumsum--sum', sum)
     taxAmountData = selectedTaxCategory
       ? (selectedTaxCategory.type === 1
           ? (sum * (selectedTaxCategory.value || 0) / 100)
           : (selectedTaxCategory.value || 0))
       : 0;
  
     const newTaxAmountData = selectedTaxCategory
       ? (selectedTaxCategory.type === 1
           ? (newTaxSum * (selectedTaxCategory.value || 0) / 100)
           : (selectedTaxCategory.value || 0))
       : 0;
  
     const taxAmountToFixed = parseFloat(parseFloat(newTaxAmountData).toFixed(2));
  
     console.log('taxAmounttttt old >', taxAmountData);
     console.log('taxAmounttttt new >', newTaxAmountData);
  
    //  if (!details?.avalara_code) {
    //    // Use the freshly calculated taxAmountData when Avalara is not used
    //    const localTax = parseFloat(taxAmountData.toFixed(2)) || 0;
    //    grandTotalData = (parseFloat(sum) + localTax).toFixed(2);
    //   //  setTaxAmount(localTax);
    //  } else {
    //    // For Avalara, taxAmount is set from API elsewhere; add that to sum
    //    const avalaraTax = parseFloat(taxAmount) || 0;
    //    grandTotalData = (parseFloat(sum) + avalaraTax).toFixed(2);
    //  }
       const avalaraTax = parseFloat(taxAmount) || 0;
       
       // --- RUSH FEE CALCULATION ---
       const productsForLeadCalc =
         selectedProducts?.length > 0 ? selectedProducts : values.products || [];
       const canOverrideCalc = !!explodedPermissions?.some((permission) =>
         ['Override Rush Fee Estimate'].includes(permission),
       );
       const rushFeeAutoLocked = isInstallBeforeRequiredLead(values, productsForLeadCalc);
       const rushFeeChecked =
         Number(values?.rush_fee) === 1 ||
         (!!rushFeeAutoLocked && !canOverrideCalc);
       const rushFeePercentageCalc = Number(data?.rush_fee_percentage) || 0;
       const rushFeeAmountCalc = calcRushFeeAmount({
         enabled: rushFeeChecked,
         subtotal: sum || 0,
         percentage: rushFeePercentageCalc,
         storedAmount: details?.rush_fee_amount || 0,
         preferStored: !openEdit,
       });
       values['rush_fee_amount'] = rushFeeAmountCalc;
       
       grandTotalData = (parseFloat(sum) + avalaraTax + rushFeeAmountCalc).toFixed(2);
       
      console.log("#####################selectedRfpServices", selectedRfpServices);
      setTotalSum(sum);
     // Update grand total as a number
     setGrandTotal(parseFloat(grandTotalData));
  
      let selectedProductsTotalProductFormula = selectedProducts?.reduce((total, data) => {
        let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
        let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
        const dataRetailPrice = data.product_retail_price || data.retail_price;
        const dataWholesalePrice = data.product_price || data.price;
        const dataQuantity = values[quantityFieldName] ? values[quantityFieldName] : (data?.quantity || 1);
  
        let newTotalProductFormula = parseFloat(data.expected_cost?.toFixed(2)) * data.quantity * data.locationQuantity;
        newTotalProductFormula = newTotalProductFormula ? Number(newTotalProductFormula) : 0;
  
        console.log('newTotalProductFormula--', newTotalProductFormula);
  
        return total + newTotalProductFormula;
      }, 0);
      console.log("###############jobcost", selectedRfpProductJobCost);
      selectedProductsTotalProductFormula = selectedProductsTotalProductFormula ? (Number(selectedProductsTotalProductFormula)) : 0
  
      setTotalProductFormula(selectedProductsTotalProductFormula)
  
      const groupIdsForWholesaleRollup = new Set()
      let selectedProductsTotalWholesalePrice = selectedProducts?.reduce((total, data, index) => {
        const gidRaw = getProductGroupId(data)
        if (gidRaw != null && String(gidRaw) !== '') {
          const gKey = String(gidRaw)
          if (groupIdsForWholesaleRollup.has(gKey)) return total
          groupIdsForWholesaleRollup.add(gKey)
          const group = groupedProductsMap.get(gKey)
          if (group && markupType === 1) {
            const sub = Number(group.adjustedGroupSubtotal || 0)
            return total + sub
          }
          if (group && markupType !== 1) return total
        }

        let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
        let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
        const dataRetailPrice = data.product_retail_price || data.retail_price
        const dataWholesalePrice = data.product_price || data.price
        const dataQuantity = values[quantityFieldName] ? values[quantityFieldName] : (data?.quantity || 1)
  
        let newTotalWholesalePrice = dataWholesalePrice * data.quantity * data.locationQuantity
        if(data?.adjustment){
          newTotalWholesalePrice = newTotalWholesalePrice ? newTotalWholesalePrice + ((newTotalWholesalePrice * Number(data?.adjustment)) / 100) : 0
        }
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
  
        console.log('newTotalWholesalePrice--', newTotalWholesalePrice);
  
        const fixedProductTotal = parseFloat(newTotalWholesalePrice).toFixed(2);
        return total + parseFloat(fixedProductTotal);
      }, 0);
      selectedProductsTotalWholesalePrice = selectedProductsTotalWholesalePrice ? Number(selectedProductsTotalWholesalePrice) : 0
  
      let selectedServicesTotalWholesalePrice = selectedServices?.reduce((total, data, index) => {
        let newTotalWholesalePrice = (data?.unit_cost * data?.quantityDifference)?.toFixed(2)
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        return total + newTotalWholesalePrice;
      }, 0);
      selectedServicesTotalWholesalePrice = selectedServicesTotalWholesalePrice ? Number(selectedServicesTotalWholesalePrice) : 0
  
      let selectedAddlServicesTotalWholesalePrice = additionalSelectedServices?.reduce((total, data, index) => {
        let newTotalWholesalePrice = data?.total
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        return total + newTotalWholesalePrice;
      }, 0);
      selectedAddlServicesTotalWholesalePrice = selectedAddlServicesTotalWholesalePrice ? Number(selectedAddlServicesTotalWholesalePrice) : 0
  
      let selectedCartTotalWholesalePrice = cart?.reduce((total, data, index) => {
        let markup = markupType ? (markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup) : 0;
        let newTotalWholesalePrice = (data.location_quantity * data.quantity * (data.product_price + (data.product_price * markup / 100))).toFixed(2)
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        return total + newTotalWholesalePrice;
      }, 0);
  
      selectedCartTotalWholesalePrice = selectedCartTotalWholesalePrice ? Number(selectedCartTotalWholesalePrice) : 0
  
      let selectedCartServicesTotalWholesalePrice = cartService?.reduce((total, data, index) => {
        const sellingPrice = Number(data.sellingPrice || data.unit_cost) || 0
        const markup = Number(data.originalMarkup) || 0
        let newTotalWholesalePrice = ((Number(data.qty) || 0) * (sellingPrice + (sellingPrice * markup / 100)))?.toFixed(2)
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        return total + newTotalWholesalePrice;
      }, 0);
      selectedCartServicesTotalWholesalePrice = selectedCartServicesTotalWholesalePrice ? Number(selectedCartServicesTotalWholesalePrice) : 0
      
      let selectedMaterialsTotalWholesalePrice = selectedMaterials?.reduce((total, data, index) => {
        let newTotalWholesalePrice = ((data.markUpCost || 0) * (data.quantity||1))?.toFixed(2)
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        return total + newTotalWholesalePrice;
      }, 0);
      selectedMaterialsTotalWholesalePrice = selectedMaterialsTotalWholesalePrice ? Number(selectedMaterialsTotalWholesalePrice) : 0
  
      let newTotalWholesalePrice = selectedProductsTotalWholesalePrice + selectedServicesTotalWholesalePrice + selectedAddlServicesTotalWholesalePrice + selectedCartTotalWholesalePrice + selectedCartServicesTotalWholesalePrice + selectedMaterialsTotalWholesalePrice
      setTotalWholesalePrice(newTotalWholesalePrice)
  
      const groupIdsForRetailRollup = new Set()
      let selectedProductsTotalRetailPrice = selectedProducts?.reduce((total, data, index) => {
        const gidRaw = getProductGroupId(data)
        if (gidRaw != null && String(gidRaw) !== '') {
          const gKey = String(gidRaw)
          if (groupIdsForRetailRollup.has(gKey)) return total
          groupIdsForRetailRollup.add(gKey)
          const group = groupedProductsMap.get(gKey)
          if (group && markupType === 2) {
            const sub = Number(group.adjustedGroupSubtotal || 0)
            return total + sub
          }
          if (group && markupType !== 2) return total
        }

        let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
        let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
        const dataRetailPrice = data.product_retail_price || data.retail_price
        const dataWholesalePrice = data.product_price || data.price
        const dataQuantity = values[quantityFieldName] ? values[quantityFieldName] : (data?.quantity || 1)
  
        let newTotalRetailPrice = dataRetailPrice * data.quantity * data.locationQuantity
        if(data?.adjustment){
          newTotalRetailPrice = newTotalRetailPrice ? newTotalRetailPrice + ((newTotalRetailPrice * Number(data?.adjustment)) / 100) : 0
        }
        newTotalRetailPrice = newTotalRetailPrice ? Number(newTotalRetailPrice) : 0
  
        console.log('newTotalRetailPrice--', newTotalRetailPrice);
  
        const fixedProductTotal = parseFloat(newTotalRetailPrice).toFixed(2);
        return total + parseFloat(fixedProductTotal);
      }, 0);
      selectedProductsTotalRetailPrice = selectedProductsTotalRetailPrice ? Number(selectedProductsTotalRetailPrice) : 0
  
      let newTotalRetailPrice = selectedProductsTotalRetailPrice + selectedServicesTotalWholesalePrice + selectedAddlServicesTotalWholesalePrice + selectedCartTotalWholesalePrice + selectedCartServicesTotalWholesalePrice + selectedMaterialsTotalWholesalePrice
      setTotalRetailPrice(newTotalRetailPrice)
  
      //discount count
      let selectedProductDiscount = selectedProducts?.reduce((acc, data, index) => {
        // const discountFieldName = `discount_${data.product_id?data.product_id:data.id}`;
        // const discountVal = values[discountFieldName]?values[discountFieldName]:(data?.discount||0);
        const discountVal = data.discount ? data.discount : 0
        let productDiscount = +discountVal || 0;
        return acc + productDiscount;
      }, 0);
      const newDiscountTotal = selectedProductDiscount + (parseFloat(values['invoice_discount']) || 0);
      setDiscountTotal(selectedProductDiscount + (parseFloat(values['invoice_discount']) || 0));
  
      console.log("#############selectedProductsTotalProductFormula", selectedProductsTotalProductFormula);
      console.log("#############selectedTotalWholesalePrice", newTotalWholesalePrice);
      console.log("#############selectedTotalRetailPrice", newTotalRetailPrice);
      console.log("####################selectedMaterials", selectedMaterials);
  
      totalJobcostSum = (selectedProductsTotalDiscountForJobCost + selectedServicesCost +selectedMaterialCostJobCost+ selectedRfpProductJobCost + selectedRfpServicesJobCost);
      console.log('total job cost------- budget', totalJobcostSum);
      values['total'] = sum
      values['taxAmount'] = taxAmountData
      values['budget'] = totalJobcostSum
      console.log("################Budget", totalJobcostSum);
      setBudget(totalJobcostSum)
      let subTotal = markupType == 1 ? ((selectedProductsTotalWholesalePrice - newDiscountTotal + selectedRfpProduct+selectedMaterialCost))
        : (markupType == 2 ? ((selectedProductsTotalRetailPrice - newDiscountTotal + selectedRfpProduct)) : 0);
      console.log("################subTotal", subTotal);
      setRFQSubTotal(subTotal)
      // let selectedProductsTotalMarkupAmount = markupType == 1 ? ((selectedProductsTotalWholesalePrice - newDiscountTotal) - selectedProductsTotalProductFormula)
      //   : (markupType == 2 ? ((selectedProductsTotalRetailPrice - newDiscountTotal) - selectedProductsTotalProductFormula) : 0);
      // setTotalMarkupAmount(selectedProductsTotalMarkupAmount)
      let selectedProductsTotalMarkupAmount = sum - totalJobcostSum
      setTotalMarkupAmount(selectedProductsTotalMarkupAmount)
  
  
      let selectedProductsTotalMarkup = (selectedProductsTotalMarkupAmount / totalJobcostSum) * 100
      setTotalMarkupPercentage(selectedProductsTotalMarkup)
  
      console.log('selectedProductsTotalMarkup-------', selectedProductsTotalMarkup);
  
      // let selectedProductsTotalMarkup = markupType == 1 ? ((((selectedProductsTotalWholesalePrice - newDiscountTotal) - selectedProductsTotalProductFormula) / selectedProductsTotalProductFormula) * 100)
      //   : (markupType == 2 ? ((((selectedProductsTotalRetailPrice - newDiscountTotal) - selectedProductsTotalProductFormula) / selectedProductsTotalProductFormula) * 100) : 0);
      // setTotalMarkupPercentage(selectedProductsTotalMarkup)
  
      // console.log('selectedProductsTotalDiscount-------',selectedProductsTotalDiscount);
      // console.log('selectedProductsTotalDiscountForJobCost-------',selectedProductsTotalDiscountForJobCost);
      // console.log('selectedServicesCost-------', selectedServicesCost);
      // console.log('selectedServicesTotalCost-------',selectedServicesTotalCost);
      // console.log('selectedServicesSubTotal-------',selectedServicesSubTotal);
      // console.log('sum-------',sum);
  
      console.log('initialServiceCost In ProductFormula-----', initialServicesCost);
      setInitialServiceCostInProductFormula(initialServicesCost)
      // }else{
      //   console.log('eeeeeeeeeeeeeeeeee');
      // }
    } catch (error) {
      console.log('Error--------------', error);
    }
  }, [currentRFQData, selectedTaxCategory, selectedProducts,selectedMaterials, selectedServices, additionalSelectedServices, values.markup_type, values.invoice_discount, values.rush_fee, refreshData, cartService, cart, markupType, groupedProductsMap, groupProductMarketingValues, groupInstallMarketingValues, taxAmount, refreshCalculation, data?.rush_fee_percentage])

  console.log('additionalSelectedServices--', additionalSelectedServices)
  ////image functionality
  const handleRemoveAll = () => {
    const removed = [...avatarUrl]
    setAvatarUrl([])
    if (removed.length === 0) return
    setProductAttachments((prev) =>
      removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev)
    )
    setServiceAttachments((prev) =>
      removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev)
    )
    setSelectedUploadedImages((prev) =>
      removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev)
    )
    setSelectedUploadedImagesService((prev) =>
      removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev)
    )
  }

  const handleRemove = (file) => {
    setAvatarUrl((prev) => prev.filter((f) => !attachmentMatches(f, file)))
    setProductAttachments((prev) => pruneAttachmentMapsByFile(prev, file))
    setServiceAttachments((prev) => pruneAttachmentMapsByFile(prev, file))
  }

  const handleOpenAttachment = (indexId) => {
    const key = String(indexId ?? '')
    const currentAttachments = getProductAttachmentsList(indexId)
    setOpenProductAttachment((prev) => ({ ...prev, [indexId]: true }))
    setAttachmentTabValue((prev) => ({ ...prev, [indexId]: 0 }))
    setSelectedUploadedImages((prev) => ({ ...prev, [key]: [...currentAttachments] }))
  }

  const handleCloseAttachment = (indexId) => {
    setOpenProductAttachment((prev) => ({ ...prev, [indexId]: false }))
    setAttachmentTabValue((prev) => ({ ...prev, [indexId]: 0 }))
    setSelectedUploadedImages((prev) => ({ ...prev, [indexId]: [] }))
  }

  const handleAttachmentTabChange = (event, newValue, indexId) => {
    setAttachmentTabValue((prev) => ({ ...prev, [indexId]: newValue }))
  }

  const handleImageSelect = (file, indexId, isSelected) => {
    const key = String(indexId ?? '')
    setSelectedUploadedImages((prev) => {
      const current = prev[key] || prev[indexId] || []
      if (isSelected) {
        if (current.some((f) => attachmentMatches(f, file))) return prev
        return { ...prev, [key]: [...current, file] }
      }
      return { ...prev, [key]: current.filter((f) => !attachmentMatches(f, file)) }
    })
  }

  const handleAddSelectedImages = (indexId) => {
    const key = String(indexId ?? '')
    const selected = selectedUploadedImages[key] || selectedUploadedImages[indexId] || []
    const original = getProductAttachmentsList(indexId)
    const toLink = selected.filter((file) => !original.some((orig) => attachmentMatches(orig, file)))
    const toUnlink = original.filter((file) => !selected.some((sel) => attachmentMatches(sel, file)))
    if (toLink.length === 0 && toUnlink.length === 0) {
      setOpenProductAttachment((prev) => ({ ...prev, [indexId]: false }))
      return
    }

    const memberIds = getGroupMemberIndexIdsByProductIndexId(indexId)
    setProductAttachments((prev) => {
      const next = { ...prev }
      memberIds.forEach((mid) => {
        next[String(mid)] = selected.map((file) => ({ ...file, product_index_id: mid }))
      })
      return next
    })
    setSelectedUploadedImages((prev) => {
      const next = { ...prev }
      memberIds.forEach((mid) => {
        next[String(mid)] = []
        next[mid] = []
      })
      return next
    })
    setOpenProductAttachment((prev) => ({ ...prev, [indexId]: false }))
    enqueueSnackbar('Product attachments updated successfully', { variant: 'success' })
  }

  const handleOpenServiceAttachment = (indexId) => {
    const key = String(indexId ?? '')
    const currentAttachments = serviceAttachments[key] || serviceAttachments[indexId] || []
    setOpenServiceAttachment((prev) => ({ ...prev, [indexId]: true }))
    setAttachmentTabValueService((prev) => ({ ...prev, [indexId]: 0 }))
    setSelectedUploadedImagesService((prev) => ({ ...prev, [key]: [...currentAttachments] }))
  }

  const handleCloseServiceAttachment = (indexId) => {
    setOpenServiceAttachment((prev) => ({ ...prev, [indexId]: false }))
    setAttachmentTabValueService((prev) => ({ ...prev, [indexId]: 0 }))
    setSelectedUploadedImagesService((prev) => ({ ...prev, [indexId]: [] }))
  }

  const handleAttachmentTabChangeService = (event, newValue, indexId) => {
    setAttachmentTabValueService((prev) => ({ ...prev, [indexId]: newValue }))
  }

  const handleImageSelectService = (file, indexId, isSelected) => {
    const key = String(indexId ?? '')
    setSelectedUploadedImagesService((prev) => {
      const current = prev[key] || prev[indexId] || []
      if (isSelected) {
        if (current.some((f) => attachmentMatches(f, file))) return prev
        return { ...prev, [key]: [...current, file] }
      }
      return { ...prev, [key]: current.filter((f) => !attachmentMatches(f, file)) }
    })
  }

  const handleAddSelectedImagesService = (indexId) => {
    const key = String(indexId ?? '')
    const selected = selectedUploadedImagesService[key] || selectedUploadedImagesService[indexId] || []
    const original = serviceAttachments[key] || serviceAttachments[indexId] || []
    const toLink = selected.filter((file) => !original.some((orig) => attachmentMatches(orig, file)))
    const toUnlink = original.filter((file) => !selected.some((sel) => attachmentMatches(sel, file)))
    if (toLink.length === 0 && toUnlink.length === 0) {
      setOpenServiceAttachment((prev) => ({ ...prev, [indexId]: false }))
      return
    }

    setServiceAttachments((prev) => ({
      ...prev,
      [key]: selected.map((file) => ({ ...file, service_index_id: indexId })),
    }))
    setSelectedUploadedImagesService((prev) => ({ ...prev, [key]: [], [indexId]: [] }))
    setOpenServiceAttachment((prev) => ({ ...prev, [indexId]: false }))
    enqueueSnackbar('Service attachments updated successfully', { variant: 'success' })
  }

  const handleDrop = useCallback(
    async (acceptedFiles) => {
      // ───── permission gate ─────
      const noPermission = !explodedPermissions?.some(
        (p) => p === 'Upload Files Sales Order',
      )
      if (noPermission && user?.added_by_client === 1) {
        enqueueSnackbar(
          'Access Denied: You do not have sufficient permissions',
          {
            variant: 'error',
          },
        )
        return
      }
      // ──────────────────────────

      if (!acceptedFiles || acceptedFiles.length === 0) return

      setIsUploading(true)

      try {
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now()
          // This removes all #, %, &, + and other dangerous URL characters
const sanitizedName = file.name.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9.\-_]/g, '');
          const fileName = `${timestamp}_${sanitizedName}`
          const filePath = `estimate/attachments/${fileName}` // 🔑 path

          // Upload to Supabase Storage
          const { error: uploadErr } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file)

          if (uploadErr) throw uploadErr

          // Get the public URL
          const { data: urlData, error: urlErr } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath)

          if (urlErr || !urlData?.publicUrl) {
            throw new Error('Failed to generate public URL')
          }

          return {
            url: urlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size,
          }
        })

        const uploadedFiles = await Promise.all(uploadPromises)

        if (!id) return

        for (const fileData of uploadedFiles) {
          const res = await axios.post(`${REST_API_END_POINT}request/upload-designs`, {
            requestId: id,
            userId: user.user_id,
            uploaded: [fileData.url],
            type: fileData.file_type,
            size: fileData.size,
            extension: fileData.extension,
            attachmentType: 'design',
          })
          if (res.data?.status !== 1) {
            throw new Error(res.data?.message || 'Failed to save design/document')
          }
        }

        setAvatarUrl((prev) => [...prev, ...uploadedFiles])
        enqueueSnackbar('New design/document added!', { variant: 'success' })
      } catch (err) {
        console.error('Upload error:', err.message)
        enqueueSnackbar(err.response?.data?.message || 'Upload failed: ' + err.message, { variant: 'error' })
      } finally {
        setIsUploading(false)
      }
    },
    [explodedPermissions, user, id, enqueueSnackbar, setAvatarUrl, setIsUploading],
  )

  const handleProductDrop = useCallback(
    async (acceptedFiles, productIndexId) => {
      const noPermission = !explodedPermissions?.some(
        (p) => p === 'Upload Files Sales Order',
      )
      if (noPermission && user?.added_by_client === 1) {
        enqueueSnackbar('Access Denied: You do not have sufficient permissions', {
          variant: 'error',
        })
        return
      }

      if (!acceptedFiles || acceptedFiles.length === 0) return

      const pKey = String(productIndexId ?? '')
      setIsUploadingProduct((prev) => ({ ...prev, [pKey]: true }))

      try {
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now()
          const sanitizedFileName = file.name.replace(/\s+/g, '_')
          const fileName = `${timestamp}_${sanitizedFileName}`
          const filePath = `estimate/attachments/${fileName}`

          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file)

          if (uploadError) throw uploadError

          const { data: publicUrlData, error: urlError } = await supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath)

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL')
          }

          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size,
            name: file.name,
            product_index_id: pKey,
          }
        })

        const uploadedFiles = await Promise.all(uploadPromises)

        if (id) {
          for (const fileData of uploadedFiles) {
            const res = await axios.post(`${REST_API_END_POINT}request/upload-designs`, {
              requestId: id,
              userId: user.user_id,
              uploaded: [fileData.url],
              type: fileData.file_type,
              size: fileData.size,
              extension: fileData.extension,
              attachmentType: 'product',
            })
            if (res.data?.status !== 1) {
              throw new Error(res.data?.message || 'Failed to save attachment')
            }
          }
        }

        const memberIds = getGroupMemberIndexIdsByProductIndexId(productIndexId)
        const filesForSelection = uploadedFiles.map((f) => ({
          ...f,
          product_index_id: productIndexId,
        }))
        setProductAttachments((prev) => {
          const next = { ...prev }
          memberIds.forEach((mid) => {
            const mKey = String(mid)
            const current = next[mKey] || []
            const existingKeys = current.map(attachmentFileKey)
            const newFiles = uploadedFiles
              .map((f) => ({ ...f, product_index_id: mid }))
              .filter((f) => !existingKeys.includes(attachmentFileKey(f)))
            next[mKey] = [...current, ...newFiles]
          })
          return next
        })
        setSelectedUploadedImages((prev) => {
          const current = prev[pKey] || prev[productIndexId] || []
          const merged = [...current]
          filesForSelection.forEach((file) => {
            if (!merged.some((f) => attachmentMatches(f, file))) {
              merged.push(file)
            }
          })
          return { ...prev, [pKey]: merged }
        })
        // fetchRequestDetails()
        enqueueSnackbar(
          memberIds.length > 1
            ? `Attachment uploaded successfully`
            : 'Attachment uploaded successfully',
          { variant: 'success' },
        )
      } catch (error) {
        console.error('Error uploading product file:', error)
        enqueueSnackbar(error.response?.data?.message || 'Failed to upload file', { variant: 'error' })
      } finally {
        setIsUploadingProduct((prev) => ({ ...prev, [pKey]: false }))
      }
    },
    [explodedPermissions, user, id, enqueueSnackbar, getGroupMemberIndexIdsByProductIndexId],
  )

  const handleProductIconDragOver = (e, productIndexId) => {
    if (e.dataTransfer?.types?.includes('Files')) {
      e.preventDefault()
      e.stopPropagation()
      setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: true }))
    }
  }

  const handleProductIconDragLeave = (e, productIndexId) => {
    e.preventDefault()
    e.stopPropagation()
    const related = e.relatedTarget
    if (related && e.currentTarget.contains(related)) return
    setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: false }))
  }

  const handleProductIconDrop = (e, productIndexId) => {
    e.preventDefault()
    e.stopPropagation()
    setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: false }))
    const files = Array.from(e.dataTransfer?.files || [])
    if (files.length > 0) {
      handleProductDrop(files, productIndexId)
    }
  }

  const handleProductRemove = (file, productIndexId) => {
    const memberIds = getGroupMemberIndexIdsByProductIndexId(productIndexId)
    setProductAttachments((prev) => {
      const next = { ...prev }
      memberIds.forEach((mid) => {
        const mKey = String(mid)
        const current = next[mKey] || []
        if (!file) {
          next[mKey] = []
        } else {
          next[mKey] = current.filter((f) => !attachmentMatches(f, file))
        }
      })
      return next
    })
    if (file) {
      setAvatarUrl((prev) => prev.filter((f) => !attachmentMatches(f, file)))
    }
    setSelectedUploadedImages((prev) => {
      if (!file) {
        const next = { ...prev }
        memberIds.forEach((mid) => {
          next[String(mid)] = []
          next[mid] = []
        })
        return next
      }
      return pruneAttachmentMapsByFile(prev, file)
    })
  }

  const handleServiceDrop = useCallback(
    async (acceptedFiles, serviceIndexId) => {
      const noPermission = !explodedPermissions?.some(
        (p) => p === 'Upload Files Sales Order',
      )
      if (noPermission && user?.added_by_client === 1) {
        enqueueSnackbar('Access Denied: You do not have sufficient permissions', {
          variant: 'error',
        })
        return
      }

      if (!acceptedFiles || acceptedFiles.length === 0) return

      const sKey = String(serviceIndexId ?? '')
      setIsUploadingService((prev) => ({ ...prev, [sKey]: true }))

      try {
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now()
          const sanitizedFileName = file.name.replace(/\s+/g, '_')
          const fileName = `${timestamp}_${sanitizedFileName}`
          const filePath = `estimate/attachments/${fileName}`

          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file)

          if (uploadError) throw uploadError

          const { data: publicUrlData, error: urlError } = await supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath)

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL')
          }

          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size,
            name: file.name,
            service_index_id: sKey,
          }
        })

        const uploadedFiles = await Promise.all(uploadPromises)

        if (id) {
          for (const fileData of uploadedFiles) {
            const res = await axios.post(`${REST_API_END_POINT}request/upload-designs`, {
              requestId: id,
              userId: user.user_id,
              uploaded: [fileData.url],
              type: fileData.file_type,
              size: fileData.size,
              extension: fileData.extension,
              attachmentType: 'service',
            })
            if (res.data?.status !== 1) {
              throw new Error(res.data?.message || 'Failed to save attachment')
            }
          }
        }

        setServiceAttachments((prev) => {
          const current = prev[sKey] || []
          const existingKeys = current.map(attachmentFileKey)
          const newFiles = uploadedFiles.filter((f) => !existingKeys.includes(attachmentFileKey(f)))
          return {
            ...prev,
            [sKey]: [...current, ...newFiles],
          }
        })
        setSelectedUploadedImagesService((prev) => {
          const current = prev[sKey] || prev[serviceIndexId] || []
          const merged = [...current]
          uploadedFiles.forEach((file) => {
            if (!merged.some((f) => attachmentMatches(f, file))) {
              merged.push({ ...file, service_index_id: serviceIndexId })
            }
          })
          return { ...prev, [sKey]: merged }
        })
        // fetchRequestDetails()
        enqueueSnackbar('Attachment uploaded successfully', { variant: 'success' })
      } catch (error) {
        console.error('Error uploading service file:', error)
        enqueueSnackbar(error.response?.data?.message || 'Failed to upload file', { variant: 'error' })
      } finally {
        setIsUploadingService((prev) => ({ ...prev, [sKey]: false }))
      }
    },
    [explodedPermissions, user, id, enqueueSnackbar],
  )

  const handleServiceRemove = (file, serviceIndexId) => {
    const key = String(serviceIndexId ?? '')
    if (!file) {
      setServiceAttachments((prev) => ({ ...prev, [key]: [] }))
      return
    }
    setServiceAttachments((prev) => {
      const current = prev[key] || []
      const filtered = current.filter((f) => !attachmentMatches(f, file))
      return {
        ...prev,
        [key]: filtered,
      }
    })
    setAvatarUrl((prev) => prev.filter((f) => !attachmentMatches(f, file)))
    setSelectedUploadedImagesService((prev) => pruneAttachmentMapsByFile(prev, file))
  }

  const uploadDesignsDisplayFiles = useMemo(() => {
    const allProductAttachmentFiles = Object.values(productAttachments).flat()
    const allServiceAttachmentFiles = Object.values(serviceAttachments).flat()
    const productAttachmentUrls = allProductAttachmentFiles.map((f) => f.url || f.name)
    const serviceAttachmentUrls = allServiceAttachmentFiles.map((f) => f.url || f.name)

    const availableAvatarFiles = (avatarUrl || [])
      .filter((file) => {
        const fileUrl = file.url || file.name
        return (
          !productAttachmentUrls.includes(fileUrl) &&
          !serviceAttachmentUrls.includes(fileUrl)
        )
      })
      .map((file) => ({
        ...file,
        product_index_id: undefined,
        service_index_id: undefined,
        productNames: [],
        serviceNames: [],
        _productAttachment: false,
        _serviceAttachment: false,
        _groupAttachment: false,
      }))

    const mapProductAttachmentForDisplay = (file, product) => {
      if (!product) {
        return {
          ...file,
          url: file.url || file.name,
          name: file.name || file.url,
          location_ids: '',
          productNames: [],
          _productAttachment: true,
          _groupAttachment: false,
        }
      }
      const location_ids =
        product.location
          ?.map((loc) => loc.id || loc.request_location_id)
          .filter(Boolean)
          .join(',') || ''
      const productName = product.product_name || product.name || ''
      return {
        ...file,
        url: file.url || file.name,
        name: file.name || file.url,
        location_ids,
        productNames: productName
          ? [{ product_id: product.product_id || product.id, product_name: productName }]
          : [],
        _productAttachment: true,
        _groupAttachment: false,
      }
    }

    const mapGroupAttachmentForDisplay = (file, groupId, products) => {
      const group = groupedProductsMap.get(String(groupId))
      const groupName =
        group?.name ||
        products[0]?.group_name ||
        products[0]?.groupName ||
        'Group'
      const labelProduct = products[0]
      const location_ids =
        labelProduct?.location
          ?.map((loc) => loc.id || loc.request_location_id)
          .filter(Boolean)
          .join(',') || 'group'
      return {
        ...file,
        url: file.url || file.name,
        name: file.name || file.url,
        location_ids,
        productNames: [{ product_id: groupId, product_name: groupName }],
        _productAttachment: true,
        _groupAttachment: true,
      }
    }

    const productFilesByUrl = new Map()
    allProductAttachmentFiles.forEach((file) => {
      const fileUrl = file.url || file.name
      if (!fileUrl) return
      const product = (selectedProducts || []).find(
        (p) => Number(p?.indexId) === Number(file.product_index_id),
      )
      if (!productFilesByUrl.has(fileUrl)) {
        productFilesByUrl.set(fileUrl, { file, products: [] })
      }
      const entry = productFilesByUrl.get(fileUrl)
      if (
        product &&
        !entry.products.some((p) => Number(p.indexId) === Number(product.indexId))
      ) {
        entry.products.push(product)
      }
    })

    const dedupedProductFiles = []
    productFilesByUrl.forEach(({ file, products }) => {
      const fileUrl = file.url || file.name
      const filesForUrl = allProductAttachmentFiles.filter(
        (f) => (f.url || f.name) === fileUrl,
      )
      const groupIds = [
        ...new Set(
          products
            .map((p) => getProductGroupId(p))
            .filter((gid) => gid != null && gid !== ''),
        ),
      ]
      const isSameGroup =
        groupIds.length === 1 &&
        products.length > 0 &&
        products.every(
          (p) => String(getProductGroupId(p) || '') === String(groupIds[0]),
        )
      const shouldShowAsGroup =
        isSameGroup && filesForUrl.length > 1

      if (shouldShowAsGroup) {
        dedupedProductFiles.push(
          mapGroupAttachmentForDisplay(file, groupIds[0], products),
        )
        return
      }

      filesForUrl.forEach((attachmentFile) => {
        const product = (selectedProducts || []).find(
          (p) => Number(p?.indexId) === Number(attachmentFile.product_index_id),
        )
        const gid = getProductGroupId(product)
        if (
          gid != null &&
          gid !== '' &&
          filesForUrl.length === 1 &&
          isSameGroup
        ) {
          dedupedProductFiles.push(
            mapGroupAttachmentForDisplay(attachmentFile, gid, products),
          )
        } else {
          dedupedProductFiles.push(
            mapProductAttachmentForDisplay(attachmentFile, product),
          )
        }
      })
    })

    const serviceFiles = allServiceAttachmentFiles.map((file) => {
      const svc =
        additionalSelectedServices?.find(
          (s) =>
            String(s.newIndexId ?? s.indexId) === String(file.service_index_id),
        ) || null
      const serviceName = svc?.name || ''
      const fileUrl = file.url || file.name
      return {
        ...file,
        url: fileUrl,
        name: file.name || fileUrl,
        serviceNames: serviceName ? [{ service_name: serviceName }] : [],
        _serviceAttachment: true,
        _fileUrl: fileUrl,
      }
    })

    return [...availableAvatarFiles, ...dedupedProductFiles, ...serviceFiles]
  }, [
    productAttachments,
    serviceAttachments,
    avatarUrl,
    selectedProducts,
    groupedProductsMap,
    additionalSelectedServices,
  ])

  const renderAttachmentModalContent = ({
    itemKey,
    isService = false,
    tabValue,
    onTabChange,
    selectedImages,
    linkedAttachments,
    onImageSelect,
    onAddSelected,
    onDrop,
    onRemove,
    isUploadingItem,
  }) => {
    if (isPreview) {
      return renderPreviewAttachmentContent(linkedAttachments)
    }

    return (
    <Grid
      container
      spacing={3}
      sx={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Upload Attachment
        </Typography>
        <Tabs
          value={tabValue || 0}
          onChange={(e, newValue) => onTabChange(e, newValue, itemKey)}
          sx={{ mb: 2 }}
        >
          <Tab label="Select from Uploaded" />
          <Tab label="Upload New" />
        </Tabs>

        {(tabValue || 0) === 0 ? (
          <Box>
            {(() => {
              const allProductAttachmentFiles = isService
                ? []
                : Object.values(productAttachments).flat()
              const allServiceAttachmentFiles = Object.values(serviceAttachments).flat()
              const currentLinkedAttachments = linkedAttachments || []

              const availableAvatarFiles = (avatarUrl || []).filter((file) => (
                !allProductAttachmentFiles.some((pfile) => attachmentMatches(pfile, file)) &&
                !allServiceAttachmentFiles.some((sfile) => attachmentMatches(sfile, file))
              ))

              const enrichProductAttachment = (file) => {
                const product = (selectedProducts || []).find(
                  (p) => Number(p?.indexId) === Number(file.product_index_id),
                )
                if (product) {
                  return mapQuotationProductAttachmentForDisplay(
                    file,
                    product,
                    groupedProductsMap,
                  )
                }
                return {
                  ...file,
                  product_index_id: file.product_index_id ?? itemKey,
                }
              }

              const enrichServiceAttachment = (file) => {
                const svc =
                  additionalSelectedServices?.find(
                    (s) =>
                      String(s.newIndexId ?? s.indexId) === String(file.service_index_id ?? itemKey),
                  ) || null
                const serviceName = svc?.name || svc?.service_name || ''
                return {
                  ...file,
                  service_index_id: file.service_index_id ?? itemKey,
                  serviceNames: file.serviceNames || (serviceName ? [{ service_name: serviceName }] : []),
                }
              }

              const allFiles = isService
                ? [
                    ...availableAvatarFiles,
                    ...allServiceAttachmentFiles.map(enrichServiceAttachment),
                    ...currentLinkedAttachments.map(enrichServiceAttachment),
                  ]
                : [
                    ...availableAvatarFiles,
                    ...allProductAttachmentFiles.map(enrichProductAttachment),
                    ...currentLinkedAttachments.map(enrichProductAttachment),
                  ]

              const allFilesUnique = (() => {
                const seen = []
                return allFiles.filter((file) => {
                  if (seen.some((f) => attachmentMatches(f, file))) return false
                  seen.push(file)
                  return true
                })
              })()

              if (allFilesUnique.length === 0) {
                return (
                  <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                    No uploaded files available. Please upload files first.
                  </Typography>
                )
              }

              const groupMemberIds = isService
                ? []
                : getGroupMemberIndexIdsByProductIndexId(itemKey)
              const groupSiblingIndexIdSet =
                groupMemberIds.length > 1
                  ? new Set(groupMemberIds.map(String))
                  : null

              const availableImages = isService
                ? allFilesUnique.filter((file) => {
                    const isAddedToOtherService = Object.entries(serviceAttachments).some(
                      ([serviceId, attachments]) => {
                        if (String(serviceId) === String(itemKey)) return false
                        return (
                          attachments &&
                          attachments.some((f) => attachmentMatches(f, file))
                        )
                      },
                    )
                    const isAddedToAnyProduct = Object.values(productAttachments).some(
                      (atts) => atts && atts.some((f) => attachmentMatches(f, file)),
                    )
                    return !isAddedToOtherService && !isAddedToAnyProduct
                  })
                : allFilesUnique.filter((file) => {
                    const isAddedToOtherProduct = Object.entries(productAttachments).some(
                      ([productId, attachments]) => {
                        if (String(productId) === String(itemKey)) return false
                        if (groupSiblingIndexIdSet?.has(String(productId))) return false
                        return (
                          attachments &&
                          attachments.some((f) => attachmentMatches(f, file))
                        )
                      },
                    )
                    const isUsedOnService = Object.values(serviceAttachments).some(
                      (atts) => atts && atts.some((f) => attachmentMatches(f, file)),
                    )
                    return !isAddedToOtherProduct && !isUsedOnService
                  })

              if (availableImages.length === 0) {
                return (
                  <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                    {isService
                      ? 'All files are already linked to other items.'
                      : 'All images are added to other products. No images left in the uploaded files.'}
                  </Typography>
                )
              }

              const toLink = (selectedImages || []).filter(
                (file) => !(linkedAttachments || []).some((orig) => attachmentMatches(orig, file)),
              )
              const toUnlink = (linkedAttachments || []).filter(
                (file) => !(selectedImages || []).some((sel) => attachmentMatches(sel, file)),
              )
              const hasChanges = toLink.length > 0 || toUnlink.length > 0

              return (
                <>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    {availableImages.map((file, idx) => {
                      const isSelected = (selectedImages || []).some((f) => attachmentMatches(f, file))
                      const isAlreadyAddedToCurrent = (linkedAttachments || []).some((f) => attachmentMatches(f, file))
                      return (
                        <Grid item xs={6} sm={4} md={3} key={idx}>
                          <Card
                            sx={{
                              position: 'relative',
                              border: isSelected ? '2px solid' : '1px solid',
                              borderColor: isSelected ? 'primary.main' : 'divider',
                              cursor: 'pointer',
                              opacity: 1,
                            }}
                            onClick={() => onImageSelect(file, itemKey, !isSelected)}
                          >
                            <Box
                              sx={{
                                position: 'relative',
                                width: '100%',
                                paddingTop: '100%',
                                overflow: 'hidden',
                              }}
                            >
                              {(() => {
                                const url = file.url || file.name
                                const preview = file.preview || url
                                return file.file_type === 'application/pdf' || file.extension === 'pdf' ? (
                                  <IconButton
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      setPdfLoading(true)
                                      setSelectedPDF(url)
                                      setOpenPDFModal(true)
                                      setUseOfficeViewer(true)
                                    }}
                                    aria-label="open pdf"
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      p: 0,
                                      borderRadius: 0,
                                    }}
                                  >
                                    <Box
                                      component="iframe"
                                      src={url}
                                      title="PDF Preview"
                                      frameBorder="0"
                                      sx={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        pointerEvents: 'none',
                                      }}
                                    />
                                  </IconButton>
                                ) : (
                                  <Box
                                    component="img"
                                    src={preview}
                                    alt={file.name || 'Uploaded file'}
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover',
                                    }}
                                    onError={(e) => {
                                      if (preview !== url) {
                                        e.target.src = url
                                      }
                                    }}
                                  />
                                )
                              })()}
                              <Checkbox
                                checked={isSelected}
                                sx={{
                                  position: 'absolute',
                                  top: 4,
                                  right: 4,
                                  bgcolor: 'rgba(255, 255, 255, 0.8)',
                                }}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  onImageSelect(file, itemKey, !isSelected)
                                }}
                              />
                              {isAlreadyAddedToCurrent && isSelected && (
                                <Chip
                                  label="Added"
                                  size="small"
                                  color="success"
                                  sx={{
                                    position: 'absolute',
                                    bottom: 4,
                                    left: 4,
                                  }}
                                />
                              )}
                            </Box>
                          </Card>
                        </Grid>
                      )
                    })}
                  </Grid>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <AttachmentDownloadAllButton
                      files={selectedImages || []}
                      allFiles={availableImages}
                      onToggleSelectAll={(checked) => {
                        availableImages.forEach((file) =>
                          onImageSelect(file, itemKey, checked),
                        )
                      }}
                      label="Download Selected"
                      hidden={isClient || userType === 3}
                    />
                    <Button
                      variant="contained"
                      onClick={() => onAddSelected(itemKey)}
                      disabled={!hasChanges}
                    >
                      Save Selection ({selectedImages?.length || 0})
                    </Button>
                  </Box>
                </>
              )
            })()}
          </Box>
        ) : (
          <UploadMultiFile
            showPreview
            multiple={true}
            maxSize={1024 * 1024 * 1024}
            // accept="image/*,application/pdf"
            files={
              isService
                ? linkedAttachments || []
                : (linkedAttachments || []).map((file) =>
                    enrichQuotationAttachmentForDisplay(
                      file,
                      itemKey,
                      selectedProducts,
                      groupedProductsMap,
                    ),
                  )
            }
            onDrop={(acceptedFiles) => onDrop(acceptedFiles, itemKey)}
            onRemove={(file) => onRemove(file, itemKey)}
            onRemoveAll={() => onRemove(null, itemKey)}
            isUploading={isUploadingItem || false}
            showProductLabels={!isService}
          />
        )}
      </Grid>
    </Grid>
  )
  }
  const ACCOUNT_TABS = [
    {
      value: `${user.isVendor ? '' : 'Estimate '}Details`,
      component: details ? (
        <ViewRequest
          teamMembers={teamMembers}
          clientDetails={invoice}
          products={invoice?.cust_product}
          fetchRequestDetails={fetchRequestDetails}
          user={user}
          designs={designs}
          setDesigns={setDesigns}
          details={details}
          isRequest={true}
          requestId={id}
          signAgreements={signAgreements}
          customTemplate={customTemplate}
          questionnaireTemplate={questionnaireTemplate}
          allDataEmpty={allDataEmpty}
          portfolio={portfolio}
          invoice={invoice}
          quotation={1}
          setRenderCards={setRenderCards}
          renderCards={renderCards}
          rfpServicesEdit={rfpServicesEdit}
          requestServices={requestServices}
          labourInstallService={labourInstallService}
          isEstimate={true}
          explodedPermissions={explodedPermissions}
          productsWithLocation={invoice?.cust_product_location}
          designersList={designersList}
          taxRateData={taxRateData}
          taxAmount={taxAmount}
        />
      ) : (
        ''
      ),
    },
    ...(user.user_type === 3 ||
    isAdminUser (user.user_type) ||
    explodedPermissions?.some((permission) =>
      [
        'View Estimate Client Message Board',
        'Access Estimate Client Message Board',
      ].includes(permission),
    )
      ? [
          {
            value: 'client message board',
            component: (
              <PublicMessageBoard
                products={invoice?.cust_product}
                requestDetails={details}
                requestId={id}
                acceptedClients={acceptedClients}
                accessPublicMessageBoard={accessPublicMessageBoard}
              />
            ),
          },
        ]
      : []),
    // ...(user.isVendor ? [] : [
    //   {
    //     value: 'change order',
    //     component: <RequestTabUpdates updates={updates?.length > 0 ? updates : []} />,
    //   },
    //   {
    //     value: 'payments',
    //     component: <PaymentRequest totalValue={invoice?.total} />,
    //   },
    {
      value: 'Locations and Notes',
      component: (
        <Locations products={invoice?.cust_product} designs={designs} />
      ),
    },
    ...(details?.design_order_id && user.isVendor
      ? []
      : [
          {
            value: 'Job Notes',
            component: (
              <Card sx={{ height: '72vh', display: 'flex' }}>
                <JobNoteWindow
                  products={invoice?.cust_product}
                  allUser={jobNoteMembers}
                  requestIdd={id}
                  designOrderId={details?.design_order_id || null}
                  requestDetails={details}
                  fromDesign={false}
                  isDesignOrder={false}
                  renderCards={renderCards}
                  setRenderCards={setRenderCards}
                  fetchRequestDetails={fetchRequestDetails}
                  details={details}
                  noteType="job"
                />
              </Card>
            ),
          },
          {
            value: 'Design Notes',
            component: (
              <Card sx={{ height: '72vh', display: 'flex' }}>
                <JobNoteWindow
                  products={invoice?.cust_product}
                  allUser={jobNoteMembers}
                  requestIdd={id}
                  designOrderId={details?.design_order_id || null}
                  requestDetails={details}
                  fromDesign={true}
                  isDesignOrder={false}
                  renderCards={renderCards}
                  setRenderCards={setRenderCards}
                  fetchRequestDetails={fetchRequestDetails}
                  details={details}
                  noteType="design"
                />
              </Card>
            ),
          },
        ]),
    ...(!details?.map_service
      ? []
      : [
          {
            value: 'Route - Map Services',
            component: (
              <RouteMap
                details={details}
                id={id}
                route_id={details?.map_service}
              />
            ),
          },
        ]),
    // ...(userType === 3 ? (user.isVendor ? [
    //   {
    //     value: 'My Proposal',
    //     component: <Proposals setReloadData={() => setRefresh(!refresh)} acceptedClients={acceptedClients} proposalData={proposalData} />,
    //   },
    // ] : []) : [
    //   {
    //     value: 'Proposals',
    //     component: <Proposals setReloadData={() => setRefresh(!refresh)} acceptedClients={acceptedClients} proposalData={proposalData} />,
    //   },
    // ]),
  ]

  const handleDeleteService = async (servId, indexId, rowData = null) => {
    // If request-estimate row exists in backend, delete it there first
    if (
      rowData?.is_service_row == 1 &&
      id &&
      (rowData?.backendId || rowData?.id)
    ) {
      try {
        const response = await axios.post(
          `${REST_API_END_POINT}request/update-service-row-estimate`,
          {
            requestId: id,
            productRow: { backendId: rowData?.backendId || rowData?.id },
            action: 'delete',
            userId: user.user_id,
          },
        )

        if (response.data.status !== 1) {
          enqueueSnackbar('Failed to delete service row from server.', {
            variant: 'error',
          })
          return
        }
        enqueueSnackbar('Service row deleted successfully.', {
          variant: 'success',
        })
      } catch (error) {
        console.error('Error deleting service row:', error)
        enqueueSnackbar('Error deleting service row.', { variant: 'error' })
        return
      }
    }

    // const newFilteredServices = additionalSelectedServices?.filter(data => data.id !== servId);
    const newFilteredServices = additionalSelectedServices?.filter((data) => {
      if (data?.isAdditionalProduct) {
        return data?.newIndexId !== indexId
      }
      return !(
        data.id == servId &&
        (data.newIndexId == indexId || data.indexId == indexId)
      )
    })

    const resettedIndexIds = newFilteredServices?.map((service, index) => {
      return {
        ...service,
        indexId: index + 1,
        newIndexId: index + 1,
        product_index: index + 1,
      }
    })
    setServiceAttachments((prev) => {
      const next = {}
      newFilteredServices.forEach((svc, idx) => {
        const oldKey = String(svc.newIndexId ?? svc.indexId ?? '')
        const newKey = String(idx + 1)
        if (prev[oldKey]?.length) {
          next[newKey] = prev[oldKey].map((f) => ({
            ...f,
            service_index_id: newKey,
          }))
        }
      })
      return next
    })
    const remapSvcKeys = (prev) => {
      const next = {}
      newFilteredServices.forEach((svc, idx) => {
        const oldKey = String(svc.newIndexId ?? svc.indexId ?? '')
        const newKey = String(idx + 1)
        if (prev[oldKey] !== undefined) next[newKey] = prev[oldKey]
      })
      return next
    }
    setAttachmentTabValueService(remapSvcKeys)
    setSelectedUploadedImagesService(remapSvcKeys)
    setOpenServiceAttachment(remapSvcKeys)
    setServiceIndexCounter(resettedIndexIds?.length || 0)
    const requestEstimateServiceRows = resettedIndexIds.filter(
      (service) => service?.is_service_row == 1,
    )
    setServiceRowsIndexCounter(requestEstimateServiceRows.length || 0)
    // const allFilteredServices = filteredServices?.find(data => data.id !== servId);
    setFieldValue('services', resettedIndexIds)
    setAdditionalSelectedServices(resettedIndexIds)

    // Keep serviceRows in sync for request-estimate row tracking
    setServiceRows(requestEstimateServiceRows)
  }
  useEffect(() => {
    if (selectedProducts.length <= 0) {
      setAllLocationSame(false)
    }
  }, [selectedProducts])
  const handleCancel = async (isEdit) => {
    console.log('isEdit++++++++isEdit', isEdit)
    console.log('isEdit++++++++edit', edit)
    // Discard catalogs created during this edit session but never committed via Save
    if (id) {
      try {
        await axios.post(`${REST_API}webservice/request/discard-pending-estimate-catalogs`, {
          requestId: id,
          userId,
          estimateName: values?.name || details?.name || currentRFQData?.name || null,
        })
      } catch (error) {
        console.error('Failed to discard pending estimate catalogs:', error)
      }
    }
    setIsOpenEdit(false)
    if(setIsPreview){
      setIsPreview(false)
    }
    // setIsOpen(false)
    setCurrentRFQdata({})
    // resetForm();
    setSelectedProducts([])
    setSelectedMapserviceProducts([])
    setSelectedServices([])
    setAdditionalSelectedServices([])
    setFilteredServices([])
    setProductAttachments({})
    setServiceAttachments({})
    fetchRequestDetails()
    setAllLocationSame(false)
    if (popupOn && !isEdit) {
      closeView()
      // setRenderCards(!renderCards)
    }
    if ((isEdit && edit) || (isEdit === undefined && edit)) {
      if (popupOn) {
        closeView()
      }
      // else{
      //   navigate(`/dashboard/quick-bid`)
      // }
    } else if (isEdit && !edit) {
      if (popupOn) {
        setIsOpen(false)
      }
      // else{
      //   navigate(`/dashboard/quick-bid`)
      // }
    }
    if (edit) {
      edit = false
      setOpenEdit(false)
      setIsOpen(false)
    }
    if (!popupOn && !isEdit) {
      // navigate(`/dashboard/quick-bid/estimate`)
    }
    setOpenEdit(false)
    setIsOpen(false)
  }

  // Filter selected products based on facility selection
  const filterSelectedProductsByFacility = (selectedFacilities) => {
    if (!selectedFacilities || selectedFacilities.length === 0) {
      return []
    }

    // Get selected facility IDs
    const selectedFacilityIds = selectedFacilities.map((facility) =>
      Number(facility.id),
    )

    return selectedProducts.filter((product) => {
      // If product has no facility_id (undefined/null), it belongs to Arizona (default)
      const productFacilityId =
        product.facility_id === undefined || product.facility_id === null
          ? 1
          : Number(product.facility_id)

      // Keep product if its facility is in the selected facilities
      return selectedFacilityIds.includes(productFacilityId)
    })
  }

  // Filtered product options based on facility and other criteria
  const filteredProductOptions = useMemo(() => {
    const filtered = (allProducts || []).filter((option) => {
      // Facility-based filtering for split orders
      if (isSplitOrder) {
        const selectedFacilities = values?.facility_type || []
        if (selectedFacilities.length === 0) {
          // If no facility is chosen (empty array), return empty
          return false
        }

        // Get selected facility IDs
        const selectedIds = new Set(selectedFacilities.map((f) => Number(f.id)))

        // Check if product's facility matches selected facilities
        const facilityMatch = selectedIds.has(Number(option.facility_id))
        if (!facilityMatch) return false

        const splitCatalogType = values?.split_catalog_type

        // For split orders, use split catalog type for filtering
        if (splitCatalogType) {
          // If "All" is selected, show all products regardless of inhouse value
          if (splitCatalogType?.id === 'all') {
            // For current facility, exclude inhouse === 6 (Split Catalog)
            if (Number(option.facility_id) === currentFacilityId) {
              return option.inhouse !== 6
            }
            return true
          }
          // Otherwise, filter based on the selected split catalog type
          if (splitCatalogType?.inhouse === 4) {
            return option.inhouse === 4
          } else if (splitCatalogType?.inhouse === 5) {
            return option.inhouse === 5
          } else if (splitCatalogType?.inhouse === 1) {
            return option.inhouse === 1
          } else if (splitCatalogType?.inhouse === 6) {
            // Only show Split Catalog for other facilities, not current facility
            return (
              option.inhouse === 6 &&
              Number(option.facility_id) !== currentFacilityId
            )
          } else if (splitCatalogType?.inhouse === 7) {
            return option.inhouse === 7 // Estimate Catalog
          } else if (splitCatalogType?.isTrafficCatalog) {
            return option.isTrafficCatalog === 1
          }
          return true // Default to show all for split orders
        }

        // For current facility (facility_id matches currentFacilityId), show only inhouse == 1, 4, 5 (exclude 6)
        if (Number(option.facility_id) === currentFacilityId) {
          return (
            option.inhouse === 1 || option.inhouse === 5 || option.inhouse === 4
          )
        }

        // For other facilities, show inhouse == 1, 4, 5, 6
        return (
          option.inhouse === 1 ||
          option.inhouse === 5 ||
          option.inhouse === 4 ||
          option.inhouse === 6
        )
      } else {
        const selectedFacilities = FacilityTypes.filter(
          (f) => Number(f.id) === Number(currentFacilityId),
        )
        if (selectedFacilities.length === 0) return false
        const selectedIds = new Set(selectedFacilities.map((f) => Number(f.id)))
        const facilityMatch = selectedIds.has(Number(option.facility_id))
        if (!facilityMatch) return false
      }

      // For normal orders, check split_catalog_type if it's set
      if (!isSplitOrder && values?.split_catalog_type) {
        const normalCatalogType = values.split_catalog_type;
        // If "All" is selected, show all products except split catalog
        if (normalCatalogType?.id === 'all') {
          return option.inhouse !== 6;
        }
        // Otherwise, filter based on the selected catalog type
        // Check isTrafficCatalog first before inhouse === 1 to avoid conflicts
        if (normalCatalogType?.isTrafficCatalog) {
          return option.isTrafficCatalog === 1;
        } else if (normalCatalogType?.inhouse === 4) {
          return option.inhouse === 4;
        } else if (normalCatalogType?.inhouse === 5) {
          return option.inhouse === 5;
        } else if (normalCatalogType?.inhouse === 1) {
          return option.inhouse === 1 && option.isTrafficCatalog !== 1; // Production Catalog (inhouse 1 but not traffic)
        } else if (normalCatalogType?.inhouse === 0) {
          return option.inhouse === 0; // Sub Contract
        } else if (normalCatalogType?.inhouse === 7) {
          return option.inhouse === 7; // Estimate Catalog
        }
        // If no match, exclude split catalog
        return option.inhouse !== 6;
      }

      // Default filtering for non-split orders
      return (
        option.inhouse === 1 ||
        option.inhouse === 5 ||
        option.inhouse === 4 ||
        option.inhouse === 7 ||
        option.inhouse === 0
      )
    })

    // Sort in strict alphanumeric order based on description and name only (ignore suffix)
    return filtered.sort((a, b) => {
      const getSortKey = (option) => {
        const name = (option.name || '').trim()
        const description = (option.description || '').trim()
        // Sort by description first, then by name for strict alphanumeric order
        const sortString = `${name}`.trim()
        return sortString
      }

      const keyA = getSortKey(a)
      const keyB = getSortKey(b)

      // Strict alphanumeric sort: case-insensitive with natural numeric ordering
      return keyA.localeCompare(keyB, undefined, {
        numeric: true,
        sensitivity: 'base',
      })
    })
  }, [
    allProducts,
    values?.facility_type,
    values?.split_catalog_type,
    isSplitOrder,
    currentFacilityId,
  ])

  console.log('values++++++++', values)
  console.log('selectedProductsselectedProducts', selectedProducts)
  const selectedProductsAdditionalCost = selectedProducts
    ?.filter((item) => item?.isAdditionalProduct == true)
    ?.reduce((total, item) => total + (item.product_total || 0), 0)
    ?.toFixed(2)

  const selectedMaterialSubTotal = selectedMaterials //?.filter(item=>item?.isAdditionalProduct == true)
    ?.reduce(
      (total, item) => total + (item.markUpCost || 0) * (item.quantity || 0),
      0,
    )
    ?.toFixed(2)

  let totalMarkup = 0
  let totalServiceMarkup = 0
  let originaltotalMarkup = 0
  let originaltotalServiceMarkup = 0
  let totalAmount = 0
  return (
    <Page title={COMPANY_NAME || 'View Estimate: View | Sign Wise Solutions'}>
      {/* Transparent overlay loader for quotation status */}
      {/* {!details?.quotation_status && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            backdropFilter: 'blur(2px)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <CircularProgress size={60} thickness={4} />
          <Typography variant="h6" color="primary" sx={{ fontWeight: 500 }}>
            Loading Estimate Details...
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please wait while we fetch the estimate information
          </Typography>
        </Box>
      )} */}

      {createJob && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            backdropFilter: 'blur(2px)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <CircularProgress size={60} thickness={4} />
          <Typography variant="h6" color="primary" sx={{ fontWeight: 500 }}>
            {isUpdating
              ? 'Updating Estimate Job...'
              : 'Creating Estimate Job...'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {isUpdating
              ? 'Please wait while we update the estimate information'
              : 'Please wait while we fetch the estimate information'}
          </Typography>
        </Box>
      )}

      {loading || !values?.name ? (
        <Stack
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            alignContent: 'center',
            my: 8,
            gap: 2,
          }}
        >
          <LoadingScreen />
          <Typography variant="body1" color="primary" sx={{ fontWeight: 500, mt: 3 }}>
            Loading Estimate Data...
          </Typography>
        </Stack>
      ) : (
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="center">
            {/* <HeaderBreadcrumbs heading={details?.is_create_estimate == 1 ? `Edit Estimate` : `Create Estimate`} /> */}
            <HeaderBreadcrumbs heading={''} />
          </Stack>
          {openEdit && (
            <FormikProvider value={formik}>
              <Form noValidate autoComplete="off" onSubmit={handleEstimateFormSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={12}>
                    <Box sx={isPreview ? ESTIMATE_PREVIEW_LOCK_SX : undefined}>
                    <Stack spacing={3}>
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        <Stack flexDirection={'column'}>
                          <TextField
                            //   fullWidth
                            sx={{ width: 400 }}
                            disabled={isPreview ? true : false}
                            label="Requested Name"
                            {...getFieldProps('name')}
                            error={Boolean(touched.name && errors.name)}
                            helperText={touched.name && errors.name}
                          />
                        </Stack>
                        <TextField
                          sx={{ width: 400 }}
                          label="#PO Number"
                          {...getFieldProps('po_number')}
                          error={Boolean(touched.po_number && errors.po_number)}
                          helperText={touched.po_number && errors.po_number}
                        />
                        <Box
                          component={MobileDatePicker}
                          disableFuture
                          label="Estimate Date"
                          value={estimateDatePickerMoment(values.created_at)}
                          onChange={(date) => {
                            setFieldValue('created_at', dateOnlyToUnix(date));
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              error={false}
                              sx={{ width: 400 }}
                            />
                          )}
                        />
                      </Stack>
                      <TextField
                        fullWidth
                        multiline
                        disabled={isPreview ? true : false}
                        minRows={3}
                        maxRows={7}
                        label="keep the summary brief and make it communicates"
                        {...getFieldProps('description')}
                        error={Boolean(
                          touched.description && errors.description,
                        )}
                        helperText={touched.description && errors.description}
                      />
                      <>
                        <LabelStyle>Upload Designs / Documents</LabelStyle>
                        <UploadMultiFile
                          showPreview
                          allowDownload
                          maxSize={1024 * 1024 * 1024}
                          files={uploadDesignsDisplayFiles}
                          onDrop={handleDrop}
                          onRemove={handleRemove}
                          onRemoveAll={handleRemoveAll}
                          isUploading={isUploading}
                          showProductLabels={true}
                          {...getEstimatePreviewUploadProps(isPreview)}
                        />
                      </>
                      {userType !== 3 ? (
                        <>
                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                          >
                            <Autocomplete
                              sx={{ width: '50%' }}
                              id="combo-box-demo"
                              // disabled={
                              //   currentRFQData?.client?.id ? true : false
                              // }
                              // disabled={details?.checkProjectExist ? true : false}
                              options={allClientsEdit || []}
                              value={values.clients ?? null}
                              isOptionEqualToValue={(option, value) =>
                                String(option?.id) === String(value?.id)
                              }
                              onChange={(event, newValue) => {
                                // if (newValue) {
                                //   setFieldValue('clients', newValue);
                                // } else {
                                //   setFieldValue('clients', null);
                                // }
                                if (newValue) {
                                  setFieldValue('clients', newValue)
                                  setFieldValue('community', null)
                                  fetchAllCommunityByClient(newValue)
                                  setSalesRepOptions([])
                                  setSalesRepName('')
                                  setSalesRepId(null)
                                } else {
                                  setFieldValue('clients', null)
                                  setFieldValue('community', null)
                                  setCommunities([])
                                  setSalesRepOptions([])
                                  setSalesRepName('')
                                  setSalesRepId(null)
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  required
                                  {...params}
                                  label="Clients"
                                  error={Boolean(
                                    touched.clients && errors.clients,
                                  )}
                                  helperText={touched.clients && errors.clients}
                                />
                              )}
                              getOptionLabel={(option) => option.name}
                            />

                            {isCommunityLoading ? (
                              <Stack
                                flexDirection={'row'}
                                alignItems="center"
                                justifyContent="center"
                              >
                                <CircularProgress
                                  color="primary"
                                  variant="indeterminate"
                                />
                                <Typography variant="body2">
                                  Loading projects...
                                </Typography>
                              </Stack>
                            ) : communities?.length > 0 ? (
                              <Autocomplete
                                sx={{ width: '50%' }}
                                id="community"
                                options={communities}
                                disabled={isPreview ? true : false}
                                value={values?.community}
                                onChange={(event, newValue) => {
                                  if (newValue) {
                                    setFieldValue('community', newValue)
                                    setCollaborators([])
                                    const repOptions = getSalesRepOptionsFromCommunity(newValue)
                                    setSalesRepOptions(repOptions)
                                    if (repOptions.length) {
                                      setSalesRepName(repOptions[0]?.name || '')
                                      setSalesRepId(repOptions[0]?.id || null)
                                    } else {
                                      setSalesRepName('')
                                      setSalesRepId(null)
                                    }

                                    // Extract new community address
                                    const {
                                      address: projAddress = '',
                                      city: projCity = '',
                                      state: projState = '',
                                      zip: projZip = '',
                                    } = newValue || {}
                                    const communityAddress = {
                                      id: 0,
                                      address: projAddress,
                                      city: projCity,
                                      state: projState,
                                      zip: projZip,
                                    }

                                    // Update locations in `setSelectedProducts`
                                    setSelectedProducts((prevProducts) =>
                                      prevProducts.map((product) => {
                                        if (product?.fromMapServices == true) {
                                          return product
                                        } else {
                                          // For split orders, ensure proper address population
                                          if (isSplitOrder) {
                                            // For split orders, create proper locations based on quantity
                                            const locationQuantity =
                                              product.locationQuantity ||
                                              product.quantity ||
                                              1
                                            const updatedAddresses = Array.from(
                                              { length: locationQuantity },
                                              () => ({
                                                id: 0,
                                                address: projAddress,
                                                city: projCity,
                                                state: projState,
                                                zip: projZip,
                                              }),
                                            )
                                            return {
                                              ...product,
                                              allLocationSame: 1,
                                              location: updatedAddresses,
                                            }
                                          } else {
                                            // For normal orders, use existing logic
                                            const updatedAddresses =
                                              product.location?.map((loc) => ({
                                                ...loc,
                                                address:
                                                  projAddress || loc.address,
                                                city: projCity || loc.city,
                                                state: projState || loc.state,
                                                zip: projZip || loc.zip,
                                              })) || [communityAddress]
                                            return {
                                              ...product,
                                              location: updatedAddresses,
                                            }
                                          }
                                        }
                                      }),
                                    )
                                    console.log(
                                      'selectedProductsselectedProducts',
                                      selectedProducts,
                                    )
                                    // Update locations in `setCart`
                                    setCart((prevCart) =>
                                      prevCart.map((product) => {
                                        const updatedAddresses =
                                          product.location?.map((loc) => ({
                                            ...loc,
                                            address: projAddress || loc.address,
                                            city: projCity || loc.city,
                                            state: projState || loc.state,
                                            zip: projZip || loc.zip,
                                          })) || [communityAddress]
                                        return {
                                          ...product,
                                          location: updatedAddresses,
                                        }
                                      }),
                                    )
                                    if (newValue.tax_category) {
                                      let taxCat = taxCategories?.find(
                                        (cat) =>
                                          newValue.tax_category === cat.id,
                                      )
                                      setSelectedTaxCategory(taxCat)
                                    }
                                  } else {
                                    setFieldValue('community', null)
                                    setSelectedTaxCategory(null)
                                    setSalesRepOptions([])
                                    setSalesRepName('')
                                    setSalesRepId(null)
                                  }
                                }}
                                renderInput={(params) => (
                                  <Tooltip
                                    title={
                                      values.community
                                        ? formatProjectAddress(values.community)
                                        : ''
                                    }
                                  >
                                    <TextField
                                      required
                                      {...params}
                                      label="Project"
                                      error={Boolean(
                                        touched.community && errors.community,
                                      )}
                                      helperText={
                                        touched.community && errors.community
                                      }
                                    />
                                  </Tooltip>
                                )}
                                getOptionLabel={(option) => option.name}
                                renderOption={(props, option) => {
                                  const { style, ...liProps } = props
                                  return (
                                    <li
                                      {...liProps}
                                      style={{
                                        ...style,
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <Tooltip title={formatProjectAddress(option)}>
                                        <span
                                          style={{
                                            flex: 1,
                                            minWidth: 0,
                                            display: 'block',
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: 'block',
                                              whiteSpace: 'nowrap',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                            }}
                                          >
                                            {option?.name || ''}
                                          </span>
                                          {/* <span
                                            style={{
                                              display: 'block',
                                              fontSize: 12,
                                              color: '#6b7280',
                                              whiteSpace: 'nowrap',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                            }}
                                          >
                                            {formatProjectAddress(option)}
                                          </span> */}
                                        </span>
                                      </Tooltip>
                                      <span style={{ display: 'none' }}>{option?.name || ''}</span>
                                    </li>
                                  )
                                }}
                              />
                            ) : (
                              <Stack
                                sx={{ width: '50%' }}
                                justifyContent={'center'}
                              >
                                {values?.clients ? (
                                  <Typography sx={{ color: 'red' }}>
                                    The selected client does not have any
                                    projects yet. Please create a new project
                                    for them!
                                  </Typography>
                                ) : (
                                  <Typography sx={{ color: 'red' }}>
                                    No client selected. Please choose a client
                                    from the list.
                                  </Typography>
                                )}
                              </Stack>
                            )}
                          </Stack>

                          {salesRepOptions?.length > 0 && (
                            <Stack sx={{ width: '100%' }}>
                              <Autocomplete
                                id="sales-rep"
                                options={salesRepOptions}
                                value={
                                  salesRepOptions.find((opt) => {
                                    if (salesRepId != null && opt?.id != null) {
                                      return String(opt.id) === String(salesRepId)
                                    }
                                    return salesRepName && opt?.name === salesRepName
                                  }) || null
                                }
                                disabled={isPreview ? true : false}
                                onChange={(event, newValue) => {
                                  setSalesRepName(newValue?.name || '')
                                  setSalesRepId(newValue?.id || null)
                                }}
                                isOptionEqualToValue={(option, value) =>
                                  (option?.id != null && value?.id != null && String(option.id) === String(value.id)) ||
                                  option?.name === value?.name
                                }
                                getOptionLabel={(option) => option?.name || ''}
                                renderInput={(params) => (
                                  <TextField {...params} label="Sales Rep" fullWidth />
                                )}
                              />
                            </Stack>
                          )}
                          <Stack sx={{ width: '100%' }}>
                            <Autocomplete
                              multiple
                              disabled={isPreview}
                              id="collaborators"
                              options={collaboratorOptions}
                              value={collaborators}
                              onChange={(event, newValue) => setCollaborators(newValue || [])}
                              loading={teamMembersLoading}
                              isOptionEqualToValue={(option, value) => (option?.id != null && value?.id != null && String(option.id) === String(value.id))}
                              getOptionLabel={(option) => option?.name || [option?.first_name, option?.last_name].filter(Boolean).join(' ').trim() || String(option?.id || '')}
                              renderInput={(params) => (
                                <TextField {...params} label="Collaborators" fullWidth placeholder="Select Collaborators" />
                              )}
                            />
                          </Stack>

                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                          >
                            <Autocomplete
                              fullWidth
                              disabled={isPreview ? true : false}
                              sx={{ width: { xs: '100%', sm: '50%' } }}
                              id="combo-box-demo-type"
                              options={projectTypes}
                              value={values.project_type}
                              onChange={(event, newValue) => {
                                setFieldValue('project_type', newValue)
                                if (newValue?.name !== 'TS') {
                                  setFieldValue('map_service', null)
                                  const filteredProducts =
                                    selectedProducts?.filter(
                                      (product) =>
                                        product?.fromMapServices !== true,
                                    )
                                  setSelectedProducts(filteredProducts)
                                }
                              }}
                              renderInput={(params) => (
                                <TextField
                                  required
                                  {...params}
                                  label="Job Class"
                                  error={Boolean(
                                    touched.project_type && errors.project_type,
                                  )}
                                  helperText={
                                    touched.project_type && errors.project_type
                                  }
                                />
                              )}
                              getOptionLabel={(option) => option.name}
                            />
                            <Autocomplete
                              sx={{ width: '50%' }}
                              multiple
                              id="sign-agreement"
                              options={signAgreementsData} // Array of agreements (full objects)
                              value={values.sign_agreement || []} // Ensure it's an array of full agreement objects
                              onChange={(event, newValue) => {
                                // Store the full selected objects in the form's field value
                                setFieldValue('sign_agreement', newValue || []); // No need to join IDs, just store the objects
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required={false}
                                  InputLabelProps={{
                                    ...params.InputLabelProps,
                                    required: false,
                                  }}
                                  label="Select Sign Agreements"
                                  error={Boolean(touched.sign_agreement && errors.sign_agreement)}
                                  helperText={touched.sign_agreement && errors.sign_agreement}
                                />
                              )}
                              isOptionEqualToValue={(option, value) => option.id === value.id} // Compare options by 'id'
                              getOptionLabel={(option) => option.name || ''} // Show 'name' of the agreement
                              filterOptions={(options, { inputValue }) => {
                                // Filter by name (case-insensitive)
                                return options.filter(option =>
                                  option.name.toLowerCase().includes(inputValue.toLowerCase())
                                );
                              }}
                            />
                          </Stack>
                          {values?.project_type?.name == 'TS' ? (
                            <Stack
                              direction={{ xs: 'column', sm: 'row' }}
                              spacing={{ xs: 3, sm: 2 }}
                            >
                              <Autocomplete
                                // fullWidth
                                sx={{ width: '50%' }}
                                disabled={isPreview ? true : false}
                                id="combo-box-demo-category"
                                options={projectCategories}
                                value={values.project_category}
                                onChange={(event, newValue) => {
                                  setFieldValue('project_category', newValue)
                                  if (
                                    values?.project_type?.name !== 'TS' ||
                                    newValue?.id != 14
                                  ) {
                                    setFieldValue('map_service', null)
                                    const filteredProducts =
                                      selectedProducts?.filter(
                                        (product) =>
                                          product?.fromMapServices !== true,
                                      )
                                    setSelectedProducts(filteredProducts)
                                    setSelectedMapserviceProducts([])
                                    setSelectedServices([])
                                  }
                                  if (values.project_category?.id == 14) {
                                    setSelectedProducts([])
                                    setSelectedMapserviceProducts([])
                                    setSelectedServices([])
                                  }
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Job Type"
                                    error={Boolean(
                                      touched.project_category &&
                                        errors.project_category,
                                    )}
                                    helperText={
                                      touched.project_category &&
                                      errors.project_category
                                    }
                                  />
                                )}
                                getOptionLabel={(option) => option.name}
                              />
                              {values.project_category?.id == 14 ? (
                                <Autocomplete
                                  // fullWidth
                                  disabled={isPreview ? true : false}
                                  sx={{ width: '50%' }}
                                  id="combo-box-demo-type"
                                  options={mapServices}
                                  value={values.map_service}
                                  onChange={(event, newValue) => {
                                    setFieldValue('map_service', newValue)
                                    if (newValue?.products) {
                                      let newIndexCounter = indexCounter
                                      const updatedProductsWithLocations =
                                        newValue?.products?.map(
                                          (product, index) => {
                                            const filteredData =
                                              allProducts?.find(
                                                (i) =>
                                                  i.id === product.product_id,
                                              )
                                            const associatedLocations =
                                              newValue?.locations
                                                .filter(
                                                  (location) =>
                                                    location?.route_product_id ===
                                                    product?.id,
                                                )
                                                .map((location) => ({
                                                  address: location.address,
                                                  city: location.city,
                                                  state: location.state,
                                                  zip: location.zip,
                                                  route_location_id:
                                                    location.id,
                                                }))
                                            newIndexCounter += 1
                                            return {
                                              ...product,
                                              ...filteredData,
                                              indexId: newIndexCounter, // `map_${index}`,
                                              fromMapServices: true,
                                              locationQuantity: product?.qty,
                                              location: associatedLocations,
                                              discount: 0,
                                              adjustment: 0,
                                              quantity: 1,
                                              markAdjType: 1,
                                            }
                                          },
                                        )
                                      console.log(
                                        'updatedProductsWithLocations-----------',
                                        updatedProductsWithLocations,
                                      )
                                      const mergedSelectedProducts = [
                                        ...selectedProducts.filter(
                                          (product) =>
                                            product?.fromMapServices !== true,
                                        ), // Keep existing products without fromMapServices
                                        ...updatedProductsWithLocations, // Add the new products from map services
                                      ]
                                      setSelectedMapserviceProducts(
                                        updatedProductsWithLocations,
                                      )
                                      setSelectedProducts(
                                        mergedSelectedProducts,
                                      )
                                      setFieldValue(
                                        'products',
                                        mergedSelectedProducts,
                                      )
                                      setIndexCounter(newIndexCounter)
                                      const productServices =
                                        mergedSelectedProducts?.reduce(
                                          (services, product) => {
                                            if (
                                              product.services &&
                                              product.services.length > 0
                                            ) {
                                              return services.concat(
                                                product.services.map(
                                                  (service) => ({
                                                    ...service,
                                                    fromMapServices:
                                                      product?.fromMapServices ||
                                                      false,
                                                    productIndex:
                                                      product?.indexId,
                                                    quantity:
                                                      service.quantity *
                                                      product.quantity *
                                                      product.locationQuantity,
                                                    previousQty:
                                                      service.quantity,
                                                    qtyData: product.quantity,
                                                    locationQuantity:
                                                      product.locationQuantity,
                                                  }),
                                                ),
                                              )
                                            }
                                            return services
                                          },
                                          [],
                                        )
                                      setSelectedServices(productServices)
                                    }
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      required
                                      {...params}
                                      label="Routes"
                                      error={Boolean(
                                        touched.map_service &&
                                          errors.map_service,
                                      )}
                                      helperText={
                                        touched.map_service &&
                                        errors.map_service
                                      }
                                    />
                                  )}
                                  // getOptionLabel={(option) => option.name}
                                  getOptionLabel={(option) =>
                                    `${option.name} (${option.locations_count})`
                                  }
                                />
                              ) : (
                                ''
                              )}
                            </Stack>
                          ) : (
                            ''
                          )}

                          {isSplitOrder ? (
                            <Stack
                              direction={{ xs: 'column', sm: 'row' }}
                              spacing={{ xs: 3, sm: 2 }}
                            >
                              <Autocomplete
                                sx={{ width: '50%' }}
                                id="split-type-autocomplete"
                                options={[{ id: 1, label: 'Split' }]}
                                disabled={isSplitOrder}
                                value={values.is_split || null}
                                onChange={(event, newValue) => {
                                  setFieldValue('is_split', newValue)
                                  // Update isSplitOrder based on the form field value
                                  setIsSplitOrder(!!newValue)

                                  // If split order is enabled, set default facility
                                  if (newValue) {
                                    const defaultFacility =
                                      FacilityTypes?.filter(
                                        (fac) => fac.default,
                                      )
                                    setFieldValue(
                                      'facility_type',
                                      defaultFacility || [],
                                    )
                                  } else {
                                    // If split order is disabled, clear facility_type
                                    setFieldValue('facility_type', [])
                                  }
                                }}
                                getOptionLabel={(option) => option?.label ?? ''}
                                isOptionEqualToValue={(option, value) =>
                                  option?.id === value?.id
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Choose Split Type"
                                    placeholder="Select split type"
                                    error={Boolean(
                                      touched.is_split && errors.is_split,
                                    )}
                                    helperText={
                                      touched.is_split && errors.is_split
                                    }
                                  />
                                )}
                              />

                              {isSplitOrder ? (
                                <Autocomplete
                                  multiple
                                  disableCloseOnSelect
                                  filterSelectedOptions
                                  sx={{ width: '50%' }}
                                  id="combo-box-demo-type"
                                  options={FacilityTypes || []}
                                  value={values.facility_type || []}
                                  onChange={(event, newValue) => {
                                    setFieldValue('facility_type', newValue)
                                    let filteredVaue = newValue.find(
                                      (v) => !v.default,
                                    )
                                    const selectedData = (
                                      Array.isArray(filteredVaue)
                                        ? filteredVaue
                                        : [filteredVaue]
                                    )
                                      .map((v) => {
                                        const id =
                                          typeof v === 'object' ? v?.id : v
                                        return splitManagementSettings?.find(
                                          (s) => String(s?.id) === String(id),
                                        )
                                      })
                                      .filter(Boolean)

                                    setSelectedSplitOrderSettings(selectedData)

                                    // Filter selected products based on new facility selection
                                    if (
                                      isSplitOrder &&
                                      selectedProducts.length > 0
                                    ) {
                                      const filteredProducts =
                                        filterSelectedProductsByFacility(
                                          newValue,
                                        )
                                      setSelectedProducts(filteredProducts)
                                      setFieldValue(
                                        'products',
                                        filteredProducts,
                                      )
                                    }
                                  }}
                                  getOptionLabel={(option) =>
                                    option?.label ?? ''
                                  }
                                  isOptionEqualToValue={(option, value) =>
                                    option?.id === value?.id
                                  }
                                  renderTags={(selected, getTagProps) =>
                                    selected.map((option, index) => (
                                      <Chip
                                        key={
                                          option?.id ?? option?.label ?? index
                                        }
                                        label={option?.label}
                                        size="small"
                                        color={option?.color} //"primary"
                                        variant="outlined"
                                        {...getTagProps({ index })} // handles delete icon
                                      />
                                    ))
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      required
                                      {...params}
                                      label="Choose Facility"
                                      placeholder="Select facilities"
                                      error={Boolean(
                                        touched.facility_type &&
                                          errors.facility_type,
                                      )}
                                      helperText={
                                        touched.facility_type &&
                                        errors.facility_type
                                      }
                                    />
                                  )}
                                />
                              ) : (
                                ''
                              )}
                            </Stack>
                          ) : (
                            ''
                          )}
                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                          >
                            <Box
                              component={MobileDatePicker}
                              label="Start Date"
                              disabled={isPreview ? true : false}
                              // minDate={moment()}
                              defaultValue={moment
                                .unix(values.start)
                                .format('MM/DD/YYYY')}
                                value={dateOnlyMoment(values.start)}
                              onChange={(date) => {
                                const newStartUnix = dateOnlyToUnix(date)
                                setFieldValue('start', newStartUnix)
                                applyInstallationFromStartAndLead(newStartUnix)
                              }}
                              renderInput={(params) => (
                                <TextField size="small" {...params} fullWidth />
                              )}
                            />

                            <Box
                              component={MobileDatePicker}
                              label="Installation Date"
                              disabled={isPreview ? true : false}
                              // minDate={moment()}
                              minDate={values.start ? dateOnlyMoment(values.start) : moment()}
                              defaultValue={moment
                                .unix(values.end)
                                .format('MM/DD/YYYY')}
                              value={
                                values.end ? dateOnlyMoment(values.end) : null
                              }
                              onChange={(date) => {
                                setFieldValue('end', dateOnlyToUnix(date))
                                // Clear installation start/end dates when single date is selected
                                setFieldValue('installation_start_date', null)
                                setFieldValue('installation_end_date', null)
                              }}
                              renderInput={(params) => (
                                <TextField
                                  size="small"
                                  {...params}
                                  fullWidth
                                  error={Boolean(touched.end && errors.end)}
                                  helperText={touched.end && errors.end}
                                />
                              )}
                            />
                          </Stack>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mt: 2, mb: 1, fontStyle: 'italic' }}
                          >
                            Choose either single installation date above OR
                            installation date range below
                          </Typography>
                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={2}
                          >
                            <Box
                              component={MobileDatePicker}
                              minDate={values.start ? dateOnlyMoment(values.start) : moment()}
                              label="Installation Start Date"
                              disabled={isPreview ? true : false}
                              value={
                                values.installation_start_date
                                  ? dateOnlyMoment(values.installation_start_date)
                                  : null
                              }
                              onChange={(date) => {
                                setFieldValue(
                                  'installation_start_date',
                                  dateOnlyToUnix(date),
                                )
                                // Clear single installation date when range is selected
                                setFieldValue('end', null)
                              }}
                              renderInput={(params) => (
                                <TextField
                                  size="small"
                                  {...params}
                                  fullWidth
                                  error={Boolean(
                                    touched.installation_start_date &&
                                      errors.installation_start_date,
                                  )}
                                  helperText={
                                    touched.installation_start_date &&
                                    errors.installation_start_date
                                  }
                                />
                              )}
                            />
                            <Box
                              component={MobileDatePicker}
                              minDate={
                                values.installation_start_date
                                  ? dateOnlyMoment(values.installation_start_date)
                                  : moment()
                              }
                              label="Installation End Date"
                              disabled={isPreview ? true : false}
                              value={
                                values.installation_end_date
                                  ? dateOnlyMoment(values.installation_end_date)
                                  : null
                              }
                              onChange={(date) => {
                                setFieldValue(
                                  'installation_end_date',
                                  dateOnlyToUnix(date),
                                )
                                // Clear single installation date when range is selected
                                setFieldValue('end', null)
                              }}
                              renderInput={(params) => (
                                <TextField
                                  size="small"
                                  {...params}
                                  fullWidth
                                  error={Boolean(
                                    touched.installation_end_date &&
                                      errors.installation_end_date,
                                  )}
                                  helperText={
                                    touched.installation_end_date &&
                                    errors.installation_end_date
                                  }
                                />
                              )}
                            />
                          </Stack>

                          <Divider />
                          {details?.is_request_estimate == 1 &&
                          (!details?.estimate_job_status ||
                            details?.estimate_job_status == 1) ? (
                            ''
                          ) : (
                            <>
                              <LabelStyleHead>Products</LabelStyleHead>
                              <Stack
                                direction={{ xs: 'column', sm: 'row' }}
                                alignItems={'center'}
                                spacing={{ xs: 3, sm: 2 }}
                              >
                                {loadingProducts ? (
                                  <Stack
                                    flexDirection={'row'}
                                    gap={1}
                                    alignItems="center"
                                    justifyContent="flex-start"
                                  >
                                    <CircularProgress
                                      color="primary"
                                      size={20}
                                      variant="indeterminate"
                                    />
                                    <Typography variant="body2">
                                      Loading products...
                                    </Typography>
                                  </Stack>
                                ) : (
                                  <Stack
                                    flexDirection={'row'}
                                    gap={1}
                                    alignItems="center"
                                    justifyContent="flex-start"
                                    sx={{ width: '100%' }}
                                  >
                                    <Autocomplete
                                      key={`product-autocomplete-${isSplitOrder}-${
                                        values?.facility_type?.length || 0
                                      }-${filteredProductOptions?.length || 0}`}
                                      sx={{ width: '40%' }}
                                      multiple
                                      disableCloseOnSelect
                                      clearOnBlur={false}
                                      disabled={isPreview ? true : false}
                                      id="combo-box-demo"
                                      options={filteredProductOptions}
                                      value={productAutocompleteDisplayValue}
                                      onChange={handleAutocompleteCatalogProductsChange}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Select a product"
                                        />
                                      )}
                                      // getOptionLabel={(option) => option.product_name ? option.product_name : option.name}
                                      renderOption={(props, option) => {
                                        const { style, ...liProps } = props;
                                        const description = option.description || ''
                                        const Name = option.name
                                        const suffix = option.isTrafficCatalog
                                          ? '(TC)'
                                          : option.inhouse === 5
                                          ? '(Client Owned Catalog)'
                                          : option.inhouse === 4
                                          ? '(In Stock Catalog)'
                                          : option.inhouse === 0
                                          ? '(Sub Contract)'
                                          : option.inhouse === 6
                                          ? '(Split Catalog)'
                                          : option.inhouse === 7
                                          ? '(Estimate Catalog)'
                                          : '(Production Catalog)'
                                        return (
                                          <li
                                            {...liProps}
                                            style={{
                                              ...style,
                                              display: 'flex',
                                              alignItems: 'center',
                                            }}
                                          >
                                            <Tooltip
                                              title={`${description} ${suffix}`}
                                            >
                                              <span
                                                style={{
                                                  flex: 1,
                                                  minWidth: 0,
                                                  display: 'block',
                                                  whiteSpace: 'nowrap',
                                                  overflow: 'hidden',
                                                  textOverflow: 'ellipsis',
                                                  color: isSplitOrder
                                                    ? theme.palette[
                                                        FacilityTypes.find(
                                                          (f) =>
                                                            f.id ===
                                                            option?.facility_id,
                                                        )?.color || 'primary'
                                                      ]?.main
                                                    : 'inherit',
                                                }}
                                              >
                                                {`${Name} ${suffix}`}
                                              </span>
                                            </Tooltip>
                                            <span style={{ display: 'none' }}>
                                              {option.name}
                                            </span>
                                          </li>
                                        )
                                      }}
                                      isOptionEqualToValue={() => false}
                                      // getOptionLabel={(option) => option.name ? option.name : ''}
                                      getOptionLabel={(option) => {
                                        const name = getCatalogAutocompleteDisplayName(option)
                                        const description = option?.isGroupAutocompleteChip
                                          ? option.group_description || ''
                                          : option.product_name || option.name || ''
                                        const suffix = option.isTrafficCatalog
                                          ? '(TC)'
                                          : option.inhouse === 5
                                          ? '(Client Owned Catalog)'
                                          : option.inhouse === 4
                                          ? '(In Stock Catalog)'
                                          : option.inhouse === 0
                                          ? '(Sub Contract)'
                                          : option.inhouse === 6
                                          ? '(Split Catalog)'
                                          : option.inhouse === 7
                                          ? '(Estimate Catalog)'
                                          : '(Production Catalog)'
                                        // return `${description} \u200B${name}`;
                                        return `${description} ${suffix} \u200B${name}`
                                      }}
                                      onInputChange={(
                                        event,
                                        newInputValue,
                                        reason,
                                      ) => {
                                        // Track the latest input value for production builds
                                        // This ensures filterOptions gets the latest inputValue even in optimized builds
                                        productInputValueRef.current =
                                          newInputValue || ''
                                        // Force re-render by clearing and setting input if needed
                                        if (reason === 'input') {
                                          // Input changed, ensure component updates
                                        }
                                      }}
                                      filterOptions={(options, { inputValue }) => {
                                        // Always use ref value as primary source for production builds
                                        // The inputValue parameter can be stale in production builds
                                        const currentInput =
                                          productInputValueRef.current ||
                                          (inputValue !== undefined &&
                                          inputValue !== null
                                            ? inputValue
                                            : '')
                                        const searchText = (currentInput || '')
                                          .toString()
                                          .trim()
                                          .toLowerCase()

                                        // If no search text, return all options
                                        if (!searchText) return options

                                        // Filter options based on search text
                                        return options.filter((option) => {
                                          const nameMatch = option.name
                                            ?.toLowerCase()
                                            .includes(searchText)
                                          const descMatch = option.description
                                            ?.toLowerCase()
                                            .includes(searchText)
                                          const tagsMatch = String(option.tags ?? '')
                                            .toLowerCase()
                                            .includes(searchText)
                                            const idMatch = option.id?.toString()
                                            .includes(searchText)
                                          return nameMatch || descMatch || idMatch || tagsMatch
                                        })
                                      }}
                                      renderTags={(value, getTagProps) =>
                                        value.map((option, index) => {
                                          const name = getCatalogAutocompleteDisplayName(option)
                                          const suffix = option.isTrafficCatalog
                                            ? '(TC)'
                                            : option.inhouse === 5
                                            ? '(Client Owned Catalog)'
                                            : option.inhouse === 4
                                            ? '(In Stock Catalog)'
                                            : option.inhouse === 0
                                            ? '(Sub Contract)'
                                            : option.inhouse === 6
                                            ? '(Split Catalog)'
                                            : option.inhouse === 7
                                            ? '(Estimate Catalog)'
                                            : '(Production Catalog)'
                                          return (
                                            <Tooltip
                                              key={
                                                option?.isGroupAutocompleteChip
                                                  ? `grp-chip-${option.group_id}`
                                                  : `prod-chip-${option.indexId ?? index}`
                                              }
                                              title={getCatalogAutocompleteTooltip(option, suffix)}
                                            >
                                              <Chip
                                                sx={{
                                                  color: isSplitOrder
                                                    ? theme.palette[
                                                        FacilityTypes.find(
                                                          (f) =>
                                                            f.id ===
                                                            option?.facility_id,
                                                        )?.color || 'primary'
                                                      ]?.main
                                                    : 'inherit',
                                                }}
                                                {...getTagProps({ index })}
                                                label={`${name} ${suffix}`}
                                              />
                                            </Tooltip>
                                          )
                                        })
                                      }
                                    />
                                    {(() => {
                                      // Hide Catalog Type field when project category is Build Order (id 15)
                                      const categoryId = values?.project_category?.id;
                                      const isBuildOrder = categoryId === 15;
                                      
                                      // Don't show Catalog Type for Build Order
                                      if (isBuildOrder) {
                                        return null;
                                      }
                                      
                                      // For normal orders: remove split_catalog, add sub_contract (keep production_catalog and estimate_catalog)
                                      const filteredCatalogTypes = splitOrderCatalogTypes
                                        .filter(type => type.id !== 'split_catalog')
                                        .concat([{ id: 'sub_contract', label: 'Sub Contract', inhouse: 0, isTrafficCatalog: false }])
                                        .sort((a, b) => {
                                          // Keep "All" at the top, then sort rest alphabetically
                                          if (a.id === 'all') return -1;
                                          if (b.id === 'all') return 1;
                                          return a.label.localeCompare(b.label);
                                        });
                                      
                                      return (
                                        <Autocomplete
                                          sx={{ width: '20%' }}
                                          id="normal-catalog-type"
                                          options={filteredCatalogTypes}
                                          value={values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')}
                                          onChange={(event, newValue) => {
                                            const finalValue = newValue || splitOrderCatalogTypes.find((type) => type.id === 'all')
                                            setFieldValue('split_catalog_type', finalValue)
                                            console.log('Normal catalog type changed:', finalValue)
                                          }}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label="Catalog Type"
                                              placeholder="Select catalog type"
                                            />
                                          )}
                                          getOptionLabel={(option) => option.label}
                                        />
                                      );
                                    })()}
                                    {isPreview ? '' :
                                      <Button variant='outlined'
                                        onClick={()=>{
                                          setOpenCatalogModal(true);
                                          setSelectedProductForCatalog(null);
                                        }}
                                        startIcon={
                                          <Stack>{' '}<Add />{' '}</Stack>
                                        }
                                      >
                                        Add Estimate Catalog
                                      </Button>
                                    }
                                  </Stack>
                                )}
                              </Stack>
                                <Modal
                                  modalTitle={selectedProductForCatalog?.addExistingEstimateCatalog ? (`${selectedProductForCatalog?.is_edit_catalog ? 'Choose Estimate Catalog' : 'Choose Estimate Catalog'}` ) : "Add Estimate Catalog"}
                                  open={openCatalogModal}
                                  handleClose={async () => {
                                    setOpenCatalogModal(false);
                                    setSelectedGroupIdForCatalog(null);
                                    // await refreshProducts();
                                  }}
                                  width={1000}
                                >
                                   <AddProducts
                                    fromSplitEstimate={false}
                                    modalInhouse={7}
                                    modalSelectedTab={'estimate_catalog'}
                                    modalIsTrafficCatalog={false}
                                    modalTimeAndMaterial={false}
                                    onClose={async(addedProductId,isExisting, addedProductData) => {
                                      setOpenCatalogModal(false);
                                      if(addedProductId){
                                        // Track newly created estimate catalogs for this edit session
                                        if (!isExisting) {
                                          const newId = parseInt(addedProductId, 10)
                                          if (Number.isFinite(newId) && newId > 0) {
                                            const existing = sessionNewEstimateCatalogIdsRef.current || []
                                            if (!existing.includes(newId)) {
                                              sessionNewEstimateCatalogIdsRef.current = [...existing, newId]
                                            }
                                          }
                                        }
                                        let updatedProducts = null;
                                        if (selectedGroupIdForCatalog) {
                                          // Delete the group — it was only created for catalog creation
                                          const del = handleDeleteGroup(selectedGroupIdForCatalog)
                                          updatedProducts = del.remainingProducts
                                          const insertAt = del.catalogInsertIndex
                                          const anchorIndexId = del.catalogAnchorIndexId
                                          setSelectedGroupIdForCatalog(null);
                                          // Clear selectedProductForCatalog so refreshProducts merges
                                          // the new catalog by list position + anchor indexId (not replace-by-indexId).
                                          setSelectedProductForCatalog(null);
                                          await refreshProducts(
                                            addedProductId,
                                            false,
                                            isExisting,
                                            updatedProducts,
                                            insertAt,
                                            anchorIndexId,
                                            addedProductData
                                          );
                                        } else {
                                          await refreshProducts(addedProductId, false, isExisting, null, null, null, addedProductData);
                                        }
                                      } else {
                                        setSelectedGroupIdForCatalog(null);
                                      }
                                    }}
                                    productName={selectedProductForCatalog ? (selectedProductForCatalog?.product_name || selectedProductForCatalog?.name) : ''}
                                    // RecipeId={selectedProductForCatalog?.recipe_id ?? null}
                                    RecipeId={null}
                                    fromRecipeList={true}
                                    selectedProductForCatalog={selectedProductForCatalog}
                                    allProducts={allProducts}
                                    isFromEstimateJob={true}
                                    currentCatalogId={selectedProductForCatalog?.id || selectedProductForCatalog?.product_id || selectedProductForCatalog?.catalogId || null}
                                    estimateRequestId={id || null}
                                  />
                                </Modal>
                                <Dialog
                                  open={openChooseProductDialog}
                                  onClose={() => {
                                    setOpenChooseProductDialog(false)
                                    setChooseProductDialogRow(null)
                                    setChooseProductDialogValue(null)
                                  }}
                                  maxWidth="md"
                                  fullWidth
                                  disableScrollLock
                                >
                                  <DialogTitle>Select Product</DialogTitle>
                                  <DialogContent>
                                    <Stack spacing={2} sx={{ mt: 1 }}>
                                      <Autocomplete
                                        sx={{ width: '100%' }}
                                        options={filteredProductOptions || []}
                                        value={chooseProductDialogValue}
                                        onChange={(event, newValue) =>
                                          setChooseProductDialogValue(newValue)
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Select a product"
                                          />
                                        )}
                                        getOptionLabel={(option) => {
                                          const name =
                                            option?.product_name || option?.name || ''
                                          const description =
                                            option?.name || option?.description || ''
                                          const suffix = option?.isTrafficCatalog
                                            ? '(TC)'
                                            : option?.inhouse === 5
                                            ? '(Client Owned Catalog)'
                                            : option?.inhouse === 4
                                            ? '(In Stock Catalog)'
                                            : option?.inhouse === 0
                                            ? '(Sub Contract)'
                                            : option?.inhouse === 6
                                            ? '(Split Catalog)'
                                            : option?.inhouse === 7
                                            ? '(Estimate Catalog)'
                                            : '(Production Catalog)'
                                          return `${description} ${suffix} \u200B${name}`
                                        }}
                                        isOptionEqualToValue={(option, value) => {
                                          const oId = option?.id ?? option?.product_id
                                          const vId = value?.id ?? value?.product_id
                                          if (oId == null || vId == null) return false
                                          if (Number(oId) !== Number(vId)) return false
                                          return String(option?.facility_id ?? '') === String(value?.facility_id ?? '')
                                        }}
                                      />
                                      {(() => {
                                        const categoryId = values?.project_category?.id
                                        if (categoryId === 15) return null
                                        const filteredCatalogTypes = getNormalCatalogTypeOptions()
                                        return (
                                          <Autocomplete
                                            sx={{ width: '100%' }}
                                            id="choose-row-catalog-type"
                                            options={filteredCatalogTypes}
                                            value={
                                              values.split_catalog_type ||
                                              splitOrderCatalogTypes.find(
                                                (type) => type.id === 'all',
                                              )
                                            }
                                            onChange={(event, newValue) => {
                                              const finalValue =
                                                newValue ||
                                                splitOrderCatalogTypes.find(
                                                  (type) => type.id === 'all',
                                                )
                                              setFieldValue(
                                                'split_catalog_type',
                                                finalValue,
                                              )
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                label="Catalog Type"
                                                placeholder="Select catalog type"
                                              />
                                            )}
                                            getOptionLabel={(option) =>
                                              option?.label || ''
                                            }
                                          />
                                        )
                                      })()}
                                    </Stack>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button
                                      onClick={() => {
                                        setOpenChooseProductDialog(false)
                                        setChooseProductDialogRow(null)
                                        setChooseProductDialogValue(null)
                                      }}
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      variant="contained"
                                      onClick={handleConfirmChooseProductDialog}
                                    >
                                      Apply
                                    </Button>
                                  </DialogActions>
                                </Dialog>
                                <Dialog
                                  open={openChooseServiceDialog}
                                  onClose={() => {
                                    setOpenChooseServiceDialog(false)
                                    setChooseServiceDialogRow(null)
                                    setChooseServiceDialogValue(null)
                                  }}
                                  maxWidth="md"
                                  fullWidth
                                  disableScrollLock
                                >
                                  <DialogTitle>
                                    {chooseServiceDialogRow?.id
                                      ? 'Change Service'
                                      : 'Select Service'}
                                  </DialogTitle>
                                  <DialogContent>
                                    <Stack spacing={2} sx={{ mt: 1 }}>
                                      <Autocomplete
                                        sx={{ width: '100%' }}
                                        options={chooseServiceDialogOptions}
                                        value={chooseServiceDialogValue}
                                        onChange={(event, newValue) =>
                                          setChooseServiceDialogValue(newValue)
                                        }
                                        isOptionEqualToValue={(option, value) =>
                                          option?.id === value?.id
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            required
                                            label={
                                              details?.is_request_estimate == 1
                                                ? 'Select services'
                                                : 'Select additional services'
                                            }
                                          />
                                        )}
                                        getOptionLabel={(option) =>
                                          option?.name
                                            ? `${option.name} (${getLabourCostServiceTabLabel(option.inhouse)})`
                                            : ''
                                        }
                                        filterOptions={(options, state) => {
                                          const searchText =
                                            state.inputValue.toLowerCase()
                                          return options.filter(
                                            (option) =>
                                              Number(option.inhouse) !== 1 &&
                                              (option.name
                                                .toLowerCase()
                                                .includes(searchText) ||
                                                (option.description &&
                                                  option.description
                                                    .toLowerCase()
                                                    .includes(searchText))),
                                          )
                                        }}
                                      />
                                    </Stack>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button
                                      onClick={() => {
                                        setOpenChooseServiceDialog(false)
                                        setChooseServiceDialogRow(null)
                                        setChooseServiceDialogValue(null)
                                      }}
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      variant="contained"
                                      onClick={handleConfirmChooseServiceDialog}
                                    >
                                      Apply
                                    </Button>
                                  </DialogActions>
                                </Dialog>
                                <Modal
                                  modalTitle="Edit Estimate Catalog"
                                  open={openEditCatalogModal}
                                  handleClose={async () => {
                                    setOpenEditCatalogModal(false);
                                    setChangeCatalog(false);
                                    // await refreshProducts();
                                  }}
                                  width={1000}
                                >
                                  <Editproduct
                                    fromSplitEstimate={false}
                                    modalInhouse={7}
                                    modalSelectedTab={'estimate_catalog'}
                                    changeCatalog={changeCatalog}
                                    modalIsTrafficCatalog={false}
                                    modalTimeAndMaterial={false}
                                    onClose={async(editedProductId, isExisting, editedProductData) => {
                                      setOpenEditCatalogModal(false);
                                      if(editedProductId){
                                        await refreshProducts(editedProductId, true, false, null, null, null, editedProductData);
                                      }
                                    }}
                                    productName={selectedProductForCatalog ? (selectedProductForCatalog?.product_name || selectedProductForCatalog?.name) : ''}
                                    RecipeId={null}
                                    fromRecipeList={true}
                                    selectedProductForCatalog={selectedProductForCatalog}
                                    editProduct={true}
                                  />
                                </Modal>
                                <Dialog
                                  open={openProductCatalogChoiceModal}
                                  onClose={() => {
                                    setOpenProductCatalogChoiceModal(false)
                                    setProductRowForCatalogChoice(null)
                                  }}
                                  maxWidth="xs"
                                  fullWidth
                                  disableScrollLock
                                >
                                  <DialogTitle>Catalog action</DialogTitle>
                                  <DialogContent>
                                    <DialogContentText>
                                      Choose how to update this line: add or
                                      replace from catalog, or edit the current
                                      selection.
                                    </DialogContentText>
                                    <Stack spacing={1.5} sx={{ mt: 2 }}>
                                      {productRowForCatalogChoice?.is_existing_catalog ==
                                        1 && (
                                        <Button
                                          fullWidth
                                          variant="outlined"
                                          onClick={() => {
                                            const row =
                                              productRowForCatalogChoice
                                            setOpenProductCatalogChoiceModal(
                                              false,
                                            )
                                            setProductRowForCatalogChoice(null)
                                            if (!row) return
                                            setSelectedProductForCatalog({
                                              ...row,
                                              catalogRepickMode: true,
                                            })
                                            setOpenCatalogModal(true)
                                          }}
                                        >
                                          Add Estimate Catalog
                                        </Button>
                                      )}
                                      {productRowForCatalogChoice?.is_existing_catalog !=
                                        1 && (
                                        <Button
                                          fullWidth
                                          variant="outlined"
                                          onClick={() => {
                                            const row =
                                              productRowForCatalogChoice
                                            setOpenProductCatalogChoiceModal(
                                              false,
                                            )
                                            setProductRowForCatalogChoice(null)
                                            if (!row) return
                                            setSelectedProductForCatalog({
                                              ...row,
                                              addExistingEstimateCatalog: true,
                                              catalogRepickMode: true,
                                            })
                                            setOpenCatalogModal(true)
                                          }}
                                        >
                                          {/* Add Existing */}
                                          Choose Catalog
                                        </Button>
                                      )}
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                          const row = productRowForCatalogChoice
                                          setOpenProductCatalogChoiceModal(false)
                                          setProductRowForCatalogChoice(null)
                                          if (!row) return
                                          if (row?.is_existing_catalog == 1) {
                                            setOpenCatalogModal(true)
                                            setSelectedProductForCatalog({
                                              ...row,
                                              addExistingEstimateCatalog: true,
                                              is_edit_catalog: true,
                                            })
                                          } else {
                                            setSelectedProductForCatalog(row)
                                            setOpenEditCatalogModal(true)
                                          }
                                        }}
                                      >
                                       {productRowForCatalogChoice?.is_existing_catalog == 1 ? 'Choose Catalog' : 'Edit Catalog'}
                                      </Button>
                                    </Stack>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button
                                      onClick={() => {
                                        setOpenProductCatalogChoiceModal(false)
                                        setProductRowForCatalogChoice(null)
                                      }}
                                    >
                                      Cancel
                                    </Button>
                                  </DialogActions>
                                </Dialog>
                                <Dialog
                                  open={openServiceCatalogChoiceModal}
                                  onClose={() => {
                                    setOpenServiceCatalogChoiceModal(false)
                                    setServiceRowForCatalogChoice(null)
                                  }}
                                  maxWidth="xs"
                                  fullWidth
                                >
                                  <DialogTitle>Service action</DialogTitle>
                                  <DialogContent>
                                    <DialogContentText>
                                      {/* Choose how to update this line: add or
                                      replace from the service list, or edit the
                                      current service. */}
                                    </DialogContentText>
                                    <Stack spacing={1.5} sx={{ mt: 2 }}>
                                      {/* {Boolean(
                                        serviceRowForCatalogChoice?.is_existing_service,
                                      ) && (
                                        <Button
                                          fullWidth
                                          variant="outlined"
                                          onClick={() => {
                                            const row =
                                              serviceRowForCatalogChoice
                                            setOpenServiceCatalogChoiceModal(
                                              false,
                                            )
                                            setServiceRowForCatalogChoice(null)
                                            if (!row) return
                                            setSelectedServiceForCatalog({
                                              ...row,
                                              is_existing_service: false,
                                              serviceRepickMode: true,
                                              estimateJobAddServiceChoice: true,
                                            })
                                            setServiceNameForAdd(
                                              row.service_name ||
                                                row.name ||
                                                '',
                                            )
                                            setServiceDescForAdd(
                                              row.service_desc || '',
                                            )
                                            setOpenEditServiceModal(false)
                                            setOpenServiceModal(true)
                                          }}
                                        >
                                          Add Service
                                        </Button>
                                      )} */}
                                      {!serviceRowForCatalogChoice?.is_existing_service && (
                                        <Button
                                          fullWidth
                                          variant="outlined"
                                          onClick={() => {
                                            const row =
                                              serviceRowForCatalogChoice
                                            setOpenServiceCatalogChoiceModal(
                                              false,
                                            )
                                            setServiceRowForCatalogChoice(null)
                                            if (!row) return
                                            setSelectedServiceForCatalog({
                                              ...row,
                                              is_existing_service: true,
                                              serviceRepickMode: true,
                                            })
                                            setServiceNameForAdd(
                                              row.service_name ||
                                                row.name ||
                                                '',
                                            )
                                            setServiceDescForAdd(
                                              row.service_desc || '',
                                            )
                                            setOpenEditServiceModal(false)
                                            setOpenServiceModal(true)
                                          }}
                                        >
                                          {/* Add Existing */}
                                          Choose Service
                                        </Button>
                                      )}
                                      <Button
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                          const row = serviceRowForCatalogChoice
                                          setOpenServiceCatalogChoiceModal(false)
                                          setServiceRowForCatalogChoice(null)
                                          if (!row) return
                                          if (row?.is_existing_service) {
                                            setOpenServiceModal(true)
                                            setSelectedServiceForCatalog(row)
                                            setOpenEditServiceModal(false)
                                            setServiceNameForAdd(null)
                                            setServiceDescForAdd(null)
                                          } else {
                                            setOpenServiceModal(true)
                                            setSelectedServiceForCatalog(row)
                                            setOpenEditServiceModal(true)
                                            setServiceNameForAdd(null)
                                            setServiceDescForAdd(null)
                                          }
                                        }}
                                      >
                                        {
                                          serviceRowForCatalogChoice?.is_existing_service ? 'Choose Service' : 'Edit Service'
                                        }
                                        {/* Edit Existing */}
                                      </Button>
                                    </Stack>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button
                                      onClick={() => {
                                        setOpenServiceCatalogChoiceModal(false)
                                        setServiceRowForCatalogChoice(null)
                                      }}
                                    >
                                      Cancel
                                    </Button>
                                  </DialogActions>
                                </Dialog>
                                <Modal
                                  modalTitle={selectedServiceForCatalog?.is_existing_service ? 'Add Existing Service' : 'Add Service'}
                                  open={openServiceModal}
                                  handleClose={async () => {
                                    setOpenServiceModal(false);
                                    setOpenEditServiceModal(false);
                                    setOpenServiceCatalogChoiceModal(false);
                                    setServiceRowForCatalogChoice(null);
                                    setServiceNameForAdd(null);
                                    setSelectedServiceForCatalog(null);
                                    setServiceDescForAdd(null)
                                  }}
                                  width={1000}
                                >
                                  <LabourCostList
                                    onClose={async (addedServiceId, catalogRowFromModal) => {
                                      setOpenServiceModal(false);
                                      setOpenServiceCatalogChoiceModal(false);
                                      setServiceRowForCatalogChoice(null);
                                      setServiceNameForAdd(null);
                                      setServiceDescForAdd(null)
                                      setOpenEditServiceModal(false);
                                      if (addedServiceId) {
                                        await refreshServices(
                                          addedServiceId,
                                          catalogRowFromModal ?? selectedServiceForCatalog,
                                        )
                                      }
                                    }}
                                    fromEstimateJob={true}
                                    setOpenServiceModal={setOpenServiceModal}
                                    serviceNameForAdd={openEditServiceModal ? null :serviceNameForAdd}
                                    serviceDescForAdd={openEditServiceModal ? null :serviceDescForAdd}
                                    selectedServiceForCatalog={
                                      openEditServiceModal ||
                                      selectedServiceForCatalog?.is_existing_service ||
                                      selectedServiceForCatalog?.serviceRepickMode
                                        ? selectedServiceForCatalog
                                        : null
                                    }
                                    setSelectedServiceForCatalog={setSelectedServiceForCatalog}
                                    openEditServiceModal={openEditServiceModal}
                                    filteredServices={filteredServices}
                                  />
                                </Modal>
                              {loadingProducts ? '' : <>
                              {renderGroupDialogs()}
                              <LabelStyle>Selected Products</LabelStyle>
                              {(() => {
                                const isAnyGroupInEditMode = Object.values(groupEditMode || {}).some(Boolean)
                                const validSelectedIds = getValidUngroupedSelectionIds(
                                  selectedProducts,
                                  groupSelectedProductIds,
                                )
                                const hasExistingGroups = (selectedProducts || []).some((p) => p.group_id)
                                if (!openEdit) return null
                                if (validSelectedIds.length === 0 || isAnyGroupInEditMode) return null

                                return (
                                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 1 }}>
                                    {validSelectedIds.length > 1 && (
                                      <Button variant="outlined" size="small" onClick={handleCreateGroupFromSelection}>
                                        Group Selected Products
                                      </Button>
                                    )}
                                    {hasExistingGroups && (
                                      <Button variant="outlined" size="small" onClick={() => setOpenAddToGroupModal(true)}>
                                        Add to Existing Group
                                      </Button>
                                    )}
                                  </Box>
                                )
                              })()}
                              <Scrollbar>
                                <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                    <TableHead>
                                      <TableRow>
                                        {openEdit && !isPreview && (
                                          <TableCell padding="checkbox" sx={{ width: 40 }} />
                                        )}
                                        <TableCell padding="checkbox" />
                                        {VALUE?.map((val) =>
                                          val.id === 10 ? (
                                            <Tooltip
                                              key={val.id}
                                              title="Product Formula Cost Per Unit * Quantity"
                                            >
                                              <TableCell>{val.value}</TableCell>
                                            </Tooltip>
                                          ) : val.id === 14 ? (
                                            <Tooltip
                                              key={val.id}
                                              title="Selling Price With Marketing Adjustment"
                                            >
                                              <TableCell>{val.value}</TableCell>
                                            </Tooltip>
                                          ) : val.id === 20 ? (
                                            // Markup column - only show for non-split orders
                                            !isSplitOrder ? (
                                              <TableCell key={val.id}>
                                                {val.value}
                                              </TableCell>
                                            ) : null
                                          ) : val.id === 16 ? (
                                            // Conditionally show Incoming Percentage column
                                            isSplitOrder ? (
                                              <TableCell key={val.id}>
                                                {val.value}
                                              </TableCell>
                                            ) : null
                                          ) : (
                                            <TableCell key={val.id}>
                                              {val.value}
                                            </TableCell>
                                          ),
                                        )}
                                        {/* {VALUE?.map((val) => (
                                  <TableCell>{val.value}</TableCell>
                                ))} */}
                                      </TableRow>
                                    </TableHead>
                                    <DragDropContext onDragEnd={handleProductTableDragEnd}>
                                      <Droppable droppableId="estimate-product-rows">
                                        {(droppableProvided) => (
                                          <TableBody
                                            ref={droppableProvided.innerRef}
                                            {...droppableProvided.droppableProps}
                                          >
                                      {productTableBodyRenderOrder.map((bodyItem, index) => {
                                        if (bodyItem.type === 'group') {
                                          const group = groupedProductsMap.get(bodyItem.groupId)
                                          if (!group) return null
                                          const isGroupOpen = openGroupedRows[group.id] === true
                                          const groupAttachmentIndexId = getGroupAnchorIndexId(group)
                                          const groupAttachmentKey = String(groupAttachmentIndexId ?? '')
                                          const groupAnchorProduct =
                                            (group.products || []).find(
                                              (p) =>
                                                Number(p?.indexId) ===
                                                Number(groupAttachmentIndexId),
                                            ) || (group.products || [])[0]
                                          const groupMemberProducts = (selectedProducts || []).filter(
                                            (p) => String(p?.group_id) === String(group.id),
                                          )
                                          const groupDisplayNote =
                                            groupMemberProducts.find(
                                              (p) =>
                                                p?.product_notes != null &&
                                                String(p.product_notes).trim() !== '',
                                            )?.product_notes || ''
                                          const {
                                            isGroupProductLosingMoney,
                                            isGroupInstallLosingMoney,
                                          } = getGroupLosingMoneyFlags(group)
                                          const groupProductLosingMoneyRowSx = getLosingMoneyRowSx(
                                            isGroupProductLosingMoney,
                                          )
                                          const groupInstallLosingMoneyRowSx = getLosingMoneyRowSx(
                                            isGroupInstallLosingMoney,
                                          )
                                          return (
                                            <Draggable
                                              key={`group-${group.id}`}
                                              draggableId={`group-${group.id}`}
                                              index={index}
                                              isDragDisabled={isPreview || !openEdit}
                                            >
                                              {(provided, snapshot) => (
                                            <React.Fragment>
                                              <TableRow
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                onDragOver={(e) =>
                                                  groupAttachmentIndexId != null &&
                                                  handleProductIconDragOver(e, groupAttachmentIndexId)
                                                }
                                                onDragLeave={(e) =>
                                                  groupAttachmentIndexId != null &&
                                                  handleProductIconDragLeave(e, groupAttachmentIndexId)
                                                }
                                                onDrop={(e) =>
                                                  groupAttachmentIndexId != null &&
                                                  handleProductIconDrop(e, groupAttachmentIndexId)
                                                }
                                                sx={{
                                                  ...(groupProductLosingMoneyRowSx || groupInstallLosingMoneyRowSx),
                                                  ...(groupAttachmentIndexId != null &&
                                                    productAttachmentDragOver[groupAttachmentIndexId] && {
                                                      backgroundColor: 'action.hover',
                                                      outline: `2px dashed ${theme.palette.primary.main}`,
                                                      outlineOffset: -2,
                                                    }),
                                                }}
                                                style={{
                                                  ...provided.draggableProps.style,
                                                  ...(snapshot.isDragging
                                                    ? {
                                                        backgroundColor:
                                                          theme.palette.action.hover,
                                                      }
                                                    : {}),
                                                }}
                                              >
                                                {openEdit && !isPreview && (
                                                  <TableCell
                                                    padding="checkbox"
                                                    {...provided.dragHandleProps}
                                                    sx={{ width: 40, cursor: 'grab' }}
                                                  >
                                                    <DragIndicator fontSize="small" color="action" />
                                                  </TableCell>
                                                )}
                                                <TableCell padding="checkbox">
                                                  <IconButton
                                                    size="small"
                                                    color="primary"
                                                    sx={{ color: 'primary.main' }}
                                                    onClick={() =>
                                                      setOpenGroupedRows((prev) => ({
                                                        ...prev,
                                                        [group.id]: !(prev?.[group.id] === true),
                                                      }))
                                                    }
                                                  >
                                                    {isGroupOpen ? <Remove /> : <Add />}
                                                  </IconButton>
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: 700 }}>#{index + 1}</TableCell>
                                                <TableCell sx={{ fontWeight: 700 }}/>
                                                <TableCell sx={{ fontWeight: 700, fontSize: '0.95rem', minWidth: 140 }}>
                                                  <Box>
                                                    {groupEditMode?.[group.id] ? (
                                                      <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        value={group.name || ''}
                                                        onChange={(e) =>
                                                          handleGroupFieldChange(group.id, 'name', e.target.value)
                                                        }
                                                        sx={{ minWidth: 120 }}
                                                      />
                                                    ) : (
                                                      <Typography
                                                        sx={{
                                                          fontWeight: 700,
                                                          fontSize: '0.95rem',
                                                        }}
                                                      >
                                                        {group.name || 'Group'}
                                                      </Typography>
                                                    )}
                                                    {groupDisplayNote ? (
                                                      <Typography sx={{ color: 'red' }}>
                                                        Note:{' '}
                                                        {groupDisplayNote}
                                                      </Typography>
                                                    ) : null}
                                                  </Box>
                                                </TableCell>
                                                <TableCell>
                                                  {groupAttachmentIndexId != null ? (
                                                    <IconButton
                                                      data-preview-allow
                                                      onClick={() =>
                                                        handleOpenGroupNote(
                                                          groupAttachmentIndexId,
                                                          groupDisplayNote || '',
                                                        )
                                                      }
                                                    >
                                                      <NoteAdd
                                                        sx={{
                                                          color:
                                                            !groupDisplayNote
                                                              ? ''
                                                              : theme.palette.primary.main,
                                                        }}
                                                      />
                                                    </IconButton>
                                                  ) : null}
                                                </TableCell>
                                                <TableCell>
                                                  {groupAttachmentIndexId != null ? (
                                                    <Tooltip title="Drop files on row or click to open attachments">
                                                      <IconButton
                                                        data-preview-allow
                                                        onClick={() => handleOpenAttachment(groupAttachmentIndexId)}
                                                      >
                                                        {isUploadingProduct[String(groupAttachmentIndexId)] ? (
                                                          <CircularProgress size={34} />
                                                        ) : (
                                                          <UploadFile
                                                            sx={{
                                                              color:
                                                                getProductAttachmentsList(
                                                                  groupAttachmentIndexId,
                                                                ).length === 0
                                                                  ? 'error.main'
                                                                  : theme.palette.primary.main,
                                                            }}
                                                          />
                                                        )}
                                                      </IconButton>
                                                    </Tooltip>
                                                  ) : null}
                                                </TableCell>
                                                {/* <TableCell align="center" sx={{ fontWeight: 600 }}> 
                                                  <Button variant='outlined'
                                                    onClick={() => {
                                                      addGroupcatalogeProducts(group);
                                                      // mergeGroup(group);
                                                    }}
                                                    startIcon={
                                                      <Stack>{' '}<MergeType />{' '}</Stack>
                                                    }
                                                  >
                                                    Merge Group
                                                  </Button>
                                                </TableCell> */}
                                                <TableCell align="center" sx={{ fontWeight: 600 }}>

                                                </TableCell>
                                                <TableCell align="center" sx={{ fontWeight: 600 }}>

                                                </TableCell>
                                                <TableCell sx={{ minWidth: 160 }}>
                                                  {groupEditMode?.[group.id] ? (
                                                    <TextField
                                                      variant="outlined"
                                                      size="small"
                                                      fullWidth
                                                      multiline
                                                      value={group.description || ''}
                                                      placeholder="Description"
                                                      onChange={(e) =>
                                                        handleGroupFieldChange(group.id, 'description', e.target.value)
                                                      }
                                                      sx={{ minWidth: 120 }}
                                                    />
                                                  ) : (
                                                    <Typography variant="body2" color="textSecondary">
                                                      {group.description || 'No description'}
                                                    </Typography>
                                                  )}
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: 600 }}>
                                                  {Number(group.baseProductFormulaEach || 0).toFixed(2)}
                                                </TableCell>
                                                <TableCell align="center" sx={{ fontWeight: 600 }}>
                                                  -
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: 600 }}>
                                                  {hasMarkupPermission && markupType == 2
                                                    ? Number(group.adjustedGroupRetailEach || 0).toFixed(2)
                                                    : null}
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: 600 }}>
                                                  {hasMarkupPermission && markupType == 1
                                                    ? Number(group.adjustedGroupRetailEach || 0).toFixed(2)
                                                    : null}
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: 600 }}>
                                                  <TextField
                                                    type="number"
                                                    size="small"
                                                    fullWidth
                                                    label="Qty"
                                                    value={Number(group.groupQuantity || 1)}
                                                    onKeyPress={(event) => {
                                                      if (
                                                        (event.key === '0' && event.target.value === '') ||
                                                        event.key === '-' ||
                                                        event.key === '.'
                                                      ) {
                                                        event.preventDefault()
                                                      }
                                                    }}
                                                    onChange={(event) =>
                                                      handleGroupQuantityChange(group.id, event.target.value)
                                                    }
                                                  />
                                                </TableCell>
                                                <TableCell align="center" sx={{ fontWeight: 600, width: 90 }}>
                                                  <IconButton
                                                    color="primary"
                                                    onClick={() =>
                                                      setGroupLocationStates((prev) => ({
                                                        ...prev,
                                                        [group.id]: true,
                                                      }))
                                                    }
                                                  >
                                                    <LocationOn
                                                      sx={{
                                                        color: (group.groupAddresses || []).some((obj) =>
                                                          [obj.address, obj.city, obj.state, obj.zip].some(
                                                            (value) => value === '' || value === null,
                                                          ),
                                                        )
                                                          ? ''
                                                          : theme.palette.primary.main,
                                                      }}
                                                    />
                                                  </IconButton>
                                                </TableCell>
                                                <TableCell sx={{ color: 'text.secondary', width: 150 }}>
                                                  <Stack
                                                    direction="row"
                                                    spacing={1}
                                                    alignItems="center"
                                                    justifyContent="center"
                                                  >
                                                    <Remove
                                                      fontSize="small"
                                                      style={{ cursor: 'pointer' }}
                                                      onClick={() =>
                                                        handleGroupMarketingTypeChange(
                                                          group.id,
                                                          false,
                                                          group.totalProductFormulaEach,
                                                          group.totalProductRetailEach,
                                                          group.groupAdjustment,
                                                        )
                                                      }
                                                    />
                                                    <FormControlLabel
                                                      control={
                                                        <Switch
                                                          checked={
                                                            group.groupAdjValueType !== false &&
                                                            group.groupAdjValueType !== 0
                                                          }
                                                          onChange={(event) =>
                                                            handleGroupMarketingTypeChange(
                                                              group.id,
                                                              event.target.checked,
                                                              group.totalProductFormulaEach,
                                                              group.totalProductRetailEach,
                                                              group.groupAdjustment,
                                                            )
                                                          }
                                                        />
                                                      }
                                                      label=""
                                                    />
                                                    <Add
                                                      fontSize="small"
                                                      style={{ cursor: 'pointer' }}
                                                      onClick={() =>
                                                        handleGroupMarketingTypeChange(
                                                          group.id,
                                                          true,
                                                          group.totalProductFormulaEach,
                                                          group.totalProductRetailEach,
                                                          group.groupAdjustment,
                                                        )
                                                      }
                                                    />
                                                  </Stack>
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: 600, width: 120 }}>
                                                  <TextField
                                                    type="number"
                                                    size="small"
                                                    fullWidth
                                                    inputProps={{ min: 0 }}
                                                    label="$"
                                                    InputLabelProps={{ shrink: true }}
                                                    value={getGroupProductMarketingAdjustmentDisplay(
                                                      groupProductMarketingValues?.[group.id] || {},
                                                      group.groupAdjustment,
                                                    )}
                                                    onWheel={(e) => e.target.blur()}
                                                    onBeforeInput={(e) => {
                                                      const nextValue = e.target.value
                                                      const adjValueType =
                                                        groupProductMarketingValues?.[group.id]?.adjValueType ??
                                                        group.groupAdjValueType ??
                                                        true
                                                      const isNegative =
                                                        adjValueType === false || Number(adjValueType) === 0
                                                      if (!isNegative) return
                                                      const hasMarketingPermission = explodedPermissions?.some((permission) =>
                                                        ['Allow Negative Marketing Adjustment Estimate'].includes(permission),
                                                      )
                                                      const formulaEach = Number(group.totalProductFormulaEach || 0)
                                                      const retailEach = Number(group.totalProductRetailEach || 0)
                                                      const maxNegative = hasMarketingPermission
                                                        ? retailEach
                                                        : Math.max(0, retailEach - formulaEach)
                                                      if (Number(nextValue) >= maxNegative && hasMarketingPermission) {
                                                        e.preventDefault()
                                                        enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                      } else if (Number(nextValue) > maxNegative && !hasMarketingPermission) {
                                                        e.preventDefault()
                                                        enqueueSnackbar(
                                                          `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
                                                          { variant: 'error' },
                                                        )
                                                      }
                                                    }}
                                                    onChange={(event) =>
                                                      handleGroupMarketingAdjustmentChange(
                                                        group.id,
                                                        event.target.value,
                                                        group.totalProductFormulaEach,
                                                        group.totalProductRetailEach,
                                                        group.groupAdjValueType,
                                                      )
                                                    }
                                                    onKeyDown={(event) => {
                                                      if (event.key === '-' || event.key === '+') {
                                                        event.preventDefault()
                                                      }
                                                      if (event.key === 'ArrowDown') {
                                                        const currentValue = parseFloat(event.target.value) || 0
                                                        const step = parseFloat(event.target.step) || 1
                                                        if (currentValue - step < 0) {
                                                          event.preventDefault()
                                                        }
                                                      }
                                                    }}
                                                  />
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: 600 }}>
                                                 ${fUSPrice(Number(group.adjustedGroupSubtotal || 0).toFixed(2))}
                                                </TableCell>
                                                <TableCell sx={{ fontWeight: 600 }}>
                                                  {Number(group.totalInstallSubtotal || 0) > 0
                                                    ? ''
                                                    : Number(group.adjustedGroupProductTotal || 0).toFixed(2)}
                                                </TableCell>
                                                <TableCell align="center" sx={QUOTATION_ROW_DELETE_CELL_SX}>
                                                  {openEdit && !isPreview ? (
                                                    <Box sx={QUOTATION_ROW_ACTIONS_BOX_SX}>
                                                      <Box sx={QUOTATION_ROW_ACTIONS_LEADING_SLOT_SX}>
                                                        <GroupEditActionButtons
                                                          isDesignTable={false}
                                                          isEditing={!!groupEditMode?.[group.id]}
                                                          onEdit={() => handleEstimateGroupEditClick(group)}
                                                          onUpdate={() => handleEstimateGroupUpdateClick(group)}
                                                          onCancel={() => handleEstimateGroupCancelEditClick(group)}
                                                        />
                                                      </Box>
                                                      <IconButton
                                                        color="error"
                                                        size="small"
                                                        onClick={() => handleDeleteGroup(group.id)}
                                                      >
                                                        <Delete />
                                                      </IconButton>
                                                    </Box>
                                                  ) : null}
                                                </TableCell>
                                              </TableRow>
                                              {renderGroupTableBelowSummaryRow(
                                                group,
                                                isGroupOpen,
                                                (groupInstallLosingMoneyRowSx||groupProductLosingMoneyRowSx),
                                              )}
                                              {groupAttachmentIndexId != null && (
                                                <>
                                                  <Modal
                                                    open={
                                                      openGroupProductNoteIndex ===
                                                      groupAttachmentIndexId
                                                    }
                                                    handleClose={() => {
                                                      setOpenGroupProductNoteIndex(null)
                                                      setCurrentNote('')
                                                    }}
                                                  >
                                                    <Grid
                                                      container
                                                      spacing={3}
                                                      sx={{
                                                        justifyContent: 'center',
                                                        width: '100%',
                                                      }}
                                                    >
                                                      <Grid item xs={12}>
                                                        <Typography variant="h5" sx={{ mb: 2 }}>
                                                          Note
                                                        </Typography>
                                                        <TextField
                                                          fullWidth
                                                          multiline
                                                          rows={4}
                                                          size="medium"
                                                          value={currentNote}
                                                          onChange={handleNoteChange}
                                                          {...getEstimatePreviewNoteFieldProps(isPreview)}
                                                          inputProps={{
                                                            maxLength: MAX_CHARACTERS,
                                                          }}
                                                          helperText={
                                                            isPreview
                                                              ? undefined
                                                              : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                          }
                                                          InputProps={{
                                                            sx: { color: 'error.main' },
                                                          }}
                                                        />
                                                      </Grid>
                                                    </Grid>
                                                    <EstimatePreviewNoteActions
                                                      isPreview={isPreview}
                                                      onClose={() => {
                                                        setOpenGroupProductNoteIndex(null)
                                                        setCurrentNote('')
                                                      }}
                                                    >
                                                    <Grid
                                                      container
                                                      justifyContent="center"
                                                      alignItems="center"
                                                    >
                                                      <Grid item xs={12} md={4}>
                                                        <Box
                                                          sx={{
                                                            mt: 3,
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            gap: 1,
                                                          }}
                                                        >
                                                          <LoadingButton
                                                            variant="contained"
                                                            onClick={() =>
                                                              handleSaveNote(groupAttachmentIndexId)
                                                            }
                                                            loading={isSavingNote}
                                                            disabled={!currentNote.trim()}
                                                          >
                                                            Save
                                                          </LoadingButton>
                                                          <LoadingButton
                                                            variant="outlined"
                                                            color="error"
                                                            onClick={() =>
                                                              handleClearNote(groupAttachmentIndexId)
                                                            }
                                                            loading={isClearingNote}
                                                            disabled={!currentNote.trim()}
                                                          >
                                                            Clear
                                                          </LoadingButton>
                                                        </Box>
                                                      </Grid>
                                                    </Grid>
                                                    </EstimatePreviewNoteActions>
                                                  </Modal>
                                                  <Modal
                                                    open={
                                                      openProductAttachment[
                                                        groupAttachmentIndexId
                                                      ] || false
                                                    }
                                                    handleClose={() =>
                                                      handleCloseAttachment(groupAttachmentIndexId)
                                                    }
                                                  >
                                                    {renderAttachmentModalContent({
                                                      itemKey: groupAttachmentKey,
                                                      tabValue:
                                                        attachmentTabValue[groupAttachmentIndexId],
                                                      onTabChange: handleAttachmentTabChange,
                                                      selectedImages:
                                                        selectedUploadedImages[
                                                          groupAttachmentKey
                                                        ] || [],
                                                      linkedAttachments: getProductAttachmentsList(
                                                      groupAttachmentIndexId,
                                                    ),
                                                      onImageSelect: handleImageSelect,
                                                      onAddSelected: handleAddSelectedImages,
                                                      onDrop: handleProductDrop,
                                                      onRemove: handleProductRemove,
                                                      isUploadingItem:
                                                        isUploadingProduct[
                                                          groupAttachmentIndexId
                                                        ] ||
                                                        isUploadingProduct[groupAttachmentKey] ||
                                                        false,
                                                    })}
                                                  </Modal>
                                                </>
                                              )}
                                            </React.Fragment>
                                              )}
                                            </Draggable>
                                          )
                                        }
                                        const data = selectedProducts.find(
                                          (p) => p.indexId === bodyItem.indexId,
                                        )
                                        if (!data) return null
                                        const quantityFieldName = `quantity_${data.product_id||data.id}`;
                                        const discountFieldName = `discount_${data.product_id||data.id}`;
                                        const adjustmentFieldName = `adjustment_${data.product_id || data.id}`;
                                        const IsInstall = data.install_cost ?? null
                                        console.log('dataaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',IsInstall)
                                        let unitName = UNITS?.filter((item)=>item?.id==data?.unit)
                                        unitName = unitName[0]?.name
                                        let shortUnitName = ''
                                        if(unitName=='Square feet'){
                                          shortUnitName = 'Sq ft'
                                        }else if(unitName=='Lineal feet'){
                                          shortUnitName = 'Lin ft'
                                        }else if(unitName=='Square Inches'){
                                          shortUnitName ='Sq Inches'
                                        }else if(unitName=='Unit'){
                                          shortUnitName = 'Unit'
                                        }
      
                                        // Split order calculation logic
                                        let incomingPercentage = data?.incoming_split_percentage || incomingSplitMarkup || 0;
                                        if(isSplitOrder && data?.facility_id !== currentFacilityId){
                                          const splitSetting = selectedSplitOrderSettings?.find(setting => setting?.id == data?.facility_id);
                                          let outgoingPercentage = data?.split_percentage || splitSetting?.split_percentage || 0;
                                          if (!data.originalExpectedCost) {
                                            data.originalExpectedCost = Number(data?.expected_cost)
                                          }
                                          
                                          let amountWithOutgoingPercentage = data.originalExpectedCost * (outgoingPercentage / 100)
                                          data.expected_cost = parseFloat(data.originalExpectedCost + amountWithOutgoingPercentage)
                                          let amountWithIncomingPercentage = data.expected_cost * (incomingPercentage / 100)
                                          data['actual_retail_price'] =data.expected_cost + amountWithIncomingPercentage
                                          data['retail_price'] =data?.actual_retail_price + data?.install_cost
                                          data['incoming_split_percentage'] =incomingPercentage || 0
                                          data['split_percentage'] =outgoingPercentage || 0
                                          data['outgoing_split_percentage'] =outgoingPercentage || 0
                                          }
      
      
                                        // ALL-815 backup - previous catalog price reset without retail_price_edited guard:
                                        // if(data.inhouse !== 1 || (data.inhouse ==1 && data.isTrafficCatalog == 1)){
                                        if((data.inhouse !== 1 || (data.inhouse ==1 && data.isTrafficCatalog == 1)) && !data.retail_price_edited){
                                          let price = data.max_price ? data.max_price : data.actual_retail_price
                                          const installCost = parseFloat(data?.install_cost) || 0
                                          data['actual_retail_price'] = price
                                          const calculatedRetailPrice = installCost > 0 ? price + installCost : price
                                          data['retail_price'] = calculatedRetailPrice
                                        }
                                        if(data.adj_value_type == null){
                                          data.adj_value_type = true
                                        }

                                        if (
                                          data.original_actual_retail_price == null &&
                                          data.original_product_retail_price == null
                                        ) {
                                          Object.assign(
                                            data,
                                            hydrateEstimateLineMarketingPrices(data),
                                          )
                                        }
                                        const signedProductAdj = getSignedMarketingAdjustment(data)
                                        const signedInstallAdj = getSignedInstallMarketingAdjustment(data)

                                        const syncedProduct = data?.is_product_row == 1
                                          ? data
                                          : getCatalogProductWithAdjustment(data)

                                        let dataActualRetail =
                                          data.actual_retail_price != null &&
                                          data.actual_retail_price !== ''
                                            ? Number(data.actual_retail_price)
                                            : getDisplayedActualRetail(syncedProduct)
                                        // Prefer product retail only; do not fall back to combined retail_price (actual + install)
                                        const installCostForRetailDisplay = parseFloat(data?.install_cost) || 0
                                        if (
                                          installCostForRetailDisplay > 0 &&
                                          dataActualRetail != null &&
                                          Number(dataActualRetail) === installCostForRetailDisplay &&
                                          data.retail_price != null &&
                                          Number(data.retail_price) > installCostForRetailDisplay
                                        ) {
                                          dataActualRetail = Number(
                                            (Number(data.retail_price) - installCostForRetailDisplay).toFixed(2),
                                          )
                                        }
                                        const dataPrice = data.actual_retail_price || data.product_price || data.price
                                        const dataretailPrice =
                                          data.product_retail_price || data.retail_price
                                        const dataWholesalePrice = data.product_price||data.price
                                        const productCost =
                                          Number(dataActualRetail || 0) *
                                          (Number(data.locationQuantity) || 1)
                                        // const dataQuantity = values[quantityFieldName]
                                        const dataQuantity = data.quantity||1
                                        console.log('data.discount--',data.discount);
                                        const dataDiscount = data.discount?data.discount:0
                                        const rowTotal = calculateTotal(markupType == 1 ? dataWholesalePrice : (markupType == 2 ? (data.install_cost && parseFloat(data.install_cost) > 0 ? dataretailPrice : dataActualRetail) : 0), dataQuantity, dataDiscount, data.quantity, data.locationQuantity, Number(data?.adjustment),data.markAdjType,data.adj_value_type);
                                        // const rowTotal = calculateTotal(markupType == 1 ? dataWholesalePrice : (markupType == 2 ? (data.install_cost && parseFloat(data.install_cost) > 0 ? dataretailPrice : dataActualRetail) : 0), dataQuantity, dataDiscount, data.quantity, data.locationQuantity, Number(data?.adjustment),data.markAdjType,persentageSplit);
                                        const locQtyForLineTotal = Number(data?.locationQuantity) || 1
                                        const installQtyForLineTotal = Number(data?.install_quantity) || 1
                                        const discountForLineTotal =
                                          Number(values[discountFieldName]) || Number(dataDiscount) || 0
                                        const lineProductSubTotal =
                                          markupType == 1
                                            ? (Number(data?.price) || 0) * locQtyForLineTotal
                                            : markupType == 2
                                            ? Number(dataActualRetail || 0) * locQtyForLineTotal
                                            : 0
                                        const lineInstallSubTotal =
                                          (Number(data?.install_cost) || 0) * installQtyForLineTotal
                                        const lineProductTotal = Math.max(
                                          0,
                                          lineProductSubTotal + lineInstallSubTotal - discountForLineTotal,
                                        )
                                        console.log('calculateTotal--rowTotal', productCost)
                                        console.log('calculateTotal--rowTotal', rowTotal)
                                        console.log('calculateTotal--dataretailPrice', dataretailPrice)
                                        console.log('calculateTotal--dataWholesalePrice', dataWholesalePrice)
                                        console.log('calculateTotal--markupType', markupType)
                                        // const markup = ((dataretailPrice - dataPrice) / dataPrice) * 100;
                                        const invoiceAmount = parseFloat(data?.expected_material_cost?.toFixed(2)) + parseFloat(data?.expected_total_service_cost?.toFixed(2))
                                        // let markup = markupType ? (invoiceAmount / rowTotal) : null
                                        console.log('markupTypemarkupTypemarkupType==',markupType)
                                        let markup = markupType == 1 ? (((dataWholesalePrice - parseFloat(data.expected_cost?.toFixed(2))) / parseFloat(data.expected_cost?.toFixed(2))) * 100) 
                                                      : (markupType == 2 ? (((dataretailPrice - parseFloat(data.expected_cost?.toFixed(2))) / parseFloat(data.expected_cost?.toFixed(2)))*100) : 0);
                                        markup = markup ? Number(markup) : 0
                                        data['markup'] = markup
                                        let markupData = data.product_markup?.toFixed(2) ||data.markup?.toFixed(2)
                                        markupData = Number(markupData) * data.quantity
                                        data['markup'] = markupData
                                        totalMarkup += Number(data.product_markup) || Number(data.markup) || 0
                                        data['markup_type'] = markupType
                                        data['totalMarkup'] = totalMarkup?.toFixed(2)
                                        let originalMarkup= markupType == 1 ? data.wholesaleMarkup :  markupType == 2 ? data.retailMarkup : 0
                                        originaltotalMarkup+=originalMarkup
                                        // values['totalMarkup'] = totalMarkup?.toFixed(2)
                                        productFormulaCost+=parseFloat(data.expected_cost?.toFixed(2))*data.quantity*data.locationQuantity
      
                                        const pfc = parseFloat(data.expected_cost?.toFixed(2)) * data.quantity*data.locationQuantity // total product formula cost
                                        const rtp = dataretailPrice * data.quantity*data.locationQuantity // total retail price
                                        const wsp = dataWholesalePrice * data.quantity*data.locationQuantity // total wholesale price
        
                                        const maxDiscount_wholesale = wsp - pfc
                                        const maxDiscount_retail = rtp - pfc
                                        
                                        // const maxDiscount_wholesale = (wsp - pfc) - DiscountTotal
                                        // const maxDiscount_retail = (rtp - pfc) - DiscountTotal
      
                                        console.log('maxDiscount_wholesale--',maxDiscount_wholesale);
                                        console.log('maxDiscount_retail--',maxDiscount_retail);
                                        console.log('DiscountTotal--',DiscountTotal);
                                        console.log('pfc--',pfc);
                                        console.log('rtp--',rtp);
                                        console.log('wsp--',wsp);
                                        data['product_total'] = lineProductTotal
                                        let SPMA = 0
                                        if(markupType){
                                          if(markupType == 1){
                                            if(data.markAdjType==2 || data.markAdjType==3) {
                                              SPMA = (Number(dataPrice) || 0) + (data.adjustment ? Number(data.adjustment) : 0)
                                            }else{
      
                                              SPMA = (Number(dataPrice) || 0) + (((dataPrice || 0) * (data.adjustment ? Number(data.adjustment) : 0)) / 100)
                                            }
                                          }else{
                                            if(data.markAdjType==2 || data.markAdjType==3) {
                                              SPMA = (Number(dataretailPrice) || 0) + (dataretailPrice ? Number(data.adjustment) : 0)
                                            }else{
      
                                              SPMA = (Number(dataretailPrice) || 0) + (((Number(dataretailPrice) || 0) * (dataretailPrice ? Number(data.adjustment) : 0)) / 100)
                                            }
                                          }
                                        }
                                        console.log('SPMA-----data.price-----',dataPrice)
                                        console.log('SPMA-----data.adjustment-----',data.adjustment)
                                        console.log('SPMA-----data.retail_price-----',dataretailPrice)
                                        console.log('SPMA-----SPMA-----',SPMA)
                                        SPMA = Number(SPMA)
                                        data['SPMA'] = SPMA?.toFixed(2)

                                        // Initialize product marketing adjustment type to positive if null
                                        if(data.adj_value_type == null){
                                          data.adj_value_type = true
                                        }

                                        // Mirror Quotation.js product marketing adjustment effects on base prices
                                        data['original_actual_retail_price'] = data?.original_actual_retail_price || data?.actual_retail_price
                                        data['original_retail_price'] = data?.original_retail_price || data?.retail_price
                                        data['original_price'] = data?.original_price || data?.price
                                        // ALL-815 backup - previous original_product_retail_price fallback:
                                        // data['original_product_retail_price'] = data?.original_product_retail_price || data?.product_retail_price
                                        data['original_product_retail_price'] = data?.original_product_retail_price || data?.original_actual_retail_price || data?.actual_retail_price || data?.product_retail_price
                                        data['original_product_price'] = data?.original_product_price || data?.product_price

                                        // Number() on bases: API/DECIMAL strings like "2000" + 0 must not concat to "20000"
                                        data['actual_retail_price'] =
                                          Number(data?.original_actual_retail_price || 0) +
                                          (data.adj_value_type
                                            ? (Number(data?.adjustment) || 0)
                                            : -(Number(data?.adjustment) || 0))
                                        data['retail_price'] =
                                          Number(data?.original_retail_price || 0) +
                                          (data.adj_value_type
                                            ? (Number(data?.adjustment) || 0)
                                            : -(Number(data?.adjustment) || 0))
                                        data['price'] =
                                          Number(data?.original_price || 0) +
                                          (data.adj_value_type
                                            ? (Number(data?.adjustment) || 0)
                                            : -(Number(data?.adjustment) || 0))
                                        data['product_retail_price'] =
                                          Number(data?.original_product_retail_price || 0) +
                                          (data.adj_value_type
                                            ? (Number(data?.adjustment) || 0)
                                            : -(Number(data?.adjustment) || 0))
                                        data['product_price'] =
                                          Number(data?.original_product_price || data?.product_price || 0) +
                                          (data.adj_value_type
                                            ? (Number(data?.adjustment) || 0)
                                            : -(Number(data?.adjustment) || 0))

                                        // Initialize install adjustment fields
                                        if(data.install_adj_value_type == null && data.install_cost){
                                          data.install_adj_value_type = true
                                        }

                                        if(data.install_quantity == null && data.install_cost){
                                          data.install_quantity = 1
                                        }

                                        if(data.install_adjustment == null && data.install_cost){
                                          data.install_adjustment = 0
                                        }

                                        // Set original_install_cost if not already set
                                        if(!data.original_install_cost && data.install_cost){
                                          // If install_cost already includes adjustment, reverse calculate original
                                          const installAdj = parseFloat(data?.install_adjustment) || 0
                                          const installAdjValueType = data?.install_adj_value_type !== false && data?.install_adj_value_type !== 0
                                          const signedInstallAdjForOriginal = installAdjValueType ? installAdj : -installAdj
                                          data.original_install_cost = Math.max(0, parseFloat(data.install_cost) - signedInstallAdjForOriginal)
                                        // ALL-815 backup - previous install recalc without install_price_edited guard:
                                        // } else if(data.install_cost && data.original_install_cost) {
                                        } else if(!data.install_price_edited && data.install_cost && data.original_install_cost) {
                                          // Apply install adjustment calculation
                                          const baseInstallCost = parseFloat(data?.original_install_cost) || 0
                                          const installAdj = parseFloat(data?.install_adjustment) || 0
                                          const signedInstallAdjForCost = (data?.install_adj_value_type === false || data?.install_adj_value_type === 0) ? -installAdj : installAdj
                                          data.install_cost = baseInstallCost ? Math.max(0, baseInstallCost + signedInstallAdjForCost) : null
                                        }

                                        const productFormulaEach = getSingleProductFormulaCostEach(data)
                                        const hasNegativeRetailPermission =
                                          explodedPermissions?.some((permission) =>
                                            [
                                              'Allow Negative Marketing Adjustment Estimate',
                                            ].includes(permission),
                                          )
                                        const retailPriceMin = hasNegativeRetailPermission
                                          ? 0.01
                                          : Math.max(0.01, productFormulaEach)

                                        const gid = data?.group_id ? String(data.group_id) : null
                                        // Sl No follows productTableBodyRenderOrder (groups + ungrouped products share one sequence).
                                        const displaySlNo = index + 1

                                        const productRetailEach = Math.max(
                                          0,
                                          Number(
                                            data?.actual_retail_price ??
                                              data?.retail_price ??
                                              data?.product_retail_price ??
                                              0,
                                          ),
                                        )
                                        const isNegativeProductAdjustmentMode =
                                          data?.adj_value_type === false ||
                                          data?.adj_value_type === 0 ||
                                          data?.adj_value_type === '0' ||
                                          data?.adj_value_type === 'false'
                                        const isProductLosingMoney =
                                          isNegativeProductAdjustmentMode &&
                                          productRetailEach < productFormulaEach

                                        const installFormulaEach = Number(
                                          data?.expected_install_labor_cost_with_markup ||
                                            0,
                                        )
                                        const installRetailEach = Math.max(
                                          0,
                                          Number(data?.install_cost || 0),
                                        )
                                        const isNegativeInstallAdjustmentMode =
                                          data?.install_adj_value_type ===
                                            false ||
                                          data?.install_adj_value_type === 0 ||
                                          data?.install_adj_value_type ===
                                            '0' ||
                                          data?.install_adj_value_type ===
                                            'false'
                                        const isInstallLosingMoney =
                                          isNegativeInstallAdjustmentMode &&
                                          installRetailEach < installFormulaEach

                                        const isLosingMoneyItem =
                                          isProductLosingMoney ||
                                          isInstallLosingMoney

                                        const losingMoneyRowSx = getLosingMoneyRowSx(isLosingMoneyItem)

                                        return (
                                          <Draggable
                                            key={`product-${data.indexId}`}
                                            draggableId={`product-${data.indexId}`}
                                            index={index}
                                            isDragDisabled={isPreview || !openEdit}
                                          >
                                            {(provided, snapshot) => (
                                          <>
                                            <TableRow
                                              key={`main-${data.indexId}`}
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              onDragOver={(e) => handleProductIconDragOver(e, data.indexId)}
                                              onDragLeave={(e) => handleProductIconDragLeave(e, data.indexId)}
                                              onDrop={(e) => handleProductIconDrop(e, data.indexId)}
                                              sx={{
                                                ...losingMoneyRowSx,
                                                ...(productAttachmentDragOver[data.indexId] && {
                                                  backgroundColor: 'action.hover',
                                                  outline: `2px dashed ${theme.palette.primary.main}`,
                                                  outlineOffset: -2,
                                                }),
                                              }}
                                              style={{
                                                ...provided.draggableProps.style,
                                                ...(snapshot.isDragging
                                                  ? {
                                                      backgroundColor:
                                                        theme.palette.action.hover,
                                                    }
                                                  : {}),
                                              }}
                                            >
                                              {openEdit && !isPreview && (
                                                <TableCell
                                                  padding="checkbox"
                                                  {...provided.dragHandleProps}
                                                  sx={{ width: 40, cursor: 'grab' }}
                                                >
                                                  <DragIndicator fontSize="small" color="action" />
                                                </TableCell>
                                              )}
                                              { data?.is_product_row !=1 ?<TableCell padding="checkbox">
                                                {(() => {
                                                  const isAnyGroupInEditMode = Object.values(groupEditMode || {}).some(Boolean)
                                                  const isGroupRow = Boolean(gid)
                                                  const canSelectUngrouped = openEdit && !isAnyGroupInEditMode && !isGroupRow
                                                  const canSelectGrouped = openEdit && isGroupRow && !!groupEditMode?.[gid]
                                                  const show = canSelectUngrouped || canSelectGrouped
                                                  return openEdit ? (
                                                    <Checkbox
                                                      checked={isIndexIdInList(groupSelectedProductIds, data.indexId)}
                                                      onChange={() => {
                                                        if (!show) return
                                                        toggleGroupProductSelection(data)
                                                      }}
                                                      sx={{ visibility: show ? 'visible' : 'hidden' }}
                                                    />
                                                  ) : null
                                                })()}
                                              </TableCell>:
                                              <TableCell></TableCell>
                                              }
                                              <TableCell>
                                                #{displaySlNo}
                                              </TableCell>
                                              <TableCell align="center">
                                                {(() => {
                                                  const toggleLocked =
                                                    isRequestEstimateLockedProductToggle(data)
                                                  const toggleMode = getProductToggleDisplayMode(data)
                                                  return isPreview ? (
                                                    toggleMode === 'choose' ? 'Choose' : 'Write'
                                                  ) : (
                                                    <ProductLineEntryToggle
                                                      mode={toggleMode}
                                                      onChange={(mode) =>
                                                        handleProductRowEntryModeChange(
                                                          data.indexId,
                                                          mode,
                                                        )
                                                      }
                                                      lockDisplay={toggleLocked}
                                                      disabled={toggleLocked}
                                                    />
                                                  )
                                                })()}
                                              </TableCell>
                                            <TableCell>
                                                {(getProductEntryMode(data) === 'write') && !isPreview ? (
                                                  <TextField
                                                    required
                                                    fullWidth
                                                    type="text"
                                                    label={'Product Name'}
                                                    sx={{ minWidth: '300px' }}
                                                    value={
                                                      data.product_name ||
                                                      data.name
                                                    }
                                                    onFocus={() => {
                                                      if (data?.is_product_row == 1) {
                                                        handleFieldFocus(data.indexId, 'name', data.product_name || data.name);
                                                      }
                                                    }}
                                                    onChange={(event) => {
                                                      const newValue = event.target.value;
                                                      if (data?.is_product_row == 1) {
                                                        handleRequestEstimateProductNameChange(data.indexId, newValue);
                                                        // Trigger debounced auto-save
                                                        const updatedRow = { ...data, product_name: newValue, name: newValue };
                                                        triggerDebouncedAutoSave(updatedRow, 'name');
                                                      } else {
                                                        // Update the selectedProducts state for additional products
                                                        setSelectedProducts(
                                                          (prevProducts) =>
                                                            prevProducts.map(
                                                              (product) => {
                                                                if (
                                                                  product.indexId ===
                                                                  data.indexId
                                                                ) {
                                                                  return {
                                                                    ...product,
                                                                    name: newValue,
                                                                    product_name:
                                                                      newValue,
                                                                  }
                                                                } else {
                                                                  return product
                                                                }
                                                              },
                                                            ),
                                                        )
                                                      }
                                                      data['name'] = newValue || ''
                                                      data['product_name'] = newValue || ''
                                                      if (isSubmitted)
                                                        setIsSubmitted(false)
                                                    }}
                                                    onBlur={() => {
                                                      if (data?.is_product_row == 1) {
                                                        handleProductRowAutoSave(data, 'name');
                                                      }
                                                    }}
                                                    error={
                                                      isSubmitted &&
                                                      !data.name?.trim() &&
                                                      !data.product_name?.trim()
                                                    }
                                                    helperText={
                                                      isSubmitted &&
                                                      !data.name?.trim() &&
                                                      !data.product_name?.trim()
                                                        ? 'Product Name is required'
                                                        : ''
                                                    }
                                                    InputProps={{
                                                      endAdornment: autoSavingField?.indexId === data.indexId && autoSavingField?.field === 'name' ? (
                                                        <InputAdornment position="end">
                                                          <CircularProgress size={20} />
                                                        </InputAdornment>
                                                      ) : null
                                                    }}
                                                  />
                                                ) : getProductEntryMode(data) === 'choose' && !data?.id && !isPreview ? (
                                                  <Button
                                                    size="small"
                                                    variant="outlined"
                                                    onClick={() => openChooseProductDialogForRow(data)}
                                                  >
                                                    Select Product
                                                  </Button>
                                                ) : (
                                              <Box>
                                                  <Typography
                                                    sx={{
                                                      color: isSplitOrder
                                                        ? theme.palette[
                                                            FacilityTypes.find(
                                                              (f) =>
                                                                f.id ===
                                                                data?.facility_id,
                                                            )?.color ||
                                                              'primary'
                                                          ]?.main
                                                        : 'inherit',
                                                    }}
                                                  >
                                                    {data.product_name ||
                                                      data.name}
                                                  </Typography>
                                                  {getProductLineNote(data) ? <Typography sx={{color:'red'}}>Note:{" "}{getProductLineNote(data)}</Typography>:""}
                                              </Box>
                                                )}
                                              </TableCell>
                                              <TableCell>
                                                <IconButton
                                                  data-preview-allow
                                                  onClick={() =>
                                                    handleOpenNote(
                                                      data.indexId,
                                                      getProductLineNote(data),
                                                    )
                                                  }
                                                >
                                                  <NoteAdd
                                                    sx={{
                                                      color:
                                                        !getProductLineNote(data)
                                                          ? ''
                                                          : theme.palette
                                                              .primary.main,
                                                    }}
                                                  />
                                                </IconButton>
                                              </TableCell>
                                              <TableCell>
                                                <Tooltip title="Drop files on row or click to open attachments">
                                                  <IconButton
                                                    data-preview-allow
                                                    onClick={() => handleOpenAttachment(data.indexId)}
                                                  >
                                                    {isUploadingProduct[String(data.indexId)] ? (
                                                      <CircularProgress size={34} />
                                                    ) : (
                                                      <UploadFile
                                                        sx={{
                                                          color:
                                                            getProductAttachmentsList(data.indexId).length === 0
                                                              ? 'error.main'
                                                              : theme.palette.primary.main,
                                                        }}
                                                      />
                                                    )}
                                                  </IconButton>
                                                </Tooltip>
                                              </TableCell>
                                              <TableCell>
                                                {canShowProductFormulaIcon(data, currentFacilityId) ? (
                                                  <Tooltip title="Product Formula">
                                                    <IconButton data-preview-allow onClick={() => handleOpenProductFormula(data.recipe_id)}>
                                                      <span className="heroicons-solid--beaker"></span>
                                                    </IconButton>
                                                  </Tooltip>
                                                ) : '-'}
                                              </TableCell>
                                              <TableCell>
                                                {getProductEntryMode(data) === 'write' ?
                                                  <Grid container spacing={1} direction="row" alignItems="center" sx={{ mb: 1 }}>
                                                    <Grid item>
                                                      <Button variant='outlined'
                                                        disabled={isPreview || !(data.product_name || data.name || '').trim()}
                                                        onClick={()=>{
                                                          setOpenCatalogModal(true);
                                                          // setSelectedProductForCatalog(data);
                                                          setSelectedProductForCatalog({ ...data, product_write: 1 });
                                                        }}
                                                      >
                                                        Add Estimate Catalog
                                                      </Button>
                                                    </Grid>
                                                    <Grid item>
                                                      <Button variant='outlined'
                                                        disabled={isPreview || !(data.product_name || data.name || '').trim()}
                                                        onClick={()=>{
                                                          setOpenCatalogModal(true);
                                                          
                                                          setSelectedProductForCatalog({ ...data, addExistingEstimateCatalog: true, product_write: 1 });
                                                        }}
                                                      >
                                                        Add Existing
                                                      </Button>
                                                    </Grid>
                                                  </Grid>
                                                : '' }
                                              </TableCell>
                                              <TableCell>
                                                {(getProductEntryMode(data) === 'write') && !isPreview ? (
                                                  <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    value={data.product_desc || data.description || ''}
                                                    onFocus={() => {
                                                      if (data?.is_product_row == 1) {
                                                        handleFieldFocus(data.indexId, 'desc', data.product_desc || data.description);
                                                      }
                                                    }}
                                                    onChange={(e) => {
                                                      const newValue = e.target.value;
                                                      if (data?.is_product_row == 1) {
                                                        handleRequestEstimateProductDescChange(data.indexId, newValue);
                                                        // Trigger debounced auto-save
                                                        const updatedRow = { ...data, product_desc: newValue };
                                                        triggerDebouncedAutoSave(updatedRow, 'desc');
                                                      } else {
                                                        // Update the selectedProducts state for additional products
                                                        setSelectedProducts(
                                                          (prevProducts) =>
                                                            prevProducts.map(
                                                              (product) => {
                                                                if (product.indexId === data.indexId) {
                                                                  return {
                                                                    ...product,
                                                                    product_desc: newValue,
                                                                  }
                                                                } else {
                                                                  return product
                                                                }
                                                              },
                                                            ),
                                                        )
                                                      }
                                                      data['product_desc'] = newValue || '';
                                                    }}
                                                    onBlur={() => {
                                                      if (data?.is_product_row == 1) {
                                                        handleProductRowAutoSave(data, 'desc');
                                                      }
                                                    }}
                                                    placeholder="Product Description"
                                                    multiline
                                                    minRows={3}
                                                    maxRows={6}
                                                    sx={{ minWidth: '400px' }}
                                                    InputProps={{
                                                      endAdornment: autoSavingField?.indexId === data.indexId && autoSavingField?.field === 'desc' ? (
                                                        <InputAdornment position="end">
                                                          <CircularProgress size={20} />
                                                        </InputAdornment>
                                                      ) : null
                                                    }}
                                                  />
                                                ) : getProductEntryMode(data) === 'choose' && (data?.id || data?.product_id) && !isPreview ? (
                                                  <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    value={ data.product_desc || data.description  ||''}
                                                    onChange={(e) => {
                                                      const newValue = e.target.value;
                                                      handleProductDescChange(data.indexId, newValue);
                                                      data['product_desc'] = newValue || '';
                                                      data['description'] = newValue || '';
                                                    }}
                                                    placeholder="Product Description"
                                                    multiline
                                                    minRows={3}
                                                    maxRows={6}
                                                    sx={{ minWidth: '400px' }}
                                                  />
                                                ) : (
                                                  (data?.product_desc || data?.description) ? (
                                                    <Tooltip title={data?.product_desc || data?.description}>
                                                      <Typography variant='subtitle2' sx={{ fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre-wrap', fontSize: '0.75rem' }}>{data?.product_desc || data?.description}</Typography>
                                                    </Tooltip>
                                                  ) : ''
                                                )}
                                              </TableCell>
                                              <TableCell>
                                                {data?.isAdditionalProduct
                                                  ? 'N/A'
                                                  : getSingleProductFormulaCostEach(data).toFixed(2)
                                                }
                                                  
                                                {/* : Math.max(
                                                    0,
                                                    (data?.expected_material_cost_with_markup || 0) +
                                                      (data?.expected_service_cost_with_markup || 0) -
                                                      (data?.expected_install_labor_cost_with_markup || 0),
                                                  ).toFixed(2)} */}
                                              </TableCell>
                                              {/* Incoming Percentage column - only show when isSplitOrder is true */}
                                              {isSplitOrder ? (
                                                <TableCell align="center">
                                                  {data?.isAdditionalProduct
                                                    ? 'N/A'
                                                    : data?.facility_id !=
                                                      currentFacilityId
                                                    ? `${
                                                        incomingPercentage ||
                                                        0
                                                      }%`
                                                    : '-'}
                                                </TableCell>
                                              ) : (
                                                <TableCell align="center">
                                                  {data.inhouse === 0 ? (data?.sub_contract_markup != null && data?.sub_contract_markup !== '' ? `${Number(data.sub_contract_markup).toFixed(2)}` : '-') : '-'}
                                                </TableCell>
                                              )}
                                              {/* <TableCell>{invoiceAmount}</TableCell> */}
                                              <Tooltip
                                                title={
                                                  isSplitOrder &&
                                                  data?.facility_id !=
                                                    currentFacilityId
                                                    ? `Product formula cost + (Product formula cost * incoming split markup (${incomingPercentage}) / 100)`
                                                    : ''
                                                }
                                              >
                                                <TableCell>
                                                  {hasMarkupPermission &&
                                                  markupType == 2 ? (
                                                    data?.isAdditionalProduct ? (
                                                      <TextField
                                                        required
                                                        fullWidth
                                                        type="number"
                                                        label={
                                                          'Retail Price Each'
                                                        }
                                                        disabled={
                                                          isPreview ? true : 
                                                          values
                                                            .project_category
                                                            ?.name ==
                                                          'Time & Material'
                                                            ? true
                                                            : false
                                                        }
                                                        sx={{ width: 85 }}
                                                        // value={dataretailPrice}
                                                        value={
                                                          data.retail_price_draft !== undefined
                                                            ? limitDecimalInput(data.retail_price_draft)
                                                            : formatRetailPriceDisplay(
                                                                roundMoneyValue(dataActualRetail ?? 0,
                                                              )) 
                                                        }
                                                        // onWheel={(e) => e.target.blur()}
                                                        onFocus={selectInputValue}
                                                        onClick={selectInputValue}
                                                        onKeyPress={(
                                                          event,
                                                        ) => {
                                                          // if (event.key === '0' && event.target.value === '') {
                                                          //   event.preventDefault();
                                                          // }
                                                          if (
                                                            event.key === '-'
                                                          ) {
                                                            event.preventDefault()
                                                          }
                                                          if (
                                                            event.key === 'e'
                                                          ) {
                                                            event.preventDefault()
                                                          }
                                                        }}
                                                        onKeyDown={(event) => {
                                                          if (
                                                            event.key === 'ArrowUp' ||
                                                            event.key === 'ArrowDown'
                                                          ) {
                                                            event.preventDefault()
                                                            const current =
                                                              data.retail_price_draft !== undefined
                                                                ? data.retail_price_draft
                                                                : formatRetailPriceDisplay(
                                                                    dataActualRetail ?? 0,
                                                                  )
                                                            handleRetailPriceChange(
                                                              data.indexId,
                                                              stepRetailPriceByArrow(
                                                                current,
                                                                event.key === 'ArrowUp'
                                                                  ? 'up'
                                                                  : 'down',
                                                                retailPriceMin,
                                                              ),
                                                              { isBlur: true },
                                                            )
                                                          }
                                                        }}
                                                        inputProps={{
                                                          min: retailPriceMin,
                                                          step: 1,
                                                        }}
                                                        defaultValue={0}
                                                        onChange={(event) => {
                                                          const current =
                                                            data.retail_price_draft !== undefined
                                                              ? data.retail_price_draft
                                                              : formatRetailPriceDisplay(
                                                                  dataActualRetail ?? 0,
                                                                )
                                                          handleRetailPriceChange(
                                                            data.indexId,
                                                            normalizeRetailArrowChange(
                                                              current,
                                                              event.target.value,
                                                              retailPriceMin,
                                                            ),
                                                          )
                                                        }}
                                                        onBlur={(event) => {
                                                          handleRetailPriceChange(
                                                            data.indexId,
                                                            event.target.value,
                                                            { isBlur: true },
                                                          )
                                                        }}
                                                        // ALL-815 backup - previous isAdditionalProduct onChange (markup type 2):
                                                        // onChange={(event) => {
                                                        //   let newValue = event.target.value
                                                        //   if (newValue !== '') {
                                                        //     setSelectedProducts((pv) => [
                                                        //       ...pv.map((p) => {
                                                        //         if (p.indexId === data.indexId) {
                                                        //           return {
                                                        //             ...p,
                                                        //             retail_price: newValue,
                                                        //             product_retail_price: newValue,
                                                        //           }
                                                        //         } else {
                                                        //           return p
                                                        //         }
                                                        //       }),
                                                        //     ])
                                                        //     data['product_retail_price'] = newValue || 0
                                                        //     data['retail_price'] = newValue || 0
                                                        //   }
                                                        // }}
                                                        // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                                        // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                                      />
                                                    ) : (
                                                      <>
                                                        {/* ALL-815 backup - previous read-only retail display (markup type 2):
                                                        dataActualRetail?.toFixed(2) */}
                                                        <TextField
                                                          required
                                                          fullWidth
                                                          type="number"
                                                          label={'Retail Price Each'}
                                                          disabled={
                                                            isPreview ? true :
                                                            values.project_category?.name == 'Time & Material'
                                                              ? true
                                                              : false
                                                          }
                                                          sx={{ width: 85 }}
                                                          value={
                                                            data.retail_price_draft !== undefined
                                                              ? limitDecimalInput(data.retail_price_draft)
                                                              : formatRetailPriceDisplay(
                                                                  roundMoneyValue(dataActualRetail) ?? 0,
                                                                )
                                                          }
                                                          onFocus={selectInputValue}
                                                          onClick={selectInputValue}
                                                          onKeyPress={(event) => {
                                                            if (event.key === '-') {
                                                              event.preventDefault()
                                                            }
                                                            if (event.key === 'e') {
                                                              event.preventDefault()
                                                            }
                                                          }}
                                                          onKeyDown={(event) => {
                                                            if (
                                                              event.key === 'ArrowUp' ||
                                                              event.key === 'ArrowDown'
                                                            ) {
                                                              event.preventDefault()
                                                              const current =
                                                                data.retail_price_draft !== undefined
                                                                  ? data.retail_price_draft
                                                                  : formatRetailPriceDisplay(
                                                                      dataActualRetail ?? 0,
                                                                    )
                                                              handleRetailPriceChange(
                                                                data.indexId,
                                                                stepRetailPriceByArrow(
                                                                  current,
                                                                  event.key === 'ArrowUp'
                                                                    ? 'up'
                                                                    : 'down',
                                                                  retailPriceMin,
                                                                ),
                                                                { isBlur: true },
                                                              )
                                                            }
                                                          }}
                                                          inputProps={{ min: retailPriceMin, step: 1 }}
                                                          defaultValue={0}
                                                          onChange={(event) => {
                                                            const current =
                                                              data.retail_price_draft !== undefined
                                                                ? data.retail_price_draft
                                                                : formatRetailPriceDisplay(
                                                                    dataActualRetail ?? 0,
                                                                  )
                                                            handleRetailPriceChange(
                                                              data.indexId,
                                                              normalizeRetailArrowChange(
                                                                current,
                                                                event.target.value,
                                                                retailPriceMin,
                                                              ),
                                                            )
                                                          }}
                                                          onBlur={(event) => {
                                                            handleRetailPriceChange(
                                                              data.indexId,
                                                              event.target.value,
                                                              { isBlur: true },
                                                            )
                                                          }}
                                                        />
                                                      </>
                                                    )
                                                  ) : null}
                                                </TableCell>
                                              </Tooltip>
                                              <TableCell>
                                                {hasMarkupPermission &&
                                                markupType == 1 ? (
                                                  data?.isAdditionalProduct ? (
                                                    <TextField
                                                      required
                                                      fullWidth
                                                      type="number"
                                                      label={
                                                        'Retail Price Each'
                                                      }
                                                      disabled={
                                                        isPreview ? true : 
                                                        values
                                                          .project_category
                                                          ?.name ==
                                                        'Time & Material'
                                                          ? true
                                                          : false
                                                      }
                                                      sx={{ width: 85 }}
                                                      // value={dataPrice}
                                                      value={
                                                        data.retail_price_draft !== undefined
                                                          ? limitDecimalInput(data.retail_price_draft)
                                                          : formatRetailPriceDisplay(
                                                              roundMoneyValue(dataPrice) ?? 0,
                                                            )
                                                            // roundMoneyValue(
                                                            //   data.actual_retail_price ||
                                                            //     data.retail_price ||
                                                            //     data.price,
                                                            // )
                                                      }
                                                      // onWheel={(e) => e.target.blur()}
                                                      onFocus={selectInputValue}
                                                      onClick={selectInputValue}
                                                      onKeyPress={(event) => {
                                                        // if (event.key === '0' && event.target.value === '') {
                                                        //   event.preventDefault();
                                                        // }
                                                        if (
                                                          event.key === '-'
                                                        ) {
                                                          event.preventDefault()
                                                        }
                                                        if (
                                                          event.key === 'e'
                                                        ) {
                                                          event.preventDefault()
                                                        }
                                                      }}
                                                      onKeyDown={(event) => {
                                                        if (
                                                          event.key === 'ArrowUp' ||
                                                          event.key === 'ArrowDown'
                                                        ) {
                                                          event.preventDefault()
                                                          const current =
                                                            data.retail_price_draft !== undefined
                                                              ? data.retail_price_draft
                                                              : formatRetailPriceDisplay(
                                                                  dataPrice ?? 0,
                                                                )
                                                          handleRetailPriceChange(
                                                            data.indexId,
                                                            stepRetailPriceByArrow(
                                                              current,
                                                              event.key === 'ArrowUp'
                                                                ? 'up'
                                                                : 'down',
                                                              retailPriceMin,
                                                            ),
                                                            { isBlur: true },
                                                          )
                                                        }
                                                      }}
                                                      inputProps={{ min: retailPriceMin, step: 1 }}
                                                      defaultValue={0}
                                                      onChange={(event) => {
                                                        const current =
                                                          data.retail_price_draft !== undefined
                                                            ? data.retail_price_draft
                                                            : formatRetailPriceDisplay(
                                                                dataPrice ?? 0,
                                                              )
                                                        handleRetailPriceChange(
                                                          data.indexId,
                                                          normalizeRetailArrowChange(
                                                            current,
                                                            event.target.value,
                                                            retailPriceMin,
                                                          ),
                                                        )
                                                      }}
                                                      onBlur={(event) => {
                                                        handleRetailPriceChange(
                                                          data.indexId,
                                                          event.target.value,
                                                          { isBlur: true },
                                                        )
                                                      }}
                                                      // ALL-815 backup - previous isAdditionalProduct onChange (markup type 1):
                                                      // onChange={(event) => {
                                                      //   let newValue = event.target.value
                                                      //   if (newValue !== '') {
                                                      //     setSelectedProducts((pv) => [
                                                      //       ...pv.map((p) => {
                                                      //         if (p.indexId === data.indexId) {
                                                      //           return {
                                                      //             ...p,
                                                      //             product_price: newValue,
                                                      //             price: newValue,
                                                      //           }
                                                      //         } else {
                                                      //           return p
                                                      //         }
                                                      //       }),
                                                      //     ])
                                                      //     data['product_price'] = newValue || 0
                                                      //     data['price'] = newValue || 0
                                                      //   }
                                                      // }}
                                                      // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                                      // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                                    />
                                                  ) : (
                                                    <>
                                                      {/* ALL-815 backup - previous read-only retail display (markup type 1):
                                                      dataPrice?.toFixed(2) */}
                                                      <TextField
                                                        required
                                                        fullWidth
                                                        type="number"
                                                        label={'Retail Price Each'}
                                                        disabled={
                                                          isPreview ? true :
                                                          values.project_category?.name == 'Time & Material'
                                                            ? true
                                                            : false
                                                        }
                                                        sx={{ width: 85 }}
                                                        value={
                                                          data.retail_price_draft !== undefined
                                                            ? limitDecimalInput(data.retail_price_draft)
                                                            : formatRetailPriceDisplay(
                                                                roundMoneyValue(dataPrice) ?? 0,
                                                              )
                                                        }
                                                        onFocus={selectInputValue}
                                                        onClick={selectInputValue}
                                                        onKeyPress={(event) => {
                                                          if (event.key === '-') {
                                                            event.preventDefault()
                                                          }
                                                          if (event.key === 'e') {
                                                            event.preventDefault()
                                                          }
                                                        }}
                                                        onKeyDown={(event) => {
                                                          if (
                                                            event.key === 'ArrowUp' ||
                                                            event.key === 'ArrowDown'
                                                          ) {
                                                            event.preventDefault()
                                                            const current =
                                                              data.retail_price_draft !== undefined
                                                                ? data.retail_price_draft
                                                                : formatRetailPriceDisplay(
                                                                    dataPrice ?? 0,
                                                                  )
                                                            handleRetailPriceChange(
                                                              data.indexId,
                                                              stepRetailPriceByArrow(
                                                                current,
                                                                event.key === 'ArrowUp'
                                                                  ? 'up'
                                                                  : 'down',
                                                                retailPriceMin,
                                                              ),
                                                              { isBlur: true },
                                                            )
                                                          }
                                                        }}
                                                        inputProps={{ min: retailPriceMin, step: 1 }}
                                                        defaultValue={0}
                                                        onChange={(event) => {
                                                          const current =
                                                            data.retail_price_draft !== undefined
                                                              ? data.retail_price_draft
                                                              : formatRetailPriceDisplay(
                                                                  dataPrice ?? 0,
                                                                )
                                                          handleRetailPriceChange(
                                                            data.indexId,
                                                            normalizeRetailArrowChange(
                                                              current,
                                                              event.target.value,
                                                              retailPriceMin,
                                                            ),
                                                          )
                                                        }}
                                                        onBlur={(event) => {
                                                          handleRetailPriceChange(
                                                            data.indexId,
                                                            event.target.value,
                                                            { isBlur: true },
                                                          )
                                                        }}
                                                      />
                                                    </>
                                                  )
                                                ) : null}
                                              </TableCell>
                                              {/* <TableCell>{hasMarkupPermission ? (data.SPMA || null) : null}</TableCell> */}
                                              {/* <TableCell>{hasMarkupPermission ? Number(markupData).toFixed(2) : null}</TableCell> */}

                                              {/* <TableCell> */}
                                              {/* previos */}
                                              {/* {(hasMarkupPermission && markupType == 1) ? data.wholesaleMarkup?.toFixed(2)
                                            : (hasMarkupPermission && markupType == 2) ? data.pf_retail_markup?.toFixed(2)
                                              : null} */}

                                              {/* //old */}
                                              {/* {(hasMarkupPermission && markupType == 1) ? data.wholesaleMarkup?.toFixed(2)
                                            : (hasMarkupPermission && markupType == 2) ? data.retailMarkup?.toFixed(2)
                                              : null} */}
                                              {/* </TableCell> */}
                                              {/* <TableCell>{shortUnitName}</TableCell> */}
                                              {/* <TableCell>
                                                <TextField
                                                  type="number"
                                                  sx={{ width: 85 }}
                                                  onKeyPress={(event) => {
                                                    if (
                                                      event.key === '0' &&
                                                      event.target.value ===
                                                        ''
                                                    ) {
                                                      event.preventDefault()
                                                    }
                                                    if (event.key === '.') {
                                                      event.preventDefault()
                                                    }
                                                  }}
                                                  fullWidth
                                                  label={shortUnitName}
                                                  disabled={
                                                    isPreview ? true : 
                                                    data?.fromMapServices ==
                                                    true
                                                      ? true
                                                      : shortUnitName ==
                                                        'Unit'
                                                      ? true
                                                      : false
                                                  }
                                                  // {...getFieldProps(quantityFieldName)}
                                                  defaultValue={
                                                    data.quantity
                                                      ? data.quantity
                                                      : 1
                                                  }
                                                  value={
                                                    data.quantity
                                                      ? data.quantity
                                                      : 1
                                                  }
                                                  onChange={(event) => {
                                                    let newValue =
                                                      event.target.value
                                                    if (
                                                      newValue.startsWith('-')
                                                    ) {
                                                      newValue =
                                                        newValue.slice(1)
                                                    }
                                                    newValue =
                                                      newValue.replace(
                                                        /[^0-9]/g,
                                                        '',
                                                      )
                                                    if (
                                                      newValue === '' ||
                                                      Number(newValue) <= 0
                                                    ) {
                                                      newValue = 1
                                                    } else {
                                                      newValue =
                                                        Number(newValue)
                                                    }

                                                    setSelectedProducts(
                                                      (pv) => [
                                                        ...pv.map((p) => {
                                                          // if(p.id===data.id){
                                                          if (
                                                            p.indexId ===
                                                            data.indexId
                                                          ) {
                                                            let arrayAddr

                                                            const commonAddresses =
                                                              data?.allLocationSame &&
                                                              pv.length > 0
                                                                ? p
                                                                    .location[0]
                                                                : null

                                                            if (
                                                              data?.allLocationSame &&
                                                              commonAddresses
                                                            ) {
                                                              arrayAddr =
                                                                Array(
                                                                  newValue,
                                                                )
                                                                  .fill()
                                                                  .map(
                                                                    (
                                                                      _,
                                                                      i,
                                                                    ) => ({
                                                                      ...commonAddresses,
                                                                      id: i,
                                                                    }),
                                                                  )
                                                            } else {
                                                              arrayAddr = [
                                                                ...p.location,
                                                              ]
                                                              console.log(
                                                                'Hifiiiiiiiiiiiiii Aff',
                                                                arrayAddr,
                                                              )
                                                              if (
                                                                p.location
                                                                  .length <=
                                                                newValue
                                                              ) {
                                                                arrayAddr.push(
                                                                  ...[
                                                                    ...Array(
                                                                      newValue -
                                                                        p
                                                                          .location
                                                                          .length,
                                                                    ),
                                                                  ].map(
                                                                    (
                                                                      a,
                                                                      i,
                                                                    ) => {
                                                                      return {
                                                                        id:
                                                                          p
                                                                            .location
                                                                            .length +
                                                                          i,
                                                                        address:
                                                                          '',
                                                                        city: '',
                                                                        state:
                                                                          '',
                                                                        zip: '',
                                                                      }
                                                                    },
                                                                  ),
                                                                )
                                                              } else {
                                                                arrayAddr =
                                                                  arrayAddr.slice(
                                                                    0,
                                                                    -(
                                                                      p
                                                                        .location
                                                                        .length -
                                                                      newValue
                                                                    ),
                                                                  )
                                                              }
                                                            }

                                                            return {
                                                              ...p,
                                                              quantity:
                                                                newValue,
                                                              // location: arrayAddr
                                                            }
                                                          } else {
                                                            return p
                                                          }
                                                        }),
                                                      ],
                                                    )
                                                    console.log(
                                                      '###############SElected services',
                                                      selectedServices,
                                                    )
                                                    setSelectedServices(
                                                      (pv) => [
                                                        ...pv.map(
                                                          (service) => {
                                                            // if (service.product_id === data.id &&service.prQty) {
                                                            if (
                                                              service.productIndex ===
                                                                data.indexId &&
                                                              service.prQty
                                                            ) {
                                                              return {
                                                                ...service,
                                                                quantity: (
                                                                  service.prQty *
                                                                  newValue *
                                                                  (service?.locationQuantity ||
                                                                    1)
                                                                ).toFixed(2),
                                                                qtyData:
                                                                  Number(
                                                                    newValue,
                                                                  ),
                                                              }
                                                            } else {
                                                              return {
                                                                ...service,
                                                              }
                                                            }
                                                          },
                                                        ),
                                                      ],
                                                    )
                                                    //new chnage on 2-2-24
                                                    //   if (newValue === '.') {
                                                    //     event.preventDefault();
                                                    //     return;
                                                    //   }
                                                    // if (newValue === '' || newValue <= 0) {
                                                    //   event.preventDefault();
                                                    //   return;
                                                    // }
                                                    //   if (newValue.startsWith('-')) {
                                                    //     newValue = newValue.slice(1);
                                                    //   }
                                                    data['quantity'] =
                                                      newValue || 1

                                                    setFieldValue(
                                                      quantityFieldName,
                                                      newValue,
                                                    )
                                                  }}
                                                  error={Boolean(
                                                    touched[
                                                      quantityFieldName
                                                    ] &&
                                                      errors[
                                                        quantityFieldName
                                                      ],
                                                  )}
                                                  helperText={
                                                    touched[
                                                      quantityFieldName
                                                    ] &&
                                                    errors[quantityFieldName]
                                                  }
                                                />
                                              </TableCell> */}
                                              <TableCell>
                                                <TextField
                                                  type="number"
                                                  onKeyPress={(event) => {
                                                    if (
                                                      event.key === '0' &&
                                                      event.target.value ===
                                                        ''
                                                    ) {
                                                      event.preventDefault()
                                                    }
                                                    if (event.key === '.') {
                                                      event.preventDefault()
                                                    }
                                                  }}
                                                  // fullWidth
                                                  sx={{ width: 85 }}
                                                  label={'Qty'}
                                                  disabled={
                                                    isPreview ? true : 
                                                    data?.fromMapServices ==
                                                    true
                                                      ? true
                                                      : false
                                                  }
                                                  // {...getFieldProps(quantityFieldName)}
                                                  defaultValue={
                                                    data.locationQuantity
                                                      ? data.locationQuantity
                                                      : 1
                                                  }
                                                  value={
                                                    data.locationQuantity
                                                      ? data.locationQuantity
                                                      : 1
                                                  }
                                                  onFocus={selectInputValue}
                                                  onClick={selectInputValue}
                                                  onChange={(event) => {
                                                    let newValue =
                                                      event.target.value
                                                    if (
                                                      newValue.startsWith('-')
                                                    ) {
                                                      newValue =
                                                        newValue.slice(1)
                                                    }
                                                    newValue =
                                                      newValue.replace(
                                                        /[^0-9]/g,
                                                        '',
                                                      )
                                                    if (
                                                      newValue === '' ||
                                                      Number(newValue) <= 0
                                                    ) {
                                                      newValue = 1
                                                    } else {
                                                      newValue =
                                                        Number(newValue)
                                                    }
                                                    const newAddr =
                                                      data?.is_single_card
                                                        ? 1
                                                        : newValue
                                                    setSelectedProducts(
                                                      (pv) => [
                                                        ...pv.map((p) => {
                                                          // if(p.id===data.id){
                                                          if (
                                                            p.indexId ===
                                                            data.indexId
                                                          ) {
                                                            let arrayAddr

                                                            const commonAddresses =
                                                              data?.allLocationSame &&
                                                              pv.length > 0
                                                                ? p
                                                                    .location[0]
                                                                : null
                                                            console.log(
                                                              'Hifiiiiiiiiiiiiii Aff',
                                                              commonAddresses,
                                                            )
                                                            if (
                                                              data?.allLocationSame &&
                                                              commonAddresses
                                                            ) {
                                                              arrayAddr =
                                                                Array(
                                                                  Number(
                                                                    newAddr,
                                                                  ),
                                                                )
                                                                  .fill()
                                                                  .map(
                                                                    (
                                                                      _,
                                                                      i,
                                                                    ) => ({
                                                                      //1
                                                                      ...commonAddresses,
                                                                      id: i,
                                                                    }),
                                                                  )
                                                            } else {
                                                              arrayAddr = [
                                                                ...p.location,
                                                              ]
                                                              console.log(
                                                                'Hifiiiiiiiiiiiiii Aff',
                                                                arrayAddr,
                                                              )
                                                              if (
                                                                p.location
                                                                  .length <=
                                                                Number(
                                                                  newAddr,
                                                                )
                                                              ) {
                                                                arrayAddr.push(
                                                                  ...[
                                                                    ...Array(
                                                                      Number(
                                                                        newAddr,
                                                                      ) -
                                                                        p
                                                                          .location
                                                                          .length,
                                                                    ),
                                                                  ].map(
                                                                    (
                                                                      a,
                                                                      i,
                                                                    ) => {
                                                                      return {
                                                                        id:
                                                                          p
                                                                            .location
                                                                            .length +
                                                                          i,
                                                                        address:
                                                                          '',
                                                                        city: '',
                                                                        state:
                                                                          '',
                                                                        zip: '',
                                                                      }
                                                                    },
                                                                  ),
                                                                )
                                                              } else if (
                                                                p.location
                                                                  .length >
                                                                Number(
                                                                  newAddr,
                                                                )
                                                              ) {
                                                                arrayAddr =
                                                                  arrayAddr.slice(
                                                                    0,
                                                                    Number(
                                                                      newAddr,
                                                                    ),
                                                                  )
                                                              } else {
                                                                arrayAddr =
                                                                  arrayAddr.slice(
                                                                    0,
                                                                    -(
                                                                      p
                                                                        .location
                                                                        .length -
                                                                      Number(
                                                                        newAddr,
                                                                      )
                                                                    ),
                                                                  )
                                                              }
                                                            }

                                                            return {
                                                              ...p,
                                                              // quantity:newValue,
                                                              locationQuantity:
                                                                newValue,
                                                                // install_quantity:newValue,
                                                              location:
                                                                arrayAddr,
                                                              install_quantity: p.manually_updated_install_quantity ?  p.install_quantity :Number(newValue) ,
                                                            }
                                                          } else {
                                                            return p
                                                          }
                                                        }),
                                                      ],
                                                    )
                                                    setSelectedServices(
                                                      (pv) => [
                                                        ...pv.map(
                                                          (service) => {
                                                            // if (service.product_id === data.id &&service.prQty) {
                                                            if (
                                                              service.productIndex ===
                                                                data.indexId &&
                                                              service.prQty
                                                            ) {
                                                              console.log(
                                                                '############service.qtyData',
                                                                service.qtyData,
                                                              )
                                                              console.log(
                                                                '############service.prQty',
                                                                service.prQty,
                                                              )
                                                              console.log(
                                                                '############service.newValue',
                                                                newValue,
                                                              )
                                                              return {
                                                                ...service,
                                                                quantity: (
                                                                  newValue *
                                                                  (service.qtyData ||
                                                                    1) *
                                                                  service.prQty
                                                                ).toFixed(2),
                                                                locationQuantity:
                                                                  newValue,
                                                                // install_quantity:newValue,
                                                              }
                                                            } else {
                                                              return {
                                                                ...service,
                                                              }
                                                            }
                                                          },
                                                        ),
                                                      ],
                                                    )
                                                  }}
                                                  error={Boolean(
                                                    touched[
                                                      quantityFieldName
                                                    ] &&
                                                      errors[
                                                        quantityFieldName
                                                      ],
                                                  )}
                                                  helperText={
                                                    touched[
                                                      quantityFieldName
                                                    ] &&
                                                    errors[quantityFieldName]
                                                  }
                                                />
                                              </TableCell>
                                              <TableCell>
                                                <IconButton
                                                  onClick={() => {
                                                    setLocationStates({
                                                      ...locationStates,
                                                      [data.indexId]: true,
                                                    })
                                                  }}
                                                  disabled={isPreview ? true : false}
                                                >
                                                  <LocationOn
                                                    sx={{
                                                      color:
                                                        data.location?.some(
                                                          (obj) =>
                                                            [
                                                              obj.address,
                                                              obj.city,
                                                              obj.state,
                                                              obj.zip,
                                                            ].some(
                                                              (value) =>
                                                                value ===
                                                                  '' ||
                                                                value ===
                                                                  null,
                                                            ),
                                                        )
                                                          ? ''
                                                          : theme.palette
                                                              .primary.main,
                                                    }}
                                                  />
                                                </IconButton>
                                              </TableCell>
                                              {/* <TableCell>{data.product_id||data.id}</TableCell> */}

                                              {/* <TableCell>
                                    <Autocomplete
sx={{ width: 70 }}
id="combo-box-demo"
disableClearable
options={marketingAdjustmentType || []}
value={marketingAdjustmentType?.find((type) => type.id === data.markAdjType)} // Use value to set the correct selected option
onChange={(event, newValue) => {
  setSelectedProducts((prevProducts) => {
    return prevProducts.map((product) => {
      if (product.indexId === data.indexId) {
        return {
          ...product,
          markAdjType: newValue?.id, // Set adjustment type or default to the first option
          // adjustment: 0,
        };
      }
      return product;
    });
  });
}}
renderInput={(params) => (
  <TextField
    {...params}
    required
    error={Boolean(touched.marketingAdjType && errors.marketingAdjType)}
    helperText={touched.marketingAdjType && errors.marketingAdjType}
    label="Select type"
  />
)}
getOptionLabel={(option) => (option.name ? option.name : '')}
/>

                                        </TableCell> */}

                                              {/* <TableCell> */}
                                              {/* <TextField
                                        type="number"
                                        label="Discount"
                                        value={Number(data.discount)}
                                        // {...getFieldProps(discountFieldName)}
                                        defaultValue={data.discount?data.discount:0}
                                        onChange={(event) => {
                                          let newValue = event.target.value;
                                          if (newValue.startsWith('-')) {
                                            newValue = newValue.slice(1);
                                          }
                                          if(markupType == 1){
                                            if (Number(newValue) > maxDiscount_wholesale) {
                                              newValue = maxDiscount_wholesale.toFixed(2);
                                            }
                                          }else if(markupType == 2){
                                            if (Number(newValue) > maxDiscount_retail) {
                                              newValue = maxDiscount_retail.toFixed(2);
                                            }
                                          }else{
                                            newValue = 0;
                                          }
                                          if (newValue === '-0.00') {
                                            newValue = 0;
                                          }
                                          setRefreshData(!refreshData)
                                          data['discount'] = newValue
                                          setFieldValue(discountFieldName, newValue);
                                        }}
                                        error={Boolean(touched[discountFieldName] && errors[discountFieldName])}
                                        helperText={touched[discountFieldName] && errors[discountFieldName]}
                                        inputProps={{ max: markupType == 1 ? maxDiscount_wholesale : markupType == 2 ? maxDiscount_retail : 0, min: 0 }}
                                      /> */}

                                              <TableCell>
                                                {data?.is_product_row == 1 ? (
                                                  'N/A'
                                                ) : (
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                  <Remove 
                                                    fontSize="small" 
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() =>
                                                      handleProductMarketingTypeChange(
                                                        data.indexId,
                                                        false,
                                                        data,
                                                      )
                                                    }
                                                  />
                                                  <FormControlLabel
                                                    control={
                                                      <Switch
                                                        checked={data.adj_value_type}
                                                        onChange={(event) =>
                                                          handleProductMarketingTypeChange(
                                                            data.indexId,
                                                            event.target.checked,
                                                            data,
                                                          )
                                                        }
                                                      />
                                                    }
                                                    label=""
                                                  />
                                                  <Add 
                                                    fontSize="small" 
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() =>
                                                      handleProductMarketingTypeChange(
                                                        data.indexId,
                                                        true,
                                                        data,
                                                      )
                                                    }
                                                  />
                                                </Stack>
                                                )}
                                              </TableCell>
                                              <TableCell>
                                                {data?.is_product_row == 1 ? (
                                                  'N/A'
                                                ) : (
                                                  <TextField
                                          type="number"
                                                    inputProps={{ min: 0 }}
                                                    label='$'
                                                    InputLabelProps={{
                                                      shrink: Boolean(
                                                        data.adjustment_draft !== undefined
                                                          ? data.adjustment_draft !== ''
                                                          : Number(data.adjustment),
                                                      ),
                                                    }}
                                                    value={
                                                      data.adjustment_draft !== undefined
                                                        ? limitDecimalInput(
                                                            data.adjustment_draft,
                                                          )
                                                        : Number(data.adjustment) || ''
                                                    }
                                                    onWheel={(e) => e.target.blur()}
                                                    onBeforeInput={(e) => {
                                                      const inputElement = e.target
                                                      const nextValue = inputElement.value 
                                                      const hasMarketingPermission = explodedPermissions?.some((permission) => ['Allow Negative Marketing Adjustment Estimate'].includes(permission));
                                                      const maxNegative = getMaxNegativeAdjustment(data, hasMarketingPermission)
                                                      if (Number(nextValue) >= maxNegative && (data.adj_value_type === false || data.adj_value_type === 0) && hasMarketingPermission) {
                                                        e.preventDefault()
                                                        enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                      } else if (Number(nextValue) > maxNegative && (data.adj_value_type === false || data.adj_value_type === 0) && !hasMarketingPermission) {
                                                        e.preventDefault()
                                                        enqueueSnackbar(
                                                          `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${maxNegative.toFixed(2)}`,
                                                          { variant: "error" },
                                                        )
                                                      }
                                                    }}
                                          onChange={(event) => {
                                                      handleMarketingAdjustmentChange(
                                                        data.indexId,
                                                        event.target.value,
                                                      )
                                          }}
                                          onBlur={(event) => {
                                                      handleMarketingAdjustmentChange(
                                                        data.indexId,
                                                        event.target.value,
                                                        { isBlur: true },
                                                      )
                                          }}
                                          onKeyDown={(event) => {
                                                      if (
                                                        event.key === '-' ||
                                                        event.key === '+'
                                                      ) {
                                                        event.preventDefault()
                                                      }
                                                      // Prevent arrow down key when value is 0 or would go negative
                                                      if (event.key === 'ArrowDown') {
                                                        const inputValue = event.target.value
                                                        const currentValue = parseFloat(inputValue) || 0
                                                        const step = parseFloat(event.target.step) || 1
                                                        if (currentValue - step < 0) {
                                                          event.preventDefault()
                                                        }
                                            }
                                          }}
                                                    error={Boolean(
                                                      touched[
                                                        adjustmentFieldName
                                                      ] &&
                                                        errors[
                                                          adjustmentFieldName
                                                        ],
                                                    )}
                                                    helperText={
                                                      touched[
                                                        adjustmentFieldName
                                                      ] &&
                                                      errors[adjustmentFieldName]
                                                    }
                                                  />
                                                )}
                                              </TableCell>
                                              <TableCell>
                                                {data?.is_product_row == 1 ? 'N/A' : productCost.toFixed(2)}
                                              </TableCell>
                                              {/* Product Total (matches stored product_total like Quotation) */}
                                              <TableCell>
                                                {(IsInstall||data?.install_cost) ? '' : `${fUSPrice(lineProductTotal.toFixed(2))}`}
                                              </TableCell>
                                              <TableCell>
                                                {(data?.fromMapServices == true || isPreview) ? (
                                                  ''
                                                ) : (
                                                  <Box sx={{ display: 'flex', flexDirection:'row', justifyContent:data?.is_product_row == 1 ? 'flex-end' : 'space-between' }} >
                                                    {data?.is_product_row == 1 ? '' :
                                                    <Tooltip title='Edit'>
                                                      <IconButton
                                                        onClick={() => {
                                                          setProductRowForCatalogChoice(data)
                                                          setOpenProductCatalogChoiceModal(true)
                                                        }}
                                                      >
                                                        <Edit />
                                                      </IconButton>
                                                    </Tooltip>}
                                                    <IconButton
                                                      // disabled={
                                                      //   userType === 18 && data?.addedByUserType !== 18
                                                      // }
                                                      onClick={() =>
                                                        data?.is_product_row == 1
                                                          ? handleDeleteRequestEstimateProduct(data.indexId, data.backendId)
                                                          : handleDeleteProduct(
                                                              data.id || data.product_id,
                                                              data.indexId,
                                                            )
                                                      }
                                                    >
                                                      <Delete />
                                                    </IconButton>
                                                  </Box>
                                                )}
                                              </TableCell>
                                            </TableRow>
                                            {(data?.install_cost) ? (
                                              <TableRow
                                                key={`summary-${data.indexId}`}
                                                sx={losingMoneyRowSx}
                                              >
                                                {openEdit && !isPreview && (
                                                  <TableCell padding="checkbox" sx={{ width: 40 }} />
                                                )}
                                                <TableCell padding="checkbox"></TableCell>
                                                <TableCell sx={{ fontWeight: 600 }}>—</TableCell>
                                                <TableCell align="center">
                                                  -
                                                </TableCell>
                                                <TableCell>
                                                  <Typography
                                                    sx={{
                                                      color: isSplitOrder
                                                        ? theme.palette[
                                                            FacilityTypes.find(
                                                              (f) =>
                                                                f.id ===
                                                                data?.facility_id,
                                                            )?.color ||
                                                              'primary'
                                                          ]?.main
                                                        : 'inherit',
                                                    }}
                                                  >
                                                    Install Price
                                                  </Typography>
                                                </TableCell>
                                                <TableCell align="center">
                                                  -
                                                </TableCell>
                                                <TableCell align="center">
                                                  -
                                                </TableCell>
                                                <TableCell align="center">
                                                  
                                                </TableCell>
                                                <TableCell align="center">
                                                  
                                                </TableCell>
                                                <TableCell align="center">
                                                  
                                                </TableCell>
                                                <TableCell>
                                                  {data?.install_formula_cost_each != null &&
                                                  data?.install_formula_cost_each !== ''
                                                    ? Number(data.install_formula_cost_each).toFixed(2)
                                                    : (data?.expected_install_labor_cost_with_markup?.toFixed(2) || 0)}
                                                </TableCell>
                                                {/* <TableCell align="center">
                                                  
                                                </TableCell> */}
                                                {/* <TableCell align="center">
                                                  
                                                </TableCell> */}
                                                {/* <TableCell align="center">
                                                  -
                                                </TableCell> */}
                                                {/* Incoming Percentage column for Install Price - only show when isSplitOrder is true */}
                                                {isSplitOrder ? (
                                                  <>
                                                    <TableCell align="center">
                                                      -
                                                    </TableCell>
                                                  </>
                                                ) : (
                                                  <TableCell align="center">-</TableCell>
                                                )}
                                                <TableCell>
                                                  {/* ALL-815 backup - previous read-only install price display:
                                                  {parseFloat(data?.install_cost || 0).toFixed(2)} */}
                                                  {(() => {
                                                    const installFormulaEach = Number(
                                                      data?.expected_install_labor_cost_with_markup ||
                                                        0,
                                                    )
                                                    const hasNegativeInstallPermission =
                                                      explodedPermissions?.some(
                                                        (permission) =>
                                                          [
                                                            'Allow Negative Marketing Adjustment Sales Order',
                                                            'Allow Negative Marketing Adjustment Estimate',
                                                          ].includes(permission),
                                                      )
                                                    const installPriceMin =
                                                      hasNegativeInstallPermission
                                                        ? 0.01
                                                        : Math.max(
                                                            0.01,
                                                            installFormulaEach,
                                                          )
                                                    const dataInstallCost = getDisplayedInstallPrice(data)
                                                    return (
                                                  <TextField
                                                    required
                                                    fullWidth
                                                    type="number"
                                                    label={'Install Price Each'}
                                                    disabled={isPreview ? true : false}
                                                    sx={{ width: 85 }}
                                                    value={
                                                      data.install_price_draft !== undefined
                                                        ? limitDecimalInput(
                                                            data.install_price_draft,
                                                          )
                                                        : formatRetailPriceDisplay(
                                                            dataInstallCost,
                                                          )
                                                    }
                                                    onFocus={selectInputValue}
                                                    onClick={selectInputValue}
                                                    onKeyPress={(event) => {
                                                      if (event.key === '-') {
                                                        event.preventDefault()
                                                      }
                                                      if (event.key === 'e') {
                                                        event.preventDefault()
                                                      }
                                                    }}
                                                    onKeyDown={(event) => {
                                                      if (
                                                        event.key === 'ArrowUp' ||
                                                        event.key === 'ArrowDown'
                                                      ) {
                                                        event.preventDefault()
                                                        const current =
                                                          data.install_price_draft !== undefined
                                                            ? data.install_price_draft
                                                            : formatRetailPriceDisplay(
                                                                dataInstallCost,
                                                              )
                                                        handleInstallPriceChange(
                                                          data.indexId,
                                                          stepRetailPriceByArrow(
                                                            current,
                                                            event.key === 'ArrowUp'
                                                              ? 'up'
                                                              : 'down',
                                                            installPriceMin,
                                                          ),
                                                          { isBlur: true },
                                                        )
                                                      }
                                                    }}
                                                    inputProps={{
                                                      min: installPriceMin,
                                                      step: 1,
                                                    }}
                                                    defaultValue={0}
                                                    onChange={(event) => {
                                                      const current =
                                                        data.install_price_draft !== undefined
                                                          ? data.install_price_draft
                                                          : formatRetailPriceDisplay(
                                                              dataInstallCost,
                                                            )
                                                      handleInstallPriceChange(
                                                        data.indexId,
                                                        normalizeRetailArrowChange(
                                                          current,
                                                          event.target.value,
                                                          installPriceMin,
                                                        ),
                                                      )
                                                    }}
                                                    onBlur={(event) => {
                                                      handleInstallPriceChange(
                                                        data.indexId,
                                                        event.target.value,
                                                        { isBlur: true },
                                                      )
                                                    }}
                                                  />
                                                    )
                                                  })()}
                                                </TableCell>
                                                <TableCell>-</TableCell>
                                                <TableCell >
                                                  <TextField
                                                    required
                                                    // fullWidth
                                                    sx={{ width: 85 }}
                                                    type="number"
                                                    label={'Qty'}
                                                    disabled={isPreview ? true : false}
                                                    value={Number(data.install_quantity || 1)}
                                                    defaultValue={1}
                                                    onFocus={selectInputValue}
                                                    onClick={selectInputValue}
                                                    onKeyPress={(event) => {
                                                      if (
                                                        event.key === '0' &&
                                                        event.target.value === ''
                                                      ) {
                                                        event.preventDefault()
                                                      }
                                                      if (event.key === '-') {
                                                        event.preventDefault()
                                                      }
                                                      if (event.key === '.') {
                                                        event.preventDefault()
                                                      }
                                                    }}
                                                    onChange={(event) => {
                                                      let newValue = event.target.value
                                                      if (newValue !== '0' && newValue !== '') {
                                                        setSelectedProducts((prevProducts) =>
                                                          prevProducts.map((p) => {
                                                            if (p.indexId !== data.indexId) return p
                                                            return {
                                                              ...p,
                                                              install_quantity: Number(newValue),
                                                              manually_updated_install_quantity: true,
                                                            }
                                                          }),
                                                        )
                                                        data['install_quantity'] = Number(newValue)
                                                      }
                                                    }}
                                                  />
                                                  {/* {data?.install_quantity || 1} */}
                                                </TableCell>
                                                <TableCell align="center"></TableCell>
                                                <TableCell align="center">
                                                  <Stack direction="row" spacing={1} alignItems="center">
                                                    <Remove
                                                      fontSize="small"
                                                      style={{ cursor: 'pointer' }}
                                                      onClick={() =>
                                                        handleInstallMarketingTypeChange(
                                                          data.indexId,
                                                          false,
                                                          data,
                                                        )
                                                      }
                                                    />
                                                    <FormControlLabel
                                                      control={
                                                        <Switch
                                                          checked={Boolean(data.install_adj_value_type)}
                                                          onChange={(event) =>
                                                            handleInstallMarketingTypeChange(
                                                              data.indexId,
                                                              event.target.checked,
                                                              data,
                                                            )
                                                          }
                                                        />
                                                      }
                                                      label=""
                                                    />
                                                    <Add
                                                      fontSize="small"
                                                      style={{ cursor: 'pointer' }}
                                                      onClick={() =>
                                                        handleInstallMarketingTypeChange(
                                                          data.indexId,
                                                          true,
                                                          data,
                                                        )
                                                      }
                                                    />
                                                  </Stack>
                                                </TableCell>
                                                {Array.from({ length: 1 }).map((_, idx) => (
                                                  <TableCell align="center" key={idx}>
                                                    {idx === 0 ? (
                                                      <TextField
                                                        type="number"
                                                        inputProps={{ min: 0 }}
                                                        label="$"
                                                        InputLabelProps={{
                                                          shrink: Boolean(
                                                            data.install_adjustment_draft !== undefined
                                                              ? data.install_adjustment_draft !== ''
                                                              : Number(data.install_adjustment),
                                                          ),
                                                        }}
                                                        value={
                                                          data.install_adjustment_draft !== undefined
                                                            ? limitDecimalInput(
                                                                data.install_adjustment_draft,
                                                              )
                                                            : Number(data.install_adjustment) || ''
                                                        }
                                                        onWheel={(e) => e.target.blur()}
                                                        onBeforeInput={(e) => {
                                                          // const char = e.data
                                                          // const nextValue = e.target.value + char
                                                          const inputElement =
                                                            e.target
                                                          const nextValue =
                                                            inputElement.value
                                                          const hasMarketingPermission =
                                                            explodedPermissions?.some(
                                                              (permission) =>
                                                                [
                                                                  'Allow Negative Marketing Adjustment Estimate',
                                                                ].includes(
                                                                  permission,
                                                                ),
                                                            )
                                                          const maxNegative =
                                                            getMaxNegativeInstallAdjustment(
                                                              data,
                                                              hasMarketingPermission,
                                                            )
                                                          if (
                                                            Number(nextValue) >=
                                                              maxNegative &&
                                                            data.install_adj_value_type ===
                                                              false &&
                                                            hasMarketingPermission
                                                          ) {
                                                            e.preventDefault()
                                                            enqueueSnackbar(
                                                              'Retail value cannot be zero or less',
                                                              {
                                                                variant:
                                                                  'error',
                                                              },
                                                            )
                                                          } else if (
                                                            Number(nextValue) >
                                                              maxNegative &&
                                                            data.install_adj_value_type ===
                                                              false &&
                                                            !hasMarketingPermission
                                                          ) {
                                                            e.preventDefault()
                                                            enqueueSnackbar(
                                                              `Negative Adjustment Amount cannot reduce below $${maxNegative.toFixed(
                                                                2,
                                                              )} (Install Formula Limit)`,
                                                              {
                                                                variant:
                                                                  'error',
                                                              },
                                                            )
                                                          }
                                                        }}
                                                        onChange={(event) =>
                                                          handleInstallMarketingAdjustmentChange(
                                                            data.indexId,
                                                            event.target.value,
                                                          )
                                                        }
                                                        onBlur={(event) =>
                                                          handleInstallMarketingAdjustmentChange(
                                                            data.indexId,
                                                            event.target.value,
                                                            { isBlur: true },
                                                          )
                                                        }
                                                        onKeyDown={(event) => {
                                                          if (event.key === '-' || event.key === '+') {
                                                            event.preventDefault()
                                                          }
                                                          if (event.key === 'ArrowDown') {
                                                            const inputValue = event.target.value
                                                            const currentValue = parseFloat(inputValue) || 0
                                                            const step = parseFloat(event.target.step) || 1
                                                            if (currentValue - step < 0) {
                                                              event.preventDefault()
                                                            }
                                                          }
                                                        }}
                                                      />
                                                    ) : (
                                                      '-'
                                                    )}
                                                  </TableCell>
                                                ))}
                                                <TableCell>
                                                  {(
                                                    parseFloat(
                                                      data?.install_cost || 0,
                                                    ) *
                                                    (Number(data?.install_quantity) || 1)
                                                  ).toFixed(2)}
                                                </TableCell>
                                                <TableCell>
                                                  {(() => {
                                                    const locQty = Number(data?.locationQuantity) || 1
                                                    const installQty = Number(data?.install_quantity) || 1
                                                    const discount = Number(data?.discount) || 0

                                                    // Use the exact same calculation as the product subtotal column
                                                    const productSubTotal =
                                                      markupType == 1
                                                        ? (Number(data?.price) || 0) * locQty
                                                        : markupType == 2
                                                        ? (Number(data?.actual_retail_price || data?.retail_price || 0)) * locQty
                                                        : 0

                                                    // Use the exact same calculation as the install subtotal column
                                                    const installSubTotal =
                                                      (Number(data?.install_cost) || 0) *
                                                      installQty

                                                    // Product Total is the sum of both subtotals minus discount
                                                    // return Math.max(
                                                    //   0,
                                                    //   productSubTotal + installSubTotal - discount,
                                                    // ).toFixed(2)
                                                    const total = Math.max(
                                                      0,
                                                      productSubTotal + installSubTotal - discount,
                                                    )
                                                    return fUSPrice(total.toFixed(2))
                                                  })()}
                                                </TableCell>
                                                <TableCell>
                                                  {isPreview ? '' : 
                                                  <Box sx={{ display: 'flex', flexDirection:'row', justifyContent:'flex-end' }} >
                                                    <IconButton
                                                    // disabled={
                                                    //   userType === 18  && data?.addedByUserType !== 18
                                                    // }
                                                      onClick={() =>
                                                        handleDeleteInstallCost(
                                                          data.id ||
                                                            data.product_id,
                                                          data.indexId,
                                                        )
                                                      }
                                                    >
                                                      <Delete />
                                                    </IconButton>
                                                  </Box>
                                                  }
                                                </TableCell>
                                              </TableRow>
                                            ) : (
                                              ''
                                            )}
                                            <TableRow>
                                              <TableCell
                                                colSpan={15}
                                                sx={{ padding: 0 }}
                                              >
                                                {/* <Divider /> */}
                                              </TableCell>
                                            </TableRow>
                                            <Modal
                                              open={
                                                locationStates[data.indexId]
                                              }
                                              handleClose={() => {
                                                setLocationStates({
                                                  ...locationStates,
                                                  [data.indexId]: false,
                                                })
                                              }}
                                            >
                                              <Stack
                                                direction={{
                                                  xs: 'column',
                                                  sm: 'row',
                                                }}
                                                justifyContent={
                                                  'space-between'
                                                }
                                                alignItems={'center'}
                                              >
                                                {data?.fromMapServices !=
                                                  true && (
                                                  //  && index === 0
                                                  <FormControlLabel
                                                    control={
                                                      <Switch
                                                        checked={
                                                          data?.allLocationSame
                                                        }
                                                        onChange={() =>
                                                          handleAllLocationSameChange(
                                                            index,
                                                          )
                                                        }
                                                      />
                                                    }
                                                    label="All Locations Same"
                                                  />
                                                )}
                                                {values.project_category
                                                  ?.id !== 14 ? (
                                                  <Box
                                                    sx={{
                                                      display: 'flex',
                                                      flexDirection: 'column',
                                                      width: '50%',
                                                      alignItems: 'center',
                                                      mt: 2,
                                                    }}
                                                  >
                                                    {/* <Typography variant="subtitle2">Qty Location Settings</Typography> */}
                                                    <LabelStyle
                                                      sx={{
                                                        fontSize: '16px',
                                                      }}
                                                    >
                                                      Qty Location Settings
                                                    </LabelStyle>
                                                    <Box
                                                      display="flex"
                                                      alignItems="center"
                                                      gap={1}
                                                      mt={1}
                                                    >
                                                      <Typography variant="subtitle2">
                                                        Multiple
                                                      </Typography>
                                                      {console.log(
                                                        'data?.is_single_card',
                                                        data?.is_single_card,
                                                      )}
                                                      {/* <LabelStyle>Multiple</LabelStyle> */}
                                                      <Switch
                                                        color="primary"
                                                        checked={Boolean(
                                                          data?.is_single_card,
                                                        )}
                                                        onChange={(event) => {
                                                          const checked =
                                                            event.target
                                                              .checked
                                                          setSelectedProducts(
                                                            (prev) =>
                                                              prev.map(
                                                                (p) => {
                                                                  if (
                                                                    p.indexId !==
                                                                    data.indexId
                                                                  )
                                                                    return p

                                                                  const count =
                                                                    Number(
                                                                      p.locationQuantity ||
                                                                        1,
                                                                    )

                                                                  if (
                                                                    checked
                                                                  ) {
                                                                    return {
                                                                      ...p,
                                                                      is_single_card: true,
                                                                      location:
                                                                        p
                                                                          .location
                                                                          ?.length
                                                                          ? [
                                                                              p
                                                                                .location[0],
                                                                            ]
                                                                          : [
                                                                              {
                                                                                id: 0,
                                                                                address:
                                                                                  '',
                                                                                city: '',
                                                                                state:
                                                                                  '',
                                                                                zip: '',
                                                                              },
                                                                            ],
                                                                    }
                                                                  } else {
                                                                    const allSame =
                                                                      p.allLocationSame
                                                                    const firstAddress =
                                                                      p
                                                                        .location?.[0]
                                                                    let arrayAddr =
                                                                      []

                                                                    if (
                                                                      allSame &&
                                                                      firstAddress
                                                                    ) {
                                                                      arrayAddr =
                                                                        Array(
                                                                          count,
                                                                        )
                                                                          .fill()
                                                                          .map(
                                                                            (
                                                                              _,
                                                                              i,
                                                                            ) => ({
                                                                              ...firstAddress,
                                                                              id: i,
                                                                              req_loc_id:
                                                                                p
                                                                                  .location[
                                                                                  i
                                                                                ]
                                                                                  ?.req_loc_id ??
                                                                                null,
                                                                            }),
                                                                          )
                                                                    } else {
                                                                      arrayAddr =
                                                                        [
                                                                          ...p.location,
                                                                        ]
                                                                      if (
                                                                        arrayAddr.length <
                                                                        count
                                                                      ) {
                                                                        arrayAddr.push(
                                                                          ...Array(
                                                                            count -
                                                                              arrayAddr.length,
                                                                          )
                                                                            .fill()
                                                                            .map(
                                                                              (
                                                                                _,
                                                                                i,
                                                                              ) => ({
                                                                                id:
                                                                                  arrayAddr.length +
                                                                                  i,
                                                                                address:
                                                                                  '',
                                                                                city: '',
                                                                                state:
                                                                                  '',
                                                                                zip: '',
                                                                              }),
                                                                            ),
                                                                        )
                                                                      } else if (
                                                                        arrayAddr.length >
                                                                        count
                                                                      ) {
                                                                        arrayAddr =
                                                                          arrayAddr.slice(
                                                                            0,
                                                                            count,
                                                                          )
                                                                      }
                                                                    }

                                                                    return {
                                                                      ...p,
                                                                      is_single_card: false,
                                                                      location:
                                                                        arrayAddr,
                                                                    }
                                                                  }
                                                                },
                                                              ),
                                                          )
                                                        }}
                                                      />
                                                      {/* <LabelStyle>Single</LabelStyle> */}
                                                      <Typography variant="subtitle2">
                                                        Single
                                                      </Typography>
                                                    </Box>
                                                  </Box>
                                                ) : (
                                                  ''
                                                )}
                                              </Stack>
                                              <Grid
                                                container
                                                spacing={3}
                                                sx={{
                                                  justifyContent: 'center',
                                                  width: '100%',
                                                }}
                                              >
                                                {data.location.map(
                                                  (addr, i) => (
                                                    <Grid item xs={12}>
                                                      <Typography
                                                        variant="h5"
                                                        sx={{ mb: 2 }}
                                                      >
                                                        Location{' '}
                                                        {data?.fromMapServices ==
                                                        true
                                                          ? i + 1
                                                          : i + 1}
                                                      </Typography>

                                                      <Stack
                                                        direction={{
                                                          xs: 'column',
                                                          sm: 'row',
                                                        }}
                                                        spacing={{
                                                          xs: 3,
                                                          sm: 2,
                                                        }}
                                                        sx={{ mb: 2 }}
                                                      >
                                                        <TextField
                                                          fullWidth
                                                          label="Address"
                                                          size="small"
                                                          value={
                                                            data.location[i]
                                                              .address || ''
                                                          }
                                                          disabled={
                                                            data?.fromMapServices ==
                                                              true &&
                                                            data.location[i]
                                                              .address
                                                              ? true
                                                              : i !== 0 &&
                                                                data?.allLocationSame
                                                              ? true
                                                              : false
                                                          }
                                                          // onChange={(event)=>{
                                                          //   let arrayAddr = [...data.location]
                                                          //   arrayAddr[i].address = event.target.value;
                                                          //   setSelectedProducts(pv=>([...pv.map(p=>{
                                                          //     // if(p.id===data.id){
                                                          //     if (p.indexId === data.indexId) {
                                                          //       return {
                                                          //         ...p,
                                                          //         location: arrayAddr
                                                          //       }
                                                          //     }else{
                                                          //       return p;
                                                          //     }
                                                          //   })]))
                                                          // }}
                                                          onChange={(
                                                            event,
                                                          ) => {
                                                            setSelectedProducts(
                                                              (
                                                                prevProducts,
                                                              ) =>
                                                                prevProducts.map(
                                                                  (p) => {
                                                                    if (
                                                                      p.indexId ===
                                                                      data.indexId
                                                                    ) {
                                                                      let updatedLocations =
                                                                        [
                                                                          ...p.location,
                                                                        ]
                                                                      if (
                                                                        p.allLocationSame
                                                                      ) {
                                                                        updatedLocations =
                                                                          updatedLocations.map(
                                                                            () => ({
                                                                              ...updatedLocations[0],
                                                                              address:
                                                                                event
                                                                                  .target
                                                                                  .value,
                                                                            }),
                                                                          )
                                                                      } else {
                                                                        updatedLocations[
                                                                          i
                                                                        ] = {
                                                                          ...updatedLocations[
                                                                            i
                                                                          ],
                                                                          address:
                                                                            event
                                                                              .target
                                                                              .value,
                                                                        }
                                                                      }
                                                                      return {
                                                                        ...p,
                                                                        location:
                                                                          updatedLocations,
                                                                      }
                                                                    }
                                                                    return p
                                                                  },
                                                                ),
                                                            )
                                                          }}
                                                        />
                                                      </Stack>

                                                      <Stack
                                                        direction={{
                                                          xs: 'column',
                                                          sm: 'row',
                                                        }}
                                                        spacing={{
                                                          xs: 3,
                                                          sm: 2,
                                                        }}
                                                        sx={{ mb: 2 }}
                                                      >
                                                        <TextField
                                                          fullWidth
                                                          label="City"
                                                          size="small"
                                                          value={
                                                            data.location[i]
                                                              .city || ''
                                                          }
                                                          disabled={
                                                            data?.fromMapServices ==
                                                              true &&
                                                            data.location[i]
                                                              .city
                                                              ? true
                                                              : i !== 0 &&
                                                                data?.allLocationSame
                                                              ? true
                                                              : false
                                                          }
                                                          // onChange={(event)=>{
                                                          //   let arrayAddr = [...data.location]
                                                          //   arrayAddr[i].city = event.target.value;
                                                          //   setSelectedProducts(pv=>([...pv.map(p=>{
                                                          //     // if(p.id===data.id){
                                                          //     if (p.indexId === data.indexId) {
                                                          //       return {
                                                          //         ...p,
                                                          //         location: arrayAddr
                                                          //       }
                                                          //     }else{
                                                          //       return p;
                                                          //     }
                                                          //   })]))
                                                          // }}
                                                          onChange={(
                                                            event,
                                                          ) => {
                                                            setSelectedProducts(
                                                              (
                                                                prevProducts,
                                                              ) =>
                                                                prevProducts.map(
                                                                  (p) => {
                                                                    if (
                                                                      p.indexId ===
                                                                      data.indexId
                                                                    ) {
                                                                      let updatedLocations =
                                                                        [
                                                                          ...p.location,
                                                                        ]
                                                                      if (
                                                                        p.allLocationSame
                                                                      ) {
                                                                        updatedLocations =
                                                                          updatedLocations.map(
                                                                            () => ({
                                                                              ...updatedLocations[0],
                                                                              city: event
                                                                                .target
                                                                                .value,
                                                                            }),
                                                                          )
                                                                      } else {
                                                                        updatedLocations[
                                                                          i
                                                                        ] = {
                                                                          ...updatedLocations[
                                                                            i
                                                                          ],
                                                                          city: event
                                                                            .target
                                                                            .value,
                                                                        }
                                                                      }
                                                                      return {
                                                                        ...p,
                                                                        location:
                                                                          updatedLocations,
                                                                      }
                                                                    }
                                                                    return p
                                                                  },
                                                                ),
                                                            )
                                                          }}
                                                        />
                                                        <TextField
                                                          fullWidth
                                                          label="State"
                                                          size="small"
                                                          value={
                                                            data.location[i]
                                                              .state || ''
                                                          }
                                                          disabled={
                                                            data?.fromMapServices ==
                                                              true &&
                                                            data.location[i]
                                                              .state
                                                              ? true
                                                              : i !== 0 &&
                                                                data?.allLocationSame
                                                              ? true
                                                              : false
                                                          }
                                                          // onChange={(event)=>{
                                                          //   let arrayAddr = [...data.location]
                                                          //   arrayAddr[i].state = event.target.value;
                                                          //   setSelectedProducts(pv=>([...pv.map(p=>{
                                                          //     // if(p.id===data.id){
                                                          //     if (p.indexId === data.indexId) {
                                                          //       return {
                                                          //         ...p,
                                                          //         location: arrayAddr
                                                          //       }
                                                          //     }else{
                                                          //       return p;
                                                          //     }
                                                          //   })]))
                                                          // }}
                                                          onChange={(
                                                            event,
                                                          ) => {
                                                            setSelectedProducts(
                                                              (
                                                                prevProducts,
                                                              ) =>
                                                                prevProducts.map(
                                                                  (p) => {
                                                                    if (
                                                                      p.indexId ===
                                                                      data.indexId
                                                                    ) {
                                                                      let updatedLocations =
                                                                        [
                                                                          ...p.location,
                                                                        ]
                                                                      if (
                                                                        p.allLocationSame
                                                                      ) {
                                                                        updatedLocations =
                                                                          updatedLocations.map(
                                                                            () => ({
                                                                              ...updatedLocations[0],
                                                                              state:
                                                                                event
                                                                                  .target
                                                                                  .value,
                                                                            }),
                                                                          )
                                                                      } else {
                                                                        updatedLocations[
                                                                          i
                                                                        ] = {
                                                                          ...updatedLocations[
                                                                            i
                                                                          ],
                                                                          state:
                                                                            event
                                                                              .target
                                                                              .value,
                                                                        }
                                                                      }
                                                                      return {
                                                                        ...p,
                                                                        location:
                                                                          updatedLocations,
                                                                      }
                                                                    }
                                                                    return p
                                                                  },
                                                                ),
                                                            )
                                                          }}
                                                        />
                                                        <TextField
                                                          fullWidth
                                                          label="Zip / Postal Code"
                                                          size="small"
                                                          value={
                                                            data.location[i]
                                                              .zip || ''
                                                          }
                                                          disabled={
                                                            data?.fromMapServices ==
                                                              true &&
                                                            data.location[i]
                                                              .zip
                                                              ? true
                                                              : i !== 0 &&
                                                                data?.allLocationSame
                                                              ? true
                                                              : false
                                                          }
                                                          // onChange={(event)=>{
                                                          //   let arrayAddr = [...data.location]
                                                          //   arrayAddr[i].zip = event.target.value;
                                                          //   setSelectedProducts(pv=>([...pv.map(p=>{
                                                          //     // if(p.id===data.id){
                                                          //     if (p.indexId === data.indexId) {
                                                          //       return {
                                                          //         ...p,
                                                          //         location: arrayAddr
                                                          //       }
                                                          //     }else{
                                                          //       return p;
                                                          //     }
                                                          //   })]))
                                                          // }}
                                                          onChange={(
                                                            event,
                                                          ) => {
                                                            setSelectedProducts(
                                                              (
                                                                prevProducts,
                                                              ) =>
                                                                prevProducts.map(
                                                                  (p) => {
                                                                    if (
                                                                      p.indexId ===
                                                                      data.indexId
                                                                    ) {
                                                                      let updatedLocations =
                                                                        [
                                                                          ...p.location,
                                                                        ]
                                                                      if (
                                                                        p.allLocationSame
                                                                      ) {
                                                                        updatedLocations =
                                                                          updatedLocations.map(
                                                                            () => ({
                                                                              ...updatedLocations[0],
                                                                              zip: event
                                                                                .target
                                                                                .value,
                                                                            }),
                                                                          )
                                                                      } else {
                                                                        updatedLocations[
                                                                          i
                                                                        ] = {
                                                                          ...updatedLocations[
                                                                            i
                                                                          ],
                                                                          zip: event
                                                                            .target
                                                                            .value,
                                                                        }
                                                                      }
                                                                      return {
                                                                        ...p,
                                                                        location:
                                                                          updatedLocations,
                                                                      }
                                                                    }
                                                                    return p
                                                                  },
                                                                ),
                                                            )
                                                          }}
                                                        />
                                                      </Stack>
                                                    </Grid>
                                                  ),
                                                )}
                                              </Grid>

                                              <Grid
                                                container
                                                justifyContent="center"
                                                alignItems="center"
                                              >
                                                <Grid item xs={12} md={4}>
                                                  {data?.fromMapServices ==
                                                  true ? (
                                                    true // (i !== 0 && data?.allLocationSame) ? true :
                                                  ) : (
                                                    <Box
                                                      sx={{
                                                        mt: 3,
                                                        display: 'flex',
                                                        justifyContent:
                                                          'center',
                                                        gap: 1,
                                                      }}
                                                    >
                                                      <LoadingButton
                                                        variant="contained"
                                                        onClick={() => {
                                                          setIsSaving(true)
                                                          setTimeout(() => {
                                                            setIsSaving(false)
                                                            setLocationStates(
                                                              false,
                                                            )
                                                          }, 100)
                                                        }}
                                                        loading={isSaving}
                                                      >
                                                        {' Save '}
                                                      </LoadingButton>
                                                    </Box>
                                                  )}
                                                </Grid>
                                              </Grid>
                                            </Modal>
                                            <Modal
                                              open={
                                                openProductNote[
                                                  data.indexId
                                                ] || false
                                              }
                                              handleClose={() =>
                                                handleCloseNote(data.indexId)
                                              }
                                            >
                                              <Grid
                                                container
                                                spacing={3}
                                                sx={{
                                                  justifyContent: 'center',
                                                  width: '100%',
                                                }}
                                              >
                                                <Grid item xs={12}>
                                                  <Typography
                                                    variant="h5"
                                                    sx={{ mb: 2 }}
                                                  >
                                                    Note
                                                  </Typography>

                                                  <Stack
                                                    direction={{
                                                      xs: 'column',
                                                      sm: 'row',
                                                    }}
                                                    spacing={{ xs: 3, sm: 2 }}
                                                    sx={{ mb: 2 }}
                                                  >
                                                    <TextField
                                                      fullWidth
                                                      multiline
                                                      rows={4}
                                                      size="medium"
                                                      value={currentNote}
                                                      onChange={
                                                        handleNoteChange
                                                      }
                                                      {...getEstimatePreviewNoteFieldProps(isPreview)}
                                                      inputProps={{
                                                        maxLength:
                                                          MAX_CHARACTERS,
                                                      }}
                                                      helperText={
                                                        isPreview
                                                          ? undefined
                                                          : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                      }
                                                      InputProps={{
                                                        sx: {
                                                          color: 'error.main',
                                                        },
                                                      }}
                                                    />
                                                  </Stack>
                                                </Grid>
                                              </Grid>

                                              <EstimatePreviewNoteActions
                                                isPreview={isPreview}
                                                onClose={() => handleCloseNote(data.indexId)}
                                              >
                                              <Grid
                                                container
                                                justifyContent="center"
                                                alignItems="center"
                                              >
                                                <Grid item xs={12} md={4}>
                                                  <Box
                                                    sx={{
                                                      mt: 3,
                                                      display: 'flex',
                                                      justifyContent:
                                                        'center',
                                                      gap: 1,
                                                    }}
                                                  >
                                                    <LoadingButton
                                                      variant="contained"
                                                      onClick={() =>
                                                        handleSaveNote(
                                                          data.indexId,
                                                        )
                                                      }
                                                      loading={isSavingNote}
                                                      disabled={!currentNote.trim()}
                                                    >
                                                      Save
                                                    </LoadingButton>
                                                    <LoadingButton
                                                      variant="outlined"
                                                      color="error"
                                                      onClick={() =>
                                                        handleClearNote(
                                                          data.indexId,
                                                        )
                                                      }
                                                      loading={isClearingNote}
                                                      disabled={!currentNote.trim()}
                                                    >
                                                      Clear
                                                    </LoadingButton>
                                                  </Box>
                                                </Grid>
                                              </Grid>
                                              </EstimatePreviewNoteActions>
                                            </Modal>
                                            <Modal
                                              open={openProductAttachment[data.indexId] || false}
                                              handleClose={() => handleCloseAttachment(data.indexId)}
                                            >
                                              {renderAttachmentModalContent({
                                                itemKey: String(data.indexId),
                                                tabValue: attachmentTabValue[data.indexId],
                                                onTabChange: handleAttachmentTabChange,
                                                selectedImages: selectedUploadedImages[String(data.indexId)] || [],
                                                linkedAttachments: getProductAttachmentsList(data.indexId),
                                                onImageSelect: handleImageSelect,
                                                onAddSelected: handleAddSelectedImages,
                                                onDrop: handleProductDrop,
                                                onRemove: handleProductRemove,
                                                isUploadingItem: isUploadingProduct[data.indexId] || false,
                                              })}
                                            </Modal>
                                          </>
                                            )}
                                          </Draggable>
                                        )
                                      })}

                                      {droppableProvided.placeholder}

                                      {/* Service Note Modal for selectedServices */}
                                      {selectedServices?.map((data, index) => (
                                        <Modal
                                          key={`service-note-${
                                            data.indexId || data.id
                                          }`}
                                          open={
                                            openServiceNote[
                                              data.indexId || data.id
                                            ] || false
                                          }
                                          handleClose={() =>
                                            handleCloseServiceNote(
                                              data.indexId || data.id,
                                            )
                                          }
                                        >
                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{
                                              justifyContent: 'center',
                                              width: '100%',
                                            }}
                                          >
                                            <Grid item xs={12}>
                                              <Typography
                                                variant="h5"
                                                sx={{ mb: 2 }}
                                              >
                                                Service Note
                                              </Typography>

                                              <Stack
                                                direction={{
                                                  xs: 'column',
                                                  sm: 'row',
                                                }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  multiline
                                                  rows={4}
                                                  size="medium"
                                                  value={currentNote}
                                                  onChange={
                                                    handleServiceNoteChange
                                                  }
                                                  {...getEstimatePreviewNoteFieldProps(isPreview)}
                                                  inputProps={{
                                                    maxLength: MAX_CHARACTERS,
                                                  }}
                                                  helperText={
                                                    isPreview
                                                      ? undefined
                                                      : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                  }
                                                  InputProps={{
                                                    sx: {
                                                      color: 'error.main',
                                                    },
                                                  }}
                                                />
                                              </Stack>
                                            </Grid>
                                          </Grid>

                                          <EstimatePreviewNoteActions
                                            isPreview={isPreview}
                                            onClose={() =>
                                              handleCloseServiceNote(
                                                data.indexId || data.id,
                                              )
                                            }
                                          >
                                          <Grid
                                            container
                                            justifyContent="center"
                                            alignItems="center"
                                          >
                                            <Grid item xs={12} md={4}>
                                              <Box
                                                sx={{
                                                  mt: 3,
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  gap: 1,
                                                }}
                                              >
                                                <LoadingButton
                                                  variant="contained"
                                                  onClick={() =>
                                                    handleSaveServiceNote(
                                                      data.newIndexId ?? data.indexId,
                                                    )
                                                  }
                                                  loading={isSavingNote}
                                                >
                                                  Save
                                                </LoadingButton>
                                              </Box>
                                            </Grid>
                                          </Grid>
                                          </EstimatePreviewNoteActions>
                                        </Modal>
                                      ))}

                                      {/* Service Note Modal for additionalSelectedServices */}
                                      {additionalSelectedServices?.map(
                                        (data, index) => (
                                          <Modal
                                            key={`additional-service-note-${
                                              data.indexId ||
                                              data.newIndexId ||
                                              index
                                            }`}
                                            open={
                                              openServiceNote[
                                                data.indexId ||
                                                  data.newIndexId ||
                                                  index
                                              ] || false
                                            }
                                            handleClose={() =>
                                              handleCloseServiceNote(
                                                data.indexId ||
                                                  data.newIndexId ||
                                                  index,
                                              )
                                            }
                                          >
                                            <Grid
                                              container
                                              spacing={3}
                                              sx={{
                                                justifyContent: 'center',
                                                width: '100%',
                                              }}
                                            >
                                              <Grid item xs={12}>
                                                <Typography
                                                  variant="h5"
                                                  sx={{ mb: 2 }}
                                                >
                                                  Service Note
                                                </Typography>

                                                <Stack
                                                  direction={{
                                                    xs: 'column',
                                                    sm: 'row',
                                                  }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    multiline
                                                    rows={4}
                                                    size="medium"
                                                    value={currentNote}
                                                    onChange={
                                                      handleServiceNoteChange
                                                    }
                                                    {...getEstimatePreviewNoteFieldProps(isPreview)}
                                                    inputProps={{
                                                      maxLength: MAX_CHARACTERS,
                                                    }}
                                                    helperText={
                                                      isPreview
                                                        ? undefined
                                                        : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                    }
                                                    InputProps={{
                                                      sx: {
                                                        color: 'error.main',
                                                      },
                                                    }}
                                                  />
                                                </Stack>
                                              </Grid>
                                            </Grid>

                                            <EstimatePreviewNoteActions
                                              isPreview={isPreview}
                                              onClose={() =>
                                                handleCloseServiceNote(
                                                  data.indexId ||
                                                    data.newIndexId ||
                                                    index,
                                                )
                                              }
                                            >
                                            <Grid
                                              container
                                              justifyContent="center"
                                              alignItems="center"
                                            >
                                              <Grid item xs={12} md={4}>
                                                <Box
                                                  sx={{
                                                    mt: 3,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    gap: 1,
                                                  }}
                                                >
                                                  <LoadingButton
                                                    variant="contained"
                                                    onClick={() =>
                                                      handleSaveServiceNote(
                                                        data.newIndexId ?? data.indexId,
                                                      )
                                                    }
                                                    loading={isSavingNote}
                                                  >
                                                    Save
                                                  </LoadingButton>
                                                </Box>
                                              </Grid>
                                            </Grid>
                                            </EstimatePreviewNoteActions>
                                          </Modal>
                                        ),
                                      )}

                                      {additionalSelectedServices?.map((data, index) => {
                                        const svcKey = String(data.newIndexId ?? data.indexId ?? '')
                                        return (
                                          <Modal
                                            key={`additional-service-attachment-${svcKey}-${index}`}
                                            open={openServiceAttachment[svcKey] || false}
                                            handleClose={() => handleCloseServiceAttachment(svcKey)}
                                          >
                                            {renderAttachmentModalContent({
                                              itemKey: svcKey,
                                              isService: true,
                                              tabValue: attachmentTabValueService[svcKey],
                                              onTabChange: handleAttachmentTabChangeService,
                                              selectedImages: selectedUploadedImagesService[svcKey] || [],
                                              linkedAttachments: serviceAttachments[svcKey] || [],
                                              onImageSelect: handleImageSelectService,
                                              onAddSelected: handleAddSelectedImagesService,
                                              onDrop: handleServiceDrop,
                                              onRemove: handleServiceRemove,
                                              isUploadingItem: isUploadingService[svcKey] || false,
                                            })}
                                          </Modal>
                                        )
                                      })}

                                      {/* Service Note Modal for cartService */}
                                      {cartService?.map((data, index) => (
                                        <Modal
                                          key={`cart-service-note-${data.id}`}
                                          open={
                                            openServiceNote[data.id] || false
                                          }
                                          handleClose={() =>
                                            handleCloseServiceNote(data.id)
                                          }
                                        >
                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{
                                              justifyContent: 'center',
                                              width: '100%',
                                            }}
                                          >
                                            <Grid item xs={12}>
                                              <Typography
                                                variant="h5"
                                                sx={{ mb: 2 }}
                                              >
                                                Service Note
                                              </Typography>

                                              <Stack
                                                direction={{
                                                  xs: 'column',
                                                  sm: 'row',
                                                }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  multiline
                                                  rows={4}
                                                  size="medium"
                                                  value={currentNote}
                                                  onChange={
                                                    handleServiceNoteChange
                                                  }
                                                  {...getEstimatePreviewNoteFieldProps(isPreview)}
                                                  inputProps={{
                                                    maxLength: MAX_CHARACTERS,
                                                  }}
                                                  helperText={
                                                    isPreview
                                                      ? undefined
                                                      : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                  }
                                                  InputProps={{
                                                    sx: {
                                                      color: 'error.main',
                                                    },
                                                  }}
                                                />
                                              </Stack>
                                            </Grid>
                                          </Grid>

                                          <EstimatePreviewNoteActions
                                            isPreview={isPreview}
                                            onClose={() => handleCloseServiceNote(data.id)}
                                          >
                                          <Grid
                                            container
                                            justifyContent="center"
                                            alignItems="center"
                                          >
                                            <Grid item xs={12} md={4}>
                                              <Box
                                                sx={{
                                                  mt: 3,
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  gap: 1,
                                                }}
                                              >
                                                <LoadingButton
                                                  variant="contained"
                                                  onClick={() =>
                                                    handleSaveServiceNote(
                                                      data.newIndexId ?? data.indexId,
                                                    )
                                                  }
                                                  loading={isSavingNote}
                                                >
                                                  Save
                                                </LoadingButton>
                                              </Box>
                                            </Grid>
                                          </Grid>
                                          </EstimatePreviewNoteActions>
                                        </Modal>
                                      ))}
                                    {!isPreview ? (
                                      <TableRow>
                                        <TableCell
                                          colSpan={17}
                                          align="right"
                                          sx={{
                                            borderBottom: 'none',
                                            py: 1,
                                            verticalAlign: 'middle',
                                          }}
                                        >
                                           <Stack
                                            direction="row"
                                            justifyContent="space-between"
                                            alignItems="center"
                                          >
                                          <Button
                                            variant="outlined"
                                            startIcon={<Icon icon={plusFill} />}
                                            onClick={addNewRequestEstimateProductRow}
                                          >
                                            Add Row
                                          </Button>
                                          </Stack>
                                        </TableCell>
                                      </TableRow>
                                    ) : null}
                                          </TableBody>
                                        )}
                                      </Droppable>
                                    </DragDropContext>
                                  </Table>
                                </TableContainer>
                              </Scrollbar>
                              </>}
                            </>
                          )}
                          {/* <Stack sx={{ justifyContent: 'space-between', alignItems: 'center', display:'flex', flexDirection:'row' }}>
                        <Button
                          variant="outlined"
                          startIcon={
                            <Stack>
                              {' '}
                              <Add />{' '}
                            </Stack>
                          }
                          onClick={() => {
                            addNewProductRow()
                            // setMarkupType(1)
                          }}
                        >
                          Add Product Row
                        </Button>
                        <Typography variant="h6">
                          Total Additional Product Cost:{' '}
                          {selectedProductsAdditionalCost}
                        </Typography>
                      </Stack> */}
                          <Divider />
                          <Stack direction="row">
                            <LabelStyleHead>Services</LabelStyleHead>
                            {showServices ? (
                              <Remove
                                sx={{ color: theme.palette.primary.main }}
                                onClick={(e) => {
                                  setShowServices(false)
                                }}
                              />
                            ) : (
                              <Add
                                sx={{ color: theme.palette.primary.main }}
                                onClick={(e) => {
                                  setShowServices(true)
                                }}
                              />
                            )}
                            
                             {/* BACKUP: top Services "Add Service" button — hidden per request */}
                             {/* <Stack
                             sx={{ marginLeft: 2 }}
                                    flexDirection={'row'}
                                    gap={1}
                                    alignItems="center"
                                    justifyContent="flex-start"
                                  >
                                    {isPreview ? '' :
                                    <Button variant='outlined'
                                      onClick={() => {
                                        setOpenServiceModal(true);
                                        setSelectedServiceForCatalog(null);
                                        setOpenEditServiceModal(false);
                                        setServiceNameForAdd(null);
                                        setServiceDescForAdd(null)
                                      }}
                                      startIcon={
                                        <Stack>{' '}<Add />{' '}</Stack>
                                      }

                                    >
                                      Add Service
                                    </Button>
                                    }
                                  </Stack> */}
                          </Stack>
                          {showServices && (
                            <>
                              {details?.is_request_estimate == 1 &&
                              (!details?.estimate_job_status || details?.estimate_job_status == 1) ? (
                                <Stack
                                  direction={{ xs: 'column', sm: 'row' }}
                                  spacing={{ xs: 3, sm: 2 }}
                                >
                                  <Autocomplete
                                    // sx={{ width: 400 }}
                                    fullWidth
                                    multiple
                                    id="combo-box-demo"
                                    disabled={isPreview ? true : false}
                                    options={
                                      filteredServices?.filter(
                                        (item) =>
                                          item.service_type == 44 &&
                                          item.status === 1 &&
                                          Number(item.inhouse) !== 1,
                                          // &&
                                          // !additionalSelectedServices.some(
                                          //   (selectedService) =>
                                          //     selectedService?.id ===
                                          //       item?.id ||
                                          //     selectedService?.labour_cost_service_id ===
                                          //       item?.id,
                                          // ),
                                      ) || []
                                    }
                                    value={additionalSelectedServices?.filter(
                                      (item) =>
                                        !item.isAdditionalProduct &&
                                        Number(item?.service_type) === 44,
                                    )}
                                    // value={values.services}
                                    onChange={(event, newValue) => {
                                      setAdditionalSelectedServices(
                                        (prevServices) => {
                                          const servicesWithRow = prevServices?.filter(
                                            (item) => item.is_service_row === 1,
                                          )
                                          const nonEstimateCatalogServices =
                                            prevServices?.filter(
                                              (item) =>
                                                !item.isAdditionalProduct &&
                                                item.is_service_row !== 1 &&
                                                Number(item.service_type) !== 44,
                                            )
                                          const additionals =
                                            prevServices?.filter(
                                              (item) =>
                                                item.isAdditionalProduct ===
                                                  true ||
                                                item.isAdditionalProduct === 1,
                                            )

                                          // Map over the newly selected services and preserve existing properties
                                          const updatedServices =
                                            newValue?.map((service) => {
                                              // Check if the service already exists in the previous selected services
                                              const existingService =
                                                prevServices.find(
                                                  (p) =>
                                                    p?.id === service?.id &&
                                                    p?.newIndexId ===
                                                      service?.newIndexId,
                                                )

                                              if (existingService) {
                                                // If service already exists, preserve all existing properties including notes
                                                return {
                                                  ...existingService,
                                                  quantity:
                                                    existingService.quantity ??
                                                    1,
                                                }
                                              } else {
                                                // If it's a new service, create it with default values
                                                return {
                                                  ...service,
                                                  newIndexId:
                                                    serviceIndexCounter +
                                                    newValue.indexOf(service) +
                                                    1,
                                                  quantity: 1,
                                                  note: '', // Initialize note as empty string
                                                }
                                              }
                                            }) || []
                                          // Update the service index counter for new services
                                          if (updatedServices.length > 0) {
                                            const maxIndexId = Math.max(
                                              ...updatedServices.map(
                                                (s) => s.newIndexId || 0,
                                              ),
                                              serviceIndexCounter,
                                            )
                                            setServiceIndexCounter(maxIndexId)
                                          }

                                          // Update Formik's 'services' field
                                          setFieldValue(
                                            'services',
                                            updatedServices,
                                          )
                                          const finalServices = [
                                            ...updatedServices,
                                            ...additionals,
                                            ...nonEstimateCatalogServices,
                                            ...servicesWithRow,
                                          ]
                                          return finalServices
                                        },
                                      )
                                      if (newValue.length > 0) {
                                        setSelectedEstimators(
                                          allEstimators || [],
                                        )
                                      } else {
                                        setSelectedEstimators([])
                                      }
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        required
                                        error={Boolean(
                                          touched.services && errors.services,
                                        )}
                                        helperText={
                                          touched.services && errors.services
                                        }
                                        label={
                                          details?.is_request_estimate == 1
                                            ? 'Select service2s'
                                            : 'Select additional services'
                                        }
                                      />
                                    )}
                                    getOptionLabel={(option) =>
                                      option?.name
                                        ? `${option.name} (${getLabourCostServiceTabLabel(option.inhouse)})`
                                        : ''
                                    }
                                    filterOptions={(options, state) => {
                                      const searchText = state.inputValue.toLowerCase();
                                      return options.filter(
                                        (option) =>
                                          option.name.toLowerCase().includes(searchText) ||
                                          (option.description && option.description.toLowerCase().includes(searchText)) // Include description in search
                                      );
                                    }}
                                  />
                                  <Autocomplete
                                    // sx={{ width: 400 }}
                                    fullWidth
                                    disabled={isPreview ? true : false}
                                    multiple
                                    id="combo-box-demo"
                                    options={allEstimators || []}
                                    value={selectedEstimators}
                                    onChange={(event, newValue) => {
                                      setSelectedEstimators(newValue)
                                    }}
                                    isOptionEqualToValue={(option, value) =>
                                      option.id === value.id
                                    }
                                    getOptionLabel={(option) =>
                                      option.name || ''
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        required
                                        label="Choose Estimator"
                                        error={Boolean(
                                          touched.services && errors.services,
                                        )}
                                        helperText={
                                          touched.services && errors.services
                                        }
                                      />
                                    )}
                                  />
                                </Stack>
                              ) : (
                                loadingServices ? (
                                  <Stack
                                    flexDirection={'row'}
                                    gap={1}
                                    alignItems="center"
                                    justifyContent="flex-start"
                                  >
                                    <CircularProgress
                                      color="primary"
                                      size={20}
                                      variant="indeterminate"
                                    />
                                    <Typography variant="body2">
                                      Loading services...
                                    </Typography>
                                  </Stack>
                                ) :
                                <Stack
                                  direction={{ xs: 'column', sm: 'row' }}
                                  spacing={{ xs: 3, sm: 2 }}
                                >
                                  {/* <Autocomplete
                                    sx={{ width: 400 }}
                                    multiple
                                    id="combo-box-demo"
                                    disabled={isPreview ? true : false}
                                    options={
                                      filteredServices?.filter((item) => {
                                        if (item.status !== 1 || item.is_service_row === 1) {
                                          return false
                                        }
                                        if (details?.is_request_estimate == 1) {
                                          return (
                                            Number(item.service_type) === 44 &&
                                            Number(item.inhouse) !== 1
                                          )
                                        }
                                        return item.service_type != 44
                                      }) || []
                                    }
                                    value={additionalSelectedServices?.filter((item) => {
                                      if (item.isAdditionalProduct || item.is_service_row == 1) {
                                        return false
                                      }
                                      if (details?.is_request_estimate == 1) {
                                        return (
                                          Number(item?.service_type) === 44 &&
                                          Number(item.inhouse) !== 1
                                        )
                                      }
                                      return item.service_type !== 44
                                    })}
                                    // value={values.services}
                                    onChange={(event, newValue) => {
                                      setAdditionalSelectedServices(
                                        (prevServices) => {
                                          const maxProductIndex = Math.max(
                                            ...prevServices.map((service) => service.product_index || 0),
                                            0 // Default to 0 if no existing services
                                          );
                                          const servicesWithRow = prevServices?.filter(
                                            (item) => item.is_service_row === 1
                                          );
                                          const isEstimateCatalogPicker =
                                            details?.is_request_estimate == 1
                                          // Request estimate: picker is type 44 only; keep other lines in state
                                          const servicesWith44 = isEstimateCatalogPicker
                                            ? []
                                            : prevServices?.filter(
                                                (item) =>
                                                  item.service_type === 44,
                                              )
                                          const nonEstimateCatalogServices =
                                            isEstimateCatalogPicker
                                              ? prevServices?.filter(
                                                  (item) =>
                                                    !item.isAdditionalProduct &&
                                                    item.is_service_row !== 1 &&
                                                    Number(item.service_type) !== 44,
                                                )
                                              : []

                                          const additionals =
                                            prevServices?.filter(
                                              (item) =>
                                                item.isAdditionalProduct ===
                                                  true ||
                                                item.isAdditionalProduct === 1,
                                            )

                                          // Map over the newly selected services and preserve existing properties
                                          const updatedServices =
                                            newValue?.map((service) => {
                                              // Check if the service already exists in the previous selected services
                                              const existingService =
                                                prevServices.find(
                                                  (p) =>
                                                    p?.id === service?.id &&
                                                    p?.newIndexId ===
                                                      service?.newIndexId,
                                                )

                                              if (existingService) {
                                                // If service already exists, preserve all existing properties including notes
                                                return {
                                                  ...existingService,
                                                  quantity:
                                                    existingService.quantity ??
                                                    1,
                                                }
                                              } else {
                                                // If it's a new service, create it with default values
                                                return {
                                                  ...service,
                                                  newIndexId: maxProductIndex + 1,
                                                    product_index : maxProductIndex + 1,
                                                    indexId : maxProductIndex + 1,
                                                  quantity: 1,
                                                  note: '', // Initialize note as empty string
                                                }
                                              }
                                            }) || []

                                          // Update the service index counter for new services
                                          if (updatedServices.length > 0) {
                                            const maxIndexId = Math.max(
                                              ...updatedServices.map(
                                                (s) => s.newIndexId || 0,
                                              ),
                                              serviceIndexCounter,
                                            )
                                            setServiceIndexCounter(maxIndexId)
                                          }
                                          // Update Formik's 'services' field
                                          setFieldValue(
                                            'services',
                                            updatedServices,
                                          )
                                          const finalServices = isEstimateCatalogPicker
                                            ? [
                                                ...updatedServices,
                                                ...additionals,
                                                ...nonEstimateCatalogServices,
                                                ...servicesWithRow,
                                              ]
                                            : [
                                                ...updatedServices,
                                                ...additionals,
                                                ...servicesWith44,
                                                ...servicesWithRow,
                                              ]
                                          return finalServices
                                        },
                                      )
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        required
                                        error={Boolean(
                                          touched.services && errors.services,
                                        )}
                                        helperText={
                                          touched.services && errors.services
                                        }
                                        label={
                                          details?.is_request_estimate == 1
                                            ? 'Select services2'
                                            : 'Select additional services'
                                        }
                                      />
                                    )}
                                    getOptionLabel={(option) =>
                                      option?.name
                                        ? `${option.name} (${getLabourCostServiceTabLabel(option.inhouse)})`
                                        : ''
                                    }
                                    filterOptions={(options, state) => {
                                      const searchText = state.inputValue.toLowerCase();
                                      return options.filter((option) => {
                                        if (
                                          details?.is_request_estimate == 1 &&
                                          (Number(option.service_type) !== 44 ||
                                            Number(option.inhouse) === 1)
                                        ) {
                                          return false
                                        }
                                        return (
                                          option.name.toLowerCase().includes(searchText) ||
                                          (option.description &&
                                            option.description
                                              .toLowerCase()
                                              .includes(searchText))
                                        )
                                      });
                                    }}
                                  /> */}
                                  {/* <Stack
                                    flexDirection={'row'}
                                    gap={1}
                                    alignItems="center"
                                    justifyContent="flex-start"
                                  >
                                    {isPreview ? '' :
                                    <Button variant='outlined'
                                      onClick={() => {
                                        setOpenServiceModal(true);
                                        setSelectedServiceForCatalog(null);
                                        setOpenEditServiceModal(false);
                                        setServiceNameForAdd(null);
                                        setServiceDescForAdd(null)
                                      }}
                                      startIcon={
                                        <Stack>{' '}<Add />{' '}</Stack>
                                      }

                                    >
                                      Add Service
                                    </Button>
                                    }
                                  </Stack> */}
                                  {/* {details?.is_request_estimate == 1 ? (
                                    <Autocomplete
                                      sx={{ width: 400 }}
                                      // fullWidth
                                      multiple
                                      id="combo-box-demo"
                                      options={allEstimators || []}
                                      value={selectedEstimators}
                                      disabled={true}
                                      onChange={(event, newValue) => {
                                        setSelectedEstimators(newValue)
                                      }}
                                      isOptionEqualToValue={(option, value) =>
                                        option.id === value.id
                                      }
                                      getOptionLabel={(option) =>
                                        option.name || ''
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          required
                                          label="Choose Estimator"
                                          error={Boolean(
                                            touched.services && errors.services,
                                          )}
                                          helperText={
                                            touched.services && errors.services
                                          }
                                        />
                                      )}
                                    />
                                  ) : (
                                    ''
                                  )} */}
                                </Stack>
                              )}
                              {loadingServices? '' : <>
                              <LabelStyle>Selected services</LabelStyle>
                              <Scrollbar>
                                <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                    <TableHead>
                                      <TableRow>
                                        {!isPreview && (
                                          <TableCell padding="checkbox" sx={{ width: 40 }} />
                                        )}
                                        {VALUE_SERVICES?.map((val) => (
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        ))}
                                      </TableRow>
                                    </TableHead>

                                    <DragDropContext onDragEnd={handleServiceTableDragEnd}>
                                      <Droppable droppableId="edit-estimate-job-service-rows" isDropDisabled={isPreview || !openEdit}>
                                        {(droppableProvided) => (
                                    <TableBody
                                      ref={droppableProvided.innerRef}
                                      {...droppableProvided.droppableProps}
                                    >
                                      {additionalSelectedServices?.sort((a, b) => (a.product_index || a.indexId || a.newIndexId || 0) - (b.product_index || b.indexId || b.newIndexId || 0))?.map( // ?.filter(itemm => itemm?.service_type != 44)
                                        (data, index) => {
                                          console.log("data-----",data)
                                          const serviceLineKey = getServiceLineKey(data)
                                          const quantityFieldName = `service_quantity_${index}`
                                          const dataQuantity = data?.quantity ? data?.quantity : 0
                                          const dataCost = data.unit_cost || data.total_cost
                                          const total = dataCost * dataQuantity
                                          const markup = dataCost / Number(total)
                                          data['markup'] = markup ? markup?.toFixed(2) : 0.0
                                          data['quantity'] = dataQuantity
                                          totalServiceMarkup += markup
                                          data['total'] = total ? total?.toFixed(2) : 0.0
                                          data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                          let originalMarkup = data.originalMarkup || 0
                                          originaltotalServiceMarkup += originalMarkup
                                          // values['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                          console.log('total---', total)
                                          console.log('data---', data)
                                          const quantityDifference = Number(data.quantity)
                                          data['quantityDifference'] = quantityDifference
                                          return (
                                            <Draggable
                                              key={`service-${serviceLineKey}`}
                                              draggableId={`service-${serviceLineKey}`}
                                              index={index}
                                              isDragDisabled={isPreview || !openEdit}
                                            >
                                              {(provided, snapshot) => (
                                            <>
                                              <TableRow
                                                key={index}
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                style={{
                                                  ...provided.draggableProps.style,
                                                  ...(snapshot.isDragging
                                                    ? { backgroundColor: theme.palette.action.hover }
                                                    : {}),
                                                }}
                                              >
                                                {!isPreview && (
                                                  <TableCell
                                                    padding="checkbox"
                                                    {...provided.dragHandleProps}
                                                    sx={{ width: 40, cursor: 'grab' }}
                                                  >
                                                    <DragIndicator fontSize="small" color="action" />
                                                  </TableCell>
                                                )}
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell align="center">
                                                  {(() => {
                                                    const serviceRowIndex =
                                                      data.newIndexId ?? data.indexId ?? data.product_index

                                                    const toggleLocked = isRequestEstimateLockedServiceToggle(data)
                                                    const toggleMode = getServiceToggleDisplayMode(data)

                                                    if (isPreview) {
                                                      return toggleMode === 'choose' ? 'Choose' : 'Write'
                                                    }

                                                    return (
                                                      <ProductLineEntryToggle
                                                        mode={toggleMode}
                                                        onChange={(mode) =>
                                                          handleServiceRowEntryModeChange(serviceRowIndex, mode)
                                                        }
                                                        lockDisplay={toggleLocked}
                                                        disabled={toggleLocked}
                                                      />
                                                    )
                                                  })()}
                                                </TableCell>
                                                <TableCell sx={{ minWidth: 200, width: 250 }}>
                                                {(getServiceEntryMode(data) === 'write') && !isPreview && !isServiceLineCatalog(data) ? (
                                                  <TextField
                                                    required
                                                    fullWidth
                                                    type="text"
                                                    label={'Service Name'}
                                                    sx={{ minWidth: '300px' }}
                                                    value={
                                                      data.service_name ||
                                                      data.name
                                                    }
                                                    onFocus={() => {
                                                      if (data?.is_service_row == 1) {
                                                        handleFieldFocus(data.indexId, 'name', data.service_name || data.name);
                                                      }
                                                    }}
                                                    onChange={(event) => {
                                                      const newValue = event.target.value;
                                                      if (data?.is_service_row == 1) {
                                                        handleRequestEstimateServiceNameChange(data.indexId, newValue);
                                                        // Trigger debounced auto-save
                                                        const updatedRow = { ...data, service_name: newValue, name: newValue };
                                                        triggerDebouncedAutoSaveService(updatedRow, 'name');
                                                      } else {
                                                        // Update the selectedProducts state for additional products
                                                        setAdditionalSelectedServices(
                                                          (prevProducts) =>
                                                            prevProducts.map(
                                                              (product) => {
                                                                if (
                                                                  product.indexId ===
                                                                  data.indexId
                                                                ) {
                                                                  return {
                                                                    ...product,
                                                                    name: newValue,
                                                                    service_name:
                                                                      newValue,
                                                                  }
                                                                } else {
                                                                  return product
                                                                }
                                                              },
                                                            ),
                                                        )
                                                      }
                                                      data['name'] = newValue || ''
                                                      data['service_name'] = newValue || ''
                                                      if (isSubmitted)
                                                        setIsSubmitted(false)
                                                    }}
                                                    onBlur={() => {
                                                      if (data?.is_service_row == 1) {
                                                        handleServiceRowAutoSave(data, 'name');
                                                      }
                                                    }}
                                                    error={
                                                      isSubmitted &&
                                                      !data.name?.trim() &&
                                                      !data.service_name?.trim()
                                                    }
                                                    helperText={
                                                      isSubmitted &&
                                                      !data.name?.trim() &&
                                                      !data.service_name?.trim()
                                                        ? 'Service Name is required'
                                                        : ''
                                                    }
                                                    InputProps={{
                                                      endAdornment: autoSavingField?.indexId === data.indexId && autoSavingField?.field === 'name' ? (
                                                        <InputAdornment position="end">
                                                          <CircularProgress size={20} />
                                                        </InputAdornment>
                                                      ) : null
                                                    }}
                                                  />
                                                ) : getServiceEntryMode(data) === 'choose' && !data?.id && !isPreview ? (
                                                  <Button
                                                    size="small"
                                                    variant="outlined"
                                                    onClick={() =>
                                                      openChooseServiceDialogForRow(data)
                                                    }
                                                  >
                                                    Select Service
                                                  </Button>
                                                ) : 
                                                <Box>
                                                  <Typography sx={{color:'inherit'}}>{ data?.service_name || data?.name }</Typography>
                                                 

                                                  {data.service_notes?<Typography sx={{color: data.service_notes ? theme.palette.error.main : '' }}>Note:{" "}{data.service_notes}</Typography>:" "}
                                                </Box>
                                             
                                                }
                                                  {/* {data?.isAdditionalProduct ? (
                                                    <TextField
                                                      required
                                                      disabled={isPreview ? true : false}
                                                      fullWidth
                                                      type="text"
                                                      label={'Service Name'}
                                                      sx={{ width: 85 }}
                                                      value={data.name || data.service_name}
                                                      onChange={(event) => {
                                                        let newValue =
                                                          event.target.value

                                                        // Update the selectedProducts state
                                                        setAdditionalSelectedServices(
                                                          (prevProducts) =>
                                                            prevProducts.map(
                                                              (service) => {
                                                                if (
                                                                  service.newIndexId ===
                                                                  data.newIndexId
                                                                ) {
                                                                  return {
                                                                    ...service,
                                                                    name: newValue,
                                                                    service_name: newValue,
                                                                  }
                                                                } else {
                                                                  return service
                                                                }
                                                              },
                                                            ),
                                                        )
                                                        data['name'] =
                                                          newValue || ''
                                                        if (isSubmitted)
                                                          setIsSubmitted(false)
                                                      }}
                                                      error={
                                                        isSubmitted &&
                                                        data?.name?.trim() ===
                                                          ''
                                                      }
                                                      helperText={
                                                        isSubmitted &&
                                                        data?.name?.trim() ===
                                                          ''
                                                          ? 'Service Name is required'
                                                          : ''
                                                      }
                                                    />
                                                  ) : data.service_notes ? <Typography sx={{ color: 'red', whiteSpace: 'pre-wrap' }}>{data.service_notes}</Typography> : data.name}
                                                    */}
                                                </TableCell>
                                                <TableCell>
                                                  <IconButton
                                                    disabled={isPreview ? true : false}
                                                      // <IconButton onClick={() => handleOpenMaterialNote(data.newIndexId, data.material_notes)}>
                                                    onClick={() =>
                                                      // handleOpenServiceNote(
                                                      //   data.newIndexId ||
                                                      //     data.indexId,
                                                      //   data.service_notes,
                                                      // )
                                                      handleOpenServiceNote(
                                                        data.newIndexId ,
                                                        data.service_notes,
                                                      )
                                                    }
                                                  >
                                                    <NoteAdd
                                                      sx={{
                                                        color:
                                                          !data?.service_notes ||
                                                          data?.service_notes ===
                                                            ''
                                                            ? ''
                                                            : theme.palette
                                                                .primary.main,
                                                      }}
                                                    />
                                                  </IconButton>
                                                </TableCell>
                                                <TableCell>
                                                  <IconButton
                                                    data-preview-allow
                                                    onClick={() => handleOpenServiceAttachment(data.newIndexId ?? data.indexId)}
                                                  >
                                                    <UploadFile
                                                      sx={{
                                                        color:
                                                          !serviceAttachments[String(data.newIndexId ?? data.indexId)] ||
                                                          serviceAttachments[String(data.newIndexId ?? data.indexId)]?.length === 0
                                                            ? 'error.main'
                                                            : theme.palette.primary.main,
                                                      }}
                                                    />
                                                  </IconButton>
                                                </TableCell>
                                                <TableCell>
                                                {shouldShowWriteServiceCatalogButtons(data) ? (
                                                  <Grid container spacing={1}>
                                                    {/* BACKUP: write-row "Add Service" — hidden per request
                                                    <Grid item>
                                                      <Button variant='outlined'
                                                        disabled={isPreview || !(data.service_name || data.name || '').trim()}
                                                        onClick={()=>{
                                                          setOpenServiceModal(true);
                                                          setSelectedServiceForCatalog({ ...data, service_write: 1 });
                                                          setServiceNameForAdd(data.service_name || data.name);
                                                          setServiceDescForAdd(data.service_desc || '');
                                                          setOpenEditServiceModal(false)
                                                        }}
                                                      >
                                                        Add Service
                                                      </Button>
                                                    </Grid>
                                                    */}
                                                    <Grid item>
                                                      <Button variant='outlined'
                                                        disabled={isPreview || !(data.service_name || data.name || '').trim()}
                                                        onClick={()=>{
                                                          setOpenServiceModal(true);
                                                          setSelectedServiceForCatalog({ ...data, is_existing_service: true, service_write: 1 });
                                                          setServiceNameForAdd(data.service_name || data.name);
                                                          setOpenEditServiceModal(false)
                                                        }}
                                                      >
                                                        Add Existing
                                                      </Button>
                                                    </Grid>
                                                  </Grid>
                                                ) : null}
                                              </TableCell>
                                              {/* <TableCell sx={{ minWidth: 200, width: 250 }}>
                                                {(getServiceEntryMode(data) === 'write') && !isPreview && !isServiceLineCatalog(data) ? (
                                                  <TextField
                                                    fullWidth
                                                    variant="outlined"
                                                    value={data.product_desc || data.service_desc || data.description || ''}
                                                    onFocus={() => {
                                                      if (data?.is_service_row == 1) {
                                                        handleFieldFocus(data.indexId, 'desc', data.product_desc || data.service_desc || data.description);
                                                      }
                                                    }}
                                                    onChange={(e) => {
                                                      const newValue = e.target.value;
                                                      if (data?.is_service_row == 1) {
                                                        handleRequestEstimateServiceDesChange(data.indexId, newValue);
                                                        // Trigger debounced auto-save
                                                        const updatedRow = { ...data, product_desc: newValue, service_desc: newValue };
                                                        triggerDebouncedAutoSaveService(updatedRow, 'desc');
                                                      } else {
                                                        // Update the selectedProducts state for additional products
                                                        setAdditionalSelectedServices(
                                                          (prevProducts) =>
                                                            prevProducts.map(
                                                              (product) => {
                                                                if (product.indexId === data.indexId) {
                                                                  return {
                                                                    ...product,
                                                                    service_desc: newValue,
                                                                  }
                                                                } else {
                                                                  return product
                                                                }
                                                              },
                                                            ),
                                                        )
                                                      }
                                                      data['service_desc'] = newValue || '';
                                                    }}
                                                    onBlur={() => {
                                                      if (data?.is_service_row == 1) {
                                                        handleServiceRowAutoSave(data, 'desc');
                                                      }
                                                    }}
                                                    placeholder="Service Description"
                                                    multiline
                                                    minRows={3}
                                                    maxRows={6}
                                                    sx={{ minWidth: '400px' }}
                                                    InputProps={{
                                                      endAdornment: autoSavingField?.indexId === data.indexId && autoSavingField?.field === 'desc' ? (
                                                        <InputAdornment position="end">
                                                          <CircularProgress size={20} />
                                                        </InputAdornment>
                                                      ) : null
                                                    }}
                                                  />
                                                ) : (
                                                  (data?.product_desc||data?.service_desc || data?.description) ? (
                                                    <Tooltip title={data?.product_desc||data?.service_desc || data?.description}>
                                                      <Typography variant='subtitle2' sx={{ fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre-wrap', fontSize: '0.75rem' }}>{data?.product_desc||data?.service_desc || data?.description}</Typography>
                                                    </Tooltip>
                                                  ) : '-'
                                                )}
                                              </TableCell> */}

                                                    <TableCell sx={{ minWidth: 200, width: 250 }}>
                                                      {(getServiceEntryMode(data) === 'write') && !isPreview && !isServiceLineCatalog(data) ? (
                                                        <TextField
                                                          fullWidth
                                                          variant="outlined"
                                                          value={data.product_desc || data.service_desc || data.description || ''}
                                                          onFocus={() => {
                                                            if (data?.is_service_row == 1) {
                                                              handleFieldFocus(
                                                                data.indexId,
                                                                'desc',
                                                                data.product_desc || data.service_desc || data.description,
                                                              );
                                                            }
                                                          }}
                                                          onChange={(e) => {
                                                            const newValue = e.target.value;

                                                            if (data?.is_service_row == 1) {
                                                              handleRequestEstimateServiceDesChange(data.indexId, newValue);

                                                              const updatedRow = {
                                                                ...data,
                                                                product_desc: newValue,
                                                                service_desc: newValue,
                                                              };

                                                              triggerDebouncedAutoSaveService(updatedRow, 'desc');
                                                            } else {
                                                              setAdditionalSelectedServices((prevProducts) =>
                                                                prevProducts.map((product) => {
                                                                  if (product.indexId === data.indexId) {
                                                                    return {
                                                                      ...product,
                                                                      service_desc: newValue,
                                                                      description: newValue,
                                                                    };
                                                                  }

                                                                  return product;
                                                                }),
                                                              );
                                                            }

                                                            data.product_desc = newValue || '';
                                                            data.service_desc = newValue || '';
                                                            data.description = newValue || '';
                                                          }}
                                                          onBlur={() => {
                                                            if (data?.is_service_row == 1) {
                                                              handleServiceRowAutoSave(data, 'desc');
                                                            }
                                                          }}
                                                          placeholder="Service Description"
                                                          multiline
                                                          minRows={3}
                                                          maxRows={6}
                                                          sx={{ minWidth: '400px' }}
                                                          InputProps={{
                                                            endAdornment:
                                                              autoSavingField?.indexId === data.indexId &&
                                                                autoSavingField?.field === 'desc' ? (
                                                                <InputAdornment position="end">
                                                                  <CircularProgress size={20} />
                                                                </InputAdornment>
                                                              ) : null,
                                                          }}
                                                        />
                                                      ) : (
                                                        <TextField
                                                          fullWidth
                                                          variant="outlined"
                                                          value={data.product_desc || data.service_desc || data.description || ''}
                                                          onChange={(e) => {
                                                            const newValue = e.target.value;

                                                            setAdditionalSelectedServices((prevProducts) =>
                                                              prevProducts.map((product) => {
                                                                const productRowId =
                                                                  product?.newIndexId ??
                                                                  product?.indexId ??
                                                                  product?.product_index
                                                                const dataRowId =
                                                                  data?.newIndexId ??
                                                                  data?.indexId ??
                                                                  data?.product_index
                                                                if (
                                                                  Number(productRowId) ===
                                                                  Number(dataRowId)
                                                                ) {
                                                                  return {
                                                                    ...product,
                                                                    product_desc: newValue,
                                                                    service_desc: newValue,
                                                                    description: newValue,
                                                                  };
                                                                }

                                                                return product;
                                                              }),
                                                            );

                                                            data.product_desc = newValue || '';
                                                            data.service_desc = newValue || '';
                                                            data.description = newValue || '';
                                                          }}
                                                          placeholder="Service Description"
                                                          multiline
                                                          minRows={3}
                                                          maxRows={6}
                                                          sx={{ minWidth: '400px' }}
                                                          disabled={isPreview}
                                                        />
                                                      )}
                                                    </TableCell>
                                                <TableCell>
                                                  {originalMarkup
                                                    ? originalMarkup?.toFixed(2)
                                                    : 0.0}
                                                </TableCell>
                                                <TableCell>
                                                  {data.cost}
                                                </TableCell>
                                                <TableCell>
                                                  {data?.isAdditionalProduct ? (
                                                    <TextField
                                                      required
                                                      fullWidth
                                                      type="number"
                                                      label={'Hourly Cost'}
                                                      // disabled={
                                                      //   isPreview ? true : 
                                                      //   values.project_category
                                                      //     ?.name ==
                                                      //   'Time & Material'
                                                      //     ? true
                                                      //     : false
                                                      // }
                                                      disabled
                                                      sx={{ width: 85 }}
                                                      value={dataCost}
                                                      // onWheel={(e) => e.target.blur()}
                                                      onFocus={selectInputValue}
                                                      onClick={selectInputValue}
                                                      onKeyPress={(event) => {
                                                        // if (event.key === '0' && event.target.value === '') {
                                                        //   event.preventDefault();
                                                        // }
                                                        if (event.key === '-') {
                                                          event.preventDefault()
                                                        }
                                                        if (event.key === 'e') {
                                                          event.preventDefault()
                                                        }
                                                      }}
                                                      inputProps={{ min: 0 }}
                                                      defaultValue={0}
                                                      onChange={(event) => {
                                                        let newValue =
                                                          event.target.value
                                                        if (newValue !== '') {
                                                          setAdditionalSelectedServices(
                                                            (pv) => [
                                                              ...pv.map((p) => {
                                                                if (
                                                                  p.newIndexId ===
                                                                  data.newIndexId
                                                                ) {
                                                                  return {
                                                                    ...p,
                                                                    total_cost:
                                                                      newValue,
                                                                    unit_cost:
                                                                      newValue,
                                                                  }
                                                                } else {
                                                                  return p
                                                                }
                                                              }),
                                                            ],
                                                          )
                                                          data['total_cost'] =
                                                            newValue || 0
                                                          data['unit_cost'] =
                                                            newValue || 0
                                                        }
                                                      }}
                                                      // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                                      // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                                    />
                                                  ) : (
                                                    dataCost
                                                  )}
                                                </TableCell>
                                                <TableCell>
                                                  <TextField
                                                    type="number"
                                                    // sx={{ width: 400 }}
                                                    sx={{ minWidth: '80px' }}
                                                    label={'Hours'}
                                                    {...getFieldProps(
                                                      quantityFieldName,
                                                    )}
                                                    value={
                                                      Number(data?.quantity) ||
                                                      0
                                                    }
                                                    defaultValue={1}
                                                    onFocus={selectInputValue}
                                                    onClick={selectInputValue}
                                                    onKeyPress={(event) => {
                                                      if (event.key === '-') {
                                                        event.preventDefault()
                                                      }
                                                    }}
                                                    onChange={(event) => {
                                                      let newValue = event.target.value || 0
                                                      console.log('newValue-----', newValue)
                                                      // if (newValue.startsWith('-')) {
                                                      //   newValue = newValue.slice(1);
                                                      // }
                                                      // data['quantity'] = newValue || 1;
                                                      const newData = {
                                                        ...data,
                                                        quantity: newValue || 0,
                                                      }
                                                      const updatedServices = [
                                                        ...additionalSelectedServices,
                                                      ]
                                                      updatedServices[index] = newData
                                                      setAdditionalSelectedServices(updatedServices)
                                                      setFieldValue(quantityFieldName, newValue)
                                                    }}
                                                    disabled={
                                                      isPreview ? true : 
                                                      (details?.is_request_estimate == 1 &&
                                                        details?.estimate_job_status != 1 &&
                                                        data?.service_type == 44) ? true : false
                                                    }
                                                    onWheel={(e) =>
                                                      e.target.blur()
                                                    }
                                                    onKeyDown={(event) => {
                                                      if (
                                                        event.key ===
                                                          'ArrowUp' ||
                                                        event.key ===
                                                          'ArrowDown'
                                                      ) {
                                                        const newValue =
                                                          event.target.value ||
                                                          0
                                                        if (
                                                          newValue < 1 &&
                                                          event.key ===
                                                            'ArrowDown'
                                                        ) {
                                                          event.preventDefault()
                                                        }
                                                      }
                                                    }}
                                                    error={Boolean(
                                                      touched[
                                                        quantityFieldName
                                                      ] &&
                                                        errors[
                                                          quantityFieldName
                                                        ],
                                                    )}
                                                    helperText={
                                                      touched[
                                                        quantityFieldName
                                                      ] &&
                                                      errors[quantityFieldName]
                                                    }
                                                  />
                                                </TableCell>

                                                {/* <TableCell>
                                                  {data?.isAdditionalProduct
                                                    ? 'N/A'
                                                    : (
                                                        data.cost *
                                                        quantityDifference?.toFixed(
                                                          2,
                                                        )
                                                      )?.toFixed(2)}
                                                </TableCell> */}
                                                <TableCell>
                                                  ${fUSPrice(total
                                                    ? total?.toFixed(2)
                                                    : 0.0)}
                                                </TableCell>
                                                <TableCell>
                                                 ${fUSPrice(total
                                                    ? total?.toFixed(2)
                                                    : 0.0)}
                                                </TableCell>
                                                {/* <TableCell></TableCell> */}
                                                <TableCell align="right">
                                                  {/* {(details?.is_request_estimate == 1 &&
                                                    details?.estimate_job_status != 1 &&
                                                    data?.service_type == 44) ? (
                                                    ''
                                                  ) : ( */}
                                                  {isPreview ? '' :
                                                  <Box sx={{ display: 'flex', flexDirection:'row', justifyContent:shouldShowWriteServiceCatalogButtons(data) ? 'flex-end' : 'space-between' }} >
                                                  {shouldShowWriteServiceCatalogButtons(data) ? '' :
                                                    <Tooltip title='Edit'>
                                                      <IconButton
                                                        onClick={() => {
                                                          setServiceRowForCatalogChoice({
                                                            ...data,
                                                            markup: data?.originalMarkup,
                                                          })
                                                          // if(data?.is_existing_service){
                                                          //   setOpenServiceModal(true);
                                                          //   setSelectedServiceForCatalog({ ...data, markup: data?.originalMarkup});
                                                          // }else{
                                                          //   setOpenServiceModal(true);
                                                          //   setSelectedServiceForCatalog({ ...data, markup: data?.originalMarkup});
                                                          //   setOpenEditServiceModal(true);
                                                          // }
                                                          // setServiceRowForCatalogChoice(data)
                                                          setOpenServiceCatalogChoiceModal(true)
                                                        }}
                                                      >
                                                        <Edit />
                                                      </IconButton>
                                                    </Tooltip>}
                                                    <IconButton
                                                      // disabled={ userType === 18 && data?.addedByUserType !== 18 }
                                                      onClick={() =>
                                                        handleDeleteService(
                                                          data.id,
                                                          data.newIndexId,
                                                          data,
                                                        )
                                                      }
                                                    >
                                                      <Delete />
                                                    </IconButton>
                                                  </Box>
                                                    }
                                                  {/* )} */}
                                                </TableCell>
                                              </TableRow>
                                            </>
                                              )}
                                            </Draggable>
                                          )
                                        },
                                      )}
                                      {droppableProvided.placeholder}
                                      {/* <TableRow>
                                    <TableCell colSpan={8}>
                                      <Typography variant="h6" align="right">
                                        Total Additional Cost: {totalProductLabourCost.toFixed(2)}
                                      </Typography>
                                    </TableCell>
                                  </TableRow> */}
                                    {!isPreview ? (
                                      <TableRow>
                                        <TableCell
                                          colSpan={12}
                                          sx={{
                                            borderBottom: 'none',
                                            py: 1,
                                            verticalAlign: 'middle',
                                          }}
                                        >
                                          <Stack
                                            direction="row"
                                            justifyContent="space-between"
                                            alignItems="center"
                                          >
                                            <Button
                                              variant="outlined"
                                              startIcon={<Icon icon={plusFill} />}
                                              onClick={addNewRequestEstimateServiceRow}
                                            >
                                              Add Row
                                            </Button>
                                            <Typography variant="h6" sx={{ mb: 0 }}>
                                              {details?.is_request_estimate == 1
                                                ? `Total Service Cost: `
                                                : `Total Additional Service Cost: `}
                                              {totalProductLabourCost?.toFixed(2)}
                                            </Typography>
                                          </Stack>
                                        </TableCell>
                                      </TableRow>
                                    ) : (
                                      <TableRow>
                                        <TableCell
                                          colSpan={12}
                                          align="right"
                                          sx={{
                                            borderBottom: 'none',
                                            py: 1,
                                            verticalAlign: 'middle',
                                          }}
                                        >
                                          <Typography variant="h6" sx={{ mb: 0 }}>
                                            {details?.is_request_estimate == 1
                                              ? `Total Service Cost1: `
                                              : `Total Additional Service Cost: `}
                                            {totalProductLabourCost?.toFixed(2)}
                                          </Typography>
                                        </TableCell>
                                      </TableRow>
                                    )}
                                    </TableBody>
                                        )}
                                      </Droppable>
                                    </DragDropContext>
                                  </Table>
                                </TableContainer>
                              </Scrollbar>
                              </>}

                              {/* {(details?.is_request_estimate == 1 &&
                                details?.estimate_job_status == 1) ? (
                                ''
                              ) : ( */}
                                <>
                                  {values?.project_type?.name == 'TS' &&
                                  values?.project_category?.id == 14 ? (
                                    ''
                                  ) : (
                                    <>
                                      <LabelStyleHead>Proposals</LabelStyleHead>
                                      <Autocomplete
                                        options={rfps}
                                        disabled={isPreview ? true : false}
                                        // getOptionLabel={(option) => option.description}
                                        getOptionLabel={(option) =>
                                          option && option.description
                                            ? `${option.description} ( ${
                                                option.vendor_name || ''
                                              })`
                                            : ''
                                        }
                                        value={values.rfp}
                                        onChange={(event, value) => {
                                          handleRfpSelect(event, value)
                                          setFieldValue('rfp', value)
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Select Proposal"
                                          />
                                        )}
                                        filterOptions={(
                                          options,
                                          { inputValue },
                                        ) =>
                                          options.filter((option) => {
                                            const searchText =
                                              inputValue.toLowerCase()
                                            return (
                                              option.name
                                                ?.toLowerCase()
                                                .includes(searchText) ||
                                              option.description
                                                ?.toLowerCase()
                                                .includes(searchText)
                                              // option.description?.toLowerCase().includes(searchText)
                                            )
                                          })
                                        }
                                      />
                                      {/* Modal for RFP Selection */}
                                      <Modal
                                        open={openModal}
                                        handleClose={closeModal}
                                      >
                                        <Box
                                          sx={{
                                            position: 'relative',
                                            p: 3,
                                            bgcolor: 'background.paper',
                                            boxShadow: 24,
                                          }}
                                        >
                                          <Tabs
                                            value={tabIndex}
                                            variant="fullWidth"
                                            sx={{
                                              marginBottom: 4,
                                            }}
                                            onChange={handleTabChange}
                                          >
                                            <Tab
                                              label="Products"
                                              sx={{ width: '50%', minWidth: 0 }}
                                            />
                                            <Tab
                                              label="Services"
                                              sx={{ width: '50%', minWidth: 0 }}
                                            />
                                            <Tab
                                              label="Materials"
                                              sx={{ width: '50%', minWidth: 0 }}
                                            />
                                          </Tabs>
                                          {/* {tabIndex === 0 && (
                                <div>
                                  {rfpServices.map((service) => (
                                    <Box key={service.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                      <Typography>{service.name}</Typography>
                                      <Typography>${service.sellingPrice}</Typography>
                                      <Button onClick={() => addToCart(service)}>Add</Button>
                                    </Box>
                                  ))}
                                </div>
                              )}
                              {tabIndex === 1 && (
                                <div>
                                  {rfpProducts.map((product) => (
                                    <Box key={product.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                      <Typography>{product.product_name}</Typography>
                                      <Typography>${product.product_price}</Typography>
                                      <Button onClick={() => addToCart(product)}>Add</Button>
                                    </Box>
                                  ))}
                                </div>
                              )} */}
                                          {tabIndex === 0 && (
                                            <TableContainer
                                              sx={{ minWidth: 500 }}
                                            >
                                              <Table>
                                                <TableHead>
                                                  <TableCell align="center">
                                                    Name
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    Unit Cost
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    Unit
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    Qty
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    Total Cost
                                                  </TableCell>
                                                  <TableCell align="center"></TableCell>
                                                </TableHead>
                                                {rfpProducts
                                                  ?.filter(
                                                    (product) =>
                                                      product.material == 0,
                                                  )
                                                  .map((product) => {
                                                    let unitName =
                                                      UNITS?.filter(
                                                        (item) =>
                                                          item?.id ==
                                                          product?.unit,
                                                      )
                                                    unitName = unitName[0]?.name
                                                    let shortUnitName = ''
                                                    if (
                                                      unitName == 'Square feet'
                                                    ) {
                                                      shortUnitName = 'Sq ft'
                                                    } else if (
                                                      unitName == 'Lineal feet'
                                                    ) {
                                                      shortUnitName = 'Lin ft'
                                                    } else if (
                                                      unitName ==
                                                      'Square Inches'
                                                    ) {
                                                      shortUnitName =
                                                        'Sq Inches'
                                                    } else if (
                                                      unitName == 'Unit'
                                                    ) {
                                                      shortUnitName = 'Unit'
                                                    }
                                                    return (
                                                      // <Box key={product.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                                      <TableRow
                                                        key={product.id}
                                                      >
                                                        <TableCell align="center">
                                                          {product.product_name}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                          $
                                                          {
                                                            product.product_price
                                                          }
                                                        </TableCell>
                                                        <TableCell align="center">
                                                          {product.quantity}{' '}
                                                          {shortUnitName}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                          {
                                                            product.location_quantity
                                                          }
                                                        </TableCell>
                                                        <TableCell align="center">
                                                          $
                                                          {(
                                                            product.location_quantity *
                                                            product.quantity *
                                                            (product.product_price.toFixed(
                                                              2,
                                                            ) || 0)
                                                          ).toFixed(2)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                          <Button
                                                            onClick={() =>
                                                              addToCart(product)
                                                            }
                                                          >
                                                            Add
                                                          </Button>
                                                        </TableCell>
                                                      </TableRow>
                                                      // </Box>
                                                    )
                                                  })}
                                              </Table>
                                            </TableContainer>
                                          )}
                                          {tabIndex === 1 && (
                                            <TableContainer
                                              sx={{ minWidth: 500 }}
                                            >
                                              <Table>
                                                <TableHead>
                                                  <TableCell align="center">
                                                    Name
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    Unit Cost
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    Hours
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    Total Cost
                                                  </TableCell>
                                                  <TableCell align="center"></TableCell>
                                                </TableHead>
                                                {rfpServices.map((service) => (
                                                  // <Box key={service.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                                  <TableRow key={service.id}>
                                                    <TableCell align="center">
                                                      {service.name}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      ${service.sellingPrice}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      {service.quantity}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      ${service.total_cost}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                      <Button
                                                        onClick={() =>
                                                          addToCart(service)
                                                        }
                                                      >
                                                        Add
                                                      </Button>
                                                    </TableCell>
                                                  </TableRow>
                                                  // </Box>
                                                ))}
                                              </Table>
                                            </TableContainer>
                                          )}
                                          {tabIndex === 2 && (
                                            <TableContainer
                                              sx={{ minWidth: 500 }}
                                            >
                                              <Table>
                                                <TableHead>
                                                  <TableCell align="center">
                                                    Name
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    Unit Cost
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    Unit
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    Qty
                                                  </TableCell>
                                                  <TableCell align="center">
                                                    Total Cost
                                                  </TableCell>
                                                  <TableCell align="center"></TableCell>
                                                </TableHead>
                                                {rfpProducts
                                                  .filter(
                                                    (product) =>
                                                      product.material == 1,
                                                  )
                                                  .map((product) => {
                                                    let unitName =
                                                      UNITS?.filter(
                                                        (item) =>
                                                          item?.id ==
                                                          product?.unit,
                                                      )
                                                    unitName = unitName[0]?.name
                                                    let shortUnitName = ''
                                                    if (
                                                      unitName == 'Square feet'
                                                    ) {
                                                      shortUnitName = 'Sq ft'
                                                    } else if (
                                                      unitName == 'Lineal feet'
                                                    ) {
                                                      shortUnitName = 'Lin ft'
                                                    } else if (
                                                      unitName ==
                                                      'Square Inches'
                                                    ) {
                                                      shortUnitName =
                                                        'Sq Inches'
                                                    } else if (
                                                      unitName == 'Unit'
                                                    ) {
                                                      shortUnitName = 'Unit'
                                                    }
                                                    return (
                                                      // <Box key={product.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                                      <TableRow
                                                        key={product.id}
                                                      >
                                                        <TableCell align="center">
                                                          {product.product_name}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                          $
                                                          {
                                                            product.product_price
                                                          }
                                                        </TableCell>
                                                        <TableCell align="center">
                                                          {product.quantity}{' '}
                                                          {shortUnitName}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                          {
                                                            product.location_quantity
                                                          }
                                                        </TableCell>
                                                        <TableCell align="center">
                                                          $
                                                          {(
                                                            product.location_quantity *
                                                            product.quantity *
                                                            (product.product_price.toFixed(
                                                              2,
                                                            ) || 0)
                                                          ).toFixed(2)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                          <Button
                                                            onClick={() =>
                                                              addToCart(product)
                                                            }
                                                          >
                                                            Add
                                                          </Button>
                                                        </TableCell>
                                                      </TableRow>
                                                      // </Box>
                                                    )
                                                  })}
                                              </Table>
                                            </TableContainer>
                                          )}
                                        </Box>
                                      </Modal>
                                      <Scrollbar>
                                        <TableContainer sx={{ minWidth: 500 }}>
                                          <Table>
                                            <TableHead>
                                              <TableRow>
                                                {VALUE_RFP_Product?.map(
                                                  (val) => (
                                                    <TableCell key={val.id}>
                                                      {val.value}
                                                    </TableCell>
                                                  ),
                                                )}
                                              </TableRow>
                                            </TableHead>
                                            <TableBody>
                                              {cart
                                                ?.filter(
                                                  (item) => item.material == 0,
                                                )
                                                ?.map((data, index) => {
                                                  let unitName = UNITS?.filter(
                                                    (item) =>
                                                      item?.id == data?.unit,
                                                  )
                                                  unitName = unitName[0]?.name
                                                  let shortUnitName = ''
                                                  if (
                                                    unitName == 'Square feet'
                                                  ) {
                                                    shortUnitName = 'Sq ft'
                                                  } else if (
                                                    unitName == 'Lineal feet'
                                                  ) {
                                                    shortUnitName = 'Lin ft'
                                                  } else if (
                                                    unitName == 'Square Inches'
                                                  ) {
                                                    shortUnitName = 'Sq Inches'
                                                  } else if (
                                                    unitName == 'Unit'
                                                  ) {
                                                    shortUnitName = 'Unit'
                                                  }
                                                  // let markup = markupType ? markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup : 0
                                                  let markup =
                                                    parseFloat(
                                                      Number(data?.markup),
                                                    ) || 0
                                                  data.product_markup = markup
                                                  return (
                                                    <>
                                                      <TableRow key={data.id}>
                                                        <TableCell>
                                                          {data.name ||
                                                            data.product_name}
                                                        </TableCell>
                                                        <TableCell />
                                                        {/* <TableCell>{invoiceAmount}</TableCell> */}
                                                        <TableCell>
                                                          {markup?.toFixed(2) ||
                                                            0.0}
                                                        </TableCell>
                                                        <TableCell>
                                                          {data.product_price?.toFixed(
                                                            2,
                                                          ) || 0}
                                                        </TableCell>
                                                        <TableCell>
                                                          {(
                                                            data.product_price +
                                                            (data.product_price *
                                                              markup) /
                                                              100
                                                          ).toFixed(2) || 0.0}
                                                        </TableCell>
                                                        <TableCell>
                                                          {data.quantity}{' '}
                                                          {shortUnitName}
                                                        </TableCell>
                                                        <TableCell>
                                                          {
                                                            data.location_quantity
                                                          }
                                                        </TableCell>

                                                        {/* <TableCell>
                                            {(data.product_price * data.quantity * data.location_quantity)?.toFixed(2)||0}
                                          </TableCell> */}
                                                        <TableCell>
                                                          {(
                                                            data.location_quantity *
                                                            data.quantity *
                                                            ((
                                                              data.product_price +
                                                              (data.product_price *
                                                                markup) /
                                                                100
                                                            )?.toFixed(2) || 0)
                                                          ).toFixed(2)}
                                                        </TableCell>
                                                        {/* <TableCell>N/A</TableCell>
                                          <TableCell>N/A</TableCell> */}
                                                        <TableCell>
                                                          <IconButton
                                                            disabled={isPreview ? true : false}
                                                            onClick={() => {
                                                              setRfpLocationStates(
                                                                {
                                                                  ...rfpLocationStates,
                                                                  [data.product_id]: true,
                                                                },
                                                              )
                                                            }}
                                                          >
                                                            <LocationOn
                                                              sx={{
                                                                color:
                                                                  data &&
                                                                  data.location &&
                                                                  data.location.some(
                                                                    (obj) =>
                                                                      [
                                                                        obj.address,
                                                                        obj.city,
                                                                        obj.state,
                                                                        obj.zip,
                                                                      ].some(
                                                                        (
                                                                          value,
                                                                        ) =>
                                                                          value ===
                                                                            '' ||
                                                                          value ===
                                                                            null,
                                                                      ),
                                                                  )
                                                                    ? ''
                                                                    : theme
                                                                        .palette
                                                                        .primary
                                                                        .main,
                                                              }}
                                                            />
                                                          </IconButton>
                                                        </TableCell>
                                                        <TableCell>
                                                          {isPreview ? '' : 
                                                          <IconButton
                                                            onClick={() =>
                                                              handleDeleteRFPProduct(
                                                                data.product_id,
                                                              )
                                                            }
                                                          >
                                                            <Delete />
                                                          </IconButton>}
                                                        </TableCell>
                                                      </TableRow>
                                                      <Modal
                                                        open={
                                                          rfpLocationStates[
                                                            data.product_id
                                                          ]
                                                        }
                                                        handleClose={() => {
                                                          setRfpLocationStates({
                                                            ...rfpLocationStates,
                                                            [data.product_id]: false,
                                                          })
                                                        }}
                                                      >
                                                        {/* {index === 0 &&  */}
                                                        <FormControlLabel
                                                          control={
                                                            <Switch
                                                              checked={
                                                                data?.allRfpProductsLocationSame
                                                              }
                                                              onChange={() =>
                                                                handleAllRfpProductsLocationSameChange(
                                                                  index,
                                                                )
                                                              }
                                                            />
                                                          }
                                                          label="All Locations Same"
                                                        />
                                                        {/* } */}

                                                        <Grid
                                                          container
                                                          spacing={3}
                                                          sx={{
                                                            justifyContent:
                                                              'center',
                                                            width: '100%',
                                                          }}
                                                        >
                                                          {data?.location?.map(
                                                            (addr, i) => (
                                                              <Grid
                                                                item
                                                                xs={12}
                                                              >
                                                                {/* Side Heading */}
                                                                <Typography
                                                                  variant="h5"
                                                                  sx={{ mb: 2 }}
                                                                >
                                                                  Location{' '}
                                                                  {i + 1}
                                                                </Typography>

                                                                {/* Address Fields */}

                                                                <Stack
                                                                  direction={{
                                                                    xs: 'column',
                                                                    sm: 'row',
                                                                  }}
                                                                  spacing={{
                                                                    xs: 3,
                                                                    sm: 2,
                                                                  }}
                                                                  sx={{ mb: 2 }}
                                                                >
                                                                  <TextField
                                                                    fullWidth
                                                                    label="Address"
                                                                    size="small"
                                                                    value={
                                                                      data
                                                                        .location[
                                                                        i
                                                                      ]
                                                                        .address ||
                                                                      ''
                                                                    }
                                                                    // onChange={(event) => {
                                                                    //   let arrayAddr = [...data.location]
                                                                    //   arrayAddr[i].address = event.target.value;
                                                                    //   setCart(pv => ([...pv.map(p => {

                                                                    //     if (p.product_id === data.product_id) {
                                                                    //       return {
                                                                    //         ...p,
                                                                    //         addresses: arrayAddr
                                                                    //       }
                                                                    //     }
                                                                    //     else {
                                                                    //       return {
                                                                    //         ...p
                                                                    //       }
                                                                    //     }

                                                                    //   })]))
                                                                    // }}
                                                                    disabled={
                                                                      i !== 0 &&
                                                                      data?.allRfpProductsLocationSame
                                                                        ? true
                                                                        : false
                                                                    }
                                                                    onChange={(
                                                                      event,
                                                                    ) => {
                                                                      setCart(
                                                                        (
                                                                          prevProducts,
                                                                        ) =>
                                                                          prevProducts.map(
                                                                            (
                                                                              p,
                                                                            ) => {
                                                                              if (
                                                                                p.product_id ===
                                                                                data.product_id
                                                                              ) {
                                                                                let updatedAddresses =
                                                                                  [
                                                                                    ...p.location,
                                                                                  ]
                                                                                if (
                                                                                  p.allRfpProductsLocationSame
                                                                                ) {
                                                                                  updatedAddresses =
                                                                                    updatedAddresses.map(
                                                                                      () => ({
                                                                                        ...updatedAddresses[0],
                                                                                        address:
                                                                                          event
                                                                                            .target
                                                                                            .value,
                                                                                      }),
                                                                                    )
                                                                                } else {
                                                                                  updatedAddresses[
                                                                                    i
                                                                                  ] =
                                                                                    {
                                                                                      ...updatedAddresses[
                                                                                        i
                                                                                      ],
                                                                                      address:
                                                                                        event
                                                                                          .target
                                                                                          .value,
                                                                                    }
                                                                                }
                                                                                return {
                                                                                  ...p,
                                                                                  location:
                                                                                    updatedAddresses,
                                                                                }
                                                                              }
                                                                              return p
                                                                            },
                                                                          ),
                                                                      )
                                                                    }}
                                                                  />
                                                                </Stack>

                                                                {/* City, State, Zip Fields */}
                                                                <Stack
                                                                  direction={{
                                                                    xs: 'column',
                                                                    sm: 'row',
                                                                  }}
                                                                  spacing={{
                                                                    xs: 3,
                                                                    sm: 2,
                                                                  }}
                                                                  sx={{ mb: 2 }}
                                                                >
                                                                  <TextField
                                                                    fullWidth
                                                                    label="City"
                                                                    size="small"
                                                                    value={
                                                                      data
                                                                        .location[
                                                                        i
                                                                      ].city ||
                                                                      ''
                                                                    }
                                                                    // onChange={(event) => {
                                                                    //   let arrayAddr = [...data.location]
                                                                    //   arrayAddr[i].city = event.target.value;
                                                                    //   setCart(pv => ([...pv.map(p => {

                                                                    //     if (p.product_id === data.product_id) {
                                                                    //       return {
                                                                    //         ...p,
                                                                    //         addresses: arrayAddr
                                                                    //       }
                                                                    //     }
                                                                    //     else {
                                                                    //       return {
                                                                    //         ...p
                                                                    //       }
                                                                    //     }

                                                                    //   })]))
                                                                    // }}
                                                                    disabled={
                                                                      i !== 0 &&
                                                                      data?.allRfpProductsLocationSame
                                                                        ? true
                                                                        : false
                                                                    }
                                                                    onChange={(
                                                                      event,
                                                                    ) => {
                                                                      setCart(
                                                                        (
                                                                          prevProducts,
                                                                        ) =>
                                                                          prevProducts.map(
                                                                            (
                                                                              p,
                                                                            ) => {
                                                                              if (
                                                                                p.product_id ===
                                                                                data.product_id
                                                                              ) {
                                                                                let updatedAddresses =
                                                                                  [
                                                                                    ...p.location,
                                                                                  ]
                                                                                if (
                                                                                  p.allRfpProductsLocationSame
                                                                                ) {
                                                                                  updatedAddresses =
                                                                                    updatedAddresses.map(
                                                                                      () => ({
                                                                                        ...updatedAddresses[0],
                                                                                        city: event
                                                                                          .target
                                                                                          .value,
                                                                                      }),
                                                                                    )
                                                                                } else {
                                                                                  updatedAddresses[
                                                                                    i
                                                                                  ] =
                                                                                    {
                                                                                      ...updatedAddresses[
                                                                                        i
                                                                                      ],
                                                                                      city: event
                                                                                        .target
                                                                                        .value,
                                                                                    }
                                                                                }
                                                                                return {
                                                                                  ...p,
                                                                                  location:
                                                                                    updatedAddresses,
                                                                                }
                                                                              }
                                                                              return p
                                                                            },
                                                                          ),
                                                                      )
                                                                    }}
                                                                  />
                                                                  <TextField
                                                                    fullWidth
                                                                    label="State"
                                                                    size="small"
                                                                    value={
                                                                      data
                                                                        .location[
                                                                        i
                                                                      ].state ||
                                                                      ''
                                                                    }
                                                                    // onChange={(event) => {
                                                                    //   let arrayAddr = [...data.location]
                                                                    //   arrayAddr[i].state = event.target.value;
                                                                    //   setCart(pv => ([...pv.map(p => {

                                                                    //     if (p.product_id === data.product_id) {
                                                                    //       return {
                                                                    //         ...p,
                                                                    //         addresses: arrayAddr
                                                                    //       }
                                                                    //     }
                                                                    //     else {
                                                                    //       return {
                                                                    //         ...p
                                                                    //       }
                                                                    //     }

                                                                    //   })]))
                                                                    // }}
                                                                    disabled={
                                                                      i !== 0 &&
                                                                      data?.allRfpProductsLocationSame
                                                                        ? true
                                                                        : false
                                                                    }
                                                                    onChange={(
                                                                      event,
                                                                    ) => {
                                                                      setCart(
                                                                        (
                                                                          prevProducts,
                                                                        ) =>
                                                                          prevProducts.map(
                                                                            (
                                                                              p,
                                                                            ) => {
                                                                              if (
                                                                                p.product_id ===
                                                                                data.product_id
                                                                              ) {
                                                                                let updatedAddresses =
                                                                                  [
                                                                                    ...p.location,
                                                                                  ]
                                                                                if (
                                                                                  p.allRfpProductsLocationSame
                                                                                ) {
                                                                                  updatedAddresses =
                                                                                    updatedAddresses.map(
                                                                                      () => ({
                                                                                        ...updatedAddresses[0],
                                                                                        state:
                                                                                          event
                                                                                            .target
                                                                                            .value,
                                                                                      }),
                                                                                    )
                                                                                } else {
                                                                                  updatedAddresses[
                                                                                    i
                                                                                  ] =
                                                                                    {
                                                                                      ...updatedAddresses[
                                                                                        i
                                                                                      ],
                                                                                      state:
                                                                                        event
                                                                                          .target
                                                                                          .value,
                                                                                    }
                                                                                }
                                                                                return {
                                                                                  ...p,
                                                                                  location:
                                                                                    updatedAddresses,
                                                                                }
                                                                              }
                                                                              return p
                                                                            },
                                                                          ),
                                                                      )
                                                                    }}
                                                                  />
                                                                  <TextField
                                                                    fullWidth
                                                                    label="Zip / Postal Code"
                                                                    size="small"
                                                                    value={
                                                                      data
                                                                        .location[
                                                                        i
                                                                      ].zip ||
                                                                      ''
                                                                    }
                                                                    // onChange={(event) => {
                                                                    //   let arrayAddr = [...data.location]
                                                                    //   arrayAddr[i].zip = event.target.value;
                                                                    //   setCart(pv => ([...pv.map(p => {

                                                                    //     if (p.product_id === data.product_id) {
                                                                    //       return {
                                                                    //         ...p,
                                                                    //         addresses: arrayAddr
                                                                    //       }
                                                                    //     }
                                                                    //     else {
                                                                    //       return {
                                                                    //         ...p
                                                                    //       }
                                                                    //     }

                                                                    //   })]))
                                                                    // }}
                                                                    disabled={
                                                                      i !== 0 &&
                                                                      data?.allRfpProductsLocationSame
                                                                        ? true
                                                                        : false
                                                                    }
                                                                    onChange={(
                                                                      event,
                                                                    ) => {
                                                                      setCart(
                                                                        (
                                                                          prevProducts,
                                                                        ) =>
                                                                          prevProducts.map(
                                                                            (
                                                                              p,
                                                                            ) => {
                                                                              if (
                                                                                p.product_id ===
                                                                                data.product_id
                                                                              ) {
                                                                                let updatedAddresses =
                                                                                  [
                                                                                    ...p.location,
                                                                                  ]
                                                                                if (
                                                                                  p.allRfpProductsLocationSame
                                                                                ) {
                                                                                  updatedAddresses =
                                                                                    updatedAddresses.map(
                                                                                      () => ({
                                                                                        ...updatedAddresses[0],
                                                                                        zip: event
                                                                                          .target
                                                                                          .value,
                                                                                      }),
                                                                                    )
                                                                                } else {
                                                                                  updatedAddresses[
                                                                                    i
                                                                                  ] =
                                                                                    {
                                                                                      ...updatedAddresses[
                                                                                        i
                                                                                      ],
                                                                                      zip: event
                                                                                        .target
                                                                                        .value,
                                                                                    }
                                                                                }
                                                                                return {
                                                                                  ...p,
                                                                                  location:
                                                                                    updatedAddresses,
                                                                                }
                                                                              }
                                                                              return p
                                                                            },
                                                                          ),
                                                                      )
                                                                    }}
                                                                  />
                                                                </Stack>
                                                              </Grid>
                                                            ),
                                                          )}
                                                        </Grid>

                                                        <Grid
                                                          container
                                                          justifyContent="center"
                                                          alignItems="center"
                                                        >
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            md={4}
                                                          >
                                                            <Box
                                                              sx={{
                                                                mt: 3,
                                                                display: 'flex',
                                                                justifyContent:
                                                                  'center',
                                                                gap: 1,
                                                              }}
                                                            >
                                                              <LoadingButton
                                                                variant="contained"
                                                                onClick={() => {
                                                                  setIsSaving(
                                                                    true,
                                                                  )
                                                                  setTimeout(
                                                                    () => {
                                                                      setIsSaving(
                                                                        false,
                                                                      )
                                                                      setRfpLocationStates(
                                                                        false,
                                                                      )
                                                                    },
                                                                    100,
                                                                  )
                                                                }}
                                                                loading={
                                                                  isSaving
                                                                }
                                                              >
                                                                {' Save '}
                                                              </LoadingButton>
                                                            </Box>
                                                          </Grid>
                                                        </Grid>
                                                      </Modal>
                                                    </>
                                                  )
                                                })}
                                            </TableBody>
                                            {cartService?.length > 0 ? (
                                              <Typography
                                                variant="subtitle2"
                                                sx={{ fontWeight: 500 }}
                                              >
                                                Services
                                              </Typography>
                                            ) : (
                                              ''
                                            )}
                                            <TableBody>
                                              {cartService?.map(
                                                (data, index) => {
                                                  data.sellingPrice =
                                                    Number(data.sellingPrice ||
                                                    data.unit_cost) || 0
                                                  data.originalMarkup =
                                                    Number(data.originalMarkup ||
                                                    data.product_markup) || 0

                                                  return (
                                                    <>
                                                      <TableRow key={data.id}>
                                                        <TableCell>
                                                          {data.name ||
                                                            data.product_name}
                                                        </TableCell>
                                                        <TableCell>
                                                          <IconButton
                                                            disabled={isPreview ? true : false}
                                                            onClick={() =>
                                                              handleOpenServiceNote(
                                                                data.id,
                                                                data.service_notes,
                                                              )
                                                            }
                                                          >
                                                            <NoteAdd
                                                              sx={{
                                                                color:
                                                                  !data?.service_notes ||
                                                                  data?.service_notes ===
                                                                    ''
                                                                    ? ''
                                                                    : theme
                                                                        .palette
                                                                        .primary
                                                                        .main,
                                                              }}
                                                            />
                                                          </IconButton>
                                                        </TableCell>
                                                        {/* <TableCell>{invoiceAmount}</TableCell> */}
                                                        <TableCell>
                                                          {data.originalMarkup?.toFixed(
                                                            2,
                                                          )}
                                                        </TableCell>
                                                        <TableCell>
                                                          {data.sellingPrice?.toFixed(
                                                            2,
                                                          )}
                                                        </TableCell>
                                                        <TableCell>
                                                          {(
                                                            data.sellingPrice +
                                                            (data.sellingPrice *
                                                              data.originalMarkup) /
                                                              100
                                                          )?.toFixed(2)}
                                                        </TableCell>
                                                        <TableCell>
                                                          {data.qty} Hours
                                                        </TableCell>
                                                        <TableCell>-</TableCell>
                                                        {/* <TableCell>
                                            {(data.qty*data.sellingPrice).toFixed(2)||0}
                                          </TableCell> */}
                                                        <TableCell>
                                                          {(
                                                            (Number(data.qty) || 0) *
                                                            (data.sellingPrice +
                                                              (data.sellingPrice *
                                                                data.originalMarkup) /
                                                                100)
                                                          )?.toFixed(2)}
                                                        </TableCell>
                                                        {/* <TableCell>
                                            <Switch
                                              checked={data.makeAsTask === 1}
                                              onChange={(e) => {
                                                const newValue = e.target.checked ? 1 : 0;
                                                setCartService((prevServices) =>
                                                  prevServices.map((service) =>
                                                    service.id === data.id
                                                      ? { ...service, makeAsTask: newValue }
                                                      : service
                                                  )
                                                );
                                                data['makeAsTask'] = newValue;
                                              }}
                                              color="primary"
                                            />
                                          </TableCell>
                                          <TableCell>
                                            <Switch
                                              checked={data.makeInstallCard === 1}
                                              onChange={(e) => {
                                                const newValue = e.target.checked ? 1 : 0;
                                                setCartService((prevServices) =>
                                                  prevServices.map((service) =>
                                                    service.id === data.id
                                                      ? { ...service, makeInstallCard: newValue }
                                                      : service
                                                  )
                                                );
                                                data['makeInstallCard'] = newValue;
                                              }}
                                              color="primary"
                                            />
                                          </TableCell> */}
                                                        <TableCell>
                                                          <IconButton
                                                            disabled={isPreview ? true : false}
                                                            onClick={() => {
                                                              setRfpServiceLocationStates(
                                                                {
                                                                  ...rfpServiceLocationStates,
                                                                  [data.id]: true,
                                                                },
                                                              )
                                                            }}
                                                          >
                                                            <LocationOn
                                                              sx={{
                                                                color:
                                                                  data &&
                                                                  data.location &&
                                                                  data.location.some(
                                                                    (obj) =>
                                                                      [
                                                                        obj.address,
                                                                        obj.city,
                                                                        obj.state,
                                                                        obj.zip,
                                                                      ].some(
                                                                        (
                                                                          value,
                                                                        ) =>
                                                                          value ===
                                                                            '' ||
                                                                          value ===
                                                                            null,
                                                                      ),
                                                                  )
                                                                    ? ''
                                                                    : theme
                                                                        .palette
                                                                        .primary
                                                                        .main,
                                                              }}
                                                            />
                                                          </IconButton>
                                                        </TableCell>

                                                        <TableCell>
                                                          {isPreview ? '' : 
                                                          <IconButton
                                                            onClick={() =>
                                                              handleDeleteRFPService(
                                                                data.labour_cost_service_id,
                                                              )
                                                            }
                                                          >
                                                            <Delete />
                                                          </IconButton>}
                                                        </TableCell>
                                                      </TableRow>
                                                      <Modal
                                                        open={
                                                          rfpServiceLocationStates[
                                                            data.id
                                                          ]
                                                        }
                                                        handleClose={() => {
                                                          setRfpServiceLocationStates(
                                                            {
                                                              ...rfpServiceLocationStates,
                                                              [data.id]: false,
                                                            },
                                                          )
                                                        }}
                                                      >
                                                        {index === 0 && (
                                                          <FormControlLabel
                                                            control={
                                                              <Switch
                                                                checked={
                                                                  allRfpServiceLocationSame
                                                                }
                                                                onChange={
                                                                  handleAllRfpServiceLocationSameChange
                                                                }
                                                              />
                                                            }
                                                            label="All Locations Same"
                                                          />
                                                        )}

                                                        <Grid
                                                          container
                                                          spacing={3}
                                                          sx={{
                                                            justifyContent:
                                                              'center',
                                                            width: '100%',
                                                          }}
                                                        >
                                                          {data?.location?.map(
                                                            (addr, i) => (
                                                              <Grid
                                                                item
                                                                xs={12}
                                                              >
                                                                {/* Side Heading */}
                                                                <Typography
                                                                  variant="h5"
                                                                  sx={{ mb: 2 }}
                                                                >
                                                                  Location
                                                                </Typography>

                                                                {/* Address Fields */}

                                                                <Stack
                                                                  direction={{
                                                                    xs: 'column',
                                                                    sm: 'row',
                                                                  }}
                                                                  spacing={{
                                                                    xs: 3,
                                                                    sm: 2,
                                                                  }}
                                                                  sx={{ mb: 2 }}
                                                                >
                                                                  <TextField
                                                                    fullWidth
                                                                    label="Address"
                                                                    size="small"
                                                                    value={
                                                                      data
                                                                        .location[
                                                                        i
                                                                      ]
                                                                        .address ||
                                                                      ''
                                                                    }
                                                                    disabled={
                                                                      index !==
                                                                        0 &&
                                                                      allRfpServiceLocationSame
                                                                        ? true
                                                                        : false
                                                                    }
                                                                    // onChange={(event) => {
                                                                    //   let arrayAddr = [...data.location]
                                                                    //   arrayAddr[i].address = event.target.value;
                                                                    //   setCartService(pv => ([...pv.map(p => {

                                                                    //     if (p.id === data.id) {
                                                                    //       return {
                                                                    //         ...p,
                                                                    //         location: arrayAddr
                                                                    //       }
                                                                    //     }
                                                                    //     else {
                                                                    //       return {
                                                                    //         ...p
                                                                    //       }
                                                                    //     }

                                                                    //   })]))
                                                                    // }}
                                                                    onChange={(
                                                                      event,
                                                                    ) => {
                                                                      const updatedValue =
                                                                        event
                                                                          .target
                                                                          .value

                                                                      setCartService(
                                                                        (
                                                                          prevServices,
                                                                        ) =>
                                                                          prevServices.map(
                                                                            (
                                                                              service,
                                                                            ) => {
                                                                              let updatedLocations =
                                                                                [
                                                                                  ...service.location,
                                                                                ]

                                                                              if (
                                                                                allRfpServiceLocationSame
                                                                              ) {
                                                                                // Apply the new value to all services in cartService
                                                                                return {
                                                                                  ...service,
                                                                                  location:
                                                                                    updatedLocations.map(
                                                                                      (
                                                                                        loc,
                                                                                      ) => ({
                                                                                        ...loc,
                                                                                        address:
                                                                                          updatedValue, // Update address field, same logic applies for others
                                                                                      }),
                                                                                    ),
                                                                                }
                                                                              } else {
                                                                                // Update only the specific service
                                                                                if (
                                                                                  service.id ===
                                                                                  data.id
                                                                                ) {
                                                                                  updatedLocations[
                                                                                    i
                                                                                  ].address =
                                                                                    updatedValue
                                                                                }
                                                                                return {
                                                                                  ...service,
                                                                                  location:
                                                                                    updatedLocations,
                                                                                }
                                                                              }
                                                                            },
                                                                          ),
                                                                      )
                                                                    }}
                                                                  />
                                                                </Stack>

                                                                {/* City, State, Zip Fields */}
                                                                <Stack
                                                                  direction={{
                                                                    xs: 'column',
                                                                    sm: 'row',
                                                                  }}
                                                                  spacing={{
                                                                    xs: 3,
                                                                    sm: 2,
                                                                  }}
                                                                  sx={{ mb: 2 }}
                                                                >
                                                                  <TextField
                                                                    fullWidth
                                                                    label="City"
                                                                    size="small"
                                                                    value={
                                                                      data
                                                                        .location[
                                                                        i
                                                                      ].city ||
                                                                      ''
                                                                    }
                                                                    disabled={
                                                                      index !==
                                                                        0 &&
                                                                      allRfpServiceLocationSame
                                                                        ? true
                                                                        : false
                                                                    }
                                                                    // onChange={(event) => {
                                                                    //   let arrayAddr = [...data.location]
                                                                    //   arrayAddr[i].city = event.target.value;
                                                                    //   setCartService(pv => ([...pv.map(p => {

                                                                    //     if (p.id === data.id) {
                                                                    //       return {
                                                                    //         ...p,
                                                                    //         location: arrayAddr
                                                                    //       }
                                                                    //     }
                                                                    //     else {
                                                                    //       return {
                                                                    //         ...p
                                                                    //       }
                                                                    //     }

                                                                    //   })]))
                                                                    // }}
                                                                    onChange={(
                                                                      event,
                                                                    ) => {
                                                                      const updatedValue =
                                                                        event
                                                                          .target
                                                                          .value

                                                                      setCartService(
                                                                        (
                                                                          prevServices,
                                                                        ) =>
                                                                          prevServices.map(
                                                                            (
                                                                              service,
                                                                            ) => {
                                                                              let updatedLocations =
                                                                                [
                                                                                  ...service.location,
                                                                                ]

                                                                              if (
                                                                                allRfpServiceLocationSame
                                                                              ) {
                                                                                // Apply the new value to all services in cartService
                                                                                return {
                                                                                  ...service,
                                                                                  location:
                                                                                    updatedLocations.map(
                                                                                      (
                                                                                        loc,
                                                                                      ) => ({
                                                                                        ...loc,
                                                                                        city: updatedValue, // Update city field, same logic applies for others
                                                                                      }),
                                                                                    ),
                                                                                }
                                                                              } else {
                                                                                // Update only the specific service
                                                                                if (
                                                                                  service.id ===
                                                                                  data.id
                                                                                ) {
                                                                                  updatedLocations[
                                                                                    i
                                                                                  ].city =
                                                                                    updatedValue
                                                                                }
                                                                                return {
                                                                                  ...service,
                                                                                  location:
                                                                                    updatedLocations,
                                                                                }
                                                                              }
                                                                            },
                                                                          ),
                                                                      )
                                                                    }}
                                                                  />
                                                                  <TextField
                                                                    fullWidth
                                                                    label="State"
                                                                    size="small"
                                                                    value={
                                                                      data
                                                                        .location[
                                                                        i
                                                                      ].state ||
                                                                      ''
                                                                    }
                                                                    disabled={
                                                                      index !==
                                                                        0 &&
                                                                      allRfpServiceLocationSame
                                                                        ? true
                                                                        : false
                                                                    }
                                                                    // onChange={(event) => {
                                                                    //   let arrayAddr = [...data.location]
                                                                    //   arrayAddr[i].state = event.target.value;
                                                                    //   setCartService(pv => ([...pv.map(p => {

                                                                    //     if (p.id === data.id) {
                                                                    //       return {
                                                                    //         ...p,
                                                                    //         location: arrayAddr
                                                                    //       }
                                                                    //     }
                                                                    //     else {
                                                                    //       return {
                                                                    //         ...p
                                                                    //       }
                                                                    //     }

                                                                    //   })]))
                                                                    // }}
                                                                    onChange={(
                                                                      event,
                                                                    ) => {
                                                                      const updatedValue =
                                                                        event
                                                                          .target
                                                                          .value

                                                                      setCartService(
                                                                        (
                                                                          prevServices,
                                                                        ) =>
                                                                          prevServices.map(
                                                                            (
                                                                              service,
                                                                            ) => {
                                                                              let updatedLocations =
                                                                                [
                                                                                  ...service.location,
                                                                                ]

                                                                              if (
                                                                                allRfpServiceLocationSame
                                                                              ) {
                                                                                // Apply the new value to all services in cartService
                                                                                return {
                                                                                  ...service,
                                                                                  location:
                                                                                    updatedLocations.map(
                                                                                      (
                                                                                        loc,
                                                                                      ) => ({
                                                                                        ...loc,
                                                                                        state:
                                                                                          updatedValue, // Update state field, same logic applies for others
                                                                                      }),
                                                                                    ),
                                                                                }
                                                                              } else {
                                                                                // Update only the specific service
                                                                                if (
                                                                                  service.id ===
                                                                                  data.id
                                                                                ) {
                                                                                  updatedLocations[
                                                                                    i
                                                                                  ].state =
                                                                                    updatedValue
                                                                                }
                                                                                return {
                                                                                  ...service,
                                                                                  location:
                                                                                    updatedLocations,
                                                                                }
                                                                              }
                                                                            },
                                                                          ),
                                                                      )
                                                                    }}
                                                                  />
                                                                  <TextField
                                                                    fullWidth
                                                                    label="Zip / Postal Code"
                                                                    size="small"
                                                                    value={
                                                                      data
                                                                        .location[
                                                                        i
                                                                      ].zip ||
                                                                      ''
                                                                    }
                                                                    disabled={
                                                                      index !==
                                                                        0 &&
                                                                      allRfpServiceLocationSame
                                                                        ? true
                                                                        : false
                                                                    }
                                                                    // onChange={(event) => {
                                                                    //   let arrayAddr = [...data.location]
                                                                    //   arrayAddr[i].zip = event.target.value;
                                                                    //   setCartService(pv => ([...pv.map(p => {

                                                                    //     if (p.id === data.id) {
                                                                    //       return {
                                                                    //         ...p,
                                                                    //         location: arrayAddr
                                                                    //       }
                                                                    //     }
                                                                    //     else {
                                                                    //       return {
                                                                    //         ...p
                                                                    //       }
                                                                    //     }

                                                                    //   })]))
                                                                    // }}
                                                                    onChange={(
                                                                      event,
                                                                    ) => {
                                                                      const updatedValue =
                                                                        event
                                                                          .target
                                                                          .value

                                                                      setCartService(
                                                                        (
                                                                          prevServices,
                                                                        ) =>
                                                                          prevServices.map(
                                                                            (
                                                                              service,
                                                                            ) => {
                                                                              let updatedLocations =
                                                                                [
                                                                                  ...service.location,
                                                                                ]

                                                                              if (
                                                                                allRfpServiceLocationSame
                                                                              ) {
                                                                                // Apply the new value to all services in cartService
                                                                                return {
                                                                                  ...service,
                                                                                  location:
                                                                                    updatedLocations.map(
                                                                                      (
                                                                                        loc,
                                                                                      ) => ({
                                                                                        ...loc,
                                                                                        zip: updatedValue, // Update ZIP field, same logic applies for others
                                                                                      }),
                                                                                    ),
                                                                                }
                                                                              } else {
                                                                                // Update only the specific service
                                                                                if (
                                                                                  service.id ===
                                                                                  data.id
                                                                                ) {
                                                                                  updatedLocations[
                                                                                    i
                                                                                  ].zip =
                                                                                    updatedValue
                                                                                }
                                                                                return {
                                                                                  ...service,
                                                                                  location:
                                                                                    updatedLocations,
                                                                                }
                                                                              }
                                                                            },
                                                                          ),
                                                                      )
                                                                    }}
                                                                  />
                                                                </Stack>
                                                              </Grid>
                                                            ),
                                                          )}
                                                        </Grid>

                                                        {index !== 0 &&
                                                        allRfpServiceLocationSame ? (
                                                          ''
                                                        ) : (
                                                          <Grid
                                                            container
                                                            justifyContent="center"
                                                            alignItems="center"
                                                          >
                                                            <Grid
                                                              item
                                                              xs={12}
                                                              md={4}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  mt: 3,
                                                                  display:
                                                                    'flex',
                                                                  justifyContent:
                                                                    'center',
                                                                  gap: 1,
                                                                }}
                                                              >
                                                                <LoadingButton
                                                                  variant="contained"
                                                                  onClick={() => {
                                                                    setIsSaving(
                                                                      true,
                                                                    )
                                                                    setTimeout(
                                                                      () => {
                                                                        setIsSaving(
                                                                          false,
                                                                        )
                                                                        setRfpServiceLocationStates(
                                                                          false,
                                                                        )
                                                                      },
                                                                      100,
                                                                    )
                                                                  }}
                                                                  loading={
                                                                    isSaving
                                                                  }
                                                                >
                                                                  {' Save '}
                                                                </LoadingButton>
                                                              </Box>
                                                            </Grid>
                                                          </Grid>
                                                        )}
                                                      </Modal>
                                                    </>
                                                  )
                                                },
                                              )}
                                            </TableBody>
                                            {cart?.filter(
                                              (item) => item.material == 1,
                                            ).length > 0 ? (
                                              <Typography
                                                variant="subtitle2"
                                                sx={{ fontWeight: 500 }}
                                              >
                                                Materials
                                              </Typography>
                                            ) : (
                                              ''
                                            )}
                                            <TableBody>
                                              {cart
                                                ?.filter(
                                                  (item) => item.material == 1,
                                                )
                                                ?.map((data, index) => {
                                                  let unitName = UNITS?.filter(
                                                    (item) =>
                                                      item?.id == data?.unit,
                                                  )
                                                  unitName = unitName[0]?.name
                                                  let shortUnitName = ''
                                                  if (
                                                    unitName == 'Square feet'
                                                  ) {
                                                    shortUnitName = 'Sq ft'
                                                  } else if (
                                                    unitName == 'Lineal feet'
                                                  ) {
                                                    shortUnitName = 'Lin ft'
                                                  } else if (
                                                    unitName == 'Square Inches'
                                                  ) {
                                                    shortUnitName = 'Sq Inches'
                                                  } else if (
                                                    unitName == 'Unit'
                                                  ) {
                                                    shortUnitName = 'Unit'
                                                  }
                                                  // let markup = markupType ? markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup : 0
                                                  let markup =
                                                    parseFloat(
                                                      Number(data?.markup),
                                                    ) || 0
                                                  data.product_markup = markup
                                                  return (
                                                    <>
                                                      <TableRow key={data.id}>
                                                        <TableCell>
                                                          {data.name ||
                                                            data.product_name}
                                                        </TableCell>
                                                        <TableCell />
                                                        {/* <TableCell>{invoiceAmount}</TableCell> */}
                                                        <TableCell>
                                                          {markup?.toFixed(2) ||
                                                            0.0}
                                                        </TableCell>
                                                        <TableCell>
                                                          {data.product_price?.toFixed(
                                                            2,
                                                          ) || 0}
                                                        </TableCell>
                                                        <TableCell>
                                                          {(
                                                            data.product_price +
                                                            (data.product_price *
                                                              markup) /
                                                              100
                                                          ).toFixed(2) || 0.0}
                                                        </TableCell>
                                                        <TableCell>
                                                          {data.quantity}{' '}
                                                          {shortUnitName}
                                                        </TableCell>
                                                        <TableCell>
                                                          {
                                                            data.location_quantity
                                                          }
                                                        </TableCell>

                                                        {/* <TableCell>
                                            {(data.product_price * data.quantity * data.location_quantity)?.toFixed(2)||0}
                                          </TableCell> */}
                                                        <TableCell>
                                                          {(
                                                            data.location_quantity *
                                                            data.quantity *
                                                            ((
                                                              data.product_price +
                                                              (data.product_price *
                                                                markup) /
                                                                100
                                                            )?.toFixed(2) || 0)
                                                          ).toFixed(2)}
                                                        </TableCell>
                                                        {/* <TableCell>N/A</TableCell>
                                          <TableCell>N/A</TableCell> */}
                                                        <TableCell>
                                                          <IconButton
                                                            disabled={isPreview ? true : false}
                                                            onClick={() => {
                                                              setRfpLocationStates(
                                                                {
                                                                  ...rfpLocationStates,
                                                                  [data.product_id]: true,
                                                                },
                                                              )
                                                            }}
                                                          >
                                                            <LocationOn
                                                              sx={{
                                                                color:
                                                                  data &&
                                                                  data.location &&
                                                                  data.location.some(
                                                                    (obj) =>
                                                                      [
                                                                        obj.address,
                                                                        obj.city,
                                                                        obj.state,
                                                                        obj.zip,
                                                                      ].some(
                                                                        (
                                                                          value,
                                                                        ) =>
                                                                          value ===
                                                                            '' ||
                                                                          value ===
                                                                            null,
                                                                      ),
                                                                  )
                                                                    ? ''
                                                                    : theme
                                                                        .palette
                                                                        .primary
                                                                        .main,
                                                              }}
                                                            />
                                                          </IconButton>
                                                        </TableCell>
                                                        <TableCell>
                                                          {isPreview ? '' : 
                                                          <IconButton
                                                            onClick={() =>
                                                              handleDeleteRFPProduct(
                                                                data.product_id,
                                                              )
                                                            }
                                                          >
                                                            <Delete />
                                                          </IconButton>}
                                                        </TableCell>
                                                      </TableRow>
                                                      <Modal
                                                        open={
                                                          rfpLocationStates[
                                                            data.product_id
                                                          ]
                                                        }
                                                        handleClose={() => {
                                                          setRfpLocationStates({
                                                            ...rfpLocationStates,
                                                            [data.product_id]: false,
                                                          })
                                                        }}
                                                      >
                                                        {/* {index === 0 &&  */}
                                                        <FormControlLabel
                                                          control={
                                                            <Switch
                                                              checked={
                                                                data?.allRfpProductsLocationSame
                                                              }
                                                              onChange={() =>
                                                                handleAllRfpProductsLocationSameChange(
                                                                  index,
                                                                )
                                                              }
                                                            />
                                                          }
                                                          label="All Locations Same"
                                                        />
                                                        {/* } */}

                                                        <Grid
                                                          container
                                                          spacing={3}
                                                          sx={{
                                                            justifyContent:
                                                              'center',
                                                            width: '100%',
                                                          }}
                                                        >
                                                          {data?.location?.map(
                                                            (addr, i) => (
                                                              <Grid
                                                                item
                                                                xs={12}
                                                              >
                                                                {/* Side Heading */}
                                                                <Typography
                                                                  variant="h5"
                                                                  sx={{ mb: 2 }}
                                                                >
                                                                  Location{' '}
                                                                  {i + 1}
                                                                </Typography>

                                                                {/* Address Fields */}

                                                                <Stack
                                                                  direction={{
                                                                    xs: 'column',
                                                                    sm: 'row',
                                                                  }}
                                                                  spacing={{
                                                                    xs: 3,
                                                                    sm: 2,
                                                                  }}
                                                                  sx={{ mb: 2 }}
                                                                >
                                                                  <TextField
                                                                    fullWidth
                                                                    label="Address"
                                                                    size="small"
                                                                    value={
                                                                      data
                                                                        .location[
                                                                        i
                                                                      ]
                                                                        .address ||
                                                                      ''
                                                                    }
                                                                    // onChange={(event) => {
                                                                    //   let arrayAddr = [...data.location]
                                                                    //   arrayAddr[i].address = event.target.value;
                                                                    //   setCart(pv => ([...pv.map(p => {

                                                                    //     if (p.product_id === data.product_id) {
                                                                    //       return {
                                                                    //         ...p,
                                                                    //         addresses: arrayAddr
                                                                    //       }
                                                                    //     }
                                                                    //     else {
                                                                    //       return {
                                                                    //         ...p
                                                                    //       }
                                                                    //     }

                                                                    //   })]))
                                                                    // }}
                                                                    disabled={
                                                                      i !== 0 &&
                                                                      data?.allRfpProductsLocationSame
                                                                        ? true
                                                                        : false
                                                                    }
                                                                    onChange={(
                                                                      event,
                                                                    ) => {
                                                                      setCart(
                                                                        (
                                                                          prevProducts,
                                                                        ) =>
                                                                          prevProducts.map(
                                                                            (
                                                                              p,
                                                                            ) => {
                                                                              if (
                                                                                p.product_id ===
                                                                                data.product_id
                                                                              ) {
                                                                                let updatedAddresses =
                                                                                  [
                                                                                    ...p.location,
                                                                                  ]
                                                                                if (
                                                                                  p.allRfpProductsLocationSame
                                                                                ) {
                                                                                  updatedAddresses =
                                                                                    updatedAddresses.map(
                                                                                      () => ({
                                                                                        ...updatedAddresses[0],
                                                                                        address:
                                                                                          event
                                                                                            .target
                                                                                            .value,
                                                                                      }),
                                                                                    )
                                                                                } else {
                                                                                  updatedAddresses[
                                                                                    i
                                                                                  ] =
                                                                                    {
                                                                                      ...updatedAddresses[
                                                                                        i
                                                                                      ],
                                                                                      address:
                                                                                        event
                                                                                          .target
                                                                                          .value,
                                                                                    }
                                                                                }
                                                                                return {
                                                                                  ...p,
                                                                                  location:
                                                                                    updatedAddresses,
                                                                                }
                                                                              }
                                                                              return p
                                                                            },
                                                                          ),
                                                                      )
                                                                    }}
                                                                  />
                                                                </Stack>

                                                                {/* City, State, Zip Fields */}
                                                                <Stack
                                                                  direction={{
                                                                    xs: 'column',
                                                                    sm: 'row',
                                                                  }}
                                                                  spacing={{
                                                                    xs: 3,
                                                                    sm: 2,
                                                                  }}
                                                                  sx={{ mb: 2 }}
                                                                >
                                                                  <TextField
                                                                    fullWidth
                                                                    label="City"
                                                                    size="small"
                                                                    value={
                                                                      data
                                                                        .location[
                                                                        i
                                                                      ].city ||
                                                                      ''
                                                                    }
                                                                    // onChange={(event) => {
                                                                    //   let arrayAddr = [...data.location]
                                                                    //   arrayAddr[i].city = event.target.value;
                                                                    //   setCart(pv => ([...pv.map(p => {

                                                                    //     if (p.product_id === data.product_id) {
                                                                    //       return {
                                                                    //         ...p,
                                                                    //         addresses: arrayAddr
                                                                    //       }
                                                                    //     }
                                                                    //     else {
                                                                    //       return {
                                                                    //         ...p
                                                                    //       }
                                                                    //     }

                                                                    //   })]))
                                                                    // }}
                                                                    disabled={
                                                                      i !== 0 &&
                                                                      data?.allRfpProductsLocationSame
                                                                        ? true
                                                                        : false
                                                                    }
                                                                    onChange={(
                                                                      event,
                                                                    ) => {
                                                                      setCart(
                                                                        (
                                                                          prevProducts,
                                                                        ) =>
                                                                          prevProducts.map(
                                                                            (
                                                                              p,
                                                                            ) => {
                                                                              if (
                                                                                p.product_id ===
                                                                                data.product_id
                                                                              ) {
                                                                                let updatedAddresses =
                                                                                  [
                                                                                    ...p.location,
                                                                                  ]
                                                                                if (
                                                                                  p.allRfpProductsLocationSame
                                                                                ) {
                                                                                  updatedAddresses =
                                                                                    updatedAddresses.map(
                                                                                      () => ({
                                                                                        ...updatedAddresses[0],
                                                                                        city: event
                                                                                          .target
                                                                                          .value,
                                                                                      }),
                                                                                    )
                                                                                } else {
                                                                                  updatedAddresses[
                                                                                    i
                                                                                  ] =
                                                                                    {
                                                                                      ...updatedAddresses[
                                                                                        i
                                                                                      ],
                                                                                      city: event
                                                                                        .target
                                                                                        .value,
                                                                                    }
                                                                                }
                                                                                return {
                                                                                  ...p,
                                                                                  location:
                                                                                    updatedAddresses,
                                                                                }
                                                                              }
                                                                              return p
                                                                            },
                                                                          ),
                                                                      )
                                                                    }}
                                                                  />
                                                                  <TextField
                                                                    fullWidth
                                                                    label="State"
                                                                    size="small"
                                                                    value={
                                                                      data
                                                                        .location[
                                                                        i
                                                                      ].state ||
                                                                      ''
                                                                    }
                                                                    // onChange={(event) => {
                                                                    //   let arrayAddr = [...data.location]
                                                                    //   arrayAddr[i].state = event.target.value;
                                                                    //   setCart(pv => ([...pv.map(p => {

                                                                    //     if (p.product_id === data.product_id) {
                                                                    //       return {
                                                                    //         ...p,
                                                                    //         addresses: arrayAddr
                                                                    //       }
                                                                    //     }
                                                                    //     else {
                                                                    //       return {
                                                                    //         ...p
                                                                    //       }
                                                                    //     }

                                                                    //   })]))
                                                                    // }}
                                                                    disabled={
                                                                      i !== 0 &&
                                                                      data?.allRfpProductsLocationSame
                                                                        ? true
                                                                        : false
                                                                    }
                                                                    onChange={(
                                                                      event,
                                                                    ) => {
                                                                      setCart(
                                                                        (
                                                                          prevProducts,
                                                                        ) =>
                                                                          prevProducts.map(
                                                                            (
                                                                              p,
                                                                            ) => {
                                                                              if (
                                                                                p.product_id ===
                                                                                data.product_id
                                                                              ) {
                                                                                let updatedAddresses =
                                                                                  [
                                                                                    ...p.location,
                                                                                  ]
                                                                                if (
                                                                                  p.allRfpProductsLocationSame
                                                                                ) {
                                                                                  updatedAddresses =
                                                                                    updatedAddresses.map(
                                                                                      () => ({
                                                                                        ...updatedAddresses[0],
                                                                                        state:
                                                                                          event
                                                                                            .target
                                                                                            .value,
                                                                                      }),
                                                                                    )
                                                                                } else {
                                                                                  updatedAddresses[
                                                                                    i
                                                                                  ] =
                                                                                    {
                                                                                      ...updatedAddresses[
                                                                                        i
                                                                                      ],
                                                                                      state:
                                                                                        event
                                                                                          .target
                                                                                          .value,
                                                                                    }
                                                                                }
                                                                                return {
                                                                                  ...p,
                                                                                  location:
                                                                                    updatedAddresses,
                                                                                }
                                                                              }
                                                                              return p
                                                                            },
                                                                          ),
                                                                      )
                                                                    }}
                                                                  />
                                                                  <TextField
                                                                    fullWidth
                                                                    label="Zip / Postal Code"
                                                                    size="small"
                                                                    value={
                                                                      data
                                                                        .location[
                                                                        i
                                                                      ].zip ||
                                                                      ''
                                                                    }
                                                                    // onChange={(event) => {
                                                                    //   let arrayAddr = [...data.location]
                                                                    //   arrayAddr[i].zip = event.target.value;
                                                                    //   setCart(pv => ([...pv.map(p => {

                                                                    //     if (p.product_id === data.product_id) {
                                                                    //       return {
                                                                    //         ...p,
                                                                    //         addresses: arrayAddr
                                                                    //       }
                                                                    //     }
                                                                    //     else {
                                                                    //       return {
                                                                    //         ...p
                                                                    //       }
                                                                    //     }

                                                                    //   })]))
                                                                    // }}
                                                                    disabled={
                                                                      i !== 0 &&
                                                                      data?.allRfpProductsLocationSame
                                                                        ? true
                                                                        : false
                                                                    }
                                                                    onChange={(
                                                                      event,
                                                                    ) => {
                                                                      setCart(
                                                                        (
                                                                          prevProducts,
                                                                        ) =>
                                                                          prevProducts.map(
                                                                            (
                                                                              p,
                                                                            ) => {
                                                                              if (
                                                                                p.product_id ===
                                                                                data.product_id
                                                                              ) {
                                                                                let updatedAddresses =
                                                                                  [
                                                                                    ...p.location,
                                                                                  ]
                                                                                if (
                                                                                  p.allRfpProductsLocationSame
                                                                                ) {
                                                                                  updatedAddresses =
                                                                                    updatedAddresses.map(
                                                                                      () => ({
                                                                                        ...updatedAddresses[0],
                                                                                        zip: event
                                                                                          .target
                                                                                          .value,
                                                                                      }),
                                                                                    )
                                                                                } else {
                                                                                  updatedAddresses[
                                                                                    i
                                                                                  ] =
                                                                                    {
                                                                                      ...updatedAddresses[
                                                                                        i
                                                                                      ],
                                                                                      zip: event
                                                                                        .target
                                                                                        .value,
                                                                                    }
                                                                                }
                                                                                return {
                                                                                  ...p,
                                                                                  location:
                                                                                    updatedAddresses,
                                                                                }
                                                                              }
                                                                              return p
                                                                            },
                                                                          ),
                                                                      )
                                                                    }}
                                                                  />
                                                                </Stack>
                                                              </Grid>
                                                            ),
                                                          )}
                                                        </Grid>

                                                        <Grid
                                                          container
                                                          justifyContent="center"
                                                          alignItems="center"
                                                        >
                                                          <Grid
                                                            item
                                                            xs={12}
                                                            md={4}
                                                          >
                                                            <Box
                                                              sx={{
                                                                mt: 3,
                                                                display: 'flex',
                                                                justifyContent:
                                                                  'center',
                                                                gap: 1,
                                                              }}
                                                            >
                                                              <LoadingButton
                                                                variant="contained"
                                                                onClick={() => {
                                                                  setIsSaving(
                                                                    true,
                                                                  )
                                                                  setTimeout(
                                                                    () => {
                                                                      setIsSaving(
                                                                        false,
                                                                      )
                                                                      setRfpLocationStates(
                                                                        false,
                                                                      )
                                                                    },
                                                                    100,
                                                                  )
                                                                }}
                                                                loading={
                                                                  isSaving
                                                                }
                                                              >
                                                                {' Save '}
                                                              </LoadingButton>
                                                            </Box>
                                                          </Grid>
                                                        </Grid>
                                                      </Modal>
                                                    </>
                                                  )
                                                })}
                                            </TableBody>
                                          </Table>
                                        </TableContainer>
                                      </Scrollbar>
                                    </>
                                  )}
                                  <LabelStyleHead>Materials</LabelStyleHead>
                                  {/* <Typography></Typography> */}
                                  <Stack
                                    direction={{ xs: 'column', sm: 'row' }}
                                    spacing={{ xs: 3, sm: 2 }}
                                  >
                                    {/* <Autocomplete
                              sx={{ width: 400 }}
                              multiple
                              id="combo-box-demo"
                              // options={materials || []}
                              // options={materials?.filter((option) => !selectedMaterials?.some(selected => selected.product_id === option.id)) || []}
                              options={
                                materials?.filter((option) => {
                                  // Exclude selected materials
                                  const isSelected = selectedMaterials?.some((selected) => selected.product_id === option.id);
                                  const isServiceOnly = values.project_category?.name === 'Service only';
                                  // Filter materials: show only inhouse = 1 unless it's 'Service only'
                                  const shouldInclude = isServiceOnly || option.inhouse === 1;
                                  return !isSelected && shouldInclude;
                                }) || []
                              }
                              value={selectedMaterials?.filter(item => !item?.isAdditionalProduct)}
                              onChange={(event, newValue) => {
                                handleMaterial(newValue);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label="Materials" variant="outlined" />
                              )}
                              // getOptionLabel={(option) => option.name ? option.name : option.product_name ? option.product_name : ''}
                              // getOptionLabel={(option) => {
                              //   const name = option.name || option.product_name || '';
                              //   const ownershipLabel = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                              //   return name + ownershipLabel;
                              // }}
                              getOptionLabel={(option) => {
                                console.log('optionssssssssss',option)
                                const name = option.name || option.product_name || '';
                                const description = option.description ||option.product_description || '';
                                return `${description} \u200B${name}`;
                              }}
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              renderOption={(props, option) => {
                                const description = option.description || '';
                                return (
                                  <li {...props}>
                                  <Tooltip title={description}>
                                    <span style={{
                                      display: 'inline-block',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      maxWidth: '300px'
                                    }}>
                                      {description}
                                    </span>
                                  </Tooltip>
                                  <span style={{ display: 'none' }}>{option.name}</span>
                                </li>
                                );
                              }}
                              filterOptions={(options, { inputValue }) =>
                                options.filter((option) => {
                                  console.log("Name:", option.name, "Description:", option.description);
                                  const searchText = inputValue.toLowerCase();
                                  return (
                                    option.name?.toLowerCase().includes(searchText) ||
                                    option.description?.toLowerCase().includes(searchText)
                                    // option.description?.toLowerCase().includes(searchText)
                                  );
                                })
                              }
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => {
                                  const suffix = option.inhouse === 1 ? '(Inhouse)' : '(Client owned)';
                                  const tooltipText = `${option.description  || ''} ${suffix}`;
                                  return(
                                       <Tooltip
                                        key={index}
                                        title={tooltipText}
                                      >
                                  <Chip
                                    {...getTagProps({ index })}
                                    label={option.description || ''}
                                  />
                                  </Tooltip>
                                )})
                              } /> */}
                                    <Autocomplete
                                      sx={{ width: 400 }}
                                      multiple
                                      disabled={isPreview ? true : false}
                                      id="combo-box-materials"
                                      options={
                                        materials?.filter((option) => {
                                          const isServiceOnly =
                                            values.project_category?.name ===
                                            'Service only'
                                          return (
                                            isServiceOnly ||
                                            option.inhouse === 1
                                          )
                                        }) || []
                                      }
                                      value={selectedMaterials.filter(
                                        (item) => !item.isAdditionalProduct,
                                      )}
                                      // onChange={(event, newValue, reason, details) => {
                                      //   if (reason === 'removeOption') {
                                      //     const updated = selectedMaterials.filter(item =>
                                      //       item.product_id !== details.option.product_id ||
                                      //       item.stock_type !== details.option.stock_type ||
                                      //       (item.stock_type === 2 && item.convertion_unit !== details.option.convertion_unit)
                                      //     );
                                      //     setSelectedMaterials(updated);
                                      //     setPendingAutocompleteMaterials(updated);
                                      //     setFieldValue('additionalMaterials', updated);
                                      //     handleMaterial(updated);
                                      //     return;
                                      //   }

                                      //   const lastSelected = newValue[newValue.length - 1];

                                      //   if (!lastSelected) return;

                                      //   // Prevent multiple partial stock selection for the same product
                                      //   if (selectedMaterials.some(item =>
                                      //     item.product_id === lastSelected.product_id && item.stock_type === 2
                                      //   )) {
                                      //     enqueueSnackbar('Partial stock already selected for this product', { variant: 'error' });
                                      //     return;
                                      //   }

                                      //   handleMaterialStockCheck(lastSelected); // Open dialog for stock type selection
                                      // }}
                                      onChange={(
                                        event,
                                        newValue,
                                        reason,
                                        details,
                                      ) => {
                                        if (!newValue) return

                                        // 🔹 Handle Clear All (via big 'X')
                                        if (reason === 'clear') {
                                          const onlyAdditional =
                                            selectedMaterials.filter(
                                              (item) =>
                                                item.isAdditionalProduct ===
                                                true,
                                            )
                                          setSelectedMaterials(onlyAdditional)
                                          setPendingAutocompleteMaterials(
                                            onlyAdditional,
                                          )
                                          setFieldValue(
                                            'additionalMaterials',
                                            onlyAdditional,
                                          )
                                          handleMaterial(onlyAdditional)
                                          return
                                        }

                                        // 🔹 Handle individual remove
                                        if (reason === 'removeOption') {
                                          const updated =
                                            selectedMaterials.filter(
                                              (item) =>
                                                item.product_id !==
                                                  details.option.product_id ||
                                                item.stock_type !==
                                                  details.option.stock_type ||
                                                (item.stock_type === 2 &&
                                                  item.convertion_unit !==
                                                    details.option
                                                      .convertion_unit),
                                            )
                                          const additional =
                                            selectedMaterials.filter(
                                              (item) =>
                                                item.isAdditionalProduct,
                                            )
                                          const finalList = [
                                            ...updated,
                                            ...additional,
                                          ]
                                          setSelectedMaterials(finalList)
                                          setPendingAutocompleteMaterials(
                                            updated,
                                          )
                                          setFieldValue(
                                            'additionalMaterials',
                                            finalList,
                                          )
                                          handleMaterial(finalList)
                                          return
                                        }

                                        // 🔹 Add new item
                                        const lastSelected =
                                          newValue[newValue.length - 1]
                                        if (!lastSelected) return

                                        const alreadySelected =
                                          selectedMaterials.some(
                                            (item) =>
                                              (item.product_id || item.id) ===
                                                (lastSelected.product_id ||
                                                  lastSelected.id) &&
                                              item.stock_type ===
                                                lastSelected.stock_type &&
                                              (item.stock_type === 1 ||
                                                item.convertion_unit ===
                                                  lastSelected.convertion_unit),
                                          )

                                        if (alreadySelected) {
                                          enqueueSnackbar(
                                            'Material Already Added',
                                            { variant: 'error' },
                                          )
                                          return
                                        }

                                        handleMaterialStockCheck(lastSelected) // Show dialog
                                      }}
                                      getOptionLabel={(option) => {
                                        const name =
                                          option.name ||
                                          option.product_name ||
                                          ''
                                        const description =
                                          option.description ||
                                          option.product_description ||
                                          ''
                                        const ownership =
                                          option.inhouse === 1
                                            ? ' (Inhouse)'
                                            : ' (Client owned)'
                                        const tags = option.tags || '';    
                                        return `${description}${ownership}${tags} \u200B${name}`
                                      }}
                                      isOptionEqualToValue={(option, value) =>
                                        option.product_id ===
                                          value.product_id &&
                                        option.stock_type ===
                                          value.stock_type &&
                                        option.convertion_unit ===
                                          value.convertion_unit
                                      }
                                      renderOption={(props, option) => {
                                        const { style, ...liProps } = props;
                                        const description =
                                          option.description ||
                                          option.product_description ||
                                          option.name ||
                                          option.product_name ||
                                          ''
                                        const ownership =
                                          option.inhouse === 1
                                            ? ' (Inhouse)'
                                            : ' (Client owned)'
                                        // const stockLabel = option.stock_type === 1
                                        //   ? 'Finished'
                                        //   : `Partial - ${UNITS.find(u => u.id === option.convertion_unit)?.name || 'Unit'}`;
                                        // const fullText = `${description} ${ownership} [${stockLabel}]`;
                                        const fullText = `${description} ${ownership}`
                                        return (
                                          <li
                                            {...liProps}
                                            style={{
                                              ...style,
                                              display: 'flex',
                                              alignItems: 'center',
                                            }}
                                          >
                                            <Tooltip title={fullText}>
                                              <span
                                                style={{
                                                  flex: 1,
                                                  minWidth: 0,
                                                  display: 'block',
                                                  whiteSpace: 'nowrap',
                                                  overflow: 'hidden',
                                                  textOverflow: 'ellipsis',
                                                }}
                                              >
                                                {fullText}
                                              </span>
                                            </Tooltip>
                                          </li>
                                        )
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Materials"
                                          error={Boolean(
                                            touched.additionalMaterials &&
                                              errors.additionalMaterials,
                                          )}
                                          helperText={
                                            touched.additionalMaterials &&
                                            errors.additionalMaterials
                                          }
                                        />
                                      )}
                                      renderTags={(value, getTagProps) =>
                                        value.map((option, index) => {
                                          const suffix =
                                            option.inhouse === 1
                                              ? '(Inhouse)'
                                              : '(Client owned)'
                                          const stockLabel =
                                            option.stock_type === 1
                                              ? 'Finished'
                                              : `Partial - ${
                                                  UNITS.find(
                                                    (u) =>
                                                      u.id ===
                                                      option.convertion_unit,
                                                  )?.name || 'Unit'
                                                }`
                                          const tooltipText = `${
                                            option.description ||
                                            option.name ||
                                            option.product_name ||
                                            ''
                                          } ${suffix} [${stockLabel}]`
                                          return (
                                            <Tooltip
                                              key={index}
                                              title={tooltipText}
                                            >
                                              <Chip
                                                {...getTagProps({ index })}
                                                label={`${
                                                  option.description ||
                                                  option.name ||
                                                  option.product_name ||
                                                  ''
                                                } ${suffix} [${stockLabel}]`}
                                              />
                                            </Tooltip>
                                          )
                                        })
                                      }
                                    />
                                  </Stack>
                                  <LabelStyle>Selected Materials</LabelStyle>
                                  <Scrollbar>
                                    <TableContainer sx={{ minWidth: 500 }}>
                                      <Table>
                                        <TableHead>
                                          <TableRow>
                                            {VALUE_MATERIAL?.map((val) =>
                                              val.id === 3 ? (
                                                <Tooltip
                                                  key={val.id}
                                                  title="Unit Price + ((Unit Price * Markup)/100)"
                                                >
                                                  <TableCell key={val.id}>
                                                    {val.value}
                                                  </TableCell>
                                                </Tooltip>
                                              ) : val.id === 5 ? (
                                                <Tooltip
                                                  key={val.id}
                                                  title="Unit Price * Quantity"
                                                >
                                                  <TableCell key={val.id}>
                                                    {val.value}
                                                  </TableCell>
                                                </Tooltip>
                                              ) : val.id === 6 ? (
                                                <Tooltip
                                                  key={val.id}
                                                  title="Markup Cost * Quantity"
                                                >
                                                  <TableCell key={val.id}>
                                                    {val.value}
                                                  </TableCell>
                                                </Tooltip>
                                              ) : (
                                                <TableCell key={val.id}>
                                                  {val.value}
                                                </TableCell>
                                              ),
                                            )}
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {selectedMaterials?.map(
                                            (data, index) => {
                                              console.log(
                                                'dataselectedMaterials',
                                                data,
                                              )
                                              let unitName = ''
                                              if (data?.stock_type === 1) {
                                                unitName = UNITS?.filter(
                                                  (item) =>
                                                    item?.id == data?.unit,
                                                )
                                              } else {
                                                unitName = UNITS?.filter(
                                                  (item) =>
                                                    item?.id ==
                                                    data?.convertion_unit,
                                                )
                                              }
                                              console.log(
                                                'unitName11111111111',
                                                unitName,
                                              )
                                              // unitName = unitName[0]?.name
                                              let shortUnitName =
                                                unitName[0]?.short_name

                                              data.price = data.price
                                                ? data.price
                                                : data.product_price
                                              data.product_id = data.product_id
                                                ? data.product_id
                                                : data.id
                                              // data.markup =  data.markup ? data.markup : data.product_markup
                                              data.markup =
                                                data?.product_markup ||
                                                data.markup
                                              const markUpCost =
                                                data.price +
                                                (parseFloat(data.price) *
                                                  parseFloat(
                                                    data.markup || 0,
                                                  )) /
                                                  100
                                              data['markUpCost'] =
                                                parseFloat(
                                                  parseFloat(
                                                    markUpCost,
                                                  ).toFixed(2),
                                                ) || 0
                                              return (
                                                <>

                                                  <TableRow
                                                    key={
                                                      data?.newIndexId || index
                                                    }
                                                  >
                                                    <TableCell>
                                                      {data?.isAdditionalProduct ? (
                                                        <TextField
                                                          disabled={isPreview ? true : false}
                                                          required
                                                          fullWidth
                                                          type="text"
                                                          label={
                                                            'Material Name'
                                                          }
                                                          sx={{ width: 85 }}
                                                          value={
                                                            data.name ||
                                                            data.product_name
                                                          }
                                                          onChange={(event) => {
                                                            let newValue =
                                                              event.target.value

                                                            // Update the selectedProducts state
                                                            setSelectedMaterials(
                                                              (prevProducts) =>
                                                                prevProducts.map(
                                                                  (service) => {
                                                                    if (
                                                                      service.newIndexId ===
                                                                      data.newIndexId
                                                                    ) {
                                                                      return {
                                                                        ...service,
                                                                        name: newValue,
                                                                        product_name:
                                                                          newValue,
                                                                      }
                                                                    } else {
                                                                      return service
                                                                    }
                                                                  },
                                                                ),
                                                            )
                                                            data['name'] =
                                                              newValue || ''
                                                            data[
                                                              'product_name'
                                                            ] = newValue || ''
                                                            if (isSubmitted)
                                                              setIsSubmitted(
                                                                false,
                                                              )
                                                          }}
                                                          error={
                                                            isSubmitted &&
                                                            !data.name?.trim() &&
                                                            !data.product_name?.trim()
                                                          }
                                                          helperText={
                                                            isSubmitted &&
                                                            !data.name?.trim() &&
                                                            !data.product_name?.trim()
                                                              ? 'Material Name is required'
                                                              : ''
                                                          }
                                                        />
                                                         ) : 
                                                        //  data.name
                                                      <Box>
                                                        <Typography sx={{color:'inherit'}}>{ data.name || data.product_name}</Typography>
                                                          {data.material_notes  ? <Typography sx={{ color: data.material_notes ? theme.palette.error.main : 'inherit' }}>Note:{" "}{data.material_notes  }</Typography>:""}
                                                        </Box>}
                                                        </TableCell>
                                                        <TableCell>
                                                          <IconButton onClick={() => handleOpenMaterialNote(data.newIndexId, data.material_notes)}>
                                                            <NoteAdd
                                                              sx={{
                                                                color: (!data?.material_notes || data?.material_notes === '') ? '' : theme.palette.primary.main,
                                                              }}
                                                            />
                                                          </IconButton>
                                                        </TableCell>
                                                    <TableCell>
                                                      {data.stock_type === 1
                                                        ? 'Finished'
                                                        : 'Partial'}
                                                    </TableCell>
                                                    <TableCell>
                                                      {data?.isAdditionalProduct ? (
                                                        <TextField
                                                          required
                                                          fullWidth
                                                          type="number"
                                                          label={'Unit Price'}
                                                          disabled={
                                                            isPreview ? true : 
                                                            values
                                                              .project_category
                                                              ?.name ==
                                                            'Time & Material'
                                                              ? true
                                                              : false
                                                          }
                                                          sx={{ width: 85 }}
                                                          value={roundMoneyValue(data.price)}
                                                          // onWheel={(e) => e.target.blur()}
                                                          onKeyPress={(
                                                            event,
                                                          ) => {
                                                            // if (event.key === '0' && event.target.value === '') {
                                                            //   event.preventDefault();
                                                            // }
                                                            if (
                                                              event.key === '-'
                                                            ) {
                                                              event.preventDefault()
                                                            }
                                                            if (
                                                              event.key === 'e'
                                                            ) {
                                                              event.preventDefault()
                                                            }
                                                          }}
                                                          inputProps={{
                                                            min: 0,
                                                          }}
                                                          defaultValue={0}
                                                          onFocus={selectInputValue}
                                                          onClick={selectInputValue}
                                                          onChange={(event) => {
                                                            let newValue =
                                                              event.target.value
                                                            if (
                                                              newValue !== ''
                                                            ) {
                                                              setAdditionalSelectedServices(
                                                                (pv) => [
                                                                  ...pv.map(
                                                                    (p) => {
                                                                      if (
                                                                        p.newIndexId ===
                                                                        data.newIndexId
                                                                      ) {
                                                                        return {
                                                                          ...p,
                                                                          price:
                                                                            Number(
                                                                              newValue,
                                                                            ),
                                                                        }
                                                                      } else {
                                                                        return p
                                                                      }
                                                                    },
                                                                  ),
                                                                ],
                                                              )
                                                              data['price'] =
                                                                Number(
                                                                  newValue || 0,
                                                                )
                                                            }
                                                          }}
                                                          // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                                          // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                                        />
                                                      ) : (
                                                        roundMoneyValue(data.price).toFixed(2)
                                                      )}
                                                    </TableCell>
                                                    <TableCell>
                                                      <TextField
                                                        required
                                                        fullWidth
                                                        type="number"
                                                        label="Markup"
                                                        disabled={isPreview ? true : false}
                                                        value={
                                                          Number(data.markup) ||
                                                          0
                                                        }
                                                        inputProps={{ min: 0 }}
                                                        onFocus={selectInputValue}
                                                        onClick={selectInputValue}
                                                        onKeyPress={(event) => {
                                                          if (
                                                            event.key === '-' ||
                                                            event.key === 'e'
                                                          ) {
                                                            event.preventDefault()
                                                          }
                                                        }}
                                                        onChange={(event) => {
                                                          let newValue =
                                                            event.target.value

                                                          // Prevent negative values and invalid inputs
                                                          if (
                                                            newValue.startsWith(
                                                              '-',
                                                            ) ||
                                                            /^0[0-9]+$/.test(
                                                              newValue,
                                                            )
                                                          ) {
                                                            newValue = '0'
                                                          }

                                                          setSelectedMaterials(
                                                            (prevMaterials) =>
                                                              prevMaterials.map(
                                                                (p) => {
                                                                  const isMatchingProduct =
                                                                    data.isAdditionalProduct
                                                                      ? p.newIndexId ===
                                                                        data.newIndexId
                                                                      : (p.product_id ||
                                                                          p.id) ===
                                                                          (data.product_id ||
                                                                            data.id) &&
                                                                        p.stock_type ===
                                                                          data.stock_type &&
                                                                        (p.stock_type ===
                                                                          1 ||
                                                                          p.convertion_unit ===
                                                                            data.convertion_unit) &&
                                                                        (p.newIndexId ===
                                                                          data.newIndexId ||
                                                                          (!data.isAdditionalProduct &&
                                                                            p.id ===
                                                                              data.id))

                                                                  return isMatchingProduct
                                                                    ? {
                                                                        ...p,
                                                                        markup:
                                                                          newValue ===
                                                                          ''
                                                                            ? 0
                                                                            : Number(
                                                                                newValue,
                                                                              ),
                                                                      }
                                                                    : p
                                                                },
                                                              ),
                                                          )
                                                        }}
                                                        onWheel={(e) =>
                                                          e.target.blur()
                                                        }
                                                      />
                                                    </TableCell>

                                                    <TableCell>
                                                      {data.markUpCost || 0}
                                                    </TableCell>
                                                    <TableCell>
                                                      <TextField
                                                        required
                                                        fullWidth
                                                        type="number"
                                                        disabled={isPreview ? true : false}
                                                        label={
                                                          shortUnitName ||
                                                          'Quantity'
                                                        }
                                                        value={
                                                          Number(
                                                            data.quantity,
                                                          ) || 0
                                                        }
                                                        defaultValue={1}
                                                        onFocus={selectInputValue}
                                                        onClick={selectInputValue}
                                                        onKeyPress={(event) => {
                                                          if (
                                                            event.target
                                                              .value === ''
                                                          ) {
                                                            event.preventDefault()
                                                          }
                                                          if (
                                                            event.key === '-' ||
                                                            event.key === 'e'
                                                          ) {
                                                            event.preventDefault()
                                                          }
                                                        }}
                                                        onChange={(event) => {
                                                          const newValue =
                                                            Number(
                                                              event.target
                                                                .value,
                                                            ) || 0

                                                          setSelectedMaterials(
                                                            (prevMaterials) =>
                                                              prevMaterials.map(
                                                                (p) => {
                                                                  const isMatchingProduct =
                                                                    data.isAdditionalProduct
                                                                      ? p.newIndexId ===
                                                                        data.newIndexId
                                                                      : (p.product_id ||
                                                                          p.id) ===
                                                                          (data.product_id ||
                                                                            data.id) &&
                                                                        p.stock_type ===
                                                                          data.stock_type &&
                                                                        (p.stock_type ===
                                                                          1 ||
                                                                          p.convertion_unit ===
                                                                            data.convertion_unit) &&
                                                                        (p.newIndexId ===
                                                                          data.newIndexId ||
                                                                          (!data.isAdditionalProduct &&
                                                                            p.id ===
                                                                              data.id))

                                                                  if (
                                                                    isMatchingProduct
                                                                  ) {
                                                                    return {
                                                                      ...p,
                                                                      quantity:
                                                                        newValue,
                                                                    }
                                                                  }
                                                                  return p
                                                                },
                                                              ),
                                                          )
                                                        }}
                                                        onWheel={(e) =>
                                                          e.target.blur()
                                                        }
                                                        onKeyDown={(event) => {
                                                          if (
                                                            event.key ===
                                                              'ArrowDown' &&
                                                            Number(
                                                              event.target
                                                                .value,
                                                            ) <= 1
                                                          ) {
                                                            event.preventDefault()
                                                          }
                                                        }}
                                                      />
                                                    </TableCell>

                                                    <TableCell>
                                                      {(
                                                        data.price *
                                                        (data.quantity || 0)
                                                      )?.toFixed(2)}
                                                    </TableCell>
                                                    <TableCell>
                                                      {(
                                                        (data.markUpCost || 0) *
                                                        (data.quantity || 0)
                                                      )?.toFixed(2)}
                                                    </TableCell>
                                                    <TableCell>
                                                      {isPreview ? '' : 
                                                      <IconButton
                                                        onClick={() =>
                                                          handleDeleteMaterial(
                                                            data.id,
                                                            data.newIndexId,
                                                          )
                                                        }
                                                      >
                                                        <Delete />
                                                      </IconButton>}
                                                    </TableCell>
                                                  </TableRow>
                                                  <Modal
                                                    open={openMaterialNote[data.newIndexId] || false}
                                                    handleClose={() =>
                                                      handleCloseMaterialNote(data.newIndexId)
                                                    }
                                                  >
                                                    <Grid
                                                      container
                                                      spacing={3}
                                                      sx={{
                                                        justifyContent: 'center',
                                                        width: '100%',
                                                      }}
                                                    >
                                                      <Grid item xs={12}>
                                                        <Typography
                                                          variant="h5"
                                                          sx={{ mb: 2 }}
                                                        >
                                                          Note
                                                        </Typography>
                                                        <Stack
                                                          direction={{
                                                            xs: 'column',
                                                            sm: 'row',
                                                          }}
                                                          spacing={{
                                                            xs: 3,
                                                            sm: 2,
                                                          }}
                                                          sx={{ mb: 2 }}
                                                        >
                                                          <TextField
                                                            fullWidth
                                                            multiline
                                                            rows={4}
                                                            size="medium"
                                                            value={currentNote}
                                                            onChange={handleNoteChange}
                                                            {...getEstimatePreviewNoteFieldProps(isPreview)}
                                                            sx={{
                                                              '& .MuiInputBase-input': {
                                                                color: 'red',
                                                              },
                                                            }}
                                                            error={
                                                              !isPreview &&
                                                              !currentNote.trim() &&
                                                              currentNote.length > 0
                                                            }
                                                            inputProps={{
                                                              maxLength: MAX_CHARACTERS,
                                                            }}
                                                            helperText={
                                                              isPreview
                                                                ? undefined
                                                                : !currentNote.trim() &&
                                                                  currentNote.length > 0
                                                                  ? 'Note cannot be empty or contain only spaces'
                                                                  : `${currentNote.length}/${MAX_CHARACTERS} characters`
                                                            }
                                                          />
                                                        </Stack>
                                                      </Grid>
                                                    </Grid>
                                                    <EstimatePreviewNoteActions
                                                      isPreview={isPreview}
                                                      onClose={() =>
                                                        handleCloseMaterialNote(data.newIndexId)
                                                      }
                                                    >
                                                    <Grid
                                                      container
                                                      justifyContent="center"
                                                      alignItems="center"
                                                    >
                                                      <Grid item xs={12} md={4}>
                                                        <Box
                                                          sx={{
                                                            mt: 3,
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            gap: 1,
                                                          }}
                                                        >
                                                          <LoadingButton
                                                            variant="contained"
                                                            onClick={() =>
                                                              handleSaveMaterialNote(
                                                                data.newIndexId,
                                                              )
                                                            }
                                                            loading={isSavingNote}
                                                            disabled={!currentNote.trim()}
                                                          >
                                                            Save
                                                          </LoadingButton>
                                                          <LoadingButton
                                                            variant="outlined"
                                                            color="error"
                                                            onClick={() =>
                                                              handleClearMaterialNote(
                                                                data.newIndexId,
                                                              )
                                                            }
                                                            loading={isClearingNote}
                                                            disabled={!currentNote.trim()}
                                                          >
                                                            Clear
                                                          </LoadingButton>
                                                        </Box>
                                                      </Grid>
                                                    </Grid>
                                                    </EstimatePreviewNoteActions>
                                                  </Modal>
                                                </>
                                              )
                                            },
                                          )}
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </Scrollbar>
                                  <Stack
                                    sx={{
                                      justifyContent: 'flex-end',
                                      alignItems: 'center',
                                      display: 'flex',
                                      flexDirection: 'row',
                                    }}
                                  >
                                    {/* <Button
                              variant="outlined"
                              startIcon={
                                <Stack>
                                  {' '}
                                  <Add />{' '}
                                </Stack>
                              }
                              onClick={() => {
                                addNewMaterialRow()
                                // setMarkupType(1)
                              }}
                            >
                              Add Material Row
                            </Button> */}
                                    <Typography variant="h6">
                                      Total Additional Material Cost:{' '}
                                      {selectedMaterialSubTotal}
                                    </Typography>
                                  </Stack>
                                </>
                              {/* )} */}
                              <Divider />
                              <TextField
                                fullWidth
                                disabled={isPreview ? true : false}
                                multiline
                                minRows={3}
                                maxRows={7}
                                label="Notes"
                                {...getFieldProps('notes')}
                                error={Boolean(touched.notes && errors.notes)}
                                helperText={touched.notes && errors.notes}
                                InputProps={{
                                  sx: {
                                    color: 'error.main',
                                  },
                                }}
                              />
                            </>
                          )}
                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                            justifyContent={'space-between'}
                          >
                            <TextField
                              fullWidth
                              // sx={{ width: 400 }}
                              type="number"
                              onKeyPress={(event) => {
                                if (event.key === '-') {
                                  event.preventDefault()
                                }
                              }}
                              onChange={(event) => {
                                let newValue = event.target.value
                                let data = 0
                                if (markupType === 1) {
                                  data = totalWholesalePrice - budget
                                } else if (markupType === 2) {
                                  data = totalRetailPrice - budget
                                }
                                console.log('extradiscount---data', data)
                                console.log(
                                  'extradiscount---totalWholesalePrice',
                                  totalWholesalePrice,
                                )
                                console.log(
                                  'extradiscount---totalRetailPrice',
                                  totalRetailPrice,
                                )
                                console.log('extradiscount---budget', budget)
                                if (Number(newValue) > data) {
                                  newValue = data?.toFixed(2)
                                }
                                if (newValue === '-0.00') {
                                  newValue = 0
                                }
                                console.log('newValue-2-------', newValue)
                                setFieldValue('invoice_discount', newValue)
                              }}
                              label={
                                hasDiscountPermission
                                  ? 'Discount (Access Denied)'
                                  : 'Discount'
                              }
                              disabled={isPreview ? true : hasDiscountPermission}
                              value={values.invoice_discount}
                              // {...getFieldProps('invoice_discount')}
                              error={Boolean(
                                touched.invoice_discount &&
                                  errors.invoice_discount,
                              )}
                              helperText={
                                touched.invoice_discount &&
                                errors.invoice_discount
                              }
                              inputProps={{
                                max:
                                  markupType === 1
                                    ? totalWholesalePrice - budget
                                    : markupType === 2
                                    ? totalRetailPrice - budget
                                    : 0,
                                min: 0,
                              }}
                            />
                            {/* <Autocomplete
                          // sx={{ width: 400 }}
                          fullWidth
                          id="combo-box-demo"
                          disabled={true}
                          options={taxCategories || []}
                          value={selectedTaxCategory || null}
                          onChange={(event, newValue) => {
                            setSelectedTaxCategory(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Tax category" />
                          )}
                          getOptionLabel={(option) => option.name ? option.name : ''}
                        /> */}
                          </Stack>
                          <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={'flex-start'} spacing={{ xs: 2, sm: 2 }} sx={{ mb: 2 }}>
                            <TextField
                              fullWidth
                              multiline
                              minRows={3}
                              maxRows={7}
                              label="Bill To"
                              placeholder="Enter billing address"
                              name="bill_to"
                              value={billToInputValue || ''}
                              onChange={(event) => {
                                const nextValue = event.target.value
                                setIsBillToDirty(true)
                                setBillToInputValue(nextValue)
                                setFieldValue('bill_to', nextValue, false)
                              }}
                              onBlur={(event) => setFieldValue('bill_to', event.target.value, false)}
                            />
                            <TextField
                              fullWidth
                              multiline
                              minRows={3}
                              maxRows={7}
                              label="Ship To"
                              placeholder="Enter shipping address"
                              name="ship_to"
                              value={shipToInputValue || ''}
                              onChange={(event) => {
                                const nextValue = event.target.value
                                setIsShipToDirty(true)
                                setShipToInputValue(nextValue)
                                setFieldValue('ship_to', nextValue, false)
                              }}
                              onBlur={(event) => setFieldValue('ship_to', event.target.value, false)}
                            />
                          </Stack>
                          <Typography sx={{ color: theme.palette.error.main }}>
                            **All values in the software are rounded to two
                            decimal places in accordance with standard US
                            calculation practices.
                          </Typography>
                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            alignItems={'center'}
                            spacing={{ xs: 3, sm: 2 }}
                          >
                            <Stack>
                              {/* <TextField
                            sx={{ width: 400 }}
                            type='number'
                            onChange={(event, newValue) => setFieldValue('invoice_discount', newValue)}
                            label="Extra Discount"
                            {...getFieldProps('invoice_discount')}
                            error={Boolean(touched.invoice_discount && errors.invoice_discount)}
                            helperText={touched.invoice_discount && errors.invoice_discount}
                          /> */}

                              {/* <Typography sx={{ color: 'text.secondary' }}>Sub Total: {rfqSubTotal ? rfqSubTotal?.toFixed(2) : 0}</Typography>
                          <Typography sx={{ color: 'text.secondary' }}>Service cost in Product Formula: {initialServiceCostInProductFormula ? initialServiceCostInProductFormula?.toFixed(2) : 0}</Typography>
                          <Typography sx={{ color: 'text.secondary' }}>Total ({rfqSubTotal?.toFixed(2)} - {initialServiceCostInProductFormula?.toFixed(2)}): {totalsum ? totalsum?.toFixed(2) : 0}</Typography> */}
                              <Typography>
                                Sub Total:{' '}
                                {totalsum ? fUSPrice(totalsum) : fUSPrice(0)}
                              </Typography>
                              {isRushFeeChecked && (
                                <Typography>
                                  Rush Fee: {fUSPrice(rushFeeAmount)}
                                </Typography>
                              )}
                              {/* <Typography >
                              Tax: {parseFloat(taxAmount).toFixed(2) || 0.00}
                            </Typography> */}
                              <Box display="flex" alignItems="center" gap={1}>
                                <Typography>
                                  Tax:{' '}
                                  {parseFloat(taxAmount).toFixed(2) || '0.00'}
                                </Typography>
                                {/* {details?.avalara_code ? ( */}
                                  <>
                                    <img
                                      src={AVALARALOGO}
                                      width="20px"
                                      height="12px"
                                      style={{ marginTop: '2px' }} // Adjust for alignment if needed
                                      alt="Avalara logo"
                                    />
                                    <Typography
                                      sx={{
                                        marginTop: '8px',
                                        color: '#fd6400',
                                        fontSize: '12px',
                                      }}
                                    >
                                      Synced with Avalara
                                    </Typography>
                                  </>
                                {/* ) : (
                                  ''
                                )} */}
                              </Box>

                              <Typography sx={{ color: theme.palette.mode === 'light' ? '#FFAF00' : 'yellow' }}>
                                Grand Total: {fUSPrice(grandTotal  || 0)}
                              </Typography>
                              {/* <Typography sx={{ color: 'yellow' }}>Grand Total : {totalsum ? totalsum?.toFixed(2) : 0}</Typography>  */}
                              {/* <Typography sx={{ color: 'yellow' }}>Total Product Formula Cost: {budget ? budget?.toFixed(2) : 0}</Typography>  */}
                              <Typography>
                                Total Discount:{' '}
                                {DiscountTotal
                                  ? DiscountTotal?.toFixed(2)
                                  : 0.0}
                              </Typography>

                              {/* <Tooltip title="Sub Total - Total Product Formula Cost">
                            <Typography sx={{ cursor:'pointer' }}>Total Markup Amount: {totalMarkupAmount ? totalMarkupAmount?.toFixed(2) : 0}</Typography>
                          </Tooltip> */}

                              {/* <Tooltip title="(Total Markup Amount / Total Product Formula Cost) * 100">
                            <Typography sx={{cursor:'pointer' }}>Total Markup Percentage: {totalMarkupPercentage ? totalMarkupPercentage?.toFixed(2) : 0}</Typography>
                          </Tooltip> */}

                              {/* <Typography sx={{ color: 'text.secondary' }}>Total Product Markup: {(originaltotalMarkup/selectedProducts.length)?.toFixed(2)}</Typography> */}
                              {/* { showServices ?<Typography sx={{ color: 'text.secondary' }}>Total Service Markup: {(originaltotalServiceMarkup/(selectedServices.length+additionalSelectedServices.length))?.toFixed(2)}</Typography>:""} */}
                            </Stack>
                            <Stack
                              direction={'column'}
                              display={'flex'}
                              justifyContent={'center'}
                            >
                              <FormControlLabel
                                disabled={isPreview ? true : false}
                                onChange={() => {
                                  // Toggle the value of welcome_message using setCurrentRFQdata
                                  setCurrentRFQdata((prevData) => ({
                                    ...prevData,
                                    welcome_message: !prevData.welcome_message,
                                  }))
                                }}
                                control={
                                  <Switch
                                    {...getFieldProps('welcome_message')}
                                    color="primary"
                                    checked={values.welcome_message == 1}
                                  />
                                }
                                labelPlacement="end"
                                label="Use Custom Welcome Message"
                                sx={{ mt: 6, mb: 2 }}
                              />
                          <FormControlLabel
                          control={
                            <Switch
                            {...getFieldProps('show_install_price')}
                              color="primary"
                              checked={values.show_install_price == 0 ? false : true}
                              onChange={(event) => setFieldValue('show_install_price', event.target.checked ? 1 : 0)}
                            />
                          }
                          labelPlacement="end"
                          label="Show Install Price"
                          sx={{ mt: 2 }}
                        />
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={isRushFeeChecked}
                              disabled={rushFeeSwitchDisabled}
                              onChange={(event) => {
                                if (rushFeeSwitchDisabled) return;
                                if (isRushFeeAutoLockedForEffect && !canOverrideRushFeeLock) return;
                                const turningOff = !event.target.checked;
                                markRushFeeUserToggled(rushFeeSyncRefs.current, {
                                  turnedOn: event.target.checked,
                                  declinedWhileLocked: turningOff && isRushFeeAutoLockedForEffect && canOverrideRushFeeLock,
                                });
                                setFieldValue('rush_fee', event.target.checked ? 1 : 0);
                              }}
                            />
                          }
                          labelPlacement="end"
                          // label={`Rush Fee (${rushFeePercentage}%)`}
                          label={
                            rushFeeAccessDenied
                              ? 'Rush Fee (Access Denied)'
                              : 'Rush Fee'
                          }
                          sx={{ mt: 2 }}
                        />
                              {(details?.is_request_estimate == 1 &&
                                details?.estimate_job_status == 1) ? (
                                ''
                              ) : (
                                <FormControlLabel
                                  control={
                                    <Switch
                                      {...getFieldProps('client_approve')}
                                      color="primary"
                                      checked={values.client_approve}
                                      onChange={(event) =>
                                        setFieldValue(
                                          'client_approve',
                                          event.target.checked,
                                        )
                                      }
                                    />
                                  }
                                  labelPlacement="end"
                                  label="Enable for Client Approval"
                                  sx={{ mt: 0 }}
                                />
                              )}
                              {(details?.is_request_estimate == 1 &&
                                details?.estimate_job_status == 1) ? (
                                ''
                              ) : (
                                <>
                                {/* Auto-lock: prevented turning OFF when total > limit or negative marketing adjustment
                                onChange={(event) => {
                                  const managerApprovalLimit = Number(data?.manager_approval_amount) || 5000;
                                  const currentTotal = parseFloat(grandTotal);
                                  if ((currentTotal > managerApprovalLimit || hasNegativeMarketingAdjustment) && !event.target.checked) {
                                    return;
                                  }
                                  setFieldValue(
                                    'manager_approval_required',
                                    event.target.checked,
                                  );
                                }}
                                sx={{
                                  ...(values.manager_approval_required === true &&
                                    (parseFloat(grandTotal) > (Number(data?.manager_approval_amount) || 5000) || hasNegativeMarketingAdjustment)
                                    ? { pointerEvents: 'none' }
                                    : {}),
                                }}
                                */}
                                <FormControlLabel
                                  control={
                                    <Switch
                                      {...getFieldProps('manager_approval_required')}
                                      color="primary"
                                      checked={values.manager_approval_required}
                                      onChange={(event) =>
                                        setFieldValue(
                                          'manager_approval_required',
                                          event.target.checked,
                                        )
                                      }
                                    />
                                  }
                                  labelPlacement="end"
                                  label="Enable for Manager approval"
                                  sx={{ mt: 0 }}
                                />
                                </>
                              )}
                            </Stack>
                          </Stack>
                          {values.welcome_message == true && (
                            <>
                              <Stack>
                                <LabelStyle>Subject</LabelStyle>
                                <TextField
                                  //   fullWidth
                                  disabled={isPreview ? true : false}
                                  type="text"
                                  sx={{ width: 400 }}
                                  defaultValue={values.subject}
                                  {...getFieldProps('subject')}
                                  error={Boolean(
                                    touched.subject && errors.subject,
                                  )}
                                  helperText={touched.subject && errors.subject}
                                />
                              </Stack>
                              <LabelStyle>Email Content</LabelStyle>
                              <TextField
                                disabled={isPreview ? true : false}
                                fullWidth
                                multiline
                                minRows={3}
                                maxRows={7}
                                label="Email Content"
                                defaultValue={values.email_content}
                                {...getFieldProps('email_content')}
                                error={Boolean(
                                  touched.email_content && errors.email_content,
                                )}
                                helperText={
                                  touched.email_content && errors.email_content
                                }
                              />
                            </>
                          )}
                          {/* <LabelStyle>Request state</LabelStyle>
                      <Typography>While in draft mode, clients you add to request tasks won't be notified</Typography>
                      <FormControlLabel
                       onChange={() => {                     
                       
                        setCurrentRFQdata((prevData) => ({
                          ...prevData,
                          draft: !prevData.draft,
                        }));
                      }}
                        control={<Switch {...getFieldProps('draft')} color="primary" checked={values.draft} />}
                        labelPlacement="end"
                        label="Draft"
                        sx={{ mt: 5 }}
                      /> */}
                        </>
                      ) : (
                        ''
                      )}
                      <Box
                        sx={{
                          mt: 3,
                          display: 'flex',
                          justifyContent: 'flex-end',
                          gap: 1,
                        }}
                      >
                        {isPreview ? '' : 
                        <>
                        <LoadingButton
                          type="submit"
                          color='success'
                          variant="contained"
                          loading={isSubmitting}
                          disabled={loadingServices || loadingProducts ||!!autoSavingField}
                        >
                          {details?.is_create_estimate == 1 ? 'Update Estimate' : 'Create Estimate'}
                        </LoadingButton>
                        <Button
                          variant="outlined"
                          onClick={handleSaveDraft}
                          disabled={loadingServices || loadingProducts || !!autoSavingField}
                        >
                          Save As Draft
                        </Button>
                        </>}
                        {/* <Button variant="outlined"  onClick={() =>{
                          setOpenPreview(!openPreview),
                          setValuesToPreview() }}>
                          Preview
                        </Button> */}
                        <Button
                          variant="outlined"
                          color='error'
                          data-preview-allow
                          onClick={() => handleCancel(true)}
                          disabled={!!autoSavingField}
                        >
                          Cancel
                        </Button>
                      </Box>
                    </Stack>
                    </Box>
                  </Grid>
                </Grid>
                <DialogAnimate open={openPDFModal} onClose={() => setOpenPDFModal(false)}>
                  <Card
                    sx={{
                      p: 3,
                      maxWidth: 768,
                      margin: 'auto',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ width: '90%', display: 'flex', justifyContent: 'flex-end', marginBottom: '15px', marginLeft: '25px' }}>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                          if (isClient || userType === 3) {
                            const newWindow = window.open('', '_blank')
                            newWindow.document.write(`
                              <html>
                                <head>
                                  <title>PDF Viewer</title>
                                  <style>
                                    body { margin: 0; padding: 0; overflow: hidden; }
                                    iframe { width: 100vw; height: 100vh; border: none; }
                                  </style>
                                </head>
                                <body>
                                  <iframe src="${selectedPDF}#toolbar=0&navpanes=0&scrollbar=0" title="PDF Viewer"></iframe>
                                </body>
                              </html>
                            `)
                            newWindow.document.close()
                          } else {
                            window.open(selectedPDF, '_blank')
                          }
                        }}
                        disabled={!selectedPDF}
                        startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                        sx={{
                          fontSize: '14px',
                        }}
                      >
                        View PDF
                      </Button>
                    </div>
                    {pdfLoading && (
                      <Skeleton variant="rectangular" width="100%" height={500} />
                    )}
                    {(isClient || userType === 3) && useOfficeViewer ? (
                      <iframe
                        src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true&toolbar=0&navpanes=0&scrollbar=0`}
                        title="Selected PDF"
                        width="100%"
                        height="500px"
                        frameBorder="0"
                        sandbox="allow-scripts allow-same-origin"
                        style={{ display: pdfLoading ? 'none' : 'block' }}
                        onLoad={() => setPdfLoading(false)}
                        onError={() => {
                          setUseOfficeViewer(false)
                          setPdfLoading(false)
                        }}
                      />
                    ) : (
                      <iframe
                        src={selectedPDF}
                        title="Selected PDF"
                        width="100%"
                        height="500px"
                        frameBorder="0"
                        style={{ display: pdfLoading ? 'none' : 'block' }}
                        onLoad={() => setPdfLoading(false)}
                      />
                    )}
                  </Card>
                </DialogAnimate>
              </Form>
            </FormikProvider>
          )}

          {/* adding client modal  */}
          <AddClients
            request_id={id}
            setIsOpen={setIsOpen}
            setAllClients={setAllClients}
            allClients={allClients?.filter((a) => !a.isVendor)}
            addClient={addClient}
            setAddClient={setAddClient}
          />
          <AddClients
            isVendor
            request_id={id}
            setIsOpen={setIsOpen}
            setAllClients={setAllClients}
            allClients={allClients?.filter((a) => a.isVendor)}
            addClient={addVendor}
            setAddClient={setAddVendor}
          />
          <AddProposal
            request_id={id}
            setIsOpen={setIsOpen}
            setReloadData={() => setRefresh(!refresh)}
            addProposal={addProposal}
            setAddProposal={setAddProposal}
          />
          <SendDesignsEmailModal
            open={openInvoiceEmailModal}
            onClose={() => setOpenInvoiceEmailModal(false)}
            selectedDesigns={invoicePdfData || []}
            designOrderId={details?.id}
            quotationId={id}
            userId={user?.user_id}
            userType={user?.user_type}
            onSuccess={handleInvoiceEmailSent}
            pageType="quotation"
          />

          {/* delete popup */}
          <ConfirmationPopup
            open={openDelete}
            loading={isLoading}
            handleClick={handleDeleteRFQ}
            handleClose={() => {
              setOpenDelete(!openDelete), setIsOpen(false)
            }}
            message={'You want to delete this Estimate '}
          />

          {/* Accept request invoice */}
          <ConfirmationPopup
            open={confirmInvoice}
            handleClick={() => handleAcceptorRejectInvoice(1)}
            handleClose={() => setConfirmInvoice(false)}
            message={'You want to Approve this Estimate '}
          />

          <ConfirmationPopup
            open={reOpen}
            handleClick={() => handleReopeningRequest()}
            handleClose={() => setReopen(false)}
            message={'You want to reopen this Estimate '}
          />
          <ConfirmationPopup
            open={convertRfq}
            loading={isLoading} // ✅ only passed here
            handleClick={async () => {
              setIsLoading(true)
              await convertToRFQ()
              setIsLoading(false)
            }}
            handleClose={() => setConvertRfq(false)}
            message={
              'This Estimate will be converted and moved to Sales Order page '
            }
          />

          <Dialog
            open={releaseApprovalDialog.open}
            onClose={() => {
              setReleaseApprovalDialog({ open: false, catalogs: [] })
              if (typeof releaseApprovalConfirmRef.current === 'function') {
                releaseApprovalConfirmRef.current(false)
              }
            }}
            aria-labelledby="release-approval-dialog-title"
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle id="release-approval-dialog-title">
              Manager approval no longer required
            </DialogTitle>
            <DialogContent>
              <DialogContentText sx={{ mb: 1.5 }}>
                The following estimate catalogs will not require manager approval anymore:
              </DialogContentText>
              <List dense>
                {(releaseApprovalDialog.catalogs || []).map((catalog) => (
                  <ListItem key={catalog.id} sx={{ py: 0.25 }}>
                    <ListItemText primary={catalog.name} />
                  </ListItem>
                ))}
              </List>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setReleaseApprovalDialog({ open: false, catalogs: [] })
                  if (typeof releaseApprovalConfirmRef.current === 'function') {
                    releaseApprovalConfirmRef.current(false)
                  }
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  setReleaseApprovalDialog({ open: false, catalogs: [] })
                  if (typeof releaseApprovalConfirmRef.current === 'function') {
                    releaseApprovalConfirmRef.current(true)
                  }
                }}
              >
                Continue Save
              </Button>
            </DialogActions>
          </Dialog>

          {/* reject request invoice */}
          {invoiceReject == true && (
            <Dialog
              open={invoiceReject}
              onClose={() => {
                setRejectInvoice(false)
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              BackdropComponent={Backdrop}
              BackdropProps={{ invisible: true }}
            >
              <DialogTitle id="alert-dialog-title">
                {'Are you sure ?'}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  You want to reject this Estimate
                </DialogContentText>
                <TextField
                  sx={{ width: 400 }}
                  label="Reason For Rejection"
                  type="text"
                  multiline
                  minRows={3}
                  maxRows={7}
                  onInput={(event) => setReason(event.target.value)}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => handleAcceptorRejectInvoice(2)}
                  sx={{ color: theme.palette.background.paper }}
                >
                  OK
                </Button>

                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    setRejectInvoice(false), setReason('')
                  }}
                  sx={{ color: theme.palette.error.main }}
                >
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          )}
          {/* reject request invoice */}
          <Dialog open={openDialog}>
            <DialogTitle>Select Stock Type</DialogTitle>
            <DialogContent>
              <RadioGroup
                value={String(stockType)}
                onChange={(e) => {
                  const val = e.target.value
                  setStockType(val === '1' ? 1 : 2)
                  if (val === '1') setConvertionUnit(0)
                }}
              >
                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="Finished Product"
                />
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="Partial Finished Product"
                />
              </RadioGroup>

              {stockType === 2 &&
                (partialProducts.length > 0 ? (
                  <>
                    <Typography>Select Conversion Unit</Typography>
                    <RadioGroup
                      value={convertionUnit}
                      onChange={(e) =>
                        setConvertionUnit(Number(e.target.value))
                      }
                    >
                      {UNITS.filter((u) =>
                        partialProducts.some((p) => p.partial_unit === u.id),
                      ).map((u) => (
                        <FormControlLabel
                          key={u.id}
                          value={u.id}
                          control={<Radio />}
                          label={u.name}
                        />
                      ))}
                    </RadioGroup>
                  </>
                ) : (
                  <Typography color="error">No partial stock found</Typography>
                ))}
            </DialogContent>
            <DialogActions>
              <Button onClick={closeDialog} color="error">
                Cancel
              </Button>
              <Button
                onClick={handleSubmitPopUp}
                disabled={stockType === 2 && partialProducts.length === 0}
                variant="contained"
              >
                Add Material
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      )}
      {/* Progress Modal */}
      {/* <RequestProgressModal
        open={showProgressModal}
        onClose={() => setShowProgressModal(false)}
        requestData={progressRequestData}
        onSocketReady={setSocketReady}
        heading={
          progressRequestData?.processType === 'update_estimate'
            ? saveAsDraft == 1 ? `Saving As Draft` : details?.is_create_estimate == 1 ? `Updating Estimate` : `Creating Estimate`
            : progressRequestData?.processType === 'estimate_job'
            ? `Estimate Job`
            : `Converting Estimate to Sales Order`
        }
      /> */}
      <ViewProductFormulaModal
        open={openProductFormulaModal}
        onClose={() => setOpenProductFormulaModal(false)}
        formulaId={selectedProductFormulaId}
        user={user}
        explodedPermissions={explodedPermissions}
        {...getEstimatePreviewFormulaModalProps(isPreview)}
          onRecipeUpdated={(updatedRecipe) => {
                    fetchProducts();
                    
                    if (updatedRecipe && selectedProducts) {
                      setSelectedProducts(prevProducts => 
                        prevProducts.map(p => 
                          p.recipe_id === updatedRecipe.id 
                            ? { 
                                ...p, 
                                expected_material_cost_with_markup: updatedRecipe.expected_material_cost_with_markup,
                                expected_service_cost_with_markup: updatedRecipe.expected_service_cost_with_markup,
                                expected_install_labor_cost_with_markup: updatedRecipe.expected_install_labor_cost_with_markup,
                                expected_cost_with_markup: updatedRecipe.expected_cost_with_markup
                              } 
                            : p
                        )
                      );
                      setRefreshCalculation((v) => !v)
                    }
                  }}
      />
      <RequestProgressModal
        open={showProgressModal}
        onClose={() => setShowProgressModal(false)}
        requestData={progressRequestData}
        heading={"Estimate Job"}
        message="We're processing your request. Please wait..."
      />
    </Page>
  )
})

export default EditEstimateJob
